webpackJsonp([114276838955818],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./type')} */
	module.exports = TypeError;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.categoryHref = exports.articleHref = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isActiveCategory = isActiveCategory;
	exports.buildTree = buildTree;
	
	var _lodash = __webpack_require__(37);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(22);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isActiveCategory(category, pathname) {
	  var articles = category.articles;
	
	
	  return articles.some(function (_ref) {
	    var href = _ref.href;
	    return pathname.includes(href);
	  });
	}
	
	var flatten = function flatten(edges) {
	  return edges.map(function (_ref2) {
	    var node = _ref2.node;
	    return node;
	  });
	};
	
	var articleHref = exports.articleHref = function articleHref(_ref3) {
	  var slug = _ref3.slug,
	      number = _ref3.number;
	  return '/article/' + number + '-' + slug;
	};
	
	var categoryHref = exports.categoryHref = function categoryHref(category) {
	  if (category.articles[0]) {
	    return articleHref(category.articles[0]);
	  }
	  return '#';
	};
	
	function buildTree(categoryEdges, articleEdges) {
	  var categoryNodes = (0, _lodash2.default)(flatten(categoryEdges), ['order']);
	  var articleNodes = flatten(articleEdges);
	
	  // initialize the tree
	  var tree = categoryNodes.reduce(function (acc, category) {
	    var name = category.name,
	        id = category.id,
	        slug = category.slug,
	        articleCount = category.articleCount,
	        description = category.description;
	
	    var node = {
	      id: id,
	      description: description,
	      name: name,
	      slug: slug,
	      articleCount: articleCount,
	      articles: []
	    };
	
	    return (0, _lodash4.default)(acc, id, node);
	  }, {});
	
	  // populate the tree and return it
	  return articleNodes.reduce(function (acc, article) {
	    return article.categories.reduce(function (treeWithArticles, id) {
	      return (0, _lodash4.default)(treeWithArticles, [id, 'articles', treeWithArticles[id].articles.length], _extends({}, article, { parent: id, href: articleHref(article) }));
	    }, acc);
	  }, tree);
	}

/***/ }),
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var implementation = __webpack_require__(112);
	
	module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var hasMap = typeof Map === 'function' && Map.prototype;
	var mapSizeDescriptor = Object.getOwnPropertyDescriptor && hasMap ? Object.getOwnPropertyDescriptor(Map.prototype, 'size') : null;
	var mapSize = hasMap && mapSizeDescriptor && typeof mapSizeDescriptor.get === 'function' ? mapSizeDescriptor.get : null;
	var mapForEach = hasMap && Map.prototype.forEach;
	var hasSet = typeof Set === 'function' && Set.prototype;
	var setSizeDescriptor = Object.getOwnPropertyDescriptor && hasSet ? Object.getOwnPropertyDescriptor(Set.prototype, 'size') : null;
	var setSize = hasSet && setSizeDescriptor && typeof setSizeDescriptor.get === 'function' ? setSizeDescriptor.get : null;
	var setForEach = hasSet && Set.prototype.forEach;
	var hasWeakMap = typeof WeakMap === 'function' && WeakMap.prototype;
	var weakMapHas = hasWeakMap ? WeakMap.prototype.has : null;
	var hasWeakSet = typeof WeakSet === 'function' && WeakSet.prototype;
	var weakSetHas = hasWeakSet ? WeakSet.prototype.has : null;
	var hasWeakRef = typeof WeakRef === 'function' && WeakRef.prototype;
	var weakRefDeref = hasWeakRef ? WeakRef.prototype.deref : null;
	var booleanValueOf = Boolean.prototype.valueOf;
	var objectToString = Object.prototype.toString;
	var functionToString = Function.prototype.toString;
	var $match = String.prototype.match;
	var $slice = String.prototype.slice;
	var $replace = String.prototype.replace;
	var $toUpperCase = String.prototype.toUpperCase;
	var $toLowerCase = String.prototype.toLowerCase;
	var $test = RegExp.prototype.test;
	var $concat = Array.prototype.concat;
	var $join = Array.prototype.join;
	var $arrSlice = Array.prototype.slice;
	var $floor = Math.floor;
	var bigIntValueOf = typeof BigInt === 'function' ? BigInt.prototype.valueOf : null;
	var gOPS = Object.getOwnPropertySymbols;
	var symToString = typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol' ? Symbol.prototype.toString : null;
	var hasShammedSymbols = typeof Symbol === 'function' && typeof Symbol.iterator === 'object';
	// ie, `has-tostringtag/shams
	var toStringTag = typeof Symbol === 'function' && Symbol.toStringTag && (typeof Symbol.toStringTag === hasShammedSymbols ? 'object' : 'symbol')
	    ? Symbol.toStringTag
	    : null;
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	
	var gPO = (typeof Reflect === 'function' ? Reflect.getPrototypeOf : Object.getPrototypeOf) || (
	    [].__proto__ === Array.prototype // eslint-disable-line no-proto
	        ? function (O) {
	            return O.__proto__; // eslint-disable-line no-proto
	        }
	        : null
	);
	
	function addNumericSeparator(num, str) {
	    if (
	        num === Infinity
	        || num === -Infinity
	        || num !== num
	        || (num && num > -1000 && num < 1000)
	        || $test.call(/e/, str)
	    ) {
	        return str;
	    }
	    var sepRegex = /[0-9](?=(?:[0-9]{3})+(?![0-9]))/g;
	    if (typeof num === 'number') {
	        var int = num < 0 ? -$floor(-num) : $floor(num); // trunc(num)
	        if (int !== num) {
	            var intStr = String(int);
	            var dec = $slice.call(str, intStr.length + 1);
	            return $replace.call(intStr, sepRegex, '$&_') + '.' + $replace.call($replace.call(dec, /([0-9]{3})/g, '$&_'), /_$/, '');
	        }
	    }
	    return $replace.call(str, sepRegex, '$&_');
	}
	
	var utilInspect = __webpack_require__(161);
	var inspectCustom = utilInspect.custom;
	var inspectSymbol = isSymbol(inspectCustom) ? inspectCustom : null;
	
	var quotes = {
	    __proto__: null,
	    'double': '"',
	    single: "'"
	};
	var quoteREs = {
	    __proto__: null,
	    'double': /(["\\])/g,
	    single: /(['\\])/g
	};
	
	module.exports = function inspect_(obj, options, depth, seen) {
	    var opts = options || {};
	
	    if (has(opts, 'quoteStyle') && !has(quotes, opts.quoteStyle)) {
	        throw new TypeError('option "quoteStyle" must be "single" or "double"');
	    }
	    if (
	        has(opts, 'maxStringLength') && (typeof opts.maxStringLength === 'number'
	            ? opts.maxStringLength < 0 && opts.maxStringLength !== Infinity
	            : opts.maxStringLength !== null
	        )
	    ) {
	        throw new TypeError('option "maxStringLength", if provided, must be a positive integer, Infinity, or `null`');
	    }
	    var customInspect = has(opts, 'customInspect') ? opts.customInspect : true;
	    if (typeof customInspect !== 'boolean' && customInspect !== 'symbol') {
	        throw new TypeError('option "customInspect", if provided, must be `true`, `false`, or `\'symbol\'`');
	    }
	
	    if (
	        has(opts, 'indent')
	        && opts.indent !== null
	        && opts.indent !== '\t'
	        && !(parseInt(opts.indent, 10) === opts.indent && opts.indent > 0)
	    ) {
	        throw new TypeError('option "indent" must be "\\t", an integer > 0, or `null`');
	    }
	    if (has(opts, 'numericSeparator') && typeof opts.numericSeparator !== 'boolean') {
	        throw new TypeError('option "numericSeparator", if provided, must be `true` or `false`');
	    }
	    var numericSeparator = opts.numericSeparator;
	
	    if (typeof obj === 'undefined') {
	        return 'undefined';
	    }
	    if (obj === null) {
	        return 'null';
	    }
	    if (typeof obj === 'boolean') {
	        return obj ? 'true' : 'false';
	    }
	
	    if (typeof obj === 'string') {
	        return inspectString(obj, opts);
	    }
	    if (typeof obj === 'number') {
	        if (obj === 0) {
	            return Infinity / obj > 0 ? '0' : '-0';
	        }
	        var str = String(obj);
	        return numericSeparator ? addNumericSeparator(obj, str) : str;
	    }
	    if (typeof obj === 'bigint') {
	        var bigIntStr = String(obj) + 'n';
	        return numericSeparator ? addNumericSeparator(obj, bigIntStr) : bigIntStr;
	    }
	
	    var maxDepth = typeof opts.depth === 'undefined' ? 5 : opts.depth;
	    if (typeof depth === 'undefined') { depth = 0; }
	    if (depth >= maxDepth && maxDepth > 0 && typeof obj === 'object') {
	        return isArray(obj) ? '[Array]' : '[Object]';
	    }
	
	    var indent = getIndent(opts, depth);
	
	    if (typeof seen === 'undefined') {
	        seen = [];
	    } else if (indexOf(seen, obj) >= 0) {
	        return '[Circular]';
	    }
	
	    function inspect(value, from, noIndent) {
	        if (from) {
	            seen = $arrSlice.call(seen);
	            seen.push(from);
	        }
	        if (noIndent) {
	            var newOpts = {
	                depth: opts.depth
	            };
	            if (has(opts, 'quoteStyle')) {
	                newOpts.quoteStyle = opts.quoteStyle;
	            }
	            return inspect_(value, newOpts, depth + 1, seen);
	        }
	        return inspect_(value, opts, depth + 1, seen);
	    }
	
	    if (typeof obj === 'function' && !isRegExp(obj)) { // in older engines, regexes are callable
	        var name = nameOf(obj);
	        var keys = arrObjKeys(obj, inspect);
	        return '[Function' + (name ? ': ' + name : ' (anonymous)') + ']' + (keys.length > 0 ? ' { ' + $join.call(keys, ', ') + ' }' : '');
	    }
	    if (isSymbol(obj)) {
	        var symString = hasShammedSymbols ? $replace.call(String(obj), /^(Symbol\(.*\))_[^)]*$/, '$1') : symToString.call(obj);
	        return typeof obj === 'object' && !hasShammedSymbols ? markBoxed(symString) : symString;
	    }
	    if (isElement(obj)) {
	        var s = '<' + $toLowerCase.call(String(obj.nodeName));
	        var attrs = obj.attributes || [];
	        for (var i = 0; i < attrs.length; i++) {
	            s += ' ' + attrs[i].name + '=' + wrapQuotes(quote(attrs[i].value), 'double', opts);
	        }
	        s += '>';
	        if (obj.childNodes && obj.childNodes.length) { s += '...'; }
	        s += '</' + $toLowerCase.call(String(obj.nodeName)) + '>';
	        return s;
	    }
	    if (isArray(obj)) {
	        if (obj.length === 0) { return '[]'; }
	        var xs = arrObjKeys(obj, inspect);
	        if (indent && !singleLineValues(xs)) {
	            return '[' + indentedJoin(xs, indent) + ']';
	        }
	        return '[ ' + $join.call(xs, ', ') + ' ]';
	    }
	    if (isError(obj)) {
	        var parts = arrObjKeys(obj, inspect);
	        if (!('cause' in Error.prototype) && 'cause' in obj && !isEnumerable.call(obj, 'cause')) {
	            return '{ [' + String(obj) + '] ' + $join.call($concat.call('[cause]: ' + inspect(obj.cause), parts), ', ') + ' }';
	        }
	        if (parts.length === 0) { return '[' + String(obj) + ']'; }
	        return '{ [' + String(obj) + '] ' + $join.call(parts, ', ') + ' }';
	    }
	    if (typeof obj === 'object' && customInspect) {
	        if (inspectSymbol && typeof obj[inspectSymbol] === 'function' && utilInspect) {
	            return utilInspect(obj, { depth: maxDepth - depth });
	        } else if (customInspect !== 'symbol' && typeof obj.inspect === 'function') {
	            return obj.inspect();
	        }
	    }
	    if (isMap(obj)) {
	        var mapParts = [];
	        if (mapForEach) {
	            mapForEach.call(obj, function (value, key) {
	                mapParts.push(inspect(key, obj, true) + ' => ' + inspect(value, obj));
	            });
	        }
	        return collectionOf('Map', mapSize.call(obj), mapParts, indent);
	    }
	    if (isSet(obj)) {
	        var setParts = [];
	        if (setForEach) {
	            setForEach.call(obj, function (value) {
	                setParts.push(inspect(value, obj));
	            });
	        }
	        return collectionOf('Set', setSize.call(obj), setParts, indent);
	    }
	    if (isWeakMap(obj)) {
	        return weakCollectionOf('WeakMap');
	    }
	    if (isWeakSet(obj)) {
	        return weakCollectionOf('WeakSet');
	    }
	    if (isWeakRef(obj)) {
	        return weakCollectionOf('WeakRef');
	    }
	    if (isNumber(obj)) {
	        return markBoxed(inspect(Number(obj)));
	    }
	    if (isBigInt(obj)) {
	        return markBoxed(inspect(bigIntValueOf.call(obj)));
	    }
	    if (isBoolean(obj)) {
	        return markBoxed(booleanValueOf.call(obj));
	    }
	    if (isString(obj)) {
	        return markBoxed(inspect(String(obj)));
	    }
	    // note: in IE 8, sometimes `global !== window` but both are the prototypes of each other
	    /* eslint-env browser */
	    if (typeof window !== 'undefined' && obj === window) {
	        return '{ [object Window] }';
	    }
	    if (
	        (typeof globalThis !== 'undefined' && obj === globalThis)
	        || (typeof global !== 'undefined' && obj === global)
	    ) {
	        return '{ [object globalThis] }';
	    }
	    if (!isDate(obj) && !isRegExp(obj)) {
	        var ys = arrObjKeys(obj, inspect);
	        var isPlainObject = gPO ? gPO(obj) === Object.prototype : obj instanceof Object || obj.constructor === Object;
	        var protoTag = obj instanceof Object ? '' : 'null prototype';
	        var stringTag = !isPlainObject && toStringTag && Object(obj) === obj && toStringTag in obj ? $slice.call(toStr(obj), 8, -1) : protoTag ? 'Object' : '';
	        var constructorTag = isPlainObject || typeof obj.constructor !== 'function' ? '' : obj.constructor.name ? obj.constructor.name + ' ' : '';
	        var tag = constructorTag + (stringTag || protoTag ? '[' + $join.call($concat.call([], stringTag || [], protoTag || []), ': ') + '] ' : '');
	        if (ys.length === 0) { return tag + '{}'; }
	        if (indent) {
	            return tag + '{' + indentedJoin(ys, indent) + '}';
	        }
	        return tag + '{ ' + $join.call(ys, ', ') + ' }';
	    }
	    return String(obj);
	};
	
	function wrapQuotes(s, defaultStyle, opts) {
	    var style = opts.quoteStyle || defaultStyle;
	    var quoteChar = quotes[style];
	    return quoteChar + s + quoteChar;
	}
	
	function quote(s) {
	    return $replace.call(String(s), /"/g, '&quot;');
	}
	
	function canTrustToString(obj) {
	    return !toStringTag || !(typeof obj === 'object' && (toStringTag in obj || typeof obj[toStringTag] !== 'undefined'));
	}
	function isArray(obj) { return toStr(obj) === '[object Array]' && canTrustToString(obj); }
	function isDate(obj) { return toStr(obj) === '[object Date]' && canTrustToString(obj); }
	function isRegExp(obj) { return toStr(obj) === '[object RegExp]' && canTrustToString(obj); }
	function isError(obj) { return toStr(obj) === '[object Error]' && canTrustToString(obj); }
	function isString(obj) { return toStr(obj) === '[object String]' && canTrustToString(obj); }
	function isNumber(obj) { return toStr(obj) === '[object Number]' && canTrustToString(obj); }
	function isBoolean(obj) { return toStr(obj) === '[object Boolean]' && canTrustToString(obj); }
	
	// Symbol and BigInt do have Symbol.toStringTag by spec, so that can't be used to eliminate false positives
	function isSymbol(obj) {
	    if (hasShammedSymbols) {
	        return obj && typeof obj === 'object' && obj instanceof Symbol;
	    }
	    if (typeof obj === 'symbol') {
	        return true;
	    }
	    if (!obj || typeof obj !== 'object' || !symToString) {
	        return false;
	    }
	    try {
	        symToString.call(obj);
	        return true;
	    } catch (e) {}
	    return false;
	}
	
	function isBigInt(obj) {
	    if (!obj || typeof obj !== 'object' || !bigIntValueOf) {
	        return false;
	    }
	    try {
	        bigIntValueOf.call(obj);
	        return true;
	    } catch (e) {}
	    return false;
	}
	
	var hasOwn = Object.prototype.hasOwnProperty || function (key) { return key in this; };
	function has(obj, key) {
	    return hasOwn.call(obj, key);
	}
	
	function toStr(obj) {
	    return objectToString.call(obj);
	}
	
	function nameOf(f) {
	    if (f.name) { return f.name; }
	    var m = $match.call(functionToString.call(f), /^function\s*([\w$]+)/);
	    if (m) { return m[1]; }
	    return null;
	}
	
	function indexOf(xs, x) {
	    if (xs.indexOf) { return xs.indexOf(x); }
	    for (var i = 0, l = xs.length; i < l; i++) {
	        if (xs[i] === x) { return i; }
	    }
	    return -1;
	}
	
	function isMap(x) {
	    if (!mapSize || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        mapSize.call(x);
	        try {
	            setSize.call(x);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof Map; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isWeakMap(x) {
	    if (!weakMapHas || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakMapHas.call(x, weakMapHas);
	        try {
	            weakSetHas.call(x, weakSetHas);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof WeakMap; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isWeakRef(x) {
	    if (!weakRefDeref || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakRefDeref.call(x);
	        return true;
	    } catch (e) {}
	    return false;
	}
	
	function isSet(x) {
	    if (!setSize || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        setSize.call(x);
	        try {
	            mapSize.call(x);
	        } catch (m) {
	            return true;
	        }
	        return x instanceof Set; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isWeakSet(x) {
	    if (!weakSetHas || !x || typeof x !== 'object') {
	        return false;
	    }
	    try {
	        weakSetHas.call(x, weakSetHas);
	        try {
	            weakMapHas.call(x, weakMapHas);
	        } catch (s) {
	            return true;
	        }
	        return x instanceof WeakSet; // core-js workaround, pre-v2.5.0
	    } catch (e) {}
	    return false;
	}
	
	function isElement(x) {
	    if (!x || typeof x !== 'object') { return false; }
	    if (typeof HTMLElement !== 'undefined' && x instanceof HTMLElement) {
	        return true;
	    }
	    return typeof x.nodeName === 'string' && typeof x.getAttribute === 'function';
	}
	
	function inspectString(str, opts) {
	    if (str.length > opts.maxStringLength) {
	        var remaining = str.length - opts.maxStringLength;
	        var trailer = '... ' + remaining + ' more character' + (remaining > 1 ? 's' : '');
	        return inspectString($slice.call(str, 0, opts.maxStringLength), opts) + trailer;
	    }
	    var quoteRE = quoteREs[opts.quoteStyle || 'single'];
	    quoteRE.lastIndex = 0;
	    // eslint-disable-next-line no-control-regex
	    var s = $replace.call($replace.call(str, quoteRE, '\\$1'), /[\x00-\x1f]/g, lowbyte);
	    return wrapQuotes(s, 'single', opts);
	}
	
	function lowbyte(c) {
	    var n = c.charCodeAt(0);
	    var x = {
	        8: 'b',
	        9: 't',
	        10: 'n',
	        12: 'f',
	        13: 'r'
	    }[n];
	    if (x) { return '\\' + x; }
	    return '\\x' + (n < 0x10 ? '0' : '') + $toUpperCase.call(n.toString(16));
	}
	
	function markBoxed(str) {
	    return 'Object(' + str + ')';
	}
	
	function weakCollectionOf(type) {
	    return type + ' { ? }';
	}
	
	function collectionOf(type, size, entries, indent) {
	    var joinedEntries = indent ? indentedJoin(entries, indent) : $join.call(entries, ', ');
	    return type + ' (' + size + ') {' + joinedEntries + '}';
	}
	
	function singleLineValues(xs) {
	    for (var i = 0; i < xs.length; i++) {
	        if (indexOf(xs[i], '\n') >= 0) {
	            return false;
	        }
	    }
	    return true;
	}
	
	function getIndent(opts, depth) {
	    var baseIndent;
	    if (opts.indent === '\t') {
	        baseIndent = '\t';
	    } else if (typeof opts.indent === 'number' && opts.indent > 0) {
	        baseIndent = $join.call(Array(opts.indent + 1), ' ');
	    } else {
	        return null;
	    }
	    return {
	        base: baseIndent,
	        prev: $join.call(Array(depth + 1), baseIndent)
	    };
	}
	
	function indentedJoin(xs, indent) {
	    if (xs.length === 0) { return ''; }
	    var lineJoiner = '\n' + indent.prev + indent.base;
	    return lineJoiner + $join.call(xs, ',' + lineJoiner) + '\n' + indent.prev;
	}
	
	function arrObjKeys(obj, inspect) {
	    var isArr = isArray(obj);
	    var xs = [];
	    if (isArr) {
	        xs.length = obj.length;
	        for (var i = 0; i < obj.length; i++) {
	            xs[i] = has(obj, i) ? inspect(obj[i], obj) : '';
	        }
	    }
	    var syms = typeof gOPS === 'function' ? gOPS(obj) : [];
	    var symMap;
	    if (hasShammedSymbols) {
	        symMap = {};
	        for (var k = 0; k < syms.length; k++) {
	            symMap['$' + syms[k]] = syms[k];
	        }
	    }
	
	    for (var key in obj) { // eslint-disable-line no-restricted-syntax
	        if (!has(obj, key)) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
	        if (isArr && String(Number(key)) === key && key < obj.length) { continue; } // eslint-disable-line no-restricted-syntax, no-continue
	        if (hasShammedSymbols && symMap['$' + key] instanceof Symbol) {
	            // this is to prevent shammed Symbols, which are stored as strings, from being included in the string key section
	            continue; // eslint-disable-line no-restricted-syntax, no-continue
	        } else if ($test.call(/[^\w$]/, key)) {
	            xs.push(inspect(key, obj) + ': ' + inspect(obj[key], obj));
	        } else {
	            xs.push(key + ': ' + inspect(obj[key], obj));
	        }
	    }
	    if (typeof gOPS === 'function') {
	        for (var j = 0; j < syms.length; j++) {
	            if (isEnumerable.call(obj, syms[j])) {
	                xs.push('[' + inspect(syms[j]) + ']: ' + inspect(obj[syms[j]], obj));
	            }
	        }
	    }
	    return xs;
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _buttonModule = __webpack_require__(35);
	
	var _buttonModule2 = _interopRequireDefault(_buttonModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var buttonClasses = function buttonClasses(props) {
	  var _classNames;
	
	  var className = props.className,
	      size = props.size,
	      variant = props.variant,
	      fullWidth = props.fullWidth;
	
	  return (0, _classnames2.default)(_buttonModule2.default.Button, _buttonModule2.default['Button--' + variant], _buttonModule2.default['Button--' + size], (_classNames = {}, _classNames[_buttonModule2.default['Button--fullWidth']] = fullWidth, _classNames), className);
	};
	
	var Button = function Button(props) {
	  var href = props.href,
	      children = props.children,
	      onClick = props.onClick;
	
	
	  if (onClick) {
	    return _react2.default.createElement(
	      'button',
	      { className: buttonClasses(props), onClick: onClick, type: 'button' },
	      children
	    );
	  }
	
	  if (/http/.test(href)) {
	    return _react2.default.createElement(
	      'a',
	      { className: buttonClasses(props), href: href },
	      children
	    );
	  }
	
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    { className: buttonClasses(props), to: href },
	    children
	  );
	};
	
	Button.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  className: _propTypes2.default.string, // eslint-disable-line react/no-unused-prop-types
	  fullWidth: _propTypes2.default.bool, // eslint-disable-line react/no-unused-prop-types
	  href: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  size: _propTypes2.default.oneOf(['small', 'medium']), // eslint-disable-line react/no-unused-prop-types
	  // eslint-disable-next-line react/no-unused-prop-types
	  variant: _propTypes2.default.oneOf(['primary', 'secondary', 'inverse', 'inverseOutline'])
	};
	
	Button.defaultProps = {
	  className: '',
	  fullWidth: false,
	  href: '#',
	  size: 'medium',
	  variant: 'primary'
	};
	
	exports.default = Button;
	module.exports = exports['default'];

/***/ }),
/* 22 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    splice = arrayProto.splice;
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 23 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 24 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./functionCall')} */
	module.exports = Function.prototype.call;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var undefined;
	
	var $Object = __webpack_require__(45);
	
	var $Error = __webpack_require__(102);
	var $EvalError = __webpack_require__(101);
	var $RangeError = __webpack_require__(103);
	var $ReferenceError = __webpack_require__(104);
	var $SyntaxError = __webpack_require__(105);
	var $TypeError = __webpack_require__(9);
	var $URIError = __webpack_require__(106);
	
	var abs = __webpack_require__(118);
	var floor = __webpack_require__(119);
	var max = __webpack_require__(121);
	var min = __webpack_require__(122);
	var pow = __webpack_require__(123);
	var round = __webpack_require__(124);
	var sign = __webpack_require__(125);
	
	var $Function = Function;
	
	// eslint-disable-next-line consistent-return
	var getEvalledConstructor = function (expressionSyntax) {
		try {
			return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
		} catch (e) {}
	};
	
	var $gOPD = __webpack_require__(49);
	var $defineProperty = __webpack_require__(44);
	
	var throwTypeError = function () {
		throw new $TypeError();
	};
	var ThrowTypeError = $gOPD
		? (function () {
			try {
				// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
				arguments.callee; // IE 8 does not throw here
				return throwTypeError;
			} catch (calleeThrows) {
				try {
					// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
					return $gOPD(arguments, 'callee').get;
				} catch (gOPDthrows) {
					return throwTypeError;
				}
			}
		}())
		: throwTypeError;
	
	var hasSymbols = __webpack_require__(115)();
	
	var getProto = __webpack_require__(113);
	var $ObjectGPO = __webpack_require__(47);
	var $ReflectGPO = __webpack_require__(48);
	
	var $apply = __webpack_require__(40);
	var $call = __webpack_require__(24);
	
	var needsEval = {};
	
	var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);
	
	var INTRINSICS = {
		__proto__: null,
		'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
		'%Array%': Array,
		'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
		'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
		'%AsyncFromSyncIteratorPrototype%': undefined,
		'%AsyncFunction%': needsEval,
		'%AsyncGenerator%': needsEval,
		'%AsyncGeneratorFunction%': needsEval,
		'%AsyncIteratorPrototype%': needsEval,
		'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
		'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
		'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
		'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
		'%Boolean%': Boolean,
		'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
		'%Date%': Date,
		'%decodeURI%': decodeURI,
		'%decodeURIComponent%': decodeURIComponent,
		'%encodeURI%': encodeURI,
		'%encodeURIComponent%': encodeURIComponent,
		'%Error%': $Error,
		'%eval%': eval, // eslint-disable-line no-eval
		'%EvalError%': $EvalError,
		'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
		'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
		'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
		'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
		'%Function%': $Function,
		'%GeneratorFunction%': needsEval,
		'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
		'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
		'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
		'%isFinite%': isFinite,
		'%isNaN%': isNaN,
		'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
		'%JSON%': typeof JSON === 'object' ? JSON : undefined,
		'%Map%': typeof Map === 'undefined' ? undefined : Map,
		'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
		'%Math%': Math,
		'%Number%': Number,
		'%Object%': $Object,
		'%Object.getOwnPropertyDescriptor%': $gOPD,
		'%parseFloat%': parseFloat,
		'%parseInt%': parseInt,
		'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
		'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
		'%RangeError%': $RangeError,
		'%ReferenceError%': $ReferenceError,
		'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
		'%RegExp%': RegExp,
		'%Set%': typeof Set === 'undefined' ? undefined : Set,
		'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
		'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
		'%String%': String,
		'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
		'%Symbol%': hasSymbols ? Symbol : undefined,
		'%SyntaxError%': $SyntaxError,
		'%ThrowTypeError%': ThrowTypeError,
		'%TypedArray%': TypedArray,
		'%TypeError%': $TypeError,
		'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
		'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
		'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
		'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
		'%URIError%': $URIError,
		'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
		'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
		'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
	
		'%Function.prototype.call%': $call,
		'%Function.prototype.apply%': $apply,
		'%Object.defineProperty%': $defineProperty,
		'%Object.getPrototypeOf%': $ObjectGPO,
		'%Math.abs%': abs,
		'%Math.floor%': floor,
		'%Math.max%': max,
		'%Math.min%': min,
		'%Math.pow%': pow,
		'%Math.round%': round,
		'%Math.sign%': sign,
		'%Reflect.getPrototypeOf%': $ReflectGPO
	};
	
	if (getProto) {
		try {
			null.error; // eslint-disable-line no-unused-expressions
		} catch (e) {
			// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
			var errorProto = getProto(getProto(e));
			INTRINSICS['%Error.prototype%'] = errorProto;
		}
	}
	
	var doEval = function doEval(name) {
		var value;
		if (name === '%AsyncFunction%') {
			value = getEvalledConstructor('async function () {}');
		} else if (name === '%GeneratorFunction%') {
			value = getEvalledConstructor('function* () {}');
		} else if (name === '%AsyncGeneratorFunction%') {
			value = getEvalledConstructor('async function* () {}');
		} else if (name === '%AsyncGenerator%') {
			var fn = doEval('%AsyncGeneratorFunction%');
			if (fn) {
				value = fn.prototype;
			}
		} else if (name === '%AsyncIteratorPrototype%') {
			var gen = doEval('%AsyncGenerator%');
			if (gen && getProto) {
				value = getProto(gen.prototype);
			}
		}
	
		INTRINSICS[name] = value;
	
		return value;
	};
	
	var LEGACY_ALIASES = {
		__proto__: null,
		'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
		'%ArrayPrototype%': ['Array', 'prototype'],
		'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
		'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
		'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
		'%ArrayProto_values%': ['Array', 'prototype', 'values'],
		'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
		'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
		'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
		'%BooleanPrototype%': ['Boolean', 'prototype'],
		'%DataViewPrototype%': ['DataView', 'prototype'],
		'%DatePrototype%': ['Date', 'prototype'],
		'%ErrorPrototype%': ['Error', 'prototype'],
		'%EvalErrorPrototype%': ['EvalError', 'prototype'],
		'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
		'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
		'%FunctionPrototype%': ['Function', 'prototype'],
		'%Generator%': ['GeneratorFunction', 'prototype'],
		'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
		'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
		'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
		'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
		'%JSONParse%': ['JSON', 'parse'],
		'%JSONStringify%': ['JSON', 'stringify'],
		'%MapPrototype%': ['Map', 'prototype'],
		'%NumberPrototype%': ['Number', 'prototype'],
		'%ObjectPrototype%': ['Object', 'prototype'],
		'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
		'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
		'%PromisePrototype%': ['Promise', 'prototype'],
		'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
		'%Promise_all%': ['Promise', 'all'],
		'%Promise_reject%': ['Promise', 'reject'],
		'%Promise_resolve%': ['Promise', 'resolve'],
		'%RangeErrorPrototype%': ['RangeError', 'prototype'],
		'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
		'%RegExpPrototype%': ['RegExp', 'prototype'],
		'%SetPrototype%': ['Set', 'prototype'],
		'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
		'%StringPrototype%': ['String', 'prototype'],
		'%SymbolPrototype%': ['Symbol', 'prototype'],
		'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
		'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
		'%TypeErrorPrototype%': ['TypeError', 'prototype'],
		'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
		'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
		'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
		'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
		'%URIErrorPrototype%': ['URIError', 'prototype'],
		'%WeakMapPrototype%': ['WeakMap', 'prototype'],
		'%WeakSetPrototype%': ['WeakSet', 'prototype']
	};
	
	var bind = __webpack_require__(17);
	var hasOwn = __webpack_require__(117);
	var $concat = bind.call($call, Array.prototype.concat);
	var $spliceApply = bind.call($apply, Array.prototype.splice);
	var $replace = bind.call($call, String.prototype.replace);
	var $strSlice = bind.call($call, String.prototype.slice);
	var $exec = bind.call($call, RegExp.prototype.exec);
	
	/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
	var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
	var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
	var stringToPath = function stringToPath(string) {
		var first = $strSlice(string, 0, 1);
		var last = $strSlice(string, -1);
		if (first === '%' && last !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
		} else if (last === '%' && first !== '%') {
			throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
		}
		var result = [];
		$replace(string, rePropName, function (match, number, quote, subString) {
			result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
		});
		return result;
	};
	/* end adaptation */
	
	var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
		var intrinsicName = name;
		var alias;
		if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
			alias = LEGACY_ALIASES[intrinsicName];
			intrinsicName = '%' + alias[0] + '%';
		}
	
		if (hasOwn(INTRINSICS, intrinsicName)) {
			var value = INTRINSICS[intrinsicName];
			if (value === needsEval) {
				value = doEval(intrinsicName);
			}
			if (typeof value === 'undefined' && !allowMissing) {
				throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
			}
	
			return {
				alias: alias,
				name: intrinsicName,
				value: value
			};
		}
	
		throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
	};
	
	module.exports = function GetIntrinsic(name, allowMissing) {
		if (typeof name !== 'string' || name.length === 0) {
			throw new $TypeError('intrinsic name must be a non-empty string');
		}
		if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
			throw new $TypeError('"allowMissing" argument must be a boolean');
		}
	
		if ($exec(/^%?[^%]*%?$/, name) === null) {
			throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
		}
		var parts = stringToPath(name);
		var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
	
		var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
		var intrinsicRealName = intrinsic.name;
		var value = intrinsic.value;
		var skipFurtherCaching = false;
	
		var alias = intrinsic.alias;
		if (alias) {
			intrinsicBaseName = alias[0];
			$spliceApply(parts, $concat([0, 1], alias));
		}
	
		for (var i = 1, isOwn = true; i < parts.length; i += 1) {
			var part = parts[i];
			var first = $strSlice(part, 0, 1);
			var last = $strSlice(part, -1);
			if (
				(
					(first === '"' || first === "'" || first === '`')
					|| (last === '"' || last === "'" || last === '`')
				)
				&& first !== last
			) {
				throw new $SyntaxError('property names with quotes must have matching quotes');
			}
			if (part === 'constructor' || !isOwn) {
				skipFurtherCaching = true;
			}
	
			intrinsicBaseName += '.' + part;
			intrinsicRealName = '%' + intrinsicBaseName + '%';
	
			if (hasOwn(INTRINSICS, intrinsicRealName)) {
				value = INTRINSICS[intrinsicRealName];
			} else if (value != null) {
				if (!(part in value)) {
					if (!allowMissing) {
						throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
					}
					return void undefined;
				}
				if ($gOPD && (i + 1) >= parts.length) {
					var desc = $gOPD(value, part);
					isOwn = !!desc;
	
					// By convention, when a data property is converted to an accessor
					// property to emulate a data property that does not suffer from
					// the override mistake, that accessor's getter is marked with
					// an `originalValue` property. Here, when we detect this, we
					// uphold the illusion by pretending to see that original data
					// property, i.e., returning the value rather than the getter
					// itself.
					if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
						value = desc.get;
					} else {
						value = value[part];
					}
				} else {
					isOwn = hasOwn(value, part);
					value = value[part];
				}
	
				if (isOwn && !skipFurtherCaching) {
					INTRINSICS[intrinsicRealName] = value;
				}
			}
		}
		return value;
	};


/***/ }),
/* 26 */
/***/ (function(module, exports) {

	'use strict';
	
	var replace = String.prototype.replace;
	var percentTwenties = /%20/g;
	
	var Format = {
	    RFC1738: 'RFC1738',
	    RFC3986: 'RFC3986'
	};
	
	module.exports = {
	    'default': Format.RFC3986,
	    formatters: {
	        RFC1738: function (value) {
	            return replace.call(value, percentTwenties, '+');
	        },
	        RFC3986: function (value) {
	            return String(value);
	        }
	    },
	    RFC1738: Format.RFC1738,
	    RFC3986: Format.RFC3986
	};


/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $TypeError = __webpack_require__(9);
	var inspect = __webpack_require__(18);
	var getSideChannelList = __webpack_require__(157);
	var getSideChannelMap = __webpack_require__(59);
	var getSideChannelWeakMap = __webpack_require__(158);
	
	var makeChannel = getSideChannelWeakMap || getSideChannelMap || getSideChannelList;
	
	/** @type {import('.')} */
	module.exports = function getSideChannel() {
		/** @typedef {ReturnType<typeof getSideChannel>} Channel */
	
		/** @type {Channel | undefined} */ var $channelData;
	
		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					var keyDesc = key && Object(key) === key
						? 'the given object key'
						: inspect(key);
					throw new $TypeError('Side channel does not contain ' + keyDesc);
				}
			},
			'delete': function (key) {
				return !!$channelData && $channelData['delete'](key);
			},
			get: function (key) {
				return $channelData && $channelData.get(key);
			},
			has: function (key) {
				return !!$channelData && $channelData.has(key);
			},
			set: function (key, value) {
				if (!$channelData) {
					$channelData = makeChannel();
				}
	
				$channelData.set(key, value);
			}
		};
	
		return channel;
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Phosphor Icons (regular weight) - https://phosphoricons.com, MIT license.
	// Path data copied from @phosphor-icons/core so the site needs no React 16+
	// icon package. To add one, copy the <path d> values from
	// assets/regular/<name>.svg in that package.
	var icons = {
	  arrowRight: ['M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z'],
	  bookOpen: ['M232,48H160a40,40,0,0,0-32,16A40,40,0,0,0,96,48H24a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H96a24,24,0,0,1,24,24,8,8,0,0,0,16,0,24,24,0,0,1,24-24h72a8,8,0,0,0,8-8V56A8,8,0,0,0,232,48ZM96,192H32V64H96a24,24,0,0,1,24,24V200A39.81,39.81,0,0,0,96,192Zm128,0H160a39.81,39.81,0,0,0-24,8V88a24,24,0,0,1,24-24h64Z'],
	  calendarCheck: ['M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-38.34-85.66a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L116,164.69l42.34-42.35A8,8,0,0,1,169.66,122.34Z'],
	  chartBarHorizontal: ['M224,96H184V56a8,8,0,0,0-8-8H56V40a8,8,0,0,0-16,0V216a8,8,0,0,0,16,0v-8h88a8,8,0,0,0,8-8V160h72a8,8,0,0,0,8-8V104A8,8,0,0,0,224,96ZM168,64V96H56V64ZM136,192H56V160h80Zm80-48H56V112H216Z'],
	  chartLineUp: ['M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0V156.69l50.34-50.35a8,8,0,0,1,11.32,0L128,132.69,180.69,80H160a8,8,0,0,1,0-16h40a8,8,0,0,1,8,8v40a8,8,0,0,1-16,0V91.31l-58.34,58.35a8,8,0,0,1-11.32,0L96,123.31l-56,56V200H224A8,8,0,0,1,232,208Z'],
	  chatCircleText: ['M168,112a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,112Zm-8,24H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm72-8A104,104,0,0,1,79.12,219.82L45.07,231.17a16,16,0,0,1-20.24-20.24l11.35-34.05A104,104,0,1,1,232,128Zm-16,0A88,88,0,1,0,51.81,172.06a8,8,0,0,1,.66,6.54L40,216,77.4,203.53a7.85,7.85,0,0,1,2.53-.42,8,8,0,0,1,4,1.08A88,88,0,0,0,216,128Z'],
	  chatsCircle: ['M232.07,186.76a80,80,0,0,0-62.5-114.17A80,80,0,1,0,23.93,138.76l-7.27,24.71a16,16,0,0,0,19.87,19.87l24.71-7.27a80.39,80.39,0,0,0,25.18,7.35,80,80,0,0,0,108.34,40.65l24.71,7.27a16,16,0,0,0,19.87-19.86ZM62,159.5a8.28,8.28,0,0,0-2.26.32L32,168l8.17-27.76a8,8,0,0,0-.63-6,64,64,0,1,1,26.26,26.26A8,8,0,0,0,62,159.5Zm153.79,28.73L224,216l-27.76-8.17a8,8,0,0,0-6,.63,64.05,64.05,0,0,1-85.87-24.88A79.93,79.93,0,0,0,174.7,89.71a64,64,0,0,1,41.75,92.48A8,8,0,0,0,215.82,188.23Z'],
	  envelopeSimpleOpen: ['M228.44,89.34l-96-64a8,8,0,0,0-8.88,0l-96,64A8,8,0,0,0,24,96V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V96A8,8,0,0,0,228.44,89.34ZM128,41.61l81.91,54.61-67,47.78H113.11l-67-47.78ZM40,200V111.53l65.9,47a8,8,0,0,0,4.65,1.49h34.9a8,8,0,0,0,4.65-1.49l65.9-47V200Z'],
	  fileText: ['M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-32-80a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,136Zm0,32a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,168Z'],
	  layout: ['M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V96H40V56ZM40,112H96v88H40Zm176,88H112V112H216v88Z'],
	  lightbulb: ['M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.49C39.74,56.83,78.26,17.14,125.88,16A88,88,0,0,1,216,104Zm-16,0a72,72,0,0,0-73.74-72c-39,.92-70.47,33.39-70.26,72.39a71.65,71.65,0,0,0,27.64,56.3A32,32,0,0,1,96,186v6h64v-6a32.15,32.15,0,0,1,12.47-25.35A71.65,71.65,0,0,0,200,104Zm-16.11-9.34a57.6,57.6,0,0,0-46.56-46.55,8,8,0,0,0-2.66,15.78c16.57,2.79,30.63,16.85,33.44,33.45A8,8,0,0,0,176,104a9,9,0,0,0,1.35-.11A8,8,0,0,0,183.89,94.66Z'],
	  plugsConnected: ['M237.66,18.34a8,8,0,0,0-11.32,0l-52.4,52.41-5.37-5.38a32.05,32.05,0,0,0-45.26,0L100,88.69l-6.34-6.35A8,8,0,0,0,82.34,93.66L88.69,100,65.37,123.31a32,32,0,0,0,0,45.26l5.38,5.37-52.41,52.4a8,8,0,0,0,11.32,11.32l52.4-52.41,5.37,5.38a32,32,0,0,0,45.26,0L156,167.31l6.34,6.35a8,8,0,0,0,11.32-11.32L167.31,156l23.32-23.31a32,32,0,0,0,0-45.26l-5.38-5.37,52.41-52.4A8,8,0,0,0,237.66,18.34Zm-116.29,161a16,16,0,0,1-22.62,0L76.69,157.25a16,16,0,0,1,0-22.62L100,111.31,144.69,156Zm57.94-57.94L156,144.69,111.31,100l23.32-23.31a16,16,0,0,1,22.62,0l22.06,22A16,16,0,0,1,179.31,121.37ZM88.57,35A8,8,0,0,1,103.43,29l8,20A8,8,0,0,1,96.57,55ZM24.57,93A8,8,0,0,1,35,88.57l20,8A8,8,0,0,1,49,111.43l-20-8A8,8,0,0,1,24.57,93ZM231.43,163a8,8,0,0,1-10.4,4.46l-20-8A8,8,0,1,1,207,144.57l20,8A8,8,0,0,1,231.43,163Zm-64,58.06A8,8,0,0,1,152.57,227l-8-20A8,8,0,0,1,159.43,201Z'],
	  question: ['M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z'],
	  rocketLaunch: ['M223.85,47.12a16,16,0,0,0-15-15c-12.58-.75-44.73.4-71.41,27.07L132.69,64H74.36A15.91,15.91,0,0,0,63,68.68L28.7,103a16,16,0,0,0,9.07,27.16l38.47,5.37,44.21,44.21,5.37,38.49a15.94,15.94,0,0,0,10.78,12.92,16.11,16.11,0,0,0,5.1.83A15.91,15.91,0,0,0,153,227.3L187.32,193A15.91,15.91,0,0,0,192,181.64V123.31l4.77-4.77C223.45,91.86,224.6,59.71,223.85,47.12ZM74.36,80h42.33L77.16,119.52,40,114.34Zm74.41-9.45a76.65,76.65,0,0,1,59.11-22.47,76.46,76.46,0,0,1-22.42,59.16L128,164.68,91.32,128ZM176,181.64,141.67,216l-5.19-37.17L176,139.31Zm-74.16,9.5C97.34,201,82.29,224,40,224a8,8,0,0,1-8-8c0-42.29,23-57.34,32.86-61.85a8,8,0,0,1,6.64,14.56c-6.43,2.93-20.62,12.36-23.12,38.91,26.55-2.5,36-16.69,38.91-23.12a8,8,0,1,1,14.56,6.64Z'],
	  timer: ['M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,216ZM173.66,90.34a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32-11.32l40-40A8,8,0,0,1,173.66,90.34ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z'],
	  userGear: ['M144,157.68a68,68,0,1,0-71.9,0c-20.65,6.76-39.23,19.39-54.17,37.17a8,8,0,1,0,12.24,10.3C50.25,181.19,77.91,168,108,168s57.75,13.19,77.87,37.15a8,8,0,0,0,12.26-10.3C183.18,177.07,164.6,164.44,144,157.68ZM56,100a52,52,0,1,1,52,52A52.06,52.06,0,0,1,56,100Zm196.25,43.07-4.66-2.69a23.6,23.6,0,0,0,0-8.76l4.66-2.69a8,8,0,1,0-8-13.86l-4.67,2.7a23.92,23.92,0,0,0-7.58-4.39V108a8,8,0,0,0-16,0v5.38a23.92,23.92,0,0,0-7.58,4.39l-4.67-2.7a8,8,0,1,0-8,13.86l4.66,2.69a23.6,23.6,0,0,0,0,8.76l-4.66,2.69a8,8,0,0,0,8,13.86l4.67-2.7a23.92,23.92,0,0,0,7.58,4.39V164a8,8,0,0,0,16,0v-5.38a23.92,23.92,0,0,0,7.58-4.39l4.67,2.7a7.92,7.92,0,0,0,4,1.07,8,8,0,0,0,4-14.93ZM216,136a8,8,0,1,1,8,8A8,8,0,0,1,216,136Z']
	};
	
	var PhosphorIcon = function PhosphorIcon(_ref) {
	  var className = _ref.className,
	      name = _ref.name,
	      size = _ref.size;
	  return _react2.default.createElement(
	    'svg',
	    {
	      'aria-hidden': 'true',
	      className: className,
	      fill: 'currentColor',
	      height: size,
	      viewBox: '0 0 256 256',
	      width: size
	    },
	    icons[name].map(function (d) {
	      return _react2.default.createElement('path', { d: d, key: d });
	    })
	  );
	};
	
	PhosphorIcon.propTypes = {
	  className: _propTypes2.default.string,
	  name: _propTypes2.default.oneOf(Object.keys(icons)).isRequired,
	  size: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string])
	};
	
	PhosphorIcon.defaultProps = {
	  size: '1em'
	};
	
	exports.default = PhosphorIcon;
	module.exports = exports['default'];

/***/ }),
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Button":"src-components----button-module---Button---3qeZK","Button--medium":"src-components----button-module---Button--medium---1F8K6","Button--small":"src-components----button-module---Button--small---3zRwC","Button--primary":"src-components----button-module---Button--primary---2TNMr","Button--secondary":"src-components----button-module---Button--secondary---1tjR8","Button--inverse":"src-components----button-module---Button--inverse---2zTdM","Button--inverseOutline":"src-components----button-module---Button--inverseOutline---2pwCo","Button--fullWidth":"src-components----button-module---Button--fullWidth---iVRKZ","spinAround":"src-components----button-module---spinAround---3Ww-h"};

/***/ }),
/* 36 */,
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * Lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    asyncTag = '[object AsyncFunction]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    nullTag = '[object Null]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    proxyTag = '[object Proxy]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    undefinedTag = '[object Undefined]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * The base implementation of `_.sortBy` which uses `comparer` to define the
	 * sort order of `array` and replaces criteria objects with their corresponding
	 * values.
	 *
	 * @private
	 * @param {Array} array The array to sort.
	 * @param {Function} comparer The function to define sort order.
	 * @returns {Array} Returns `array`.
	 */
	function baseSortBy(array, comparer) {
	  var length = array.length;
	
	  array.sort(comparer);
	  while (length--) {
	    array[length] = array[length].value;
	  }
	  return array;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice,
	    symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	/**
	 * The base implementation of `_.orderBy` without param guards.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	 * @param {string[]} orders The sort orders of `iteratees`.
	 * @returns {Array} Returns the new sorted array.
	 */
	function baseOrderBy(collection, iteratees, orders) {
	  if (iteratees.length) {
	    iteratees = arrayMap(iteratees, function(iteratee) {
	      if (isArray(iteratee)) {
	        return function(value) {
	          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
	        };
	      }
	      return iteratee;
	    });
	  } else {
	    iteratees = [identity];
	  }
	
	  var index = -1;
	  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));
	
	  var result = baseMap(collection, function(value, key, collection) {
	    var criteria = arrayMap(iteratees, function(iteratee) {
	      return iteratee(value);
	    });
	    return { 'criteria': criteria, 'index': ++index, 'value': value };
	  });
	
	  return baseSortBy(result, function(object, other) {
	    return compareMultiple(object, other, orders);
	  });
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	/**
	 * Compares values to sort them in ascending order.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {number} Returns the sort order indicator for `value`.
	 */
	function compareAscending(value, other) {
	  if (value !== other) {
	    var valIsDefined = value !== undefined,
	        valIsNull = value === null,
	        valIsReflexive = value === value,
	        valIsSymbol = isSymbol(value);
	
	    var othIsDefined = other !== undefined,
	        othIsNull = other === null,
	        othIsReflexive = other === other,
	        othIsSymbol = isSymbol(other);
	
	    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	        (valIsNull && othIsDefined && othIsReflexive) ||
	        (!valIsDefined && othIsReflexive) ||
	        !valIsReflexive) {
	      return 1;
	    }
	    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	        (othIsNull && valIsDefined && valIsReflexive) ||
	        (!othIsDefined && valIsReflexive) ||
	        !othIsReflexive) {
	      return -1;
	    }
	  }
	  return 0;
	}
	
	/**
	 * Used by `_.orderBy` to compare multiple properties of a value to another
	 * and stable sort them.
	 *
	 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	 * specify an order of "desc" for descending or "asc" for ascending sort order
	 * of corresponding values.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {boolean[]|string[]} orders The order to sort by for each property.
	 * @returns {number} Returns the sort order indicator for `object`.
	 */
	function compareMultiple(object, other, orders) {
	  var index = -1,
	      objCriteria = object.criteria,
	      othCriteria = other.criteria,
	      length = objCriteria.length,
	      ordersLength = orders.length;
	
	  while (++index < length) {
	    var result = compareAscending(objCriteria[index], othCriteria[index]);
	    if (result) {
	      if (index >= ordersLength) {
	        return result;
	      }
	      var order = orders[index];
	      return result * (order == 'desc' ? -1 : 1);
	    }
	  }
	  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	  // that causes it, under certain circumstances, to provide the same value for
	  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	  // for more details.
	  //
	  // This also ensures a stable sort in V8 and other engines.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	  return object.index - other.index;
	}
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * This method is like `_.sortBy` except that it allows specifying the sort
	 * orders of the iteratees to sort by. If `orders` is unspecified, all values
	 * are sorted in ascending order. Otherwise, specify an order of "desc" for
	 * descending or "asc" for ascending sort order of corresponding values.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	 *  The iteratees to sort by.
	 * @param {string[]} [orders] The sort orders of `iteratees`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {Array} Returns the new sorted array.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'fred',   'age': 48 },
	 *   { 'user': 'barney', 'age': 34 },
	 *   { 'user': 'fred',   'age': 40 },
	 *   { 'user': 'barney', 'age': 36 }
	 * ];
	 *
	 * // Sort by `user` in ascending order and by `age` in descending order.
	 * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	 */
	function orderBy(collection, iteratees, orders, guard) {
	  if (collection == null) {
	    return [];
	  }
	  if (!isArray(iteratees)) {
	    iteratees = iteratees == null ? [] : [iteratees];
	  }
	  orders = guard ? undefined : orders;
	  if (!isArray(orders)) {
	    orders = orders == null ? [] : [orders];
	  }
	  return baseOrderBy(collection, iteratees, orders);
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = orderBy;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(23)(module)))

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./functionApply')} */
	module.exports = Function.prototype.apply;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(17);
	var $TypeError = __webpack_require__(9);
	
	var $call = __webpack_require__(24);
	var $actualApply = __webpack_require__(92);
	
	/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
	module.exports = function callBindBasic(args) {
		if (args.length < 1 || typeof args[0] !== 'function') {
			throw new $TypeError('a function is required');
		}
		return $actualApply(bind, $call, args);
	};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(25);
	
	var callBindBasic = __webpack_require__(41);
	
	/** @type {(thisArg: string, searchString: string, position?: number) => number} */
	var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);
	
	/** @type {import('.')} */
	module.exports = function callBoundIntrinsic(name, allowMissing) {
		/* eslint no-extra-parens: 0 */
	
		var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
		if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
			return callBindBasic(/** @type {const} */ ([intrinsic]));
		}
		return intrinsic;
	};


/***/ }),
/* 43 */,
/* 44 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	var $defineProperty = Object.defineProperty || false;
	if ($defineProperty) {
		try {
			$defineProperty({}, 'a', { value: 1 });
		} catch (e) {
			// IE 8 has a broken defineProperty
			$defineProperty = false;
		}
	}
	
	module.exports = $defineProperty;


/***/ }),
/* 45 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Object;


/***/ }),
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $Object = __webpack_require__(45);
	
	/** @type {import('./Object.getPrototypeOf')} */
	module.exports = $Object.getPrototypeOf || null;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./Reflect.getPrototypeOf')} */
	module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/** @type {import('.')} */
	var $gOPD = __webpack_require__(114);
	
	if ($gOPD) {
		try {
			$gOPD([], 'length');
		} catch (e) {
			// IE 8 has a broken gOPD
			$gOPD = null;
		}
	}
	
	module.exports = $gOPD;


/***/ }),
/* 50 */,
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var formats = __webpack_require__(26);
	var getSideChannel = __webpack_require__(30);
	var defineProperty = __webpack_require__(44);
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	
	// Track objects created from arrayLimit overflow using side-channel
	// Stores the current max numeric index for O(1) lookup
	var overflowChannel = getSideChannel();
	
	var markOverflow = function markOverflow(obj, maxIndex) {
	    overflowChannel.set(obj, maxIndex);
	    return obj;
	};
	
	var isOverflow = function isOverflow(obj) {
	    return overflowChannel.has(obj);
	};
	
	var getMaxIndex = function getMaxIndex(obj) {
	    return overflowChannel.get(obj);
	};
	
	var setMaxIndex = function setMaxIndex(obj, maxIndex) {
	    overflowChannel.set(obj, maxIndex);
	};
	
	// Track containers produced by a `strictMerge` conflict wrap, and their current max numeric index,
	// so repeated conflicts on one path append instead of nesting a new wrapper each time
	var conflictChannel = getSideChannel();
	
	var markConflict = function markConflict(obj, maxIndex) {
	    conflictChannel.set(obj, maxIndex);
	    return obj;
	};
	
	var isConflict = function isConflict(obj) {
	    return conflictChannel.has(obj);
	};
	
	var getConflictIndex = function getConflictIndex(obj) {
	    return conflictChannel.get(obj);
	};
	
	var hexTable = (function () {
	    var array = [];
	    for (var i = 0; i < 256; ++i) {
	        array[array.length] = '%' + ((i < 16 ? '0' : '') + i.toString(16)).toUpperCase();
	    }
	
	    return array;
	}());
	
	var compactQueue = function compactQueue(queue) {
	    while (queue.length > 1) {
	        var item = queue.pop();
	        var obj = item.obj[item.prop];
	
	        if (isArray(obj)) {
	            var compacted = [];
	
	            for (var j = 0; j < obj.length; ++j) {
	                if (typeof obj[j] !== 'undefined') {
	                    compacted[compacted.length] = obj[j];
	                }
	            }
	
	            item.obj[item.prop] = compacted;
	        }
	    }
	};
	
	var arrayToObject = function arrayToObject(source, options) {
	    var obj = options && options.plainObjects ? { __proto__: null } : {};
	    for (var i = 0; i < source.length; ++i) {
	        if (typeof source[i] !== 'undefined') {
	            obj[i] = source[i];
	        }
	    }
	
	    return obj;
	};
	
	var setProperty = function setProperty(obj, key, value) {
	    if (key === '__proto__' && defineProperty) {
	        defineProperty(obj, key, {
	            configurable: true,
	            enumerable: true,
	            value: value,
	            writable: true
	        });
	    } else {
	        obj[key] = value;
	    }
	};
	
	var maxNumericIndex = function maxNumericIndex(obj, min) {
	    var max = min;
	    var keys = Object.keys(obj);
	    for (var i = 0; i < keys.length; ++i) {
	        var num = parseInt(keys[i], 10);
	        if (String(num) === keys[i] && num > max) {
	            max = num;
	        }
	    }
	
	    return max;
	};
	
	var limitedPair = function limitedPair(first, second, options) {
	    var pair = [first, second];
	    if (options && typeof options.arrayLimit === 'number' && pair.length > options.arrayLimit) {
	        if (options.throwOnLimitExceeded) {
	            throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
	        }
	        return markOverflow(arrayToObject(pair, options), 1);
	    }
	    return pair;
	};
	
	var merge = function merge(target, source, options) {
	    /* eslint no-param-reassign: 0 */
	    if (!source) {
	        return target;
	    }
	
	    if (typeof source !== 'object' && typeof source !== 'function') {
	        if (isArray(target)) {
	            var nextIndex = target.length;
	            if (options && typeof options.arrayLimit === 'number' && nextIndex >= options.arrayLimit) {
	                if (options.throwOnLimitExceeded) {
	                    throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
	                }
	                return markOverflow(arrayToObject(target.concat(source), options), nextIndex);
	            }
	            target[nextIndex] = source;
	        } else if (target && typeof target === 'object') {
	            if (isOverflow(target)) {
	                // Add at next numeric index for overflow objects
	                var newIndex = getMaxIndex(target) + 1;
	                target[newIndex] = source;
	                setMaxIndex(target, newIndex);
	            } else if (options && options.strictMerge && isConflict(target)) {
	                var nextConflict = getConflictIndex(target) + 1;
	                if (
	                    options.throwOnLimitExceeded
	                    && typeof options.arrayLimit === 'number'
	                    && nextConflict >= options.arrayLimit
	                ) {
	                    throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
	                }
	                target[nextConflict] = source;
	                markConflict(target, nextConflict);
	            } else if (options && options.strictMerge) {
	                var conflict = limitedPair(target, source, options);
	                return isArray(conflict) ? markConflict(conflict, 1) : conflict;
	            } else if (
	                (options && (options.plainObjects || options.allowPrototypes))
	                || !has.call(Object.prototype, source)
	            ) {
	                target[source] = true;
	            }
	        } else {
	            return limitedPair(target, source, options);
	        }
	
	        return target;
	    }
	
	    if (!target || typeof target !== 'object') {
	        if (isOverflow(source)) {
	            // Create new object with target at 0, source values shifted by 1
	            var sourceKeys = Object.keys(source);
	            var result = options && options.plainObjects
	                ? { __proto__: null, 0: target }
	                : { 0: target };
	            for (var m = 0; m < sourceKeys.length; m++) {
	                var oldKey = parseInt(sourceKeys[m], 10);
	                result[oldKey + 1] = source[sourceKeys[m]];
	            }
	            return markOverflow(result, getMaxIndex(source) + 1);
	        }
	        var combined = [target].concat(source);
	        if (options && typeof options.arrayLimit === 'number' && combined.length > options.arrayLimit) {
	            if (options.throwOnLimitExceeded) {
	                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
	            }
	            return markOverflow(arrayToObject(combined, options), combined.length - 1);
	        }
	        return combined;
	    }
	
	    var mergeTarget = target;
	    if (isArray(target) && !isArray(source)) {
	        mergeTarget = arrayToObject(target, options);
	        if (isConflict(target)) {
	            // the array may have grown past its last conflict, so continue after its last index
	            markConflict(mergeTarget, target.length - 1);
	        }
	    }
	
	    if (isArray(target) && isArray(source)) {
	        source.forEach(function (item, i) {
	            if (has.call(target, i)) {
	                var targetItem = target[i];
	                if (targetItem && typeof targetItem === 'object' && item && typeof item === 'object') {
	                    target[i] = merge(targetItem, item, options);
	                } else {
	                    target[target.length] = item;
	                }
	            } else {
	                target[i] = item;
	            }
	        });
	        if (options && typeof options.arrayLimit === 'number' && target.length > options.arrayLimit) {
	            if (options.throwOnLimitExceeded) {
	                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
	            }
	            return markOverflow(arrayToObject(target, options), target.length - 1);
	        }
	        return target;
	    }
	
	    return Object.keys(source).reduce(function (acc, key) {
	        var value = source[key];
	
	        if (has.call(acc, key)) {
	            setProperty(acc, key, merge(acc[key], value, options));
	        } else {
	            setProperty(acc, key, value);
	        }
	
	        if (isOverflow(source) && !isOverflow(acc)) {
	            markOverflow(acc, maxNumericIndex(acc, getMaxIndex(source)));
	        }
	        if (isOverflow(acc)) {
	            var keyNum = parseInt(key, 10);
	            if (String(keyNum) === key && keyNum >= 0 && keyNum > getMaxIndex(acc)) {
	                setMaxIndex(acc, keyNum);
	            }
	        }
	        if (isConflict(acc)) {
	            var conflictKey = parseInt(key, 10);
	            if (String(conflictKey) === key && conflictKey > getConflictIndex(acc)) {
	                markConflict(acc, conflictKey);
	            }
	        }
	
	        return acc;
	    }, mergeTarget);
	};
	
	var assign = function assignSingleSource(target, source) {
	    return Object.keys(source).reduce(function (acc, key) {
	        setProperty(acc, key, source[key]);
	        return acc;
	    }, target);
	};
	
	var decode = function (str, defaultDecoder, charset) {
	    // With no `%` there is no escape to expand, in either charset: `unescape` has
	    // nothing to match, and `decodeURIComponent` is the identity on such a string
	    // (and cannot throw). So only `+` -> ' ' remains, and often not even that.
	    if (typeof str === 'string' && str.indexOf('%') === -1) {
	        return str.indexOf('+') === -1 ? str : str.replace(/\+/g, ' ');
	    }
	
	    var strWithoutPlus = str.replace(/\+/g, ' ');
	    if (charset === 'iso-8859-1') {
	        // unescape never throws, no try...catch needed:
	        return strWithoutPlus.replace(/%[0-9a-f]{2}/gi, unescape);
	    }
	    // utf-8
	    try {
	        return decodeURIComponent(strWithoutPlus);
	    } catch (e) {
	        return strWithoutPlus;
	    }
	};
	
	var hasToPrimitive = typeof Symbol === 'function' && typeof Symbol.toPrimitive === 'symbol';
	var arrayJoin = Array.prototype.join;
	var arrayToString = Array.prototype.toString;
	var objectToString = Object.prototype.toString;
	
	// an object with no callable toString (eg, from JSON, or null-prototype) would make String() or join() throw,
	// so it becomes its primitive valueOf or else Object.prototype.toString; arrays are walked like join walks them,
	// copied only once an element changes, with an array already being joined becoming '' as engines do for cycles
	var toCoercible = function toCoercible(value, joining) {
	    if (!value || (typeof value !== 'object' && typeof value !== 'function')) {
	        return value;
	    }
	    if (hasToPrimitive && value[Symbol.toPrimitive] != null) {
	        return value;
	    }
	    if (isArray(value) && value.toString === arrayToString && value.join === arrayJoin) {
	        var ancestors = joining || getSideChannel();
	        if (ancestors.has(value)) {
	            return '';
	        }
	        ancestors.set(value, true);
	        var copy;
	        for (var i = 0; i < value.length; i += 1) {
	            var item = value[i];
	            var coerced = toCoercible(item, ancestors);
	            if (!copy && coerced !== item) {
	                copy = [];
	                for (var j = 0; j < i; j += 1) {
	                    copy[j] = value[j];
	                }
	            }
	            if (copy) {
	                copy[i] = coerced;
	            }
	        }
	        ancestors['delete'](value);
	        return copy || value;
	    }
	    if (typeof value.toString === 'function') {
	        return value;
	    }
	    var valueOf = value.valueOf;
	    if (typeof valueOf === 'function') {
	        var primitive = valueOf.call(value);
	        if (!primitive || (typeof primitive !== 'object' && typeof primitive !== 'function')) {
	            return String(primitive);
	        }
	    }
	    return objectToString.call(value);
	};
	
	var limit = 1024;
	
	/* eslint operator-linebreak: [2, "before"] */
	
	var encode = function encode(str, defaultEncoder, charset, kind, format) {
	    // This code was originally written by Brian White (mscdex) for the io.js core querystring library.
	    // It has been adapted here for stricter adherence to RFC 3986
	    if (str.length === 0) {
	        return str;
	    }
	
	    var string = str;
	    if (typeof str === 'symbol') {
	        string = Symbol.prototype.toString.call(str);
	    } else if (typeof str !== 'string') {
	        string = String(toCoercible(str));
	    }
	
	    if (charset === 'iso-8859-1') {
	        // `escape` leaves `+` untouched, but a literal `+` is decoded back to a space,
	        // so it must be percent-encoded to round-trip (the utf-8 path already does this).
	        return escape(string).replace(/%u[0-9a-f]{4}/gi, function ($0) {
	            return '%26%23' + parseInt($0.slice(2), 16) + '%3B';
	        }).replace(/\+/g, '%2B');
	    }
	
	    var out = '';
	    for (var j = 0; j < string.length; j += limit) {
	        var segment = string.length >= limit ? string.slice(j, j + limit) : string;
	        if (j + limit < string.length) {
	            var last = segment.charCodeAt(segment.length - 1);
	            if (last >= 0xD800 && last <= 0xDBFF) {
	                segment = segment.slice(0, -1);
	                j -= 1;
	            }
	        }
	        var arr = [];
	
	        for (var i = 0; i < segment.length; ++i) {
	            var c = segment.charCodeAt(i);
	            if (
	                c === 0x2D // -
	                || c === 0x2E // .
	                || c === 0x5F // _
	                || c === 0x7E // ~
	                || (c >= 0x30 && c <= 0x39) // 0-9
	                || (c >= 0x41 && c <= 0x5A) // a-z
	                || (c >= 0x61 && c <= 0x7A) // A-Z
	                || (format === formats.RFC1738 && (c === 0x28 || c === 0x29)) // ( )
	            ) {
	                arr[arr.length] = segment.charAt(i);
	                continue;
	            }
	
	            if (c < 0x80) {
	                arr[arr.length] = hexTable[c];
	                continue;
	            }
	
	            if (c < 0x800) {
	                arr[arr.length] = hexTable[0xC0 | (c >> 6)]
	                    + hexTable[0x80 | (c & 0x3F)];
	                continue;
	            }
	
	            if (c < 0xD800 || c >= 0xE000) {
	                arr[arr.length] = hexTable[0xE0 | (c >> 12)]
	                    + hexTable[0x80 | ((c >> 6) & 0x3F)]
	                    + hexTable[0x80 | (c & 0x3F)];
	                continue;
	            }
	
	            i += 1;
	            c = 0x10000 + (((c & 0x3FF) << 10) | (segment.charCodeAt(i) & 0x3FF));
	
	            arr[arr.length] = hexTable[0xF0 | (c >> 18)]
	                + hexTable[0x80 | ((c >> 12) & 0x3F)]
	                + hexTable[0x80 | ((c >> 6) & 0x3F)]
	                + hexTable[0x80 | (c & 0x3F)];
	        }
	
	        out += arr.join('');
	    }
	
	    return out;
	};
	
	var compact = function compact(value) {
	    var queue = [{ obj: { o: value }, prop: 'o' }];
	    var refs = getSideChannel();
	
	    for (var i = 0; i < queue.length; ++i) {
	        var item = queue[i];
	        var obj = item.obj[item.prop];
	
	        var keys = Object.keys(obj);
	        for (var j = 0; j < keys.length; ++j) {
	            var key = keys[j];
	            var val = obj[key];
	            if (typeof val === 'object' && val !== null && !refs.has(val)) {
	                queue[queue.length] = { obj: obj, prop: key };
	                refs.set(val, true);
	            }
	        }
	    }
	
	    compactQueue(queue);
	
	    return value;
	};
	
	var isRegExp = function isRegExp(obj) {
	    return Object.prototype.toString.call(obj) === '[object RegExp]';
	};
	
	var isBuffer = function isBuffer(obj) {
	    if (!obj || typeof obj !== 'object') {
	        return false;
	    }
	
	    return !!(obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj));
	};
	
	var combine = function combine(a, b, arrayLimit, plainObjects, throwOnLimitExceeded) {
	    // If 'a' is already an overflow object, add to it
	    if (isOverflow(a)) {
	        if (throwOnLimitExceeded) {
	            throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
	        }
	        // spread `b` one level, matching the `[].concat(a, b)` used below, so a
	        // collection appended to an already-overflowed object is flattened
	        // rather than nested under a single index
	        var bValues = isArray(b) ? b : [b];
	        var newIndex = getMaxIndex(a);
	        for (var i = 0; i < bValues.length; ++i) {
	            newIndex += 1;
	            a[newIndex] = bValues[i];
	        }
	        setMaxIndex(a, newIndex);
	        return a;
	    }
	
	    var result = [].concat(a, b);
	    if (result.length > arrayLimit) {
	        if (throwOnLimitExceeded) {
	            throw new RangeError('Array limit exceeded. Only ' + arrayLimit + ' element' + (arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
	        }
	        return markOverflow(arrayToObject(result, { plainObjects: plainObjects }), result.length - 1);
	    }
	    return result;
	};
	
	var maybeMap = function maybeMap(val, fn) {
	    if (isArray(val)) {
	        var mapped = [];
	        for (var i = 0; i < val.length; i += 1) {
	            mapped[mapped.length] = fn(val[i]);
	        }
	        return mapped;
	    }
	    return fn(val);
	};
	
	module.exports = {
	    arrayToObject: arrayToObject,
	    assign: assign,
	    combine: combine,
	    compact: compact,
	    decode: decode,
	    encode: encode,
	    isBuffer: isBuffer,
	    isOverflow: isOverflow,
	    isRegExp: isRegExp,
	    markOverflow: markOverflow,
	    maybeMap: maybeMap,
	    merge: merge,
	    toCoercible: toCoercible
	};


/***/ }),
/* 52 */,
/* 53 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _reactDom = __webpack_require__(27);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _Portal = __webpack_require__(141);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _LegacyPortal = __webpack_require__(140);
	
	var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Portal = void 0;
	
	if (_reactDom2.default.createPortal) {
	  Portal = _Portal2.default;
	} else {
	  Portal = _LegacyPortal2.default;
	}
	
	exports.default = Portal;

/***/ }),
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(25);
	var callBound = __webpack_require__(42);
	var inspect = __webpack_require__(18);
	
	var $TypeError = __webpack_require__(9);
	var $Map = GetIntrinsic('%Map%', true);
	
	/** @type {<K, V>(thisArg: Map<K, V>, key: K) => V} */
	var $mapGet = callBound('Map.prototype.get', true);
	/** @type {<K, V>(thisArg: Map<K, V>, key: K, value: V) => void} */
	var $mapSet = callBound('Map.prototype.set', true);
	/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
	var $mapHas = callBound('Map.prototype.has', true);
	/** @type {<K, V>(thisArg: Map<K, V>, key: K) => boolean} */
	var $mapDelete = callBound('Map.prototype.delete', true);
	/** @type {<K, V>(thisArg: Map<K, V>) => number} */
	var $mapSize = callBound('Map.prototype.size', true);
	
	/** @type {import('.')} */
	module.exports = !!$Map && /** @type {Exclude<import('.'), false>} */ function getSideChannelMap() {
		/** @typedef {ReturnType<typeof getSideChannelMap>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */
	
		/** @type {Map<K, V> | undefined} */ var $m;
	
		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				if ($m) {
					var result = $mapDelete($m, key);
					if ($mapSize($m) === 0) {
						$m = void undefined;
					}
					return result;
				}
				return false;
			},
			get: function (key) { // eslint-disable-line consistent-return
				if ($m) {
					return $mapGet($m, key);
				}
			},
			has: function (key) {
				if ($m) {
					return $mapHas($m, key);
				}
				return false;
			},
			set: function (key, value) {
				if (!$m) {
					// @ts-expect-error TS can't handle narrowing a variable inside a closure
					$m = new $Map();
				}
				$mapSet($m, key, value);
			}
		};
	
		// @ts-expect-error TODO: figure out why TS is erroring here
		return channel;
	};


/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Footer":"src-components-footer----footer-module---Footer---1OMO6","Footer__inner":"src-components-footer----footer-module---Footer__inner---LlTEN","Footer__top":"src-components-footer----footer-module---Footer__top---2r3fL","Footer__logo":"src-components-footer----footer-module---Footer__logo---pAA3n","Footer__logoImg":"src-components-footer----footer-module---Footer__logoImg---33eLh","Footer__nav":"src-components-footer----footer-module---Footer__nav---32RWm","NavHeading":"src-components-footer----footer-module---NavHeading---3eYS_","Footer__navItem":"src-components-footer----footer-module---Footer__navItem---1Sr5V","Footer__link":"src-components-footer----footer-module---Footer__link---3a_WF","Footer__bottom":"src-components-footer----footer-module---Footer__bottom---3ipiG","Footer__copyright":"src-components-footer----footer-module---Footer__copyright---1JSWq","Footer__legal":"src-components-footer----footer-module---Footer__legal---3tsVL","Footer__socialLinks":"src-components-footer----footer-module---Footer__socialLinks---1Cv1O","Footer__socialLink":"src-components-footer----footer-module---Footer__socialLink---19y5R","spinAround":"src-components-footer----footer-module---spinAround---GBGKY"};

/***/ }),
/* 65 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object ? baseValues(object, keys(object)) : [];
	}
	
	module.exports = values;


/***/ }),
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.searchArticles = searchArticles;
	exports.searchTypeahead = searchTypeahead;
	
	var _querystring = __webpack_require__(132);
	
	var _lodash = __webpack_require__(22);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _url = __webpack_require__(160);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function searchArticles(query) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  var url = '/.netlify/functions/search';
	  var querystring = (0, _querystring.stringify)(_extends({}, params, { query: query }));
	  return fetch(url + '?' + querystring).then(function (response) {
	    return response.json();
	  }).then(function (json) {
	    return json.articles;
	  });
	}
	
	var localizeResult = function localizeResult(result) {
	  return (0, _lodash2.default)(result, 'url', (0, _url.parse)(result.url).path);
	};
	
	var localizeResults = function localizeResults(results) {
	  return results.map(localizeResult);
	};
	
	function searchTypeahead(query) {
	  var url = ("https://teamgantt.helpscoutdocs.com/search/typeahead");
	  var term = encodeURIComponent(query);
	  return fetch(url + '?query=' + term).then(function (response) {
	    return response.json();
	  }).then(function (json) {
	    return json.articles;
	  }).then(function (articles) {
	    return articles.results;
	  }).then(localizeResults);
	}

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// TeamGantt wordmark, drawn in currentColor so it can follow token colors
	var Logo = function Logo(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    'svg',
	    {
	      'aria-label': 'TeamGantt',
	      className: className,
	      fill: 'currentColor',
	      role: 'img',
	      viewBox: '0 0 127.727 20'
	    },
	    _react2.default.createElement('rect', { height: '3.7', rx: '0.2', width: '20', x: '0', y: '0' }),
	    _react2.default.createElement('rect', { height: '3.7', rx: '0.2', width: '15', x: '5', y: '5.7' }),
	    _react2.default.createElement('rect', { height: '3.7', rx: '0.2', width: '10', x: '10', y: '11.4' }),
	    _react2.default.createElement(
	      'g',
	      { transform: 'translate(24 0)' },
	      _react2.default.createElement('path', { d: 'M1.20377 12.2374V6.04699H0.170084C0.0762511 6.04699 0 5.97075 0 5.8765V3.49088C0 3.39664 0.0762511 3.32021 0.170084 3.32021H1.20377V0.248251C1.20377 0.154006 1.28002 0.0775758 1.37386 0.0775758H4.17049C4.26452 0.0775758 4.34077 0.154006 4.34077 0.248251V3.32021H6.47064C6.56447 3.32021 6.64072 3.39664 6.64072 3.49088V5.8765C6.64072 5.97075 6.56447 6.04699 6.47064 6.04699H4.34077V8.89866C4.34784 11.5751 4.14087 12.6568 5.264 12.7728C5.77979 12.8261 6.03606 12.6964 6.56237 12.4899C6.64454 12.4577 6.73895 12.4815 6.78309 12.5581L7.86227 14.43C7.90527 14.5045 7.8894 14.6016 7.81965 14.6518C7.11046 15.1636 5.78858 15.4801 4.5613 15.4801C2.38022 15.4801 1.20377 14.3501 1.20377 12.2374' }),
	      _react2.default.createElement('path', { d: 'M13.5347 5.50648C11.5986 5.50648 10.7654 6.95597 10.6182 8.13499H16.4512C16.3778 7.00501 15.5935 5.50648 13.5347 5.50648ZM7.40788 9.24045C7.40788 5.80128 9.932 3.02547 13.5347 3.02547C17.0639 3.02547 19.4657 5.67849 19.4657 9.55977V10.0772C19.4657 10.1712 19.3894 10.2476 19.2954 10.2476H10.6674C10.8634 11.746 12.0644 12.9989 14.0738 12.9989C15.0185 12.9989 16.3096 12.6082 17.0921 11.9492C17.1707 11.8829 17.2867 11.895 17.3444 11.9799L18.5214 13.7075C18.5705 13.7795 18.5598 13.8787 18.4937 13.9354C17.3133 14.9503 15.5106 15.4801 13.7308 15.4801C10.1283 15.4801 7.40788 13.048 7.40788 9.24045Z' }),
	      _react2.default.createElement('path', { d: 'M27.805 12.2736V10.9239C27.805 10.8839 27.7922 10.844 27.7672 10.8128C27.2433 10.1575 26.2859 9.83014 25.3053 9.83014C24.08 9.83014 23.0751 10.4688 23.0751 11.6233C23.0751 12.7287 24.08 13.3674 25.3053 13.3674C26.2859 13.3674 27.2433 13.0398 27.767 12.3847C27.792 12.3535 27.805 12.3138 27.805 12.2736ZM27.805 15.0147V13.957C26.9964 14.9149 25.5993 15.48 24.0555 15.48C22.1684 15.48 19.9382 14.2025 19.9382 11.5497C19.9382 8.77371 22.1684 7.71748 24.0555 7.71748C25.6239 7.71748 27.0207 8.23314 27.805 9.16678V7.56998C27.805 6.36644 26.7757 5.5803 25.2073 5.5803C23.9984 5.5803 22.8779 6.00019 21.9083 6.83996C21.8267 6.91065 21.7019 6.89188 21.6489 6.79782L20.6452 5.01656C20.6047 4.94473 20.6204 4.8524 20.6833 4.79914C22.1133 3.58622 23.9298 3.02535 25.7464 3.02535C28.4423 3.02535 30.9174 4.10629 30.9174 7.52094V15.0147C30.9174 15.1088 30.8413 15.1852 30.7473 15.1852H27.9753C27.8813 15.1852 27.805 15.1088 27.805 15.0147Z' }),
	      _react2.default.createElement('path', { d: 'M47.1005 15.1852C47.0065 15.1852 46.9302 15.1088 46.9302 15.0147V7.69276C46.9302 6.5875 46.44 5.80136 45.1657 5.80136C44.0887 5.80136 43.1987 6.50417 42.7469 7.13189C42.7255 7.16158 42.715 7.19683 42.715 7.23342V15.0147C42.715 15.1088 42.6389 15.1852 42.5449 15.1852H39.7483C39.6543 15.1852 39.5782 15.1088 39.5782 15.0147V7.69276C39.5782 6.5875 39.0878 5.80136 37.8135 5.80136C36.7594 5.80136 35.8696 6.50513 35.3951 7.15622C35.3733 7.1861 35.3626 7.22154 35.3626 7.2587V15.0147C35.3626 15.1088 35.2863 15.1852 35.1923 15.1852H32.4203C32.3263 15.1852 32.2503 15.1088 32.2503 15.0147V3.49083C32.2503 3.39658 32.3263 3.32034 32.4203 3.32034H35.1923C35.2863 3.32034 35.3626 3.39658 35.3626 3.49083V4.86791C35.8528 4.15552 37.4214 3.02535 39.2348 3.02535C40.9748 3.02535 42.0779 3.83601 42.5189 5.18723C43.205 4.10648 44.7734 3.02535 46.5874 3.02535C48.7683 3.02535 50.0672 4.18004 50.0672 6.61182V15.0147C50.0672 15.1088 49.9911 15.1852 49.8971 15.1852H47.1005Z' }),
	      _react2.default.createElement('path', { d: 'M60.272 10.928V7.20781C60.272 7.1718 60.2619 7.13655 60.2414 7.10686C59.7138 6.34466 58.6101 5.80142 57.6007 5.80142C55.8361 5.80142 54.6109 7.02947 54.6109 9.06838C54.6109 11.1073 55.8361 12.3357 57.6007 12.3357C58.6092 12.3357 59.7119 11.7697 60.2401 11.0305C60.2615 11.0006 60.272 10.9648 60.272 10.928ZM51.9933 18.1048L53.1971 16.1574C53.2554 16.063 53.3847 16.0519 53.4631 16.1306C54.3978 17.0698 55.5952 17.4452 57.0127 17.4452C58.5073 17.4452 60.272 16.7819 60.272 14.4484V13.2446C59.3407 14.4237 58.0662 15.1115 56.6205 15.1115C53.655 15.1115 51.4001 13.0236 51.4001 9.06837C51.4001 5.1871 53.6305 3.02541 56.6205 3.02541C58.0422 3.02541 59.3164 3.63972 60.272 4.84345V3.49088C60.272 3.39664 60.3482 3.32021 60.4423 3.32021H63.2387C63.3327 3.32021 63.409 3.39664 63.409 3.49088V14.3746C63.409 18.8945 59.9289 20 57.0127 20C55.0303 20 53.49 19.5567 52.0292 18.3291C51.9641 18.2743 51.9484 18.1772 51.9933 18.1048Z' }),
	      _react2.default.createElement('path', { d: 'M72.2412 12.2736V10.9239C72.2412 10.8839 72.2282 10.844 72.2034 10.8128C71.6795 10.1575 70.7219 9.83013 69.7414 9.83013C68.5162 9.83013 67.5112 10.4688 67.5112 11.6233C67.5112 12.7287 68.5162 13.3674 69.7414 13.3674C70.7219 13.3674 71.6795 13.0398 72.2032 12.3847C72.2282 12.3535 72.2412 12.3138 72.2412 12.2736ZM72.2412 15.0147V13.957C71.4327 14.9149 70.0355 15.48 68.4917 15.48C66.6044 15.48 64.3742 14.2025 64.3742 11.5497C64.3742 8.77371 66.6044 7.71747 68.4917 7.71747C70.0601 7.71747 71.4571 8.23314 72.2412 9.16678V7.56998C72.2412 6.36644 71.2119 5.5803 69.6433 5.5803C68.4346 5.5803 67.3141 6.00019 66.3445 6.83996C66.2629 6.91065 66.1381 6.89188 66.0852 6.79782L65.0815 5.01656C65.0411 4.94473 65.0568 4.8524 65.1195 4.79914C66.5495 3.58622 68.3662 3.02554 70.1828 3.02554C72.8784 3.02554 75.354 4.10629 75.354 7.52094V15.0147C75.354 15.1088 75.2777 15.1852 75.1837 15.1852H72.4113C72.3175 15.1852 72.2412 15.1088 72.2412 15.0147Z' }),
	      _react2.default.createElement('path', { d: 'M84.8985 15.1852C84.8045 15.1852 84.7282 15.1088 84.7282 15.0147V8.01209C84.7282 6.36644 83.8705 5.80136 82.5469 5.80136C81.3483 5.80136 80.4075 6.45954 79.8854 7.15526C79.8627 7.18553 79.8514 7.22231 79.8514 7.26023V15.0147C79.8514 15.1088 79.7751 15.1852 79.6811 15.1852H76.9088C76.8147 15.1852 76.7387 15.1088 76.7387 15.0147V3.49083C76.7387 3.39658 76.8147 3.32034 76.9088 3.32034H79.6811C79.7751 3.32034 79.8514 3.39658 79.8514 3.49083V4.86791C80.6108 3.95899 82.0569 3.02535 83.993 3.02535C86.5905 3.02535 87.8407 4.49936 87.8407 6.80836V15.0147C87.8407 15.1088 87.7645 15.1852 87.6705 15.1852H84.8985Z' }),
	      _react2.default.createElement('path', { d: 'M89.6513 12.1599V5.96941H88.6234C88.5294 5.96941 88.4531 5.89317 88.4531 5.79893V3.41331C88.4531 3.31906 88.5294 3.24263 88.6234 3.24263H89.6513V0.170675C89.6513 0.0764302 89.7276 0 89.8216 0H92.6181C92.7121 0 92.7883 0.0764302 92.7883 0.170675V3.24263H94.9182C95.012 3.24263 95.0883 3.31906 95.0883 3.41331V5.79893C95.0883 5.89317 95.012 5.96941 94.9182 5.96941H92.7883V8.87261C92.8011 11.4595 92.5884 12.5792 93.7116 12.6953C94.2274 12.7485 94.4836 12.6188 95.0099 12.4123C95.0921 12.3802 95.1865 12.4039 95.2307 12.4805L96.3098 14.3524C96.3528 14.4269 96.337 14.524 96.2672 14.5742C95.558 15.0861 94.2362 15.4025 93.0089 15.4025C90.8278 15.4025 89.6513 14.2725 89.6513 12.1599' }),
	      _react2.default.createElement('path', { d: 'M97.0451 12.1599V5.96941H96.0155C95.9214 5.96941 95.8452 5.89317 95.8452 5.79893V3.41331C95.8452 3.31906 95.9214 3.24263 96.0155 3.24263H97.0451V0.170675C97.0451 0.0764302 97.1214 0 97.2154 0H100.012C100.106 0 100.182 0.0764302 100.182 0.170675V3.24263H102.312C102.406 3.24263 102.482 3.31906 102.482 3.41331V5.79893C102.482 5.89317 102.406 5.96941 102.312 5.96941H100.182V8.87261C100.195 11.4595 99.9822 12.5792 101.105 12.6953C101.621 12.7485 101.877 12.6188 102.404 12.4123C102.486 12.3802 102.58 12.4039 102.624 12.4805L103.704 14.3524C103.747 14.4269 103.731 14.524 103.661 14.5742C102.952 15.0861 101.63 15.4025 100.403 15.4025C98.2216 15.4025 97.0451 14.2725 97.0451 12.1599' })
	    )
	  );
	};
	
	Logo.propTypes = {
	  className: _propTypes2.default.string
	};
	
	exports.default = Logo;
	module.exports = exports['default'];

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _formModule = __webpack_require__(107);
	
	var _formModule2 = _interopRequireDefault(_formModule);
	
	var _PhosphorIcon = __webpack_require__(31);
	
	var _PhosphorIcon2 = _interopRequireDefault(_PhosphorIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	//import PropTypes from 'prop-types';
	
	var encode = function encode(data) {
	  return Object.keys(data).map(function (key) {
	    return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
	  }).join('&');
	};
	
	var Form = function (_Component) {
	  _inherits(Form, _Component);
	
	  function Form() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Form);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      name: '',
	      email: '',
	      field: '',
	      success: false
	    }, _this.handleSubmit = function (e) {
	      e.preventDefault();
	
	      var submission = {
	        name: _this.state.name,
	        email: _this.state.email,
	        field: _this.state.message
	      };
	
	      fetch('https://formbucket.com/f/buk_sdzUuOoRYgVMGDC8IhqLXPa3', {
	        method: 'POST',
	        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
	        body: encode(_extends({ 'form-name': 'contact' }, submission))
	      }).then(function () {
	        return _this.setState({ success: true });
	      });
	    }, _this.update = function (e) {
	      var _this$setState;
	
	      return _this.setState((_this$setState = {}, _this$setState[e.target.name] = e.target.value, _this$setState));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Form.prototype.renderFields = function renderFields() {
	    var _state = this.state,
	        name = _state.name,
	        email = _state.email,
	        message = _state.message,
	        success = _state.success;
	
	
	    if (success) {
	      return null;
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'field' },
	        _react2.default.createElement(
	          'label',
	          { className: (0, _classnames2.default)('label', _formModule2.default.Form__label) },
	          'Your Name'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'control' },
	          _react2.default.createElement('input', {
	            className: 'input',
	            name: 'name',
	            onChange: this.update,
	            required: true,
	            type: 'text',
	            value: name
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'field' },
	        _react2.default.createElement(
	          'label',
	          { className: (0, _classnames2.default)('label', _formModule2.default.Form__label) },
	          'Email'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'control' },
	          _react2.default.createElement('input', {
	            className: 'input',
	            name: 'email',
	            onChange: this.update,
	            required: true,
	            type: 'email',
	            value: email
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'field' },
	        _react2.default.createElement(
	          'label',
	          { className: (0, _classnames2.default)('label', _formModule2.default.Form__label) },
	          'Message'
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'control' },
	          _react2.default.createElement('textarea', {
	            className: 'textarea',
	            name: 'message',
	            onChange: this.update,
	            required: true,
	            rows: 2,
	            value: message
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'button',
	        { className: _formModule2.default.Form__button, type: 'submit' },
	        'Send Your Message'
	      )
	    );
	  };
	
	  Form.prototype.renderText = function renderText() {
	    var success = this.state.success;
	
	    var className = _formModule2.default.Form__heading__text;
	
	    if (!success) {
	      return _react2.default.createElement(
	        'p',
	        { className: className },
	        'We would love to hear from you!',
	        _react2.default.createElement('br', null),
	        'Send us your questions or feedback.'
	      );
	    }
	
	    return _react2.default.createElement(
	      'p',
	      { className: className },
	      'Thanks! We got your message.',
	      _react2.default.createElement('br', null),
	      'We\'ll be in touch soon.'
	    );
	  };
	
	  Form.prototype.render = function render() {
	    var _classNames;
	
	    var success = this.state.success;
	
	
	    return _react2.default.createElement(
	      'form',
	      {
	        className: (0, _classnames2.default)(_formModule2.default.Form, (_classNames = {}, _classNames[_formModule2.default['Form--success']] = success, _classNames)),
	        'data-netlify': 'true',
	        onSubmit: this.handleSubmit
	      },
	      _react2.default.createElement(
	        'div',
	        { className: _formModule2.default.Form__heading },
	        _react2.default.createElement(
	          'span',
	          { className: _formModule2.default.Form__icon },
	          _react2.default.createElement(_PhosphorIcon2.default, {
	            name: success ? 'envelopeSimpleOpen' : 'chatCircleText',
	            size: 24
	          })
	        ),
	        this.renderText()
	      ),
	      this.renderFields()
	    );
	  };
	
	  return Form;
	}(_react.Component);
	
	exports.default = Form;
	module.exports = exports['default'];

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _methodsModule = __webpack_require__(108);
	
	var _methodsModule2 = _interopRequireDefault(_methodsModule);
	
	var _PhosphorIcon = __webpack_require__(31);
	
	var _PhosphorIcon2 = _interopRequireDefault(_PhosphorIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Methods = function Methods(_ref) {
	  var showForm = _ref.showForm;
	  return _react2.default.createElement(
	    'ul',
	    { className: _methodsModule2.default.Methods },
	    _react2.default.createElement(
	      'li',
	      { className: _methodsModule2.default.Methods__method },
	      _react2.default.createElement(
	        'a',
	        {
	          href: 'https://app.teamgantt.com/book-a-demo?ref=helpdocs',
	          target: '_blank'
	        },
	        _react2.default.createElement(
	          'div',
	          { className: _methodsModule2.default.Methods__icon },
	          _react2.default.createElement(_PhosphorIcon2.default, { name: 'calendarCheck', size: 22 })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _methodsModule2.default.Methods__text },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Schedule live help'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'Book a call with one of our friendly experts.'
	          )
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'li',
	      { className: _methodsModule2.default.Methods__method },
	      _react2.default.createElement(
	        'a',
	        { href: '#', onClick: showForm },
	        _react2.default.createElement(
	          'div',
	          { className: _methodsModule2.default.Methods__icon },
	          _react2.default.createElement(_PhosphorIcon2.default, { name: 'chatCircleText', size: 22 })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _methodsModule2.default.Methods__text },
	          _react2.default.createElement(
	            'h4',
	            null,
	            'Send us a message'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'We love your feedback and hearing what you have to say!'
	          )
	        )
	      )
	    )
	  );
	};
	
	Methods.propTypes = {
	  showForm: _propTypes2.default.func.isRequired
	};
	
	exports.default = Methods;
	module.exports = exports['default'];

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Methods = __webpack_require__(86);
	
	var _Methods2 = _interopRequireDefault(_Methods);
	
	var _Form = __webpack_require__(85);
	
	var _Form2 = _interopRequireDefault(_Form);
	
	var _modalModule = __webpack_require__(109);
	
	var _modalModule2 = _interopRequireDefault(_modalModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modal = function (_Component) {
	  _inherits(Modal, _Component);
	
	  function Modal() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Modal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isFormShowing: false
	    }, _this.showForm = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      _this.setState({ isFormShowing: true });
	    }, _this.stopPropagation = function (e) {
	      e.stopPropagation();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  // Keeps clicks inside the dialog from closing it via the backdrop
	
	
	  Modal.prototype.render = function render() {
	    var close = this.props.close;
	    var isFormShowing = this.state.isFormShowing;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: _modalModule2.default.Modal, onClick: close, role: 'presentation' },
	      _react2.default.createElement(
	        'div',
	        {
	          'aria-label': 'Contact TeamGantt support',
	          'aria-modal': 'true',
	          className: _modalModule2.default.Modal__body,
	          onClick: this.stopPropagation,
	          role: 'dialog'
	        },
	        _react2.default.createElement(
	          'button',
	          {
	            'aria-label': 'Close',
	            className: _modalModule2.default.Modal__close,
	            onClick: close,
	            type: 'button'
	          },
	          '\xD7'
	        ),
	        !isFormShowing ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: _modalModule2.default.Modal__heading },
	            _react2.default.createElement(
	              'p',
	              { className: _modalModule2.default.Modal__eyebrow },
	              'Contact us'
	            ),
	            _react2.default.createElement(
	              'h3',
	              { className: _modalModule2.default.Modal__title },
	              'How can we assist you?'
	            ),
	            _react2.default.createElement(
	              'p',
	              { className: _modalModule2.default.Modal__summary },
	              'We\u2019re real people who are always happy to help.'
	            )
	          ),
	          _react2.default.createElement(_Methods2.default, { showForm: this.showForm })
	        ) : _react2.default.createElement(_Form2.default, null)
	      )
	    );
	  };
	
	  return Modal;
	}(_react.Component);
	
	Modal.propTypes = {
	  close: _propTypes2.default.func.isRequired
	};
	
	exports.default = Modal;
	module.exports = exports['default'];

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactPortal = __webpack_require__(143);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Button = __webpack_require__(21);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Modal = __webpack_require__(87);
	
	var _Modal2 = _interopRequireDefault(_Modal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContactLink = function ContactLink(_ref) {
	  var size = _ref.size,
	      variant = _ref.variant;
	  return _react2.default.createElement(
	    _reactPortal.PortalWithState,
	    { closeOnEsc: true },
	    function (_ref2) {
	      var openPortal = _ref2.openPortal,
	          portal = _ref2.portal,
	          closePortal = _ref2.closePortal;
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _Button2.default,
	          { onClick: openPortal, size: size, variant: variant },
	          'Contact us'
	        ),
	        portal(_react2.default.createElement(_Modal2.default, { close: closePortal }))
	      );
	    }
	  );
	};
	
	ContactLink.propTypes = {
	  size: _propTypes2.default.oneOf(['small', 'medium']),
	  variant: _propTypes2.default.oneOf(['primary', 'secondary', 'inverse', 'inverseOutline'])
	};
	
	ContactLink.defaultProps = {
	  size: 'small',
	  variant: 'primary'
	};
	
	exports.default = ContactLink;
	module.exports = exports['default'];

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _search = __webpack_require__(67);
	
	var _SearchIcon = __webpack_require__(90);
	
	var _SearchIcon2 = _interopRequireDefault(_SearchIcon);
	
	var _inputModule = __webpack_require__(110);
	
	var _inputModule2 = _interopRequireDefault(_inputModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Input = function (_Component) {
	  _inherits(Input, _Component);
	
	  function Input() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Input);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      typeaheadResults: [],
	      query: ''
	    }, _this.onChange = function (e) {
	      var children = _this.props.children;
	
	      if (!children) {
	        return;
	      }
	      var query = e.target.value;
	
	      (0, _search.searchTypeahead)(query).then(function (typeaheadResults) {
	        return _this.setState({ typeaheadResults: typeaheadResults, query: query });
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Input.prototype.render = function render() {
	    var _props = this.props,
	        defaultValue = _props.defaultValue,
	        size = _props.size,
	        placeholder = _props.placeholder,
	        children = _props.children;
	    var _state = this.state,
	        typeaheadResults = _state.typeaheadResults,
	        query = _state.query;
	
	
	    return _react2.default.createElement(
	      'form',
	      {
	        action: '/search',
	        className: _inputModule2.default.Input + ' ' + _inputModule2.default['Input--' + size],
	        method: 'GET',
	        role: 'search'
	      },
	      _react2.default.createElement(
	        'label',
	        { className: _inputModule2.default.Input__field },
	        _react2.default.createElement(_SearchIcon2.default, { className: _inputModule2.default.Input__icon }),
	        _react2.default.createElement('input', {
	          'aria-label': 'Search help articles',
	          autoComplete: 'off',
	          className: _inputModule2.default.Input__control,
	          defaultValue: defaultValue,
	          name: 'query',
	          onChange: this.onChange,
	          placeholder: placeholder,
	          type: 'search'
	        })
	      ),
	      children && children({ query: query, typeaheadResults: typeaheadResults })
	    );
	  };
	
	  return Input;
	}(_react.Component);
	
	Input.propTypes = {
	  children: _propTypes2.default.func,
	  defaultValue: _propTypes2.default.string,
	  placeholder: _propTypes2.default.string,
	  size: _propTypes2.default.string
	};
	
	Input.defaultProps = {
	  placeholder: 'Search articles',
	  size: 'large'
	};
	
	exports.default = Input;
	module.exports = exports['default'];

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SearchIcon = function SearchIcon(_ref) {
	  var className = _ref.className;
	  return _react2.default.createElement(
	    'svg',
	    {
	      'aria-hidden': 'true',
	      className: className,
	      fill: 'none',
	      stroke: 'currentColor',
	      strokeLinecap: 'round',
	      strokeWidth: '1.5',
	      viewBox: '0 0 16 16'
	    },
	    _react2.default.createElement('circle', { cx: '7', cy: '7', r: '5' }),
	    _react2.default.createElement('path', { d: 'M10.75 10.75L14 14' })
	  );
	};
	
	SearchIcon.propTypes = {
	  className: _propTypes2.default.string
	};
	
	exports.default = SearchIcon;
	module.exports = exports['default'];

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _typeaheadModule = __webpack_require__(111);
	
	var _typeaheadModule2 = _interopRequireDefault(_typeaheadModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TypeaheadResults = function (_Component) {
	  _inherits(TypeaheadResults, _Component);
	
	  function TypeaheadResults() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TypeaheadResults);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      index: -1
	    }, _this.componentDidMount = function () {
	      document.addEventListener('keydown', _this.listen);
	    }, _this.componentDidUpdate = function (prevProps) {
	      var previousResults = prevProps.results;
	      var results = _this.props.results;
	
	      if (results.length !== previousResults.length) {
	        // eslint-disable-next-line react/no-did-update-set-state
	        _this.setState({ index: -1 });
	      }
	    }, _this.componentWillUnmount = function () {
	      document.removeEventListener('keydown', _this.listen);
	    }, _this.listen = function (e) {
	      var results = _this.props.results;
	      var index = _this.state.index;
	      var which = e.which;
	
	      var ENTER = 13;
	      var DOWN = 40;
	      var UP = 38;
	      var preventsDefault = which === DOWN || which === UP;
	      var nextIndex = index;
	      var scrollOpts = { block: 'nearest' };
	
	      if (results.length > 0 && preventsDefault) {
	        e.preventDefault();
	      }
	
	      if (which === DOWN) {
	        nextIndex = Math.min(index + 1, results.length - 1);
	      }
	
	      if (which === UP) {
	        nextIndex = Math.max(0, index - 1);
	      }
	
	      if (which === ENTER && index >= 0) {
	        (0, _gatsbyLink.navigateTo)(results[index].url);
	        return;
	      }
	
	      if (index === nextIndex) {
	        return;
	      }
	
	      _this.setState({ index: nextIndex }, function () {
	        if (!_this.element) {
	          return;
	        }
	        var children = _this.element.getElementsByClassName('result');
	        children[nextIndex].scrollIntoView(scrollOpts);
	      });
	    }, _this.setElement = function (node) {
	      _this.element = node;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  TypeaheadResults.prototype.renderText = function renderText() {
	    var results = this.props.results;
	
	    if (results.length > 0) {
	      return 'Top article suggestions';
	    }
	    return 'No results found';
	  };
	
	  TypeaheadResults.prototype.render = function render() {
	    var _classNames;
	
	    var _props = this.props,
	        query = _props.query,
	        results = _props.results,
	        className = _props.className;
	    var current = this.state.index;
	
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: (0, _classnames2.default)('navbar-dropdown', _typeaheadModule2.default.TypeaheadResults, (_classNames = {}, _classNames[_typeaheadModule2.default['TypeaheadResults--active']] = query.length > 0, _classNames), className),
	        ref: this.setElement
	      },
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('navbar-item', _typeaheadModule2.default.TypeaheadResults__label)
	        },
	        this.renderText()
	      ),
	      _react2.default.createElement('hr', {
	        className: (0, _classnames2.default)(_typeaheadModule2.default.TypeaheadResults__separator, {
	          'is-hidden': results.length === 0
	        })
	      }),
	      _react2.default.createElement(
	        'div',
	        { className: _typeaheadModule2.default.TypeaheadResults__scrollBox },
	        results.map(function (_ref, index) {
	          var _classNames2;
	
	          var name = _ref.name,
	              url = _ref.url;
	          return _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              className: (0, _classnames2.default)('navbar-item result', (_classNames2 = {}, _classNames2[_typeaheadModule2.default['TypeaheadResult--active']] = index === current, _classNames2)),
	              key: url,
	              to: url
	            },
	            name
	          );
	        })
	      )
	    );
	  };
	
	  return TypeaheadResults;
	}(_react.Component);
	
	TypeaheadResults.propTypes = {
	  className: _propTypes2.default.string,
	  query: _propTypes2.default.string,
	  results: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    name: _propTypes2.default.string.isRequired,
	    url: _propTypes2.default.string.isRequired
	  })).isRequired
	};
	
	exports.default = TypeaheadResults;
	module.exports = exports['default'];

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(17);
	
	var $apply = __webpack_require__(40);
	var $call = __webpack_require__(24);
	var $reflectApply = __webpack_require__(93);
	
	/** @type {import('./actualApply')} */
	module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),
/* 93 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./reflectApply')} */
	module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var callBind = __webpack_require__(41);
	var gOPD = __webpack_require__(49);
	
	var hasProtoAccessor;
	try {
		// eslint-disable-next-line no-extra-parens, no-proto
		hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
	} catch (e) {
		if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
			throw e;
		}
	}
	
	// eslint-disable-next-line no-extra-parens
	var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));
	
	var $Object = Object;
	var $getPrototypeOf = $Object.getPrototypeOf;
	
	/** @type {import('./get')} */
	module.exports = desc && typeof desc.get === 'function'
		? callBind([desc.get])
		: typeof $getPrototypeOf === 'function'
			? /** @type {import('./get')} */ function getDunder(value) {
				// eslint-disable-next-line eqeqeq
				return $getPrototypeOf(value == null ? value : $Object(value));
			}
			: false;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./eval')} */
	module.exports = EvalError;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('.')} */
	module.exports = Error;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./range')} */
	module.exports = RangeError;


/***/ }),
/* 104 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./ref')} */
	module.exports = ReferenceError;


/***/ }),
/* 105 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./syntax')} */
	module.exports = SyntaxError;


/***/ }),
/* 106 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./uri')} */
	module.exports = URIError;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Form":"src-components-contact----form-module---Form---2Q1eo","Form--success":"src-components-contact----form-module---Form--success---34VFa","Form__heading":"src-components-contact----form-module---Form__heading---3LUlS","Form__heading__text":"src-components-contact----form-module---Form__heading__text---qOHZn","Form__icon":"src-components-contact----form-module---Form__icon---2jwhR","Form__label":"src-components-contact----form-module---Form__label---2bNjW","Form__button":"src-components-contact----form-module---Form__button---1ozaA","spinAround":"src-components-contact----form-module---spinAround---2kCIN"};

/***/ }),
/* 108 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Methods":"src-components-contact----methods-module---Methods---3gt6U","Methods__method":"src-components-contact----methods-module---Methods__method---1fd_E","Methods__icon":"src-components-contact----methods-module---Methods__icon---l_CNn","Methods__text":"src-components-contact----methods-module---Methods__text---19c9s","spinAround":"src-components-contact----methods-module---spinAround---2farZ"};

/***/ }),
/* 109 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Modal":"src-components-contact----modal-module---Modal---1Jgo6","Modal__body":"src-components-contact----modal-module---Modal__body---QkJvs","Modal__close":"src-components-contact----modal-module---Modal__close---3m3ad","Modal__heading":"src-components-contact----modal-module---Modal__heading---32dhb","Modal__eyebrow":"src-components-contact----modal-module---Modal__eyebrow---VBZJ6","Modal__title":"src-components-contact----modal-module---Modal__title---unHdy","Modal__summary":"src-components-contact----modal-module---Modal__summary---WsWPY","spinAround":"src-components-contact----modal-module---spinAround---34-Kq"};

/***/ }),
/* 110 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Input":"src-components-search----input-module---Input---1b17Y","Input__field":"src-components-search----input-module---Input__field---2JivW","Input__icon":"src-components-search----input-module---Input__icon---1klbJ","Input__control":"src-components-search----input-module---Input__control---1T0Is","Input--large":"src-components-search----input-module---Input--large---1aTPK","Input--small":"src-components-search----input-module---Input--small---2R7ad","spinAround":"src-components-search----input-module---spinAround---10QVz"};

/***/ }),
/* 111 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"TypeaheadResults":"src-components-search----typeahead-module---TypeaheadResults---1XDOj","TypeaheadResults--active":"src-components-search----typeahead-module---TypeaheadResults--active---1KXH0","TypeaheadResults__label":"src-components-search----typeahead-module---TypeaheadResults__label---2rLV6","TypeaheadResults__scrollBox":"src-components-search----typeahead-module---TypeaheadResults__scrollBox---24h2X","TypeaheadResults__separator":"src-components-search----typeahead-module---TypeaheadResults__separator---18VKm","TypeaheadResult--active":"src-components-search----typeahead-module---TypeaheadResult--active---ZkzQa","spinAround":"src-components-search----typeahead-module---spinAround---aX0NR"};

/***/ }),
/* 112 */
/***/ (function(module, exports) {

	'use strict';
	
	/* eslint no-invalid-this: 1 */
	
	var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
	var toStr = Object.prototype.toString;
	var max = Math.max;
	var funcType = '[object Function]';
	
	var concatty = function concatty(a, b) {
	    var arr = [];
	
	    for (var i = 0; i < a.length; i += 1) {
	        arr[i] = a[i];
	    }
	    for (var j = 0; j < b.length; j += 1) {
	        arr[j + a.length] = b[j];
	    }
	
	    return arr;
	};
	
	var slicy = function slicy(arrLike, offset) {
	    var arr = [];
	    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
	        arr[j] = arrLike[i];
	    }
	    return arr;
	};
	
	var joiny = function (arr, joiner) {
	    var str = '';
	    for (var i = 0; i < arr.length; i += 1) {
	        str += arr[i];
	        if (i + 1 < arr.length) {
	            str += joiner;
	        }
	    }
	    return str;
	};
	
	module.exports = function bind(that) {
	    var target = this;
	    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
	        throw new TypeError(ERROR_MESSAGE + target);
	    }
	    var args = slicy(arguments, 1);
	
	    var bound;
	    var binder = function () {
	        if (this instanceof bound) {
	            var result = target.apply(
	                this,
	                concatty(args, arguments)
	            );
	            if (Object(result) === result) {
	                return result;
	            }
	            return this;
	        }
	        return target.apply(
	            that,
	            concatty(args, arguments)
	        );
	
	    };
	
	    var boundLength = max(0, target.length - args.length);
	    var boundArgs = [];
	    for (var i = 0; i < boundLength; i++) {
	        boundArgs[i] = '$' + i;
	    }
	
	    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
	
	    if (target.prototype) {
	        var Empty = function Empty() {};
	        Empty.prototype = target.prototype;
	        bound.prototype = new Empty();
	        Empty.prototype = null;
	    }
	
	    return bound;
	};


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var reflectGetProto = __webpack_require__(48);
	var originalGetProto = __webpack_require__(47);
	
	var getDunderProto = __webpack_require__(100);
	
	/** @type {import('.')} */
	module.exports = reflectGetProto
		? function getProto(O) {
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return reflectGetProto(O);
		}
		: originalGetProto
			? function getProto(O) {
				if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
					throw new TypeError('getProto: not an object');
				}
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return originalGetProto(O);
			}
			: getDunderProto
				? function getProto(O) {
					// @ts-expect-error TS can't narrow inside a closure, for some reason
					return getDunderProto(O);
				}
				: null;


/***/ }),
/* 114 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./gOPD')} */
	module.exports = Object.getOwnPropertyDescriptor;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var origSymbol = typeof Symbol !== 'undefined' && Symbol;
	var hasSymbolSham = __webpack_require__(116);
	
	/** @type {import('.')} */
	module.exports = function hasNativeSymbols() {
		if (typeof origSymbol !== 'function') { return false; }
		if (typeof Symbol !== 'function') { return false; }
		if (typeof origSymbol('foo') !== 'symbol') { return false; }
		if (typeof Symbol('bar') !== 'symbol') { return false; }
	
		return hasSymbolSham();
	};


/***/ }),
/* 116 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./shams')} */
	/* eslint complexity: [2, 18], max-statements: [2, 33] */
	module.exports = function hasSymbols() {
		if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
		if (typeof Symbol.iterator === 'symbol') { return true; }
	
		/** @type {{ [k in symbol]?: unknown }} */
		var obj = {};
		var sym = Symbol('test');
		var symObj = Object(sym);
		if (typeof sym === 'string') { return false; }
	
		if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
		if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }
	
		// temp disabled per https://github.com/ljharb/object.assign/issues/17
		// if (sym instanceof Symbol) { return false; }
		// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
		// if (!(symObj instanceof Symbol)) { return false; }
	
		// if (typeof Symbol.prototype.toString !== 'function') { return false; }
		// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
	
		var symVal = 42;
		obj[sym] = symVal;
		for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
		if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }
	
		if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }
	
		var syms = Object.getOwnPropertySymbols(obj);
		if (syms.length !== 1 || syms[0] !== sym) { return false; }
	
		if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }
	
		if (typeof Object.getOwnPropertyDescriptor === 'function') {
			// eslint-disable-next-line no-extra-parens
			var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
			if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
		}
	
		return true;
	};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var call = Function.prototype.call;
	var $hasOwn = Object.prototype.hasOwnProperty;
	var bind = __webpack_require__(17);
	
	/** @type {import('.')} */
	module.exports = bind.call(call, $hasOwn);


/***/ }),
/* 118 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./abs')} */
	module.exports = Math.abs;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./floor')} */
	module.exports = Math.floor;


/***/ }),
/* 120 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./isNaN')} */
	module.exports = Number.isNaN || function isNaN(a) {
		return a !== a;
	};


/***/ }),
/* 121 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./max')} */
	module.exports = Math.max;


/***/ }),
/* 122 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./min')} */
	module.exports = Math.min;


/***/ }),
/* 123 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./pow')} */
	module.exports = Math.pow;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

	'use strict';
	
	/** @type {import('./round')} */
	module.exports = Math.round;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var $isNaN = __webpack_require__(120);
	
	/** @type {import('./sign')} */
	module.exports = function sign(number) {
		if ($isNaN(number) || number === 0) {
			return number;
		}
		return number < 0 ? -1 : +1;
	};


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! https://mths.be/punycode v1.4.1 by @mathias */
	;(function(root) {
	
		/** Detect free variables */
		var freeExports = typeof exports == 'object' && exports &&
			!exports.nodeType && exports;
		var freeModule = typeof module == 'object' && module &&
			!module.nodeType && module;
		var freeGlobal = typeof global == 'object' && global;
		if (
			freeGlobal.global === freeGlobal ||
			freeGlobal.window === freeGlobal ||
			freeGlobal.self === freeGlobal
		) {
			root = freeGlobal;
		}
	
		/**
		 * The `punycode` object.
		 * @name punycode
		 * @type Object
		 */
		var punycode,
	
		/** Highest positive signed 32-bit float value */
		maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1
	
		/** Bootstring parameters */
		base = 36,
		tMin = 1,
		tMax = 26,
		skew = 38,
		damp = 700,
		initialBias = 72,
		initialN = 128, // 0x80
		delimiter = '-', // '\x2D'
	
		/** Regular expressions */
		regexPunycode = /^xn--/,
		regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
		regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators
	
		/** Error messages */
		errors = {
			'overflow': 'Overflow: input needs wider integers to process',
			'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
			'invalid-input': 'Invalid input'
		},
	
		/** Convenience shortcuts */
		baseMinusTMin = base - tMin,
		floor = Math.floor,
		stringFromCharCode = String.fromCharCode,
	
		/** Temporary variable */
		key;
	
		/*--------------------------------------------------------------------------*/
	
		/**
		 * A generic error utility function.
		 * @private
		 * @param {String} type The error type.
		 * @returns {Error} Throws a `RangeError` with the applicable error message.
		 */
		function error(type) {
			throw new RangeError(errors[type]);
		}
	
		/**
		 * A generic `Array#map` utility function.
		 * @private
		 * @param {Array} array The array to iterate over.
		 * @param {Function} callback The function that gets called for every array
		 * item.
		 * @returns {Array} A new array of values returned by the callback function.
		 */
		function map(array, fn) {
			var length = array.length;
			var result = [];
			while (length--) {
				result[length] = fn(array[length]);
			}
			return result;
		}
	
		/**
		 * A simple `Array#map`-like wrapper to work with domain name strings or email
		 * addresses.
		 * @private
		 * @param {String} domain The domain name or email address.
		 * @param {Function} callback The function that gets called for every
		 * character.
		 * @returns {Array} A new string of characters returned by the callback
		 * function.
		 */
		function mapDomain(string, fn) {
			var parts = string.split('@');
			var result = '';
			if (parts.length > 1) {
				// In email addresses, only the domain name should be punycoded. Leave
				// the local part (i.e. everything up to `@`) intact.
				result = parts[0] + '@';
				string = parts[1];
			}
			// Avoid `split(regex)` for IE8 compatibility. See #17.
			string = string.replace(regexSeparators, '\x2E');
			var labels = string.split('.');
			var encoded = map(labels, fn).join('.');
			return result + encoded;
		}
	
		/**
		 * Creates an array containing the numeric code points of each Unicode
		 * character in the string. While JavaScript uses UCS-2 internally,
		 * this function will convert a pair of surrogate halves (each of which
		 * UCS-2 exposes as separate characters) into a single code point,
		 * matching UTF-16.
		 * @see `punycode.ucs2.encode`
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode.ucs2
		 * @name decode
		 * @param {String} string The Unicode input string (UCS-2).
		 * @returns {Array} The new array of code points.
		 */
		function ucs2decode(string) {
			var output = [],
			    counter = 0,
			    length = string.length,
			    value,
			    extra;
			while (counter < length) {
				value = string.charCodeAt(counter++);
				if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
					// high surrogate, and there is a next character
					extra = string.charCodeAt(counter++);
					if ((extra & 0xFC00) == 0xDC00) { // low surrogate
						output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
					} else {
						// unmatched surrogate; only append this code unit, in case the next
						// code unit is the high surrogate of a surrogate pair
						output.push(value);
						counter--;
					}
				} else {
					output.push(value);
				}
			}
			return output;
		}
	
		/**
		 * Creates a string based on an array of numeric code points.
		 * @see `punycode.ucs2.decode`
		 * @memberOf punycode.ucs2
		 * @name encode
		 * @param {Array} codePoints The array of numeric code points.
		 * @returns {String} The new Unicode string (UCS-2).
		 */
		function ucs2encode(array) {
			return map(array, function(value) {
				var output = '';
				if (value > 0xFFFF) {
					value -= 0x10000;
					output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
					value = 0xDC00 | value & 0x3FF;
				}
				output += stringFromCharCode(value);
				return output;
			}).join('');
		}
	
		/**
		 * Converts a basic code point into a digit/integer.
		 * @see `digitToBasic()`
		 * @private
		 * @param {Number} codePoint The basic numeric code point value.
		 * @returns {Number} The numeric value of a basic code point (for use in
		 * representing integers) in the range `0` to `base - 1`, or `base` if
		 * the code point does not represent a value.
		 */
		function basicToDigit(codePoint) {
			if (codePoint - 48 < 10) {
				return codePoint - 22;
			}
			if (codePoint - 65 < 26) {
				return codePoint - 65;
			}
			if (codePoint - 97 < 26) {
				return codePoint - 97;
			}
			return base;
		}
	
		/**
		 * Converts a digit/integer into a basic code point.
		 * @see `basicToDigit()`
		 * @private
		 * @param {Number} digit The numeric value of a basic code point.
		 * @returns {Number} The basic code point whose value (when used for
		 * representing integers) is `digit`, which needs to be in the range
		 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
		 * used; else, the lowercase form is used. The behavior is undefined
		 * if `flag` is non-zero and `digit` has no uppercase form.
		 */
		function digitToBasic(digit, flag) {
			//  0..25 map to ASCII a..z or A..Z
			// 26..35 map to ASCII 0..9
			return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
		}
	
		/**
		 * Bias adaptation function as per section 3.4 of RFC 3492.
		 * https://tools.ietf.org/html/rfc3492#section-3.4
		 * @private
		 */
		function adapt(delta, numPoints, firstTime) {
			var k = 0;
			delta = firstTime ? floor(delta / damp) : delta >> 1;
			delta += floor(delta / numPoints);
			for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
				delta = floor(delta / baseMinusTMin);
			}
			return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
		}
	
		/**
		 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
		 * symbols.
		 * @memberOf punycode
		 * @param {String} input The Punycode string of ASCII-only symbols.
		 * @returns {String} The resulting string of Unicode symbols.
		 */
		function decode(input) {
			// Don't use UCS-2
			var output = [],
			    inputLength = input.length,
			    out,
			    i = 0,
			    n = initialN,
			    bias = initialBias,
			    basic,
			    j,
			    index,
			    oldi,
			    w,
			    k,
			    digit,
			    t,
			    /** Cached calculation results */
			    baseMinusT;
	
			// Handle the basic code points: let `basic` be the number of input code
			// points before the last delimiter, or `0` if there is none, then copy
			// the first basic code points to the output.
	
			basic = input.lastIndexOf(delimiter);
			if (basic < 0) {
				basic = 0;
			}
	
			for (j = 0; j < basic; ++j) {
				// if it's not a basic code point
				if (input.charCodeAt(j) >= 0x80) {
					error('not-basic');
				}
				output.push(input.charCodeAt(j));
			}
	
			// Main decoding loop: start just after the last delimiter if any basic code
			// points were copied; start at the beginning otherwise.
	
			for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {
	
				// `index` is the index of the next character to be consumed.
				// Decode a generalized variable-length integer into `delta`,
				// which gets added to `i`. The overflow checking is easier
				// if we increase `i` as we go, then subtract off its starting
				// value at the end to obtain `delta`.
				for (oldi = i, w = 1, k = base; /* no condition */; k += base) {
	
					if (index >= inputLength) {
						error('invalid-input');
					}
	
					digit = basicToDigit(input.charCodeAt(index++));
	
					if (digit >= base || digit > floor((maxInt - i) / w)) {
						error('overflow');
					}
	
					i += digit * w;
					t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
	
					if (digit < t) {
						break;
					}
	
					baseMinusT = base - t;
					if (w > floor(maxInt / baseMinusT)) {
						error('overflow');
					}
	
					w *= baseMinusT;
	
				}
	
				out = output.length + 1;
				bias = adapt(i - oldi, out, oldi == 0);
	
				// `i` was supposed to wrap around from `out` to `0`,
				// incrementing `n` each time, so we'll fix that now:
				if (floor(i / out) > maxInt - n) {
					error('overflow');
				}
	
				n += floor(i / out);
				i %= out;
	
				// Insert `n` at position `i` of the output
				output.splice(i++, 0, n);
	
			}
	
			return ucs2encode(output);
		}
	
		/**
		 * Converts a string of Unicode symbols (e.g. a domain name label) to a
		 * Punycode string of ASCII-only symbols.
		 * @memberOf punycode
		 * @param {String} input The string of Unicode symbols.
		 * @returns {String} The resulting Punycode string of ASCII-only symbols.
		 */
		function encode(input) {
			var n,
			    delta,
			    handledCPCount,
			    basicLength,
			    bias,
			    j,
			    m,
			    q,
			    k,
			    t,
			    currentValue,
			    output = [],
			    /** `inputLength` will hold the number of code points in `input`. */
			    inputLength,
			    /** Cached calculation results */
			    handledCPCountPlusOne,
			    baseMinusT,
			    qMinusT;
	
			// Convert the input in UCS-2 to Unicode
			input = ucs2decode(input);
	
			// Cache the length
			inputLength = input.length;
	
			// Initialize the state
			n = initialN;
			delta = 0;
			bias = initialBias;
	
			// Handle the basic code points
			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue < 0x80) {
					output.push(stringFromCharCode(currentValue));
				}
			}
	
			handledCPCount = basicLength = output.length;
	
			// `handledCPCount` is the number of code points that have been handled;
			// `basicLength` is the number of basic code points.
	
			// Finish the basic string - if it is not empty - with a delimiter
			if (basicLength) {
				output.push(delimiter);
			}
	
			// Main encoding loop:
			while (handledCPCount < inputLength) {
	
				// All non-basic code points < n have been handled already. Find the next
				// larger one:
				for (m = maxInt, j = 0; j < inputLength; ++j) {
					currentValue = input[j];
					if (currentValue >= n && currentValue < m) {
						m = currentValue;
					}
				}
	
				// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
				// but guard against overflow
				handledCPCountPlusOne = handledCPCount + 1;
				if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
					error('overflow');
				}
	
				delta += (m - n) * handledCPCountPlusOne;
				n = m;
	
				for (j = 0; j < inputLength; ++j) {
					currentValue = input[j];
	
					if (currentValue < n && ++delta > maxInt) {
						error('overflow');
					}
	
					if (currentValue == n) {
						// Represent delta as a generalized variable-length integer
						for (q = delta, k = base; /* no condition */; k += base) {
							t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
							if (q < t) {
								break;
							}
							qMinusT = q - t;
							baseMinusT = base - t;
							output.push(
								stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
							);
							q = floor(qMinusT / baseMinusT);
						}
	
						output.push(stringFromCharCode(digitToBasic(q, 0)));
						bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
						delta = 0;
						++handledCPCount;
					}
				}
	
				++delta;
				++n;
	
			}
			return output.join('');
		}
	
		/**
		 * Converts a Punycode string representing a domain name or an email address
		 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
		 * it doesn't matter if you call it on a string that has already been
		 * converted to Unicode.
		 * @memberOf punycode
		 * @param {String} input The Punycoded domain name or email address to
		 * convert to Unicode.
		 * @returns {String} The Unicode representation of the given Punycode
		 * string.
		 */
		function toUnicode(input) {
			return mapDomain(input, function(string) {
				return regexPunycode.test(string)
					? decode(string.slice(4).toLowerCase())
					: string;
			});
		}
	
		/**
		 * Converts a Unicode string representing a domain name or an email address to
		 * Punycode. Only the non-ASCII parts of the domain name will be converted,
		 * i.e. it doesn't matter if you call it with a domain that's already in
		 * ASCII.
		 * @memberOf punycode
		 * @param {String} input The domain name or email address to convert, as a
		 * Unicode string.
		 * @returns {String} The Punycode representation of the given domain name or
		 * email address.
		 */
		function toASCII(input) {
			return mapDomain(input, function(string) {
				return regexNonASCII.test(string)
					? 'xn--' + encode(string)
					: string;
			});
		}
	
		/*--------------------------------------------------------------------------*/
	
		/** Define the public API */
		punycode = {
			/**
			 * A string representing the current Punycode.js version number.
			 * @memberOf punycode
			 * @type String
			 */
			'version': '1.4.1',
			/**
			 * An object of methods to convert from JavaScript's internal character
			 * representation (UCS-2) to Unicode code points, and back.
			 * @see <https://mathiasbynens.be/notes/javascript-encoding>
			 * @memberOf punycode
			 * @type Object
			 */
			'ucs2': {
				'decode': ucs2decode,
				'encode': ucs2encode
			},
			'decode': decode,
			'encode': encode,
			'toASCII': toASCII,
			'toUnicode': toUnicode
		};
	
		/** Expose `punycode` */
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return punycode;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (freeExports && freeModule) {
			if (module.exports == freeExports) {
				// in Node.js, io.js, or RingoJS v0.8.0+
				freeModule.exports = punycode;
			} else {
				// in Narwhal or RingoJS v0.7.0-
				for (key in punycode) {
					punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
				}
			}
		} else {
			// in Rhino or a web browser
			root.punycode = punycode;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)(module), (function() { return this; }())))

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var stringify = __webpack_require__(129);
	var parse = __webpack_require__(128);
	var formats = __webpack_require__(26);
	
	module.exports = {
	    formats: formats,
	    parse: parse,
	    stringify: stringify
	};


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getSideChannel = __webpack_require__(30);
	var utils = __webpack_require__(51);
	
	var has = Object.prototype.hasOwnProperty;
	var isArray = Array.isArray;
	var getPrototypeOf = Object.getPrototypeOf;
	
	var isPlainContainer = function isPlainContainer(value) {
	    if (!value || typeof value !== 'object') {
	        return false;
	    }
	    if (isArray(value)) {
	        return true;
	    }
	    var proto = getPrototypeOf(value);
	    return proto === Object.prototype || proto === null;
	};
	
	var emptyCopyOf = function emptyCopyOf(value) {
	    if (isArray(value)) {
	        var arr = [];
	        arr.length = value.length;
	        return arr;
	    }
	    return getPrototypeOf(value) === null ? { __proto__: null } : {};
	};
	
	// `merge` and `compact` modify the containers they are given, so copy the caller's arrays and plain objects first
	var copyInput = function copyInput(input) {
	    var copies = getSideChannel();
	    var result = {};
	    var queue = [{ source: input, target: result }];
	
	    for (var i = 0; i < queue.length; ++i) {
	        var source = queue[i].source;
	        var target = queue[i].target;
	        var keys = Object.keys(source);
	        for (var j = 0; j < keys.length; ++j) {
	            var value = source[keys[j]];
	            if (isPlainContainer(value)) {
	                if (!copies.has(value)) {
	                    var copy = emptyCopyOf(value);
	                    copies.set(value, copy);
	                    queue[queue.length] = { source: value, target: copy };
	                }
	                target[keys[j]] = copies.get(value);
	            } else {
	                target[keys[j]] = value;
	            }
	        }
	    }
	
	    return result;
	};
	
	var defaults = {
	    allowDots: false,
	    allowEmptyArrays: false,
	    allowPrototypes: false,
	    allowSparse: false,
	    arrayLimit: 20,
	    charset: 'utf-8',
	    charsetSentinel: false,
	    comma: false,
	    decodeDotInKeys: false,
	    decoder: utils.decode,
	    delimiter: '&',
	    depth: 5,
	    duplicates: 'combine',
	    ignoreQueryPrefix: false,
	    interpretNumericEntities: false,
	    parameterLimit: 1000,
	    parseArrays: true,
	    plainObjects: false,
	    strictDepth: false,
	    strictMerge: true,
	    strictNullHandling: false,
	    throwOnLimitExceeded: false
	};
	
	var interpretNumericEntities = function (str) {
	    return str.replace(/&#(\d+);/g, function ($0, numberStr) {
	        return String.fromCharCode(parseInt(numberStr, 10));
	    });
	};
	
	var parseArrayValue = function (val, options, currentArrayLength) {
	    if (val && typeof val === 'string' && options.comma && val.indexOf(',') > -1) {
	        if (options.throwOnLimitExceeded) {
	            var commaCount = 0;
	            var commaIndex = val.indexOf(',');
	            while (commaIndex > -1) {
	                commaCount += 1;
	                if (commaCount >= options.arrayLimit) {
	                    throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
	                }
	                commaIndex = val.indexOf(',', commaIndex + 1);
	            }
	        }
	        return val.split(',');
	    }
	
	    if (options.throwOnLimitExceeded && currentArrayLength >= options.arrayLimit) {
	        throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
	    }
	
	    return val;
	};
	
	// This is what browsers will submit when the ✓ character occurs in an
	// application/x-www-form-urlencoded body and the encoding of the page containing
	// the form is iso-8859-1, or when the submitted form has an accept-charset
	// attribute of iso-8859-1. Presumably also with other charsets that do not contain
	// the ✓ character, such as us-ascii.
	var isoSentinel = 'utf8=%26%2310003%3B'; // encodeURIComponent('&#10003;')
	
	// These are the percent-encoded utf-8 octets representing a checkmark, indicating that the request actually is utf-8 encoded.
	var charsetSentinel = 'utf8=%E2%9C%93'; // encodeURIComponent('✓')
	
	var parseValues = function parseQueryStringValues(str, options) {
	    var obj = { __proto__: null };
	
	    var cleanStr = options.ignoreQueryPrefix ? str.replace(/^\?/, '') : str;
	    cleanStr = cleanStr.replace(/%5B/gi, '[').replace(/%5D/gi, ']');
	
	    var limit = options.parameterLimit === Infinity ? void undefined : options.parameterLimit;
	    var parts = cleanStr.split(
	        options.delimiter,
	        options.throwOnLimitExceeded && typeof limit !== 'undefined' ? limit + 1 : limit
	    );
	
	    if (options.throwOnLimitExceeded && typeof limit !== 'undefined' && parts.length > limit) {
	        throw new RangeError('Parameter limit exceeded. Only ' + limit + ' parameter' + (limit === 1 ? '' : 's') + ' allowed.');
	    }
	
	    var skipIndex = -1; // Keep track of where the utf8 sentinel was found
	    var i;
	
	    var charset = options.charset;
	    if (options.charsetSentinel) {
	        for (i = 0; i < parts.length; ++i) {
	            if (parts[i].indexOf('utf8=') === 0) {
	                if (parts[i] === charsetSentinel) {
	                    charset = 'utf-8';
	                } else if (parts[i] === isoSentinel) {
	                    charset = 'iso-8859-1';
	                }
	                skipIndex = i;
	                i = parts.length; // The eslint settings do not allow break;
	            }
	        }
	    }
	
	    for (i = 0; i < parts.length; ++i) {
	        if (i === skipIndex) {
	            continue;
	        }
	        var part = parts[i];
	
	        var bracketEqualsPos = part.indexOf(']=');
	        var pos = bracketEqualsPos === -1 ? part.indexOf('=') : bracketEqualsPos + 1;
	
	        // `[]` belongs to the key, so look for it at the split point, not anywhere in the part
	        var isEmptyBracketKey = pos > 1 && part.slice(pos - 2, pos) === '[]';
	
	        var key;
	        var val;
	        if (pos === -1) {
	            key = options.decoder(part, defaults.decoder, charset, 'key');
	            val = options.strictNullHandling ? null : '';
	        } else {
	            key = options.decoder(part.slice(0, pos), defaults.decoder, charset, 'key');
	
	            if (key !== null) {
	                val = utils.maybeMap(
	                    parseArrayValue(
	                        part.slice(pos + 1),
	                        options,
	                        isArray(obj[key]) ? obj[key].length : 0
	                    ),
	                    function (encodedVal) {
	                        return options.decoder(encodedVal, defaults.decoder, charset, 'value');
	                    }
	                );
	            }
	        }
	
	        if (val && options.interpretNumericEntities && charset === 'iso-8859-1') {
	            val = interpretNumericEntities(String(val));
	        }
	
	        if (isEmptyBracketKey) {
	            val = isArray(val) ? [val] : val;
	        }
	
	        if (options.comma && isArray(val) && val.length > options.arrayLimit) {
	            val = utils.combine([], val, options.arrayLimit, options.plainObjects, options.throwOnLimitExceeded);
	        }
	
	        if (key !== null) {
	            var existing = has.call(obj, key);
	            if (existing && (options.duplicates === 'combine' || isEmptyBracketKey)) {
	                obj[key] = utils.combine(
	                    obj[key],
	                    val,
	                    options.arrayLimit,
	                    options.plainObjects,
	                    options.throwOnLimitExceeded
	                );
	            } else if (!existing || options.duplicates === 'last') {
	                obj[key] = val;
	            }
	        }
	    }
	
	    return obj;
	};
	
	var parseObject = function (chain, val, options, valuesParsed) {
	    var currentArrayLength = 0;
	    if (chain.length > 0 && chain[chain.length - 1] === '[]') {
	        var parentKey = chain.slice(0, -1).join('');
	        currentArrayLength = Array.isArray(val) && val[parentKey] ? val[parentKey].length : 0;
	    }
	
	    var leaf = valuesParsed ? val : parseArrayValue(val, options, currentArrayLength);
	
	    for (var i = chain.length - 1; i >= 0; --i) {
	        var obj;
	        var root = chain[i];
	
	        if (root === '[]' && options.parseArrays) {
	            if (utils.isOverflow(leaf)) {
	                // leaf is already an overflow object, preserve it
	                obj = leaf;
	            } else {
	                obj = options.allowEmptyArrays && (leaf === '' || (options.strictNullHandling && leaf === null))
	                    ? []
	                    : utils.combine(
	                        [],
	                        leaf,
	                        options.arrayLimit,
	                        options.plainObjects,
	                        options.throwOnLimitExceeded
	                    );
	            }
	        } else {
	            obj = options.plainObjects ? { __proto__: null } : {};
	            var cleanRoot = root.charAt(0) === '[' && root.charAt(root.length - 1) === ']' ? root.slice(1, -1) : root;
	            var decodedRoot = options.decodeDotInKeys ? cleanRoot.replace(/%2E/g, '.') : cleanRoot;
	            var index = parseInt(decodedRoot, 10);
	            var isValidArrayIndex = !isNaN(index)
	                && root !== decodedRoot
	                && String(index) === decodedRoot
	                && index >= 0
	                && options.parseArrays;
	            if (!options.parseArrays && decodedRoot === '') {
	                obj = { 0: leaf };
	            } else if (isValidArrayIndex && index < options.arrayLimit) {
	                obj = [];
	                obj[index] = leaf;
	            } else if (isValidArrayIndex && options.throwOnLimitExceeded) {
	                throw new RangeError('Array limit exceeded. Only ' + options.arrayLimit + ' element' + (options.arrayLimit === 1 ? '' : 's') + ' allowed in an array.');
	            } else if (isValidArrayIndex) {
	                obj[index] = leaf;
	                utils.markOverflow(obj, index);
	            } else if (decodedRoot !== '__proto__') {
	                obj[decodedRoot] = leaf;
	            }
	        }
	
	        leaf = obj;
	    }
	
	    return leaf;
	};
	
	// Behaves like `key.replace(/\.([^.[]+)/g, '[$1]')`, but only rewrites a dot
	// that sits at bracket depth 0. A literal dot already inside a `[...]` segment
	// is left untouched instead of corrupting the key (e.g. "outer[a.b]"). (#617)
	var topLevelDotsToBrackets = function topLevelDotsToBrackets(key) {
	    var result = '';
	    var depth = 0;
	    for (var i = 0; i < key.length; i += 1) {
	        var cu = key.charCodeAt(i);
	        if (cu === 0x5B) { // '['
	            depth += 1;
	            result += '[';
	        } else if (cu === 0x5D) { // ']'
	            if (depth > 0) {
	                depth -= 1;
	            }
	            result += ']';
	        } else if (
	            cu === 0x2E // '.'
	            && depth === 0
	            && i + 1 < key.length
	            && key.charCodeAt(i + 1) !== 0x2E // not another '.'
	            && key.charCodeAt(i + 1) !== 0x5B // not '['
	        ) {
	            var start = i + 1;
	            var j = start;
	            while (j < key.length && key.charCodeAt(j) !== 0x2E && key.charCodeAt(j) !== 0x5B) {
	                j += 1;
	            }
	            result += '[' + key.slice(start, j) + ']';
	            i = j - 1;
	        } else {
	            result += key.charAt(i);
	        }
	    }
	    return result;
	};
	
	// Split a key like "a[b][c[]]" into ['a', '[b]', '[c[]]'] while preserving
	// qs parse semantics for depth/prototype guards.
	var splitKeyIntoSegments = function splitKeyIntoSegments(originalKey, options) {
	    var key = options.allowDots ? topLevelDotsToBrackets(originalKey) : originalKey;
	
	    // depth <= 0 keeps the whole key as one segment
	    if (options.depth <= 0) {
	        if (!options.plainObjects && has.call(Object.prototype, key)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        return [key];
	    }
	
	    var segments = [];
	
	    // parent before the first '[' (may be empty if key starts with '[')
	    var first = key.indexOf('[');
	    var parent = first >= 0 ? key.slice(0, first) : key;
	    if (parent) {
	        if (!options.plainObjects && has.call(Object.prototype, parent)) {
	            if (!options.allowPrototypes) {
	                return;
	            }
	        }
	
	        segments[segments.length] = parent;
	    }
	
	    var n = key.length;
	    var open = first;
	    var collected = 0;
	
	    while (open >= 0 && collected < options.depth) {
	        var level = 1;
	        var i = open + 1;
	        var close = -1;
	
	        // balance nested '[' and ']' inside this bracket group using a nesting level counter
	        while (i < n && close < 0) {
	            var cu = key.charCodeAt(i);
	            if (cu === 0x5B) { // '['
	                level += 1;
	            } else if (cu === 0x5D) { // ']'
	                level -= 1;
	                if (level === 0) {
	                    close = i; // found matching close; loop will exit by condition
	                }
	            }
	            i += 1;
	        }
	
	        if (close < 0) {
	            // Unterminated group: wrap the raw remainder in one bracket pair so it stays
	            // a single literal segment (e.g. "[[]b" -> "[[]b]"); we do not infer missing ']'.
	            segments[segments.length] = '[' + key.slice(open) + ']';
	            return segments;
	        }
	
	        var seg = key.slice(open, close + 1);
	        // prototype guard for the content of this group
	        var content = seg.slice(1, -1);
	        if (!options.plainObjects && has.call(Object.prototype, content) && !options.allowPrototypes) {
	            return;
	        }
	
	        segments[segments.length] = seg;
	        collected += 1;
	
	        // find the next '[' after this balanced group
	        open = key.indexOf('[', close + 1);
	    }
	
	    if (open >= 0) {
	        if (options.strictDepth === true) {
	            throw new RangeError('Input depth exceeded depth option of ' + options.depth + ' and strictDepth is true');
	        }
	
	        segments[segments.length] = '[' + key.slice(open) + ']';
	    }
	
	    return segments;
	};
	
	var parseKeys = function parseQueryStringKeys(givenKey, val, options, valuesParsed) {
	    if (!givenKey) {
	        return;
	    }
	
	    var keys = splitKeyIntoSegments(givenKey, options);
	
	    if (!keys) {
	        return;
	    }
	
	    return parseObject(keys, val, options, valuesParsed);
	};
	
	var normalizeParseOptions = function normalizeParseOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
	        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
	    }
	
	    if (typeof opts.decodeDotInKeys !== 'undefined' && typeof opts.decodeDotInKeys !== 'boolean') {
	        throw new TypeError('`decodeDotInKeys` option can only be `true` or `false`, when provided');
	    }
	
	    if (opts.decoder !== null && typeof opts.decoder !== 'undefined' && typeof opts.decoder !== 'function') {
	        throw new TypeError('Decoder has to be a function.');
	    }
	
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	
	    if (typeof opts.throwOnLimitExceeded !== 'undefined' && typeof opts.throwOnLimitExceeded !== 'boolean') {
	        throw new TypeError('`throwOnLimitExceeded` option must be a boolean');
	    }
	
	    var charset = typeof opts.charset === 'undefined' ? defaults.charset : opts.charset;
	
	    var duplicates = typeof opts.duplicates === 'undefined' ? defaults.duplicates : opts.duplicates;
	
	    if (duplicates !== 'combine' && duplicates !== 'first' && duplicates !== 'last') {
	        throw new TypeError('The duplicates option must be either combine, first, or last');
	    }
	
	    var allowDots = typeof opts.allowDots === 'undefined' ? opts.decodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
	
	    return {
	        allowDots: allowDots,
	        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
	        allowPrototypes: typeof opts.allowPrototypes === 'boolean' ? opts.allowPrototypes : defaults.allowPrototypes,
	        allowSparse: typeof opts.allowSparse === 'boolean' ? opts.allowSparse : defaults.allowSparse,
	        arrayLimit: typeof opts.arrayLimit === 'number' ? opts.arrayLimit : defaults.arrayLimit,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        comma: typeof opts.comma === 'boolean' ? opts.comma : defaults.comma,
	        decodeDotInKeys: typeof opts.decodeDotInKeys === 'boolean' ? opts.decodeDotInKeys : defaults.decodeDotInKeys,
	        decoder: typeof opts.decoder === 'function' ? opts.decoder : defaults.decoder,
	        delimiter: typeof opts.delimiter === 'string' || utils.isRegExp(opts.delimiter) ? opts.delimiter : defaults.delimiter,
	        // eslint-disable-next-line no-implicit-coercion, no-extra-parens
	        depth: (typeof opts.depth === 'number' || opts.depth === false) ? +opts.depth : defaults.depth,
	        duplicates: duplicates,
	        ignoreQueryPrefix: opts.ignoreQueryPrefix === true,
	        interpretNumericEntities: typeof opts.interpretNumericEntities === 'boolean' ? opts.interpretNumericEntities : defaults.interpretNumericEntities,
	        parameterLimit: typeof opts.parameterLimit === 'number' ? opts.parameterLimit : defaults.parameterLimit,
	        parseArrays: opts.parseArrays !== false,
	        plainObjects: typeof opts.plainObjects === 'boolean' ? opts.plainObjects : defaults.plainObjects,
	        strictDepth: typeof opts.strictDepth === 'boolean' ? !!opts.strictDepth : defaults.strictDepth,
	        strictMerge: typeof opts.strictMerge === 'boolean' ? !!opts.strictMerge : defaults.strictMerge,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling,
	        throwOnLimitExceeded: typeof opts.throwOnLimitExceeded === 'boolean' ? opts.throwOnLimitExceeded : false
	    };
	};
	
	module.exports = function (str, opts) {
	    var options = normalizeParseOptions(opts);
	
	    if (str === '' || str === null || typeof str === 'undefined') {
	        return options.plainObjects ? { __proto__: null } : {};
	    }
	
	    var tempObj = typeof str === 'string' ? parseValues(str, options) : copyInput(str);
	    var obj = options.plainObjects ? { __proto__: null } : {};
	
	    // Iterate over the keys and setup the new object
	
	    var keys = Object.keys(tempObj);
	    for (var i = 0; i < keys.length; ++i) {
	        var key = keys[i];
	        var newObj = parseKeys(key, tempObj[key], options, typeof str === 'string');
	        obj = utils.merge(obj, newObj, options);
	    }
	
	    if (options.allowSparse === true) {
	        return obj;
	    }
	
	    return utils.compact(obj);
	};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var getSideChannel = __webpack_require__(30);
	var utils = __webpack_require__(51);
	var formats = __webpack_require__(26);
	var has = Object.prototype.hasOwnProperty;
	
	var arrayPrefixGenerators = {
	    brackets: function brackets(prefix) {
	        return prefix + '[]';
	    },
	    comma: 'comma',
	    indices: function indices(prefix, key) {
	        return prefix + '[' + key + ']';
	    },
	    repeat: function repeat(prefix) {
	        return prefix;
	    }
	};
	
	var isArray = Array.isArray;
	var push = Array.prototype.push;
	var pushToArray = function (arr, valueOrArray) {
	    push.apply(arr, isArray(valueOrArray) ? valueOrArray : [valueOrArray]);
	};
	
	var toISO = Date.prototype.toISOString;
	
	var defaultFormat = formats['default'];
	var defaults = {
	    addQueryPrefix: false,
	    allowDots: false,
	    allowEmptyArrays: false,
	    arrayFormat: 'indices',
	    charset: 'utf-8',
	    charsetSentinel: false,
	    commaRoundTrip: false,
	    delimiter: '&',
	    depth: Infinity,
	    encode: true,
	    encodeDotInKeys: false,
	    encoder: utils.encode,
	    encodeValuesOnly: false,
	    filter: void undefined,
	    format: defaultFormat,
	    formatter: formats.formatters[defaultFormat],
	    // deprecated
	    indices: false,
	    serializeDate: function serializeDate(date) {
	        return toISO.call(date);
	    },
	    skipNulls: false,
	    strictNullHandling: false
	};
	
	var isNonNullishPrimitive = function isNonNullishPrimitive(v) {
	    return typeof v === 'string'
	        || typeof v === 'number'
	        || typeof v === 'boolean'
	        || typeof v === 'symbol'
	        || typeof v === 'bigint';
	};
	
	var sentinel = {};
	
	var stringify = function stringify(
	    object,
	    prefix,
	    generateArrayPrefix,
	    commaRoundTrip,
	    allowEmptyArrays,
	    strictNullHandling,
	    skipNulls,
	    encodeDotInKeys,
	    encoder,
	    filter,
	    sort,
	    allowDots,
	    serializeDate,
	    format,
	    formatter,
	    encodeValuesOnly,
	    charset,
	    sideChannel,
	    depth,
	    currentDepth
	) {
	    var obj = object;
	
	    if (currentDepth > depth) {
	        throw new RangeError('Input depth exceeded depth option of ' + depth);
	    }
	
	    var tmpSc = sideChannel;
	    var step = 0;
	    var findFlag = false;
	    while ((tmpSc = tmpSc.get(sentinel)) !== void undefined && !findFlag) {
	        // Where object last appeared in the ref tree
	        var pos = tmpSc.get(object);
	        step += 1;
	        if (typeof pos !== 'undefined') {
	            if (pos === step) {
	                throw new RangeError('Cyclic object value');
	            } else {
	                findFlag = true; // Break while
	            }
	        }
	        if (typeof tmpSc.get(sentinel) === 'undefined') {
	            step = 0;
	        }
	    }
	
	    obj = typeof filter === 'function' ? filter(prefix, obj) : obj;
	
	    if (obj instanceof Date) {
	        obj = serializeDate(obj);
	    } else if (generateArrayPrefix === 'comma' && isArray(obj)) {
	        obj = utils.maybeMap(obj, function (value) {
	            if (value instanceof Date) {
	                return serializeDate(value);
	            }
	            return value;
	        });
	    }
	
	    if (obj === null) {
	        if (strictNullHandling) {
	            return formatter(encoder && !encodeValuesOnly ? encoder(prefix, defaults.encoder, charset, 'key', format) : prefix);
	        }
	
	        obj = '';
	    }
	
	    if (isNonNullishPrimitive(obj) || utils.isBuffer(obj)) {
	        if (encoder) {
	            var keyValue = encodeValuesOnly ? prefix : encoder(prefix, defaults.encoder, charset, 'key', format);
	            return [formatter(keyValue) + '=' + formatter(encoder(obj, defaults.encoder, charset, 'value', format))];
	        }
	        return [formatter(prefix) + '=' + formatter(String(obj))];
	    }
	
	    var values = [];
	
	    if (typeof obj === 'undefined') {
	        return values;
	    }
	
	    var objKeys;
	    if (generateArrayPrefix === 'comma' && isArray(obj)) {
	        // we need to join elements in
	        if (encodeValuesOnly && encoder) {
	            obj = utils.maybeMap(obj, function (v) {
	                return v == null ? v : encoder(v, defaults.encoder, charset, 'value', format);
	            });
	        }
	        objKeys = [{ value: obj.length > 0 ? utils.toCoercible(obj).join(',') || null : void undefined }];
	    } else if (isArray(filter)) {
	        objKeys = filter;
	    } else {
	        var keys = Object.keys(obj);
	        objKeys = sort ? keys.sort(sort) : keys;
	    }
	
	    var encodedPrefix = String(prefix);
	
	    var adjustedPrefix = commaRoundTrip && isArray(obj) && obj.length === 1 ? encodedPrefix + '[]' : encodedPrefix;
	
	    if (allowEmptyArrays && isArray(obj) && obj.length === 0 && Object.keys(obj).length === 0) {
	        return formatter(encoder && !encodeValuesOnly ? encoder(adjustedPrefix, defaults.encoder, charset, 'key', format) : adjustedPrefix) + '[]';
	    }
	
	    for (var j = 0; j < objKeys.length; ++j) {
	        var key = objKeys[j];
	        var value = typeof key === 'object' && key && typeof key.value !== 'undefined'
	            ? key.value
	            : obj[key];
	
	        if (skipNulls && value === null) {
	            continue;
	        }
	
	        var encodedKey = allowDots && encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
	        var keyPrefix = isArray(obj)
	            ? typeof generateArrayPrefix === 'function' ? generateArrayPrefix(adjustedPrefix, encodedKey) : adjustedPrefix
	            : adjustedPrefix + (allowDots ? '.' + encodedKey : '[' + encodedKey + ']');
	
	        sideChannel.set(object, step);
	        var valueSideChannel = getSideChannel();
	        valueSideChannel.set(sentinel, sideChannel);
	        pushToArray(values, stringify(
	            value,
	            keyPrefix,
	            generateArrayPrefix,
	            commaRoundTrip,
	            allowEmptyArrays,
	            strictNullHandling,
	            skipNulls,
	            encodeDotInKeys,
	            generateArrayPrefix === 'comma' && encodeValuesOnly && isArray(obj) ? null : encoder,
	            filter,
	            sort,
	            allowDots,
	            serializeDate,
	            format,
	            formatter,
	            encodeValuesOnly,
	            charset,
	            valueSideChannel,
	            depth,
	            currentDepth + 1
	        ));
	    }
	
	    return values;
	};
	
	var normalizeStringifyOptions = function normalizeStringifyOptions(opts) {
	    if (!opts) {
	        return defaults;
	    }
	
	    if (typeof opts.allowEmptyArrays !== 'undefined' && typeof opts.allowEmptyArrays !== 'boolean') {
	        throw new TypeError('`allowEmptyArrays` option can only be `true` or `false`, when provided');
	    }
	
	    if (typeof opts.encodeDotInKeys !== 'undefined' && typeof opts.encodeDotInKeys !== 'boolean') {
	        throw new TypeError('`encodeDotInKeys` option can only be `true` or `false`, when provided');
	    }
	
	    if (opts.encoder !== null && typeof opts.encoder !== 'undefined' && typeof opts.encoder !== 'function') {
	        throw new TypeError('Encoder has to be a function.');
	    }
	
	    var charset = opts.charset || defaults.charset;
	    if (typeof opts.charset !== 'undefined' && opts.charset !== 'utf-8' && opts.charset !== 'iso-8859-1') {
	        throw new TypeError('The charset option must be either utf-8, iso-8859-1, or undefined');
	    }
	
	    var format = formats['default'];
	    if (typeof opts.format !== 'undefined') {
	        if (!has.call(formats.formatters, opts.format)) {
	            throw new TypeError('Unknown format option provided.');
	        }
	        format = opts.format;
	    }
	    var formatter = formats.formatters[format];
	
	    var filter = defaults.filter;
	    if (typeof opts.filter === 'function' || isArray(opts.filter)) {
	        filter = opts.filter;
	    }
	
	    var arrayFormat;
	    if (has.call(arrayPrefixGenerators, opts.arrayFormat)) {
	        arrayFormat = opts.arrayFormat;
	    } else if ('indices' in opts) {
	        arrayFormat = opts.indices ? 'indices' : 'repeat';
	    } else {
	        arrayFormat = defaults.arrayFormat;
	    }
	
	    if ('commaRoundTrip' in opts && typeof opts.commaRoundTrip !== 'boolean') {
	        throw new TypeError('`commaRoundTrip` must be a boolean, or absent');
	    }
	
	    var allowDots = typeof opts.allowDots === 'undefined' ? opts.encodeDotInKeys === true ? true : defaults.allowDots : !!opts.allowDots;
	
	    return {
	        addQueryPrefix: typeof opts.addQueryPrefix === 'boolean' ? opts.addQueryPrefix : defaults.addQueryPrefix,
	        allowDots: allowDots,
	        allowEmptyArrays: typeof opts.allowEmptyArrays === 'boolean' ? !!opts.allowEmptyArrays : defaults.allowEmptyArrays,
	        arrayFormat: arrayFormat,
	        charset: charset,
	        charsetSentinel: typeof opts.charsetSentinel === 'boolean' ? opts.charsetSentinel : defaults.charsetSentinel,
	        commaRoundTrip: !!opts.commaRoundTrip,
	        delimiter: typeof opts.delimiter === 'undefined' ? defaults.delimiter : opts.delimiter,
	        depth: typeof opts.depth === 'number' ? opts.depth : defaults.depth,
	        encode: typeof opts.encode === 'boolean' ? opts.encode : defaults.encode,
	        encodeDotInKeys: typeof opts.encodeDotInKeys === 'boolean' ? opts.encodeDotInKeys : defaults.encodeDotInKeys,
	        encoder: typeof opts.encoder === 'function' ? opts.encoder : defaults.encoder,
	        encodeValuesOnly: typeof opts.encodeValuesOnly === 'boolean' ? opts.encodeValuesOnly : defaults.encodeValuesOnly,
	        filter: filter,
	        format: format,
	        formatter: formatter,
	        serializeDate: typeof opts.serializeDate === 'function' ? opts.serializeDate : defaults.serializeDate,
	        skipNulls: typeof opts.skipNulls === 'boolean' ? opts.skipNulls : defaults.skipNulls,
	        sort: typeof opts.sort === 'function' ? opts.sort : null,
	        strictNullHandling: typeof opts.strictNullHandling === 'boolean' ? opts.strictNullHandling : defaults.strictNullHandling
	    };
	};
	
	module.exports = function (object, opts) {
	    var obj = object;
	    var options = normalizeStringifyOptions(opts);
	
	    var objKeys;
	    var filter;
	
	    if (typeof options.filter === 'function') {
	        filter = options.filter;
	        obj = filter('', obj);
	    } else if (isArray(options.filter)) {
	        filter = options.filter;
	        objKeys = filter;
	    }
	
	    var keys = [];
	
	    if (typeof obj !== 'object' || obj === null) {
	        return '';
	    }
	
	    var generateArrayPrefix = arrayPrefixGenerators[options.arrayFormat];
	    var commaRoundTrip = generateArrayPrefix === 'comma' && options.commaRoundTrip;
	
	    if (!objKeys) {
	        objKeys = Object.keys(obj);
	    }
	
	    if (options.sort) {
	        objKeys.sort(options.sort);
	    }
	
	    var sideChannel = getSideChannel();
	    for (var i = 0; i < objKeys.length; ++i) {
	        var key = objKeys[i];
	
	        if (typeof key === 'undefined' || key === null) {
	            continue;
	        }
	
	        var value = obj[key];
	
	        if (options.skipNulls && value === null) {
	            continue;
	        }
	
	        var encodedKey = options.encodeDotInKeys ? String(key).replace(/\./g, '%2E') : String(key);
	
	        pushToArray(keys, stringify(
	            value,
	            encodedKey,
	            generateArrayPrefix,
	            commaRoundTrip,
	            options.allowEmptyArrays,
	            options.strictNullHandling,
	            options.skipNulls,
	            options.encodeDotInKeys,
	            options.encode ? options.encoder : null,
	            options.filter,
	            options.sort,
	            options.allowDots,
	            options.serializeDate,
	            options.format,
	            options.formatter,
	            options.encodeValuesOnly,
	            options.charset,
	            sideChannel,
	            options.depth,
	            0
	        ));
	    }
	
	    var joined = keys.join(options.delimiter);
	    var prefix = options.addQueryPrefix === true ? '?' : '';
	
	    if (options.charsetSentinel) {
	        if (options.charset === 'iso-8859-1') {
	            // encodeURIComponent('&#10003;'), the "numeric entity" representation of a checkmark
	            prefix += 'utf8=%26%2310003%3B' + options.delimiter;
	        } else {
	            // encodeURIComponent('✓')
	            prefix += 'utf8=%E2%9C%93' + options.delimiter;
	        }
	    }
	
	    return joined.length > 0 ? prefix + joined : '';
	};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	// If obj.hasOwnProperty has been overridden, then calling
	// obj.hasOwnProperty(prop) will break.
	// See: https://github.com/joyent/node/issues/1707
	function hasOwnProperty(obj, prop) {
	  return Object.prototype.hasOwnProperty.call(obj, prop);
	}
	
	module.exports = function(qs, sep, eq, options) {
	  sep = sep || '&';
	  eq = eq || '=';
	  var obj = {};
	
	  if (typeof qs !== 'string' || qs.length === 0) {
	    return obj;
	  }
	
	  var regexp = /\+/g;
	  qs = qs.split(sep);
	
	  var maxKeys = 1000;
	  if (options && typeof options.maxKeys === 'number') {
	    maxKeys = options.maxKeys;
	  }
	
	  var len = qs.length;
	  // maxKeys <= 0 means that we should not limit keys count
	  if (maxKeys > 0 && len > maxKeys) {
	    len = maxKeys;
	  }
	
	  for (var i = 0; i < len; ++i) {
	    var x = qs[i].replace(regexp, '%20'),
	        idx = x.indexOf(eq),
	        kstr, vstr, k, v;
	
	    if (idx >= 0) {
	      kstr = x.substr(0, idx);
	      vstr = x.substr(idx + 1);
	    } else {
	      kstr = x;
	      vstr = '';
	    }
	
	    k = decodeURIComponent(kstr);
	    v = decodeURIComponent(vstr);
	
	    if (!hasOwnProperty(obj, k)) {
	      obj[k] = v;
	    } else if (Array.isArray(obj[k])) {
	      obj[k].push(v);
	    } else {
	      obj[k] = [obj[k], v];
	    }
	  }
	
	  return obj;
	};


/***/ }),
/* 131 */
/***/ (function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	var stringifyPrimitive = function(v) {
	  switch (typeof v) {
	    case 'string':
	      return v;
	
	    case 'boolean':
	      return v ? 'true' : 'false';
	
	    case 'number':
	      return isFinite(v) ? v : '';
	
	    default:
	      return '';
	  }
	};
	
	module.exports = function(obj, sep, eq, name) {
	  sep = sep || '&';
	  eq = eq || '=';
	  if (obj === null) {
	    obj = undefined;
	  }
	
	  if (typeof obj === 'object') {
	    return Object.keys(obj).map(function(k) {
	      var ks = encodeURIComponent(stringifyPrimitive(k)) + eq;
	      if (Array.isArray(obj[k])) {
	        return obj[k].map(function(v) {
	          return ks + encodeURIComponent(stringifyPrimitive(v));
	        }).join(sep);
	      } else {
	        return ks + encodeURIComponent(stringifyPrimitive(obj[k]));
	      }
	    }).filter(Boolean).join(sep);
	
	  }
	
	  if (!name) return '';
	  return encodeURIComponent(stringifyPrimitive(name)) + eq +
	         encodeURIComponent(stringifyPrimitive(obj));
	};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.decode = exports.parse = __webpack_require__(130);
	exports.encode = exports.stringify = __webpack_require__(131);


/***/ }),
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */
/***/ (function(module, exports) {

	'use strict';
	
	var isArray = Array.isArray;
	var keyList = Object.keys;
	var hasProp = Object.prototype.hasOwnProperty;
	var hasElementType = typeof Element !== 'undefined';
	
	function equal(a, b) {
	  // fast-deep-equal index.js 2.0.1
	  if (a === b) return true;
	
	  if (a && b && typeof a == 'object' && typeof b == 'object') {
	    var arrA = isArray(a)
	      , arrB = isArray(b)
	      , i
	      , length
	      , key;
	
	    if (arrA && arrB) {
	      length = a.length;
	      if (length != b.length) return false;
	      for (i = length; i-- !== 0;)
	        if (!equal(a[i], b[i])) return false;
	      return true;
	    }
	
	    if (arrA != arrB) return false;
	
	    var dateA = a instanceof Date
	      , dateB = b instanceof Date;
	    if (dateA != dateB) return false;
	    if (dateA && dateB) return a.getTime() == b.getTime();
	
	    var regexpA = a instanceof RegExp
	      , regexpB = b instanceof RegExp;
	    if (regexpA != regexpB) return false;
	    if (regexpA && regexpB) return a.toString() == b.toString();
	
	    var keys = keyList(a);
	    length = keys.length;
	
	    if (length !== keyList(b).length)
	      return false;
	
	    for (i = length; i-- !== 0;)
	      if (!hasProp.call(b, keys[i])) return false;
	    // end fast-deep-equal
	
	    // start react-fast-compare
	    // custom handling for DOM elements
	    if (hasElementType && a instanceof Element && b instanceof Element)
	      return a === b;
	
	    // custom handling for React
	    for (i = length; i-- !== 0;) {
	      key = keys[i];
	      if (key === '_owner' && a.$$typeof) {
	        // React-specific: avoid traversing React elements' _owner.
	        //  _owner contains circular references
	        // and is not needed when comparing the actual elements (and not their owners)
	        // .$$typeof and ._store on just reasonable markers of a react element
	        continue;
	      } else {
	        // all other properties should be traversed as usual
	        if (!equal(a[key], b[key])) return false;
	      }
	    }
	    // end react-fast-compare
	
	    // fast-deep-equal index.js 2.0.1
	    return true;
	  }
	
	  return a !== a && b !== b;
	}
	// end fast-deep-equal
	
	module.exports = function exportedEqual(a, b) {
	  try {
	    return equal(a, b);
	  } catch (error) {
	    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
	      // warn on circular references, don't crash
	      // browsers give this different errors name and messages:
	      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
	      // firefox: "InternalError", too much recursion"
	      // edge: "Error", "Out of stack space"
	      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
	      return false;
	    }
	    // some other error. we should definitely know about these
	    throw error;
	  }
	};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(146);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _reactFastCompare = __webpack_require__(137);
	
	var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);
	
	var _HelmetUtils = __webpack_require__(139);
	
	var _HelmetConstants = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _reactFastCompare2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	             * @param {Object} bodyAttributes: {"className": "root"}
	             * @param {String} defaultTitle: "Default Title"
	             * @param {Boolean} defer: true
	             * @param {Boolean} encodeSpecialCharacters: true
	             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	             * @param {String} title: "Title"
	             * @param {Object} titleAttributes: {"itemprop": "name"}
	             * @param {String} titleTemplate: "MySite.com - %s"
	             */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(5);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(27);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // This file is a fallback for a consumer who is not yet on React 16
	// as createPortal was introduced in React 16
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(props) {
	      this.renderPortal();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      _reactDom2.default.unmountComponentAtNode(this.defaultNode || this.props.node);
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	      this.portal = null;
	    }
	  }, {
	    key: 'renderPortal',
	    value: function renderPortal(props) {
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	
	      var children = this.props.children;
	      // https://gist.github.com/jimfb/d99e0678e9da715ccf6454961ef04d1b
	      if (typeof this.props.children.type === 'function') {
	        children = _react2.default.cloneElement(this.props.children);
	      }
	
	      this.portal = _reactDom2.default.unstable_renderSubtreeIntoContainer(this, children, this.props.node || this.defaultNode);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	exports.default = Portal;
	
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(27);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _utils = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Portal = function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _possibleConstructorReturn(this, (Portal.__proto__ || Object.getPrototypeOf(Portal)).apply(this, arguments));
	  }
	
	  _createClass(Portal, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.defaultNode) {
	        document.body.removeChild(this.defaultNode);
	      }
	      this.defaultNode = null;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (!_utils.canUseDOM) {
	        return null;
	      }
	      if (!this.props.node && !this.defaultNode) {
	        this.defaultNode = document.createElement('div');
	        document.body.appendChild(this.defaultNode);
	      }
	      return _reactDom2.default.createPortal(this.props.children, this.props.node || this.defaultNode);
	    }
	  }]);
	
	  return Portal;
	}(_react2.default.Component);
	
	Portal.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  node: _propTypes2.default.any
	};
	
	exports.default = Portal;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PortalCompat = __webpack_require__(54);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var KEYCODES = {
	  ESCAPE: 27
	};
	
	var PortalWithState = function (_React$Component) {
	  _inherits(PortalWithState, _React$Component);
	
	  function PortalWithState(props) {
	    _classCallCheck(this, PortalWithState);
	
	    var _this = _possibleConstructorReturn(this, (PortalWithState.__proto__ || Object.getPrototypeOf(PortalWithState)).call(this, props));
	
	    _this.portalNode = null;
	    _this.state = { active: !!props.defaultOpen };
	    _this.openPortal = _this.openPortal.bind(_this);
	    _this.closePortal = _this.closePortal.bind(_this);
	    _this.wrapWithPortal = _this.wrapWithPortal.bind(_this);
	    _this.handleOutsideMouseClick = _this.handleOutsideMouseClick.bind(_this);
	    _this.handleKeydown = _this.handleKeydown.bind(_this);
	    return _this;
	  }
	
	  _createClass(PortalWithState, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.closeOnEsc) {
	        document.addEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.addEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.props.closeOnEsc) {
	        document.removeEventListener('keydown', this.handleKeydown);
	      }
	      if (this.props.closeOnOutsideClick) {
	        document.removeEventListener('click', this.handleOutsideMouseClick);
	      }
	    }
	  }, {
	    key: 'openPortal',
	    value: function openPortal(e) {
	      if (this.state.active) {
	        return;
	      }
	      if (e && e.nativeEvent) {
	        e.nativeEvent.stopImmediatePropagation();
	      }
	      this.setState({ active: true }, this.props.onOpen);
	    }
	  }, {
	    key: 'closePortal',
	    value: function closePortal() {
	      if (!this.state.active) {
	        return;
	      }
	      this.setState({ active: false }, this.props.onClose);
	    }
	  }, {
	    key: 'wrapWithPortal',
	    value: function wrapWithPortal(children) {
	      var _this2 = this;
	
	      if (!this.state.active) {
	        return null;
	      }
	      return _react2.default.createElement(
	        _PortalCompat2.default,
	        {
	          node: this.props.node,
	          key: 'react-portal',
	          ref: function ref(portalNode) {
	            return _this2.portalNode = portalNode;
	          }
	        },
	        children
	      );
	    }
	  }, {
	    key: 'handleOutsideMouseClick',
	    value: function handleOutsideMouseClick(e) {
	      if (!this.state.active) {
	        return;
	      }
	      var root = this.portalNode && (this.portalNode.props.node || this.portalNode.defaultNode);
	      if (!root || root.contains(e.target) || e.button && e.button !== 0) {
	        return;
	      }
	      this.closePortal();
	    }
	  }, {
	    key: 'handleKeydown',
	    value: function handleKeydown(e) {
	      if (e.keyCode === KEYCODES.ESCAPE && this.state.active) {
	        this.closePortal();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children({
	        openPortal: this.openPortal,
	        closePortal: this.closePortal,
	        portal: this.wrapWithPortal,
	        isOpen: this.state.active
	      });
	    }
	  }]);
	
	  return PortalWithState;
	}(_react2.default.Component);
	
	PortalWithState.propTypes = {
	  children: _propTypes2.default.func.isRequired,
	  defaultOpen: _propTypes2.default.bool,
	  node: _propTypes2.default.any,
	  closeOnEsc: _propTypes2.default.bool,
	  closeOnOutsideClick: _propTypes2.default.bool,
	  onOpen: _propTypes2.default.func,
	  onClose: _propTypes2.default.func
	};
	
	PortalWithState.defaultProps = {
	  onOpen: function onOpen() {},
	  onClose: function onClose() {}
	};
	
	exports.default = PortalWithState;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PortalWithState = exports.Portal = undefined;
	
	var _PortalCompat = __webpack_require__(54);
	
	var _PortalCompat2 = _interopRequireDefault(_PortalCompat);
	
	var _PortalWithState = __webpack_require__(142);
	
	var _PortalWithState2 = _interopRequireDefault(_PortalWithState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Portal = _PortalCompat2.default;
	exports.PortalWithState = _PortalWithState2.default;

/***/ }),
/* 144 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ }),
/* 145 */,
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var React = __webpack_require__(2);
	var React__default = _interopDefault(React);
	var shallowEqual = _interopDefault(__webpack_require__(156));
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect =
	    /*#__PURE__*/
	    function (_Component) {
	      _inheritsLoose(SideEffect, _Component);
	
	      function SideEffect() {
	        return _Component.apply(this, arguments) || this;
	      }
	
	      // Try to use displayName of wrapped component
	      // Expose canUseDOM so tests can monkeypatch it
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      var _proto = SideEffect.prototype;
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !shallowEqual(nextProps, this.props);
	      };
	
	      _proto.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      _proto.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      _proto.render = function render() {
	        return React__default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(React.Component);
	
	    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");
	
	    _defineProperty(SideEffect, "canUseDOM", canUseDOM);
	
	    return SideEffect;
	  };
	}
	
	module.exports = withSideEffect;


/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */
/***/ (function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var inspect = __webpack_require__(18);
	
	var $TypeError = __webpack_require__(9);
	
	/*
	* This function traverses the list returning the node corresponding to the given key.
	*
	* That node is also moved to the head of the list, so that if it's accessed again we don't need to traverse the whole list.
	* By doing so, all the recently used nodes can be accessed relatively quickly.
	*/
	/** @type {import('./list.d.ts').listGetNode} */
	// eslint-disable-next-line consistent-return
	var listGetNode = function (list, key, isDelete) {
		/** @type {typeof list | NonNullable<(typeof list)['next']>} */
		var prev = list;
		/** @type {(typeof list)['next']} */
		var curr;
		// eslint-disable-next-line eqeqeq
		for (; (curr = prev.next) != null; prev = curr) {
			if (curr.key === key) {
				prev.next = curr.next;
				if (!isDelete) {
					// eslint-disable-next-line no-extra-parens
					curr.next = /** @type {NonNullable<typeof list.next>} */ (list.next);
					list.next = curr; // eslint-disable-line no-param-reassign
				}
				return curr;
			}
		}
	};
	
	/** @type {import('./list.d.ts').listGet} */
	var listGet = function (objects, key) {
		if (!objects) {
			return void undefined;
		}
		var node = listGetNode(objects, key);
		return node && node.value;
	};
	/** @type {import('./list.d.ts').listSet} */
	var listSet = function (objects, key, value) {
		var node = listGetNode(objects, key);
		if (node) {
			node.value = value;
		} else {
			// Prepend the new node to the beginning of the list
			objects.next = /** @type {import('./list.d.ts').ListNode<typeof value, typeof key>} */ ({ // eslint-disable-line no-param-reassign, no-extra-parens
				key: key,
				next: objects.next,
				value: value
			});
		}
	};
	/** @type {import('./list.d.ts').listHas} */
	var listHas = function (objects, key) {
		if (!objects) {
			return false;
		}
		return !!listGetNode(objects, key);
	};
	/** @type {import('./list.d.ts').listDelete} */
	// eslint-disable-next-line consistent-return
	var listDelete = function (objects, key) {
		if (objects) {
			return listGetNode(objects, key, true);
		}
	};
	
	/** @type {import('.')} */
	module.exports = function getSideChannelList() {
		/** @typedef {ReturnType<typeof getSideChannelList>} Channel */
		/** @typedef {Parameters<Channel['get']>[0]} K */
		/** @typedef {Parameters<Channel['set']>[1]} V */
	
		/** @type {import('./list.d.ts').RootNode<V, K> | undefined} */ var $o;
	
		/** @type {Channel} */
		var channel = {
			assert: function (key) {
				if (!channel.has(key)) {
					throw new $TypeError('Side channel does not contain ' + inspect(key));
				}
			},
			'delete': function (key) {
				var deletedNode = listDelete($o, key);
				if (deletedNode && $o && !$o.next) {
					$o = void undefined;
				}
				return !!deletedNode;
			},
			get: function (key) {
				return listGet($o, key);
			},
			has: function (key) {
				return listHas($o, key);
			},
			set: function (key, value) {
				if (!$o) {
					// Initialize the linked list as an empty node, so that we don't have to special-case handling of the first node: we can always refer to it as (previous node).next, instead of something like (list).head
					$o = {
						next: void undefined
					};
				}
				// eslint-disable-next-line no-extra-parens
				listSet(/** @type {NonNullable<typeof $o>} */ ($o), key, value);
			}
		};
		return channel;
	};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var GetIntrinsic = __webpack_require__(25);
	var callBound = __webpack_require__(42);
	var inspect = __webpack_require__(18);
	var getSideChannelMap = __webpack_require__(59);
	
	var $TypeError = __webpack_require__(9);
	var $WeakMap = GetIntrinsic('%WeakMap%', true);
	
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => V} */
	var $weakMapGet = callBound('WeakMap.prototype.get', true);
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K, value: V) => void} */
	var $weakMapSet = callBound('WeakMap.prototype.set', true);
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
	var $weakMapHas = callBound('WeakMap.prototype.has', true);
	/** @type {<K extends object, V>(thisArg: WeakMap<K, V>, key: K) => boolean} */
	var $weakMapDelete = callBound('WeakMap.prototype.delete', true);
	
	/** @type {import('.')} */
	module.exports = $WeakMap
		? /** @type {Exclude<import('.'), false>} */ function getSideChannelWeakMap() {
			/** @typedef {ReturnType<typeof getSideChannelWeakMap>} Channel */
			/** @typedef {Parameters<Channel['get']>[0]} K */
			/** @typedef {Parameters<Channel['set']>[1]} V */
	
			/** @type {WeakMap<K & object, V> | undefined} */ var $wm;
			/** @type {Channel | undefined} */ var $m;
	
			/** @type {Channel} */
			var channel = {
				assert: function (key) {
					if (!channel.has(key)) {
						throw new $TypeError('Side channel does not contain ' + inspect(key));
					}
				},
				'delete': function (key) {
					if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
						if ($wm) {
							return $weakMapDelete($wm, key);
						}
					} else if (getSideChannelMap) {
						if ($m) {
							return $m['delete'](key);
						}
					}
					return false;
				},
				get: function (key) {
					if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
						if ($wm) {
							return $weakMapGet($wm, key);
						}
					}
					return $m && $m.get(key);
				},
				has: function (key) {
					if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
						if ($wm) {
							return $weakMapHas($wm, key);
						}
					}
					return !!$m && $m.has(key);
				},
				set: function (key, value) {
					if ($WeakMap && key && (typeof key === 'object' || typeof key === 'function')) {
						if (!$wm) {
							$wm = new $WeakMap();
						}
						$weakMapSet($wm, key, value);
					} else if (getSideChannelMap) {
						if (!$m) {
							$m = getSideChannelMap();
						}
						// eslint-disable-next-line no-extra-parens
						/** @type {NonNullable<typeof $m>} */ ($m).set(key, value);
					}
				}
			};
	
			// @ts-expect-error TODO: figure out why this is erroring
			return channel;
		}
		: getSideChannelMap;


/***/ }),
/* 159 */,
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 * Copyright Joyent, Inc. and other Node contributors.
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a
	 * copy of this software and associated documentation files (the
	 * "Software"), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to permit
	 * persons to whom the Software is furnished to do so, subject to the
	 * following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included
	 * in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	 * USE OR OTHER DEALINGS IN THE SOFTWARE.
	 */
	
	'use strict';
	
	var punycode = __webpack_require__(126);
	
	function Url() {
	  this.protocol = null;
	  this.slashes = null;
	  this.auth = null;
	  this.host = null;
	  this.port = null;
	  this.hostname = null;
	  this.hash = null;
	  this.search = null;
	  this.query = null;
	  this.pathname = null;
	  this.path = null;
	  this.href = null;
	}
	
	// Reference: RFC 3986, RFC 1808, RFC 2396
	
	/*
	 * define these here so at least they only have to be
	 * compiled once on the first module load.
	 */
	var protocolPattern = /^([a-z0-9.+-]+:)/i,
	  portPattern = /:[0-9]*$/,
	
	  // Special case for a simple path URL
	  simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/,
	
	  /*
	   * RFC 2396: characters reserved for delimiting URLs.
	   * We actually just auto-escape these.
	   */
	  delims = [
	    '<', '>', '"', '`', ' ', '\r', '\n', '\t'
	  ],
	
	  // RFC 2396: characters not allowed for various reasons.
	  unwise = [
	    '{', '}', '|', '\\', '^', '`'
	  ].concat(delims),
	
	  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
	  autoEscape = ['\''].concat(unwise),
	  /*
	   * Characters that are never ever allowed in a hostname.
	   * Note that any invalid chars are also handled, but these
	   * are the ones that are *expected* to be seen, so we fast-path
	   * them.
	   */
	  nonHostChars = [
	    '%', '/', '?', ';', '#'
	  ].concat(autoEscape),
	  hostEndingChars = [
	    '/', '?', '#'
	  ],
	  hostnameMaxLen = 255,
	  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
	  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
	  // protocols that can allow "unsafe" and "unwise" chars.
	  unsafeProtocol = {
	    javascript: true,
	    'javascript:': true
	  },
	  // protocols that never have a hostname.
	  hostlessProtocol = {
	    javascript: true,
	    'javascript:': true
	  },
	  // protocols that always contain a // bit.
	  slashedProtocol = {
	    http: true,
	    https: true,
	    ftp: true,
	    gopher: true,
	    file: true,
	    'http:': true,
	    'https:': true,
	    'ftp:': true,
	    'gopher:': true,
	    'file:': true
	  },
	  querystring = __webpack_require__(127);
	
	function urlParse(url, parseQueryString, slashesDenoteHost) {
	  if (url && typeof url === 'object' && url instanceof Url) { return url; }
	
	  var u = new Url();
	  u.parse(url, parseQueryString, slashesDenoteHost);
	  return u;
	}
	
	Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
	  if (typeof url !== 'string') {
	    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
	  }
	
	  /*
	   * Copy chrome, IE, opera backslash-handling behavior.
	   * Back slashes before the query string get converted to forward slashes
	   * See: https://code.google.com/p/chromium/issues/detail?id=25916
	   */
	  var queryIndex = url.indexOf('?'),
	    splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
	    uSplit = url.split(splitter),
	    slashRegex = /\\/g;
	  uSplit[0] = uSplit[0].replace(slashRegex, '/');
	  url = uSplit.join(splitter);
	
	  var rest = url;
	
	  /*
	   * trim before proceeding.
	   * This is to support parse stuff like "  http://foo.com  \n"
	   */
	  rest = rest.trim();
	
	  if (!slashesDenoteHost && url.split('#').length === 1) {
	    // Try fast path regexp
	    var simplePath = simplePathPattern.exec(rest);
	    if (simplePath) {
	      this.path = rest;
	      this.href = rest;
	      this.pathname = simplePath[1];
	      if (simplePath[2]) {
	        this.search = simplePath[2];
	        if (parseQueryString) {
	          this.query = querystring.parse(this.search.substr(1));
	        } else {
	          this.query = this.search.substr(1);
	        }
	      } else if (parseQueryString) {
	        this.search = '';
	        this.query = {};
	      }
	      return this;
	    }
	  }
	
	  var proto = protocolPattern.exec(rest);
	  if (proto) {
	    proto = proto[0];
	    var lowerProto = proto.toLowerCase();
	    this.protocol = lowerProto;
	    rest = rest.substr(proto.length);
	  }
	
	  /*
	   * figure out if it's got a host
	   * user@server is *always* interpreted as a hostname, and url
	   * resolution will treat //foo/bar as host=foo,path=bar because that's
	   * how the browser resolves relative URLs.
	   */
	  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
	    var slashes = rest.substr(0, 2) === '//';
	    if (slashes && !(proto && hostlessProtocol[proto])) {
	      rest = rest.substr(2);
	      this.slashes = true;
	    }
	  }
	
	  if (!hostlessProtocol[proto] && (slashes || (proto && !slashedProtocol[proto]))) {
	
	    /*
	     * there's a hostname.
	     * the first instance of /, ?, ;, or # ends the host.
	     *
	     * If there is an @ in the hostname, then non-host chars *are* allowed
	     * to the left of the last @ sign, unless some host-ending character
	     * comes *before* the @-sign.
	     * URLs are obnoxious.
	     *
	     * ex:
	     * http://a@b@c/ => user:a@b host:c
	     * http://a@b?@c => user:a host:c path:/?@c
	     */
	
	    /*
	     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
	     * Review our test case against browsers more comprehensively.
	     */
	
	    // find the first instance of any hostEndingChars
	    var hostEnd = -1;
	    for (var i = 0; i < hostEndingChars.length; i++) {
	      var hec = rest.indexOf(hostEndingChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
	    }
	
	    /*
	     * at this point, either we have an explicit point where the
	     * auth portion cannot go past, or the last @ char is the decider.
	     */
	    var auth, atSign;
	    if (hostEnd === -1) {
	      // atSign can be anywhere.
	      atSign = rest.lastIndexOf('@');
	    } else {
	      /*
	       * atSign must be in auth portion.
	       * http://a@b/c@d => host:b auth:a path:/c@d
	       */
	      atSign = rest.lastIndexOf('@', hostEnd);
	    }
	
	    /*
	     * Now we have a portion which is definitely the auth.
	     * Pull that off.
	     */
	    if (atSign !== -1) {
	      auth = rest.slice(0, atSign);
	      rest = rest.slice(atSign + 1);
	      this.auth = decodeURIComponent(auth);
	    }
	
	    // the host is the remaining to the left of the first non-host char
	    hostEnd = -1;
	    for (var i = 0; i < nonHostChars.length; i++) {
	      var hec = rest.indexOf(nonHostChars[i]);
	      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
	    }
	    // if we still have not hit it, then the entire thing is a host.
	    if (hostEnd === -1) { hostEnd = rest.length; }
	
	    this.host = rest.slice(0, hostEnd);
	    rest = rest.slice(hostEnd);
	
	    // pull out port.
	    this.parseHost();
	
	    /*
	     * we've indicated that there is a hostname,
	     * so even if it's empty, it has to be present.
	     */
	    this.hostname = this.hostname || '';
	
	    /*
	     * if hostname begins with [ and ends with ]
	     * assume that it's an IPv6 address.
	     */
	    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';
	
	    // validate a little.
	    if (!ipv6Hostname) {
	      var hostparts = this.hostname.split(/\./);
	      for (var i = 0, l = hostparts.length; i < l; i++) {
	        var part = hostparts[i];
	        if (!part) { continue; }
	        if (!part.match(hostnamePartPattern)) {
	          var newpart = '';
	          for (var j = 0, k = part.length; j < k; j++) {
	            if (part.charCodeAt(j) > 127) {
	              /*
	               * we replace non-ASCII char with a temporary placeholder
	               * we need this to make sure size of hostname is not
	               * broken by replacing non-ASCII by nothing
	               */
	              newpart += 'x';
	            } else {
	              newpart += part[j];
	            }
	          }
	          // we test again with ASCII char only
	          if (!newpart.match(hostnamePartPattern)) {
	            var validParts = hostparts.slice(0, i);
	            var notHost = hostparts.slice(i + 1);
	            var bit = part.match(hostnamePartStart);
	            if (bit) {
	              validParts.push(bit[1]);
	              notHost.unshift(bit[2]);
	            }
	            if (notHost.length) {
	              rest = '/' + notHost.join('.') + rest;
	            }
	            this.hostname = validParts.join('.');
	            break;
	          }
	        }
	      }
	    }
	
	    if (this.hostname.length > hostnameMaxLen) {
	      this.hostname = '';
	    } else {
	      // hostnames are always lower case.
	      this.hostname = this.hostname.toLowerCase();
	    }
	
	    if (!ipv6Hostname) {
	      /*
	       * IDNA Support: Returns a punycoded representation of "domain".
	       * It only converts parts of the domain name that
	       * have non-ASCII characters, i.e. it doesn't matter if
	       * you call it with a domain that already is ASCII-only.
	       */
	      this.hostname = punycode.toASCII(this.hostname);
	    }
	
	    var p = this.port ? ':' + this.port : '';
	    var h = this.hostname || '';
	    this.host = h + p;
	    this.href += this.host;
	
	    /*
	     * strip [ and ] from the hostname
	     * the host field still retains them, though
	     */
	    if (ipv6Hostname) {
	      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
	      if (rest[0] !== '/') {
	        rest = '/' + rest;
	      }
	    }
	  }
	
	  /*
	   * now rest is set to the post-host stuff.
	   * chop off any delim chars.
	   */
	  if (!unsafeProtocol[lowerProto]) {
	
	    /*
	     * First, make 100% sure that any "autoEscape" chars get
	     * escaped, even if encodeURIComponent doesn't think they
	     * need to be.
	     */
	    for (var i = 0, l = autoEscape.length; i < l; i++) {
	      var ae = autoEscape[i];
	      if (rest.indexOf(ae) === -1) { continue; }
	      var esc = encodeURIComponent(ae);
	      if (esc === ae) {
	        esc = escape(ae);
	      }
	      rest = rest.split(ae).join(esc);
	    }
	  }
	
	  // chop off from the tail first.
	  var hash = rest.indexOf('#');
	  if (hash !== -1) {
	    // got a fragment string.
	    this.hash = rest.substr(hash);
	    rest = rest.slice(0, hash);
	  }
	  var qm = rest.indexOf('?');
	  if (qm !== -1) {
	    this.search = rest.substr(qm);
	    this.query = rest.substr(qm + 1);
	    if (parseQueryString) {
	      this.query = querystring.parse(this.query);
	    }
	    rest = rest.slice(0, qm);
	  } else if (parseQueryString) {
	    // no query string, but parseQueryString still requested
	    this.search = '';
	    this.query = {};
	  }
	  if (rest) { this.pathname = rest; }
	  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
	    this.pathname = '/';
	  }
	
	  // to support http.request
	  if (this.pathname || this.search) {
	    var p = this.pathname || '';
	    var s = this.search || '';
	    this.path = p + s;
	  }
	
	  // finally, reconstruct the href based on what has been validated.
	  this.href = this.format();
	  return this;
	};
	
	// format a parsed object into a url string
	function urlFormat(obj) {
	  /*
	   * ensure it's an object, and not a string url.
	   * If it's an obj, this is a no-op.
	   * this way, you can call url_format() on strings
	   * to clean up potentially wonky urls.
	   */
	  if (typeof obj === 'string') { obj = urlParse(obj); }
	  if (!(obj instanceof Url)) { return Url.prototype.format.call(obj); }
	  return obj.format();
	}
	
	Url.prototype.format = function () {
	  var auth = this.auth || '';
	  if (auth) {
	    auth = encodeURIComponent(auth);
	    auth = auth.replace(/%3A/i, ':');
	    auth += '@';
	  }
	
	  var protocol = this.protocol || '',
	    pathname = this.pathname || '',
	    hash = this.hash || '',
	    host = false,
	    query = '';
	
	  if (this.host) {
	    host = auth + this.host;
	  } else if (this.hostname) {
	    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
	    if (this.port) {
	      host += ':' + this.port;
	    }
	  }
	
	  if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) {
	    query = querystring.stringify(this.query, {
	      arrayFormat: 'repeat',
	      addQueryPrefix: false
	    });
	  }
	
	  var search = this.search || (query && ('?' + query)) || '';
	
	  if (protocol && protocol.substr(-1) !== ':') { protocol += ':'; }
	
	  /*
	   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
	   * unless they had them to begin with.
	   */
	  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
	    host = '//' + (host || '');
	    if (pathname && pathname.charAt(0) !== '/') { pathname = '/' + pathname; }
	  } else if (!host) {
	    host = '';
	  }
	
	  if (hash && hash.charAt(0) !== '#') { hash = '#' + hash; }
	  if (search && search.charAt(0) !== '?') { search = '?' + search; }
	
	  pathname = pathname.replace(/[?#]/g, function (match) {
	    return encodeURIComponent(match);
	  });
	  search = search.replace('#', '%23');
	
	  return protocol + host + pathname + search + hash;
	};
	
	function urlResolve(source, relative) {
	  return urlParse(source, false, true).resolve(relative);
	}
	
	Url.prototype.resolve = function (relative) {
	  return this.resolveObject(urlParse(relative, false, true)).format();
	};
	
	function urlResolveObject(source, relative) {
	  if (!source) { return relative; }
	  return urlParse(source, false, true).resolveObject(relative);
	}
	
	Url.prototype.resolveObject = function (relative) {
	  if (typeof relative === 'string') {
	    var rel = new Url();
	    rel.parse(relative, false, true);
	    relative = rel;
	  }
	
	  var result = new Url();
	  var tkeys = Object.keys(this);
	  for (var tk = 0; tk < tkeys.length; tk++) {
	    var tkey = tkeys[tk];
	    result[tkey] = this[tkey];
	  }
	
	  /*
	   * hash is always overridden, no matter what.
	   * even href="" will remove it.
	   */
	  result.hash = relative.hash;
	
	  // if the relative url is empty, then there's nothing left to do here.
	  if (relative.href === '') {
	    result.href = result.format();
	    return result;
	  }
	
	  // hrefs like //foo/bar always cut to the protocol.
	  if (relative.slashes && !relative.protocol) {
	    // take everything except the protocol from relative
	    var rkeys = Object.keys(relative);
	    for (var rk = 0; rk < rkeys.length; rk++) {
	      var rkey = rkeys[rk];
	      if (rkey !== 'protocol') { result[rkey] = relative[rkey]; }
	    }
	
	    // urlParse appends trailing / to urls like http://www.example.com
	    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
	      result.pathname = '/';
	      result.path = result.pathname;
	    }
	
	    result.href = result.format();
	    return result;
	  }
	
	  if (relative.protocol && relative.protocol !== result.protocol) {
	    /*
	     * if it's a known url protocol, then changing
	     * the protocol does weird things
	     * first, if it's not file:, then we MUST have a host,
	     * and if there was a path
	     * to begin with, then we MUST have a path.
	     * if it is file:, then the host is dropped,
	     * because that's known to be hostless.
	     * anything else is assumed to be absolute.
	     */
	    if (!slashedProtocol[relative.protocol]) {
	      var keys = Object.keys(relative);
	      for (var v = 0; v < keys.length; v++) {
	        var k = keys[v];
	        result[k] = relative[k];
	      }
	      result.href = result.format();
	      return result;
	    }
	
	    result.protocol = relative.protocol;
	    if (!relative.host && !hostlessProtocol[relative.protocol]) {
	      var relPath = (relative.pathname || '').split('/');
	      while (relPath.length && !(relative.host = relPath.shift())) { }
	      if (!relative.host) { relative.host = ''; }
	      if (!relative.hostname) { relative.hostname = ''; }
	      if (relPath[0] !== '') { relPath.unshift(''); }
	      if (relPath.length < 2) { relPath.unshift(''); }
	      result.pathname = relPath.join('/');
	    } else {
	      result.pathname = relative.pathname;
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    result.host = relative.host || '';
	    result.auth = relative.auth;
	    result.hostname = relative.hostname || relative.host;
	    result.port = relative.port;
	    // to support http.request
	    if (result.pathname || result.search) {
	      var p = result.pathname || '';
	      var s = result.search || '';
	      result.path = p + s;
	    }
	    result.slashes = result.slashes || relative.slashes;
	    result.href = result.format();
	    return result;
	  }
	
	  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
	    isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
	    mustEndAbs = isRelAbs || isSourceAbs || (result.host && relative.pathname),
	    removeAllDots = mustEndAbs,
	    srcPath = result.pathname && result.pathname.split('/') || [],
	    relPath = relative.pathname && relative.pathname.split('/') || [],
	    psychotic = result.protocol && !slashedProtocol[result.protocol];
	
	  /*
	   * if the url is a non-slashed url, then relative
	   * links like ../.. should be able
	   * to crawl up to the hostname, as well.  This is strange.
	   * result.protocol has already been set by now.
	   * Later on, put the first path part into the host field.
	   */
	  if (psychotic) {
	    result.hostname = '';
	    result.port = null;
	    if (result.host) {
	      if (srcPath[0] === '') { srcPath[0] = result.host; } else { srcPath.unshift(result.host); }
	    }
	    result.host = '';
	    if (relative.protocol) {
	      relative.hostname = null;
	      relative.port = null;
	      if (relative.host) {
	        if (relPath[0] === '') { relPath[0] = relative.host; } else { relPath.unshift(relative.host); }
	      }
	      relative.host = null;
	    }
	    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
	  }
	
	  if (isRelAbs) {
	    // it's absolute.
	    result.host = relative.host || relative.host === '' ? relative.host : result.host;
	    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
	    result.search = relative.search;
	    result.query = relative.query;
	    srcPath = relPath;
	    // fall through to the dot-handling below.
	  } else if (relPath.length) {
	    /*
	     * it's relative
	     * throw away the existing file, and take the new path instead.
	     */
	    if (!srcPath) { srcPath = []; }
	    srcPath.pop();
	    srcPath = srcPath.concat(relPath);
	    result.search = relative.search;
	    result.query = relative.query;
	  } else if (relative.search != null) {
	    /*
	     * just pull out the search.
	     * like href='?foo'.
	     * Put this after the other two cases because it simplifies the booleans
	     */
	    if (psychotic) {
	      result.host = srcPath.shift();
	      result.hostname = result.host;
	      /*
	       * occationaly the auth can get stuck only in host
	       * this especially happens in cases like
	       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	       */
	      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
	      if (authInHost) {
	        result.auth = authInHost.shift();
	        result.hostname = authInHost.shift();
	        result.host = result.hostname;
	      }
	    }
	    result.search = relative.search;
	    result.query = relative.query;
	    // to support http.request
	    if (result.pathname !== null || result.search !== null) {
	      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  if (!srcPath.length) {
	    /*
	     * no path at all.  easy.
	     * we've already handled the other stuff above.
	     */
	    result.pathname = null;
	    // to support http.request
	    if (result.search) {
	      result.path = '/' + result.search;
	    } else {
	      result.path = null;
	    }
	    result.href = result.format();
	    return result;
	  }
	
	  /*
	   * if a url ENDs in . or .., then it must get a trailing slash.
	   * however, if it ends in anything else non-slashy,
	   * then it must NOT get a trailing slash.
	   */
	  var last = srcPath.slice(-1)[0];
	  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';
	
	  /*
	   * strip single dots, resolve double dots to parent dir
	   * if the path tries to go above the root, `up` ends up > 0
	   */
	  var up = 0;
	  for (var i = srcPath.length; i >= 0; i--) {
	    last = srcPath[i];
	    if (last === '.') {
	      srcPath.splice(i, 1);
	    } else if (last === '..') {
	      srcPath.splice(i, 1);
	      up++;
	    } else if (up) {
	      srcPath.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (!mustEndAbs && !removeAllDots) {
	    for (; up--; up) {
	      srcPath.unshift('..');
	    }
	  }
	
	  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
	    srcPath.unshift('');
	  }
	
	  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
	    srcPath.push('');
	  }
	
	  var isAbsolute = srcPath[0] === '' || (srcPath[0] && srcPath[0].charAt(0) === '/');
	
	  // put the host back
	  if (psychotic) {
	    result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
	    result.host = result.hostname;
	    /*
	     * occationaly the auth can get stuck only in host
	     * this especially happens in cases like
	     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
	     */
	    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
	    if (authInHost) {
	      result.auth = authInHost.shift();
	      result.hostname = authInHost.shift();
	      result.host = result.hostname;
	    }
	  }
	
	  mustEndAbs = mustEndAbs || (result.host && srcPath.length);
	
	  if (mustEndAbs && !isAbsolute) {
	    srcPath.unshift('');
	  }
	
	  if (srcPath.length > 0) {
	    result.pathname = srcPath.join('/');
	  } else {
	    result.pathname = null;
	    result.path = null;
	  }
	
	  // to support request.http
	  if (result.pathname !== null || result.search !== null) {
	    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
	  }
	  result.auth = relative.auth || result.auth;
	  result.slashes = result.slashes || relative.slashes;
	  result.href = result.format();
	  return result;
	};
	
	Url.prototype.parseHost = function () {
	  var host = this.host;
	  var port = portPattern.exec(host);
	  if (port) {
	    port = port[0];
	    if (port !== ':') {
	      this.port = port.substr(1);
	    }
	    host = host.substr(0, host.length - port.length);
	  }
	  if (host) { this.hostname = host; }
	};
	
	exports.parse = urlParse;
	exports.resolve = urlResolve;
	exports.resolveObject = urlResolveObject;
	exports.format = urlFormat;
	
	exports.Url = Url;


/***/ }),
/* 161 */
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _footerModule = __webpack_require__(64);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavHeading = function NavHeading(_ref) {
	  var text = _ref.text;
	  return _react2.default.createElement(
	    'h2',
	    { className: _footerModule2.default.NavHeading },
	    text
	  );
	};
	
	NavHeading.propTypes = {
	  text: _propTypes2.default.string.isRequired
	};
	
	exports.default = NavHeading;
	module.exports = exports['default'];

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _twitter = __webpack_require__(248);
	
	var _twitter2 = _interopRequireDefault(_twitter);
	
	var _facebook = __webpack_require__(246);
	
	var _facebook2 = _interopRequireDefault(_facebook);
	
	var _linkedin = __webpack_require__(247);
	
	var _linkedin2 = _interopRequireDefault(_linkedin);
	
	var _youtube = __webpack_require__(249);
	
	var _youtube2 = _interopRequireDefault(_youtube);
	
	var _contact = __webpack_require__(245);
	
	var _contact2 = _interopRequireDefault(_contact);
	
	var _footerModule = __webpack_require__(64);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var channels = [{
	  href: 'https://twitter.com/teamgantt',
	  logo: _twitter2.default,
	  name: 'Twitter'
	}, {
	  href: 'https://www.facebook.com/pages/TeamGantt/267785880859',
	  logo: _facebook2.default,
	  name: 'Facebook'
	}, {
	  href: 'https://www.linkedin.com/company/teamgantt',
	  logo: _linkedin2.default,
	  name: 'LinkedIn'
	}, {
	  href: 'https://www.youtube.com/user/teamgantt',
	  logo: _youtube2.default,
	  name: 'YouTube'
	}, {
	  href: 'https://www.teamgantt.com/contact-us/',
	  logo: _contact2.default,
	  name: 'Contact'
	}];
	
	var Social = function Social() {
	  return _react2.default.createElement(
	    'ul',
	    { className: _footerModule2.default.Footer__socialLinks },
	    channels.map(function (_ref) {
	      var href = _ref.href,
	          logo = _ref.logo,
	          name = _ref.name;
	      return _react2.default.createElement(
	        'li',
	        { key: name },
	        _react2.default.createElement(
	          'a',
	          { 'aria-label': name, className: _footerModule2.default.Footer__socialLink, href: href },
	          _react2.default.createElement('img', { alt: '', src: logo })
	        )
	      );
	    })
	  );
	};
	
	exports.default = Social;
	module.exports = exports['default'];

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Logo = __webpack_require__(84);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _NavHeading = __webpack_require__(185);
	
	var _NavHeading2 = _interopRequireDefault(_NavHeading);
	
	var _Social = __webpack_require__(186);
	
	var _Social2 = _interopRequireDefault(_Social);
	
	var _footerModule = __webpack_require__(64);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var legalLinks = [{ title: 'Privacy', href: 'https://www.teamgantt.com/privacy-policy/' }, { title: 'Security', href: 'https://www.teamgantt.com/security/' }, { title: 'Terms', href: 'https://www.teamgantt.com/terms/' }];
	
	var Footer = function Footer(_ref) {
	  var footerLinks = _ref.footerLinks;
	  return _react2.default.createElement(
	    'footer',
	    { className: _footerModule2.default.Footer },
	    _react2.default.createElement(
	      'div',
	      { className: _footerModule2.default.Footer__inner },
	      _react2.default.createElement(
	        'div',
	        { className: _footerModule2.default.Footer__top },
	        _react2.default.createElement(
	          'a',
	          {
	            'aria-label': 'TeamGantt home',
	            className: _footerModule2.default.Footer__logo,
	            href: 'https://www.teamgantt.com/'
	          },
	          _react2.default.createElement(_Logo2.default, { className: _footerModule2.default.Footer__logoImg })
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: _footerModule2.default.Footer__nav },
	          footerLinks.map(function (_ref2, i) {
	            var heading = _ref2.heading,
	                links = _ref2.links;
	            return _react2.default.createElement(
	              'div',
	              { key: 'footer-links-' + i },
	              _react2.default.createElement(_NavHeading2.default, { text: heading }),
	              _react2.default.createElement(
	                'ul',
	                null,
	                links.map(function (_ref3, j) {
	                  var title = _ref3.title,
	                      href = _ref3.href;
	                  return _react2.default.createElement(
	                    'li',
	                    { className: _footerModule2.default.Footer__navItem, key: 'link-' + i + '-' + j },
	                    _react2.default.createElement(
	                      'a',
	                      { className: _footerModule2.default.Footer__link, href: href },
	                      title
	                    )
	                  );
	                })
	              )
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _footerModule2.default.Footer__bottom },
	        _react2.default.createElement(
	          'p',
	          { className: _footerModule2.default.Footer__copyright },
	          '\xA9 ',
	          new Date().getFullYear(),
	          ' TeamGantt'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: _footerModule2.default.Footer__legal },
	          legalLinks.map(function (_ref4) {
	            var title = _ref4.title,
	                href = _ref4.href;
	            return _react2.default.createElement(
	              'li',
	              { key: title },
	              _react2.default.createElement(
	                'a',
	                { className: _footerModule2.default.Footer__link, href: href },
	                title
	              )
	            );
	          })
	        ),
	        _react2.default.createElement(_Social2.default, null)
	      )
	    )
	  );
	};
	
	Footer.propTypes = {
	  footerLinks: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    heading: _propTypes2.default.string.isRequired,
	    links: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      title: _propTypes2.default.string.isRequired,
	      href: _propTypes2.default.string.isRequired
	    })).isRequired
	  })).isRequired
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(12);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _lodash = __webpack_require__(65);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _classnames = __webpack_require__(11);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _categories = __webpack_require__(10);
	
	var _Button = __webpack_require__(21);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _Logo = __webpack_require__(84);
	
	var _Logo2 = _interopRequireDefault(_Logo);
	
	var _ContactLink = __webpack_require__(88);
	
	var _ContactLink2 = _interopRequireDefault(_ContactLink);
	
	var _navModule = __webpack_require__(219);
	
	var _navModule2 = _interopRequireDefault(_navModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Nav = function (_Component) {
	  _inherits(Nav, _Component);
	
	  function Nav() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Nav);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      isActive: false
	    }, _this.componentDidMount = function () {
	      window.addEventListener('scroll', _this.dismiss);
	    }, _this.componentWillUnmount = function () {
	      window.removeEventListener('scroll', _this.dismiss);
	    }, _this.dismiss = function () {
	      var isActive = _this.state.isActive;
	
	      if (isActive) {
	        _this.setState({ isActive: false });
	      }
	    }, _this.toggleActive = function () {
	      var isActive = _this.state.isActive;
	
	      _this.setState({ isActive: !isActive });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Nav.prototype.render = function render() {
	    var articleTree = this.props.articleTree;
	    var isActive = this.state.isActive;
	
	
	    return _react2.default.createElement(
	      'nav',
	      {
	        'aria-label': 'main navigation',
	        className: (0, _classnames2.default)('navbar', _navModule2.default.Nav),
	        role: 'navigation'
	      },
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar-brand' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { className: _navModule2.default.Nav__brand, to: '/' },
	          _react2.default.createElement(_Logo2.default, { className: _navModule2.default.Nav__logo }),
	          _react2.default.createElement(
	            'span',
	            { className: _navModule2.default.Nav__product },
	            'Support'
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            'aria-expanded': isActive,
	            'aria-label': 'menu',
	            className: (0, _classnames2.default)('navbar-burger', _navModule2.default.Nav__burger, {
	              'is-active': isActive
	            }),
	            onClick: this.toggleActive,
	            role: 'button'
	          },
	          _react2.default.createElement('span', { 'aria-hidden': 'true' }),
	          _react2.default.createElement('span', { 'aria-hidden': 'true' }),
	          _react2.default.createElement('span', { 'aria-hidden': 'true' })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          className: (0, _classnames2.default)('navbar-menu', _navModule2.default.Nav__menu, {
	            'is-active': isActive
	          })
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'navbar-start' },
	          _react2.default.createElement(
	            'div',
	            { className: 'navbar-item has-dropdown is-hoverable' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                className: (0, _classnames2.default)('navbar-link', _navModule2.default.Nav__link),
	                to: '/article/77-welcome-to-teamgantt'
	              },
	              'Help docs'
	            ),
	            _react2.default.createElement(
	              'div',
	              {
	                className: (0, _classnames2.default)('navbar-dropdown', _navModule2.default.Nav__dropdown)
	              },
	              (0, _lodash2.default)(articleTree).map(function (category) {
	                return _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  {
	                    className: (0, _classnames2.default)('navbar-item', _navModule2.default.Nav__dropdownItem),
	                    key: category.id,
	                    to: (0, _categories.categoryHref)(category)
	                  },
	                  category.name
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            {
	              className: (0, _classnames2.default)('navbar-item', _navModule2.default.Nav__link),
	              href: 'https://www.teamgantt.com/'
	            },
	            'TeamGantt.com'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: (0, _classnames2.default)('navbar-end', _navModule2.default.Nav__actions) },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              href: 'https://app.teamgantt.com/login',
	              size: 'small',
	              variant: 'secondary'
	            },
	            'Log in'
	          ),
	          _react2.default.createElement(_ContactLink2.default, null)
	        )
	      )
	    );
	  };
	
	  return Nav;
	}(_react.Component);
	
	Nav.propTypes = {
	  articleTree: _propTypes2.default.objectOf(_propTypes2.default.object).isRequired
	};
	
	exports.default = Nav;
	module.exports = exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Nav = __webpack_require__(188);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _headerModule = __webpack_require__(218);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header(_ref) {
	  var articleNavigation = _ref.articleNavigation;
	  return _react2.default.createElement(
	    'header',
	    { className: _headerModule2.default.Header },
	    _react2.default.createElement(_Nav2.default, { articleTree: articleNavigation })
	  );
	};
	
	Header.propTypes = {
	  articleNavigation: _propTypes2.default.objectOf(_propTypes2.default.object).isRequired
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Header":"src-components-header----header-module---Header---v-bMc","spinAround":"src-components-header----header-module---spinAround---2u2QS"};

/***/ }),
/* 219 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Nav":"src-components-header----nav-module---Nav---ZKJX7","Nav__brand":"src-components-header----nav-module---Nav__brand---p6Gxh","Nav__logo":"src-components-header----nav-module---Nav__logo---2Nsck","Nav__product":"src-components-header----nav-module---Nav__product---1SSKN","Nav__burger":"src-components-header----nav-module---Nav__burger---OZHOP","Nav__link":"src-components-header----nav-module---Nav__link---12EyB","Nav__dropdownItem":"src-components-header----nav-module---Nav__dropdownItem---nPWNh","Nav__actions":"src-components-header----nav-module---Nav__actions---Jvtlj","Nav__menu":"src-components-header----nav-module---Nav__menu---3BLtg","Nav__dropdown":"src-components-header----nav-module---Nav__dropdown---2yeqP","spinAround":"src-components-header----nav-module---spinAround---tJ0W_"};

/***/ }),
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Getting Started With TeamGantt","popularTags":[{"href":"/article/8-dependencies","title":"Dependencies"},{"href":"/article/83-add-edit-resources","title":"Resourcing"},{"href":"/article/102-time-tracking","title":"Time Tracking"},{"href":"/article/48-baselines","title":"Baselines"},{"href":"/article/22-reschedule-multiple-tasks","title":"Scheduling"},{"href":"/article/49-assigning-multiple-tasks-at-once","title":"Assigning"}],"footerLinks":[{"heading":"Product","links":[{"title":"Features","href":"https://www.teamgantt.com/features"},{"title":"Pricing","href":"https://www.teamgantt.com/pricing"},{"title":"Customers","href":"https://www.teamgantt.com/customers"},{"title":"Support","href":"/"}]},{"heading":"Learning Center","links":[{"title":"Resources","href":"https://www.teamgantt.com/resources"},{"title":"Blog","href":"https://www.teamgantt.com/blog"}]},{"heading":"Company","links":[{"title":"About Us","href":"https://www.teamgantt.com/about-us"},{"title":"Contact Us","href":"https://www.teamgantt.com/contact-us"},{"title":"Jobs","href":"https://www.teamgantt.com/jobs"}]}]}},"allHelpScoutCategory":{"edges":[{"node":{"name":"Frequently Asked Questions","id":"6a021cfef97dd896ebfc81ba","order":1}},{"node":{"name":"Getting Started","id":"5511aff4e4b061031401fb4c","order":1}},{"node":{"name":"Viewing Your Projects","id":"5f510e62c9e77c0016384617","order":2}},{"node":{"name":"Collaborating","id":"5284de2fe4b027e0d843bc97","order":3}},{"node":{"name":"Managing Your Projects","id":"526eaf43e4b06c89ec332a52","order":4}},{"node":{"name":"Reporting","id":"5afb35e42c7d3a640ed6de95","order":5}},{"node":{"name":"Tips & Tricks","id":"5284df24e4b027e0d843bca8","order":6}},{"node":{"name":"Account & Billing","id":"57e9e78d9033602e61d4835c","order":7}},{"node":{"name":"Time Estimating/Tracking","id":"5284dea7e4b04fbdf2ac3a02","order":8}},{"node":{"name":"Apps & Integrations","id":"528a6bcee4b0bb9de0e9a1f6","order":9}},{"node":{"name":"Uncategorized","id":"526eaec6e4b09e5feddf35be","order":10000}}]},"allHelpScoutArticle":{"edges":[{"node":{"slug":"welcome-to-teamgantt","text":"<ul>\n\t\n<h2> <strong>How do I get started with TeamGantt?</strong></h2><p>\n\t\tTeamGantt is designed to help you manage your projects with ease.&nbsp;This quick, 2-minute video shows you the basics of creating, managing, and navigating projects in TeamGantt.\n\t</p><p>\t\n<iframe src=\"//fast.wistia.net/embed/iframe/pti9ndq30f?videoFoam=true\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" name=\"wistia_embed\" allowfullscreen=\"\" mozallowfullscreen=\"mozallowfullscreen\" webkitallowfullscreen=\"webkitallowfullscreen\" oallowfullscreen=\"oallowfullscreen\" msallowfullscreen=\"msallowfullscreen\" width=\"814\" height=\"458\" style=\"width: 814px; height: 458px;\" kwframeid=\"2\">\n\t</iframe></p><p>\n\t\t All done? \n\t\t<a href=\"https://teamgantt.com/gantt/\">Log in</a> to start creating and managing your projects.\n\t</p><h3> <strong>Pro tips</strong>:&nbsp;</h3><p>\n\t\t To learn more about how to set up TeamGantt to meet your needs, watch our \n\t\t<a href=\"https://support.teamgantt.com/article/32-videos\">Video Tutorials</a> or <a href=\"https://calendly.com/d/y2p-28t-gqm/welcome-to-teamgantt-30-minute-training\">set up a&nbsp;demo call</a> with our Customer Success Team!\n\t</p><hr>\n\t\n<h3>Check out some of our other helpful articles to get started:&nbsp;</h3><ul>\n\t\t\n<li><a href=\"https://support.teamgantt.com/article/106-projects\">Creating Projects</a></li>\t\t\n<li><a href=\"https://support.teamgantt.com/article/4-adding-tasks\">Adding Tasks</a></li>\t\t\n<li><a href=\"https://support.teamgantt.com/article/95-teamgantt-kickoff-meeting-resources/\"></a><a href=\"https://support.teamgantt.com/article/6-inviting-people\">Inviting People to Your Project</a></li>\t\t\n<li><a href=\"https://support.teamgantt.com/article/95-teamgantt-kickoff-meeting-resources/\">TeamGantt Kickoff Meeting Resources</a></li>\t\t\n<li><a href=\"https://support.teamgantt.com/article/93-key-steps-for-getting-your-team-to-use-teamgantt\">Get Your Team to Use TeamGantt</a></li>\t\t\n<li><a href=\"https://support.teamgantt.com/article/147-frequently-asked-questions\">FAQs</a></li>\t</ul></ul>","name":"Welcome to TeamGantt","number":77,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"dependencies","text":"<p>\n\t Got tasks that need to be knocked out in a certain order? That's where dependencies come in handy! TeamGantt supports the following dependency types:&nbsp;</p><p>\n\t<strong>Finish-to-Start</strong> -&nbsp;The successor task can't start unless the predecessor task has been completed.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/686d669d7f965b3c0d58a4ae/file-LtbDY2XVsM.png\" style=\"width: 637px;\"></p><p>\n\t<b style=\"background-color: initial;\">Start-to-Start</b>-&nbsp;The successor task can't start unless the predecessor task has been initiated.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/686d68327f965b3c0d58a4b8/file-AADQrNo4Gs.png\" style=\"width: 626px;\"></p><p>\n\t<strong>Finish-to-Finish</strong> -&nbsp;A successor task can only finish after its predecessor has been completed.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/686d68e02d3e8147c7696b9a/file-qSZakwgypJ.png\" style=\"width: 624px;\"></p><p>\n\t<strong>Start-to-Finish</strong>-&nbsp;A successor task cannot finish until the predecessor has started.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/686d696d1bce3f2f24b40e73/file-bdYVcJWSqx.png\" style=\"width: 629px;\"></p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/z010ci81rm?videoFoam=true\" title=\"4_Add Dependencies Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><h2><hr>\n</h2><h2> <strong>How do I set dependencies between tasks?</strong></h2><p>\n\tThere are 3 ways to create dependencies in TeamGantt.</p><p>\n\t 1) Simply click the dot at the end of the task, and drag it to the beginning of the dependent task.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66df417344628317ef903750/file-NKlWg6LxMz.png\"></p><p>\n\t&nbsp;After you drag the line, the dependency should look like this:</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66df41a7dd5b956281ae48a5/file-GudJ2yIScl.png\"></p><p>\n\t2) Another way to create a dependency would be to click the dot at the end of the task. Then, select the \"+\" sign on the desired dependent task or use the \"Search\" bar to search for the desired task.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66df475d15d0b8223306392e/file-OZFer8IYlE.png\">3) The last way to create a task is by opening the task details window. Simply click \"Add\" to select a task you would like to create a dependency with.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/686d46a61bce3f2f24b40de4/file-VWov5JCkuV.png\"></p><hr><h2>How do I change the dependency type?&nbsp;</h2><p>\n\tYou can change the dependency type by clicking the blue dot at the end of the task bar. Then, simply click on the type to select a new dependency.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/686d48a72d3e8147c7696b2d/file-X6ExTZLsZA.png\">You can also change the dependency type by opening the task edit window.&nbsp;</p><hr><h2>How do I add lag or lead time to my dependency?&nbsp;</h2><p>\n\tTo add lag or lead time, click on the blue dot next to the taskbar. Here, you can click on \n\t<em>Set</em>&nbsp;to set a lag or lead time for the dependency. Positive values are used for <em>lag,</em> and negative values are used for <em>lead</em>.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/686d63f72d3e8147c7696b82/file-AWhv2kgkq7.png\"></p><h2></h2><h2>Why is my dependency line red?</h2><p>\n\tIf the dependency line is red, that means a task is scheduled to start before the previous task ends.</p><h2><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66df41e5ceae9468399d402d/file-Eylqs1Wj9z.png\" style=\"background-color: initial; font-size: 14px;\"></h2><hr><h2>How do I fix invalid dependencies?</h2><p>\n\tIn TeamGantt, you can fix an invalid dependency by dragging the successor task to the right so it starts the day after the predecessor task ends. That simple move will turn your dependency line gray again!</p><p>\n\tYou can also fix an invalid dependency by hovering over the task name to select the triple dot icon and selecting \"Fix invalid dependencies\" from the drop-down.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66df4996ceae9468399d4032/file-MhjvtdzQKr.png\">&nbsp;</p><p>\n\t<em style=\"background-color: initial;\">Are your valid dependencies appearing red? See this <a href=\"https://support.teamgantt.com/article/103-why-are-my-valid-dependency-lines-appearing-red\">article</a> for helpful tips!</em></p><hr><h2> <strong>How do I add dependencies to multiple tasks at once?</strong></h2><p>\n\t Hot keys enable you to add dependencies between multiple tasks at the same time. Here's how:</p><p>\n\t1) Start by holding \n\t<em style=\"background-color: initial;\">S</em><em style=\"background-color: initial;\">hift</em> and selecting all the tasks you want to connect together.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/686d64d37f965b3c0d58a4ab/file-R3x1j2736o.png\"></p><p>\n\t2) Then click \n\t<em style=\"background-color: initial;\">Shift+D</em> to create dependencies between the series of tasks.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/686d65191bce3f2f24b40e62/file-vDAtbaQeGX.png\"></p><hr><h2> <strong>How do I delete a dependency?</strong></h2><p>\n\t There are 2 ways you can delete dependencies between tasks in TeamGantt.</p><p>\n\t 1)&nbsp;&nbsp; \n\t<strong>From&nbsp;<em>Edit</em>&nbsp;mode:</strong> Double-click on a task bar to open the <em>Task Details</em>&nbsp;window. You'll see a list of all dependencies at the bottom of this window. Simply click the (<em>x</em>) icon to delete a dependency.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66df4b6e15d0b82233063932/file-lWumX5mAth.png\"></p><p>\n\t2)&nbsp;&nbsp; \n\t<strong style=\"background-color: initial;\">From&nbsp;the gantt chart view:</strong> Hover your cursor over the dependency line you wish to delete, and click on the blue dot that appears.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66df4bb9ceae9468399d4035/file-Qk9vLTUEPQ.png\"></p><p>\n\tA new window&nbsp;showing the established dependencies will pop up. Simply click the&nbsp; \n\t<em style=\"background-color: initial;\">(x)&nbsp;</em>icon to the left of the dependency to delete it.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66df4bdae6b2356def909247/file-aTS8C9aNHb.png\"></p><h2><hr id=\"horizontalrule\">\n</h2><h2>How do I manage dependency preferences?</h2><p><p>\n\tDependency preferences give you more control over how tasks behave when dependencies, lead/lag, or task dates are updated.</p><p>\n\tTo open dependency preferences --&nbsp;</p><p>\n\tOption 1:</p><ol>\n\t\n<li>Open your project.</li>\t\n<li>Go to Menu.</li>\t\n<li>Select My Preferences &gt;Dependencies preferences.</li>\t\n<li>Check or uncheck the options you want to use.</li></ol><p>\n\tOption 2:&nbsp;</p><ol>\n\t\n<li>Open your project.</li>\t\n<li>Hover over a task bar in the Gantt chart, and click on the blue dot that appears on either side.</li>\t\n<li>Select Preferences.</li>\t\n<li>Check or uncheck the options you want to use.</li></ol><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a468fb24ee231f8691b6453/file-8jpzIh4VvS.png\"></p><p>\n\t<strong>Remove float when dragging predecessor tasks</strong></p></p><p><p>\n\tWhen this option is turned on, moving a predecessor task will also move the dependent task(s) so the schedule stays connected.&nbsp;This is helpful when you want dependent tasks to follow predecessor task changes automatically, rather than leaving extra space&mdash;or float&mdash;between tasks.</p></p><p><strong>Apply lead/lag changes immediately on the chart</strong></p><p><p>\n\tWhen this option is turned on, changes to lead or lag time will be applied right away on the gantt chart.&nbsp;This can help you quickly see how adding or removing time between dependent tasks affects your schedule in real time.</p></p><p><strong>Infer lead/lag from existing task spacing when creating a dependency</strong></p><p><p>\n\tWhen this option is turned on, TeamGantt will look at the current spacing between tasks and automatically add lead or lag time when a dependency is created.For example, if there are 2 days between 2 tasks when you connect them, TeamGantt can keep that spacing by adding lag time to the dependency.</p></p><p><strong>Automatically fix invalid dependencies when task dates are edited</strong></p><p><p>\n\tWhen this option is turned on, TeamGantt will automatically adjust dependent tasks when date changes create an invalid dependency.&nbsp;This can help keep your schedule moving in the right order and reduce the need to manually fix red dependency lines.</p><p>\n\t<em>Note: These preferences only affect how dependencies behave while editing your project. You can update them anytime to match the way you prefer to schedule.</em></p></p>","name":"Dependencies","number":8,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"organize-your-projects","text":"<p>\n\t Projects on the TeamGantt dashboard are listed in alpha-numeric order by default. The good news is, it's easy to prioritize projects so the most important ones get top billing on your list.&nbsp;</p><hr><h2>How do I favorite a project?</h2><p>\n\t To favorite a project or bring it to the top of your list, simply hover over the project name, and a star will appear. Click the star, and the selected project will move to the&nbsp;top of your project list.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a906745d926334a741edf85/file-LvJW23tSTg.png\"></p><p>If you favorite more than one project, the starred projects will show up in alpha-numeric order at the top of your list\n\t<strong style=\"background-color: initial;\">,</strong> followed by the remaining unstarred&nbsp;projects (also in alpha-numeric order).&nbsp;</p><h2><hr>\n</h2><h2>How do I organize projects using a custom sort?</h2><p>\n\t Want to prioritize more than one project or sort projects in a different order than the standard A-Z? Simply get creative with your naming conventions, and you can customize your project view right from your home page! Here are a couple of ideas to get you started:</p><p>\n\t<strong>1) Organize numerically</strong></p><p>\n\t If you want to list your projects in the order they'll occur, use numbers in the project name to rearrange your project list on the TeamGantt dashboard, like so:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a9067bb6f9f378e74c1fc3d/file-I2i7OZhO6M.png\"></p><p><strong style=\"background-color: initial;\">2) Organize by project groups</strong></p><p>\n\t You can organize your dashboard by project events or groups by starting each project name with a similar tag, as shown below:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a9068fd9f65cc0cc64d682c/file-Ml7wGJw9P0.png\"></p><p>\n\t<strong>Heads up:</strong>&nbsp;We have a <a href=\"https://support.teamgantt.com/article/150-portfolio-view/\">Portfolio view</a> on our Business and Builder Edition plans!&nbsp;<em>Portfolio</em>&nbsp;view allows you to organize projects with folders and view&nbsp;<em>Project Health Report</em>&nbsp;data inline. If you have any questions about the feature or would like to trial it, email us at support@teamgantt.com.</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Organize Your Projects","number":44,"categories":["5284df24e4b027e0d843bca8"]}},{"node":{"slug":"trello-sync-options","text":"<p>\n\t Watch the video below to learn about the various sync options you have with the TeamGantt Power-Up for Trello.</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/sz1t6flaib?videoFoam=true\" title=\"Trello Card Sync Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><p>\n\t TeamGantt’s Power-up enables you to see your Trello cards in a beautiful project timeline, create&nbsp;</p><h3><strong>Recommended configuration</strong></h3><p>\n\t The most common way to set up your sync is by syncing 1 Trello board to&nbsp;1 TeamGantt project.&nbsp;</p><p>\n\t To set this up, \n\t<a href=\"https://support.teamgantt.com/article/116-trello-powerup\">enable the TeamGantt Power-Up</a> on your Trello board, and simply select the TeamGantt project you'd like to sync with. Newly created cards and tasks will&nbsp;automatically sync&nbsp;from one Trello board to a single TeamGantt gantt chart. Cards are synced immediately upon creation, and vice versa.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5b6206122c7d3a03f89d4241/file-8wBlrwB20r.png\" style=\"width: 843px;\"></p><p>\n\t If you'd like to disable the auto syncing of your cards, select \n\t<em>Manual Sync&nbsp;</em>from&nbsp;<em>Menu &gt; Power-Ups &gt; Enabled &gt; TeamGantt &gt; Edit Power-Up Settings &gt; Project Sync Setting</em></p><hr><h3><strong>Alternative configurations</strong></h3><p>\n\t To get a custom high-level view of your projects, manually sync any individual card as a task to any TeamGantt project.</p><p>\n\t This can only be accomplished with a manual sync, but the benefit is that it gives you full control over when and where your cards are synced to TeamGantt. Since cards are not automatically synced upon creation, it allows you to finalize a card's details before syncing to TeamGantt.</p><p>\n\t To set up manual syncing, select \n\t<em>None</em> as your project when enabling the TeamGantt Power-Up on your board. Or you can do so after the fact from&nbsp;<em style=\"background-color: initial;\">Menu &gt; Power-Ups &gt; Enabled &gt; TeamGantt &gt; Edit Power-Up Settings &gt; Project Sync Setting &gt; Manual Sync</em></p><p>\n\t<strong>Here are some different options for manually syncing Trello and TeamGantt:</strong></p><p>\n\t 1. Cards from 1 Trello board to multiple TeamGantt projects</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5b6206980428631d7a899124/file-yhDj2bv018.png\" style=\"width: 688px;\"></p><p>\n\t 2. Cards from multiple Trello boards to a single TeamGantt project</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5b6208692c7d3a03f89d4261/file-m4mU4YVS7E.png\" style=\"width: 673px;\"></p><p>\n\t 3. Cards from multiple Trello boards to multiple TeamGantt projects</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5b6207222c7d3a03f89d424d/file-EuzUJTLMKC.png\" style=\"width: 674px;\"></p><p>\n\t<strong> Notes:&nbsp;</strong></p><ul>\n\t\n<li>A card can only be synced to TeamGantt&nbsp;as a task on a single&nbsp;project. A single card can't be represented as two separate tasks (synced to multiple TeamGantt projects simultaneously).</li>\t\n<li>With manual syncing, an&nbsp;individual task cannot be created in TeamGantt and synced to a Trello board. Only individual Trello cards can be pushed to TeamGantt.</li></ul><hr><h3>Data that syncs between TeamGantt and Trello</h3><p>\n\t Although the TeamGantt Power-Up for Trello is a great way to visualize your Trello board in a gantt chart format, not all data syncs between the two platforms. Here's the breakdown of what does and does not sync:&nbsp;</p><ul>\n\t\n<li>Sync\n\t\n<ul>\n\t\t\n<li>Task name</li>\t\t\n<li>Start/end date (if any)</li>\t</ul></li>\t\n<li>Do not sync\n\t\n<ul>\n\t\t\n<li>Checklists</li>\t\t\n<li>Attachments</li>\t\t\n<li>Comments</li>\t</ul></li>\t\n<li>Do not sync, but will be displayed in the Trello card\n\t\n<ul>\n\t\t\n<li>Dependencies</li>\t\t\n<li>Resource assignment (labels)</li>\t\t\n<li>Percentage completed</li>\t</ul></li></ul><p>\n\t Note: Trello and TeamGantt can sync at the \n\t<strong>b</strong><strong>oard to project </strong>level and the <strong>card to task </strong>level. Currently, there is no ability to sync <strong>lists to groups</strong>.&nbsp;</p><hr><p>\n\t<g>\n\tHave \n\t</g>&nbsp;other questions about our TeamGantt Power-Up for Trello? Just email support@teamgantt.com! Or check out one of our other articles about Trello:&nbsp;</p><ul>\n\t\n<li><a href=\"https://support.teamgantt.com/article/116-trello-powerup\">TeamGantt Power-Up for Trello</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/118-trello-troubleshooting\">Trello - Troubleshooting</a> </li>\t\n<li><a href=\"https://support.teamgantt.com/article/123-syncing-trello-list-progress-with-teamgantt\">Syncing Trello List Progress with TeamGantt</a></li></ul><hr><p>\n\t<em><strong>To learn more about using TeamGantt and Trello together, join us for our <a href=\"https://www.teamgantt.com/live-classes/teamgantt-power-up-for-trello-15\">free class</a>!&nbsp;</strong></em></p>","name":"Trello - Sync Options","number":117,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"adding-tasks","text":"<p>\n\t Ready to start adding tasks to your project? Watch this quick video to learn a few tricks!</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/erpn4xszhf?videoFoam=true\" title=\"Adding Tasks__Intro Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><hr><h2><strong>How do I add tasks</strong><strong>&nbsp;to my project?</strong></h2><p>\n\t Adding tasks in TeamGantt is simple! You've got four options to choose from:</p><p>\n\t 1) Hover your mouse over the first column in your project, and select the&nbsp;\n\t<em>Task </em>icon&nbsp;from the <em>(+)</em> options:</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e1a14e44628317ef903952/file-groKaKD1Ko.png\"></p><p>\n\t2) Hover over a task name, and click&nbsp;the 3 dots that appear to the right of the task name.&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e1a1cdceae9468399d4242/file-v0DhksbWmC.png\"></p><p>\n\tThen, select \n\t<em style=\"background-color: initial;\">Insert Task Below</em>:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e1a482ceae9468399d4246/file-tFTSh7gfF8.png\"></p><p>\n\t3) Hover between tasks, and an \n\t<em>Add Task </em>option will appear<em>.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e1a62144628317ef903958/file-b05rXHoSNZ.png\"></em></p><p>\n\t4) Use the following&nbsp;hot keys:&nbsp;</p><p style=\"margin-left: 20px;\">\n\t<strong>All: </strong>After adding a task,&nbsp;hit <em>Enter</em>. The task you just added&nbsp;will automatically&nbsp;save, and a new task will appear under it.&nbsp;When your task list is complete, simply hit&nbsp;<em>Escape</em>&nbsp;to stop adding new tasks.&nbsp;</p><p>\n\t<strong>Note:</strong>&nbsp;Quickly added tasks will be created without task bars. Be sure to schedule each task in the gantt chart by assigning the appropriate start and end dates once your tasks have all been added to your project.&nbsp;</p><hr><h2>How do I add a task group to my project?</h2><p>\n\t Need to add a new group of tasks to your project? Hover over the last task in your list, and the options to add a new task, milestone, subgroup or group of tasks will appear. Select the \n\t<em>Add New Group </em>icon<em>,</em> and you’re all set!</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/4jfdog6ist?videoFoam=true\" title=\"3_Group Related Tasks Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div>\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<br>\n\t</div></div><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e1a768e6b2356def90943e/file-VCPuHIuW72.png\">You can also hover over a group for an <em>Add Group</em>&nbsp;icon to appear. This will add a group above.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e1a7cfe6b2356def909440/file-eddnL9Vq41.png\"></p><h2>How do I schedule tasks?</h2><p>\n\t Now that you've added tasks to your project and given them a name, it's time to schedule them!&nbsp;</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/900rcoqzrt?videoFoam=true\" title=\"2_Set Dates Add Notes Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><p>\n\tThere are 3 easy ways to do this:&nbsp;</p><p>\n\t<b style=\"background-color: initial;\">Option 1: From gantt view</b></p><p>\n\t<b style=\"background-color: initial;\"></b>Hover over the timeline section of your gantt&nbsp;chart, and a colored taskbar will appear. Simply click on the timeline to place the taskbar below the date you'd like to schedule your task.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e1a73dceae9468399d4249/file-CRydVLummX.png\"></p><p>\n\tNeed to adjust the task's duration? Drag either side of the taskbar to shorten or extend the task's timeline.&nbsp;&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e1a85fe6b2356def909442/file-OCBC0RVzmH.png\"><strong style=\"background-color: initial;\">Option 2:&nbsp;From gantt view</strong></p><p>\n\t Hover over the task name, and click the \n\t<em>task details</em>&nbsp;icon.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e1a93c44628317ef90395c/file-2xSTxFKIgs.png\"></p><p>\n\tThis will open up the task's edit window. Simply enter the following details to schedule your task:&nbsp;</p><ul>\n\t\n<li>Start and end date</li>\t\n<li>Duration (estimated hours, weeks, and/or days)<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e1a9f415d0b82233063b63/file-j7GNSy0Xir.png\"></li></ul><p>\n\t<strong style=\"background-color: initial;\">Option 3: From list view</strong></p><p>\n\tHover over the task to click \n\t<em>set</em><em>&nbsp;start</em>&nbsp;to the right of the task name, and select the start and end dates from the calendar.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/65e9f441859b696e0f433ebd/file-sa0zIT8rjo.png\">Want to make lots of changes to your schedule in a single swoop? Check out \n\t<a href=\"https://support.teamgantt.com/article/22-reschedule-multiple-tasks\">How to Move and Reschedule Multiple Tasks</a>.</p><h2><hr>\n</h2><h2> <strong>Frequently asked questions about tasks</strong></h2><ul>\n\t\n<li><strong>Can I add multiple tasks in one row?</strong>\n\t\n<ul>\n\t\t\n<li>Currently, TeamGantt only supports a single task per row, meaning we don't support split tasks. If a task exists over two non-consecutive periods of time, you'll need to a create a separate task for each time period.&nbsp;</li>\t</ul></li>\t\n<li><strong>Can I create recurring tasks?</strong>\n\t\n<ul>\n\t\t\n<li>Currently, TeamGantt does not support recurring tasks. To account for recurring tasks, you'll need to manually create a new task for each iteration of the task.&nbsp;</li>\t</ul></li></ul><p>\n\t<strong>Other articles about tasks you may find helpful:</strong><em>&nbsp;</em><a href=\"https://support.teamgantt.com/article/18-task-colors\">Task Colors</a> | <a href=\"https://support.teamgantt.com/article/104-how-to-edit-delete-and-complete-a-task\">How to Edit/Delete/Complete a Task</a> | <a href=\"https://support.teamgantt.com/article/26-duplicating-a-group\">How to Duplicate a Group of Tasks</a><em>&nbsp;|&nbsp;</em><a href=\"https://support.teamgantt.com/article/105-recurring-tasks\">Recurring Tasks</a></p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/webinars/\">webinars</a>!&nbsp;</strong></em></p>","name":"Create Tasks for Your Project","number":4,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"importing-a-csv","text":"<p>\n\t Importing a CSV file is a great way to get a project started if you already have data in another application, such as Microsoft Project or a spreadsheet you'd like to move into TeamGantt.</p><hr><h2>How do I import files into TeamGantt?</h2><p>\n\t Here's how to import a CSV file:</p><ol>\n\t\n<li>Format your CSV file according to the format options below.</li>\t\n<li>Click the <em style=\"background-color: initial;\">New Project </em>button in the top right of your <em style=\"background-color: initial;\">My Projects</em> page.&nbsp;</li>\t\n<li>Select <em style=\"background-color: initial;\">Upload a CSV</em> to begin the import process.</li>\t\n<li>Choose your account and file, then select <em style=\"background-color: initial;\">Upload File.</em>&nbsp;</li>\t\n<li>Once the file has been uploaded, match the columns in your CSV file to the corresponding TeamGantt fields using the drop-down at the top of each column (green row).&nbsp;</li></ol><hr><h2>How should my CSV file be formatted?</h2><p>\n\t There are two strategies for importing CSV files into TeamGantt:</p><h3>\n<strong>1) Simple method</strong></h3><p>\n\t<strong></strong>You can create a basic list of task names and their start and end dates and import them into TeamGantt. You can also add a group name to each row of your CSV if you'd like to group tasks together in TeamGantt. Here's an example:</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5d88ee4e2c7d3a7e9ae17ebf/file-VxLkHNmq3j.jpg\" alt=\"\" style=\"display: block; margin: auto;\"></p><h3>\n<strong style=\"background-color: initial;\">2) Work breakdown structure format</strong></h3><p>\n\t<strong style=\"background-color: initial;\"></strong>This is a little more complicated, but it's also more powerful because it allows you to specify subgroups and task predecessors. For more information on work breakdown structure, see this link <a href=\"https://en.wikipedia.org/wiki/Work_breakdown_structure\">here</a>, and&nbsp;scroll down to \"Coding scheme\" for an example.</p><p>\n\t Here's an example of a work breakdown structure CSV import file:</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5d88ee782c7d3a7e9ae17ec1/file-bg6CTlWh1s.jpg\" alt=\"\" style=\"display: block; margin: auto;\"></p><h3>\n<strong style=\"background-color: initial;\">Important tips:</strong></h3><ul>\n\t\n<li>Dates must be entered in the format MM/DD/YYYY&nbsp;or YYYY-MM-DD for the file to upload correctly. Using any other format (DD/MM/YYYY, for example) may cause the file to be rejected.</li>\t\n<li>For single-day tasks, you can specify just the start date, and the end date will be automatically set to the same date.</li>\t\n<li>CSV import can only be used to create a&nbsp;<em>new</em>&nbsp;project in TeamGantt. It can't be used to import data into an existing project.&nbsp;</li>\t\n<li>Looking for a template to model your file after? Export an existing project by opening the project and selecting&nbsp;<em>Menu &gt; Export CSV</em>. This will give you a good idea of acceptable formatting.&nbsp;</li></ul><hr><h2>What fields can be imported into TeamGantt?</h2><p>\n\t Depending on the data you want to import and the import strategy you've chosen, you can import a combination of the following fields.&nbsp;</p><h3><b style=\"background-color: initial;\"><u>Simple method only</u></b></h3><h4>Group name:&nbsp;</h4><p>\n\t This field can be used to indicate the name of a group or subgroup.</p><h4>Task name:&nbsp;</h4><p>\n\t This field can be&nbsp;used to indicate the name of a task or milestone.</p><h3><b style=\"background-color: initial;\"><u><br>\n</u></b></h3><h3><b style=\"background-color: initial;\"><u>Work breakdown method only</u></b></h3><h4>WBS #:&nbsp; </h4><p>\n\t This field is essential if you choose to use the work breakdown structure option. (Note:&nbsp;Any whole number represents an entirely new project). For example:</p><ul>\n\t\n<li>1 \"First Project\"&nbsp;</li>\t\n<li>1.1 \"Group 1\"</li>\t\n<li>1.1.1 \"Task 1 in Group 1\"</li>\t\n<li>1.2. \"Group 2\"</li>\t\n<li>1.2.1 \"Task 1 in Group 2\"</li>\t\n<li>2 \"Second Project\"</li></ul><h4> </h4><h4>Name/title:&nbsp; </h4><p>\n\t This field can be used to indicate the project, group, and task names if you choose to import them all in a single column.\n\t<span style=\"font-weight: normal;\"></span></p><h4>Predecessors:&nbsp;</h4><p>\n\t This field can be used to indicate the preceding task in a dependency set. The preceding task must be indicated by WBS number. Read more about dependencies in TeamGantt \n\t<a href=\"https://support.teamgantt.com/article/8-dependencies\">here</a>.&nbsp;</p><h3><u><br>\n</u></h3><h3><u>Either method</u></h3><h4> <strong>Start date, end date:&nbsp;</strong></h4><p>\n\t<strong></strong>These fields can be used to indicate the start and end dates of a project, group, or task. These fields must be entered in MM/DD/YYYY or YYYY-MM-DD format.</p><h4> <strong>Estimated hours:&nbsp;</strong></h4><p>\n\t<strong></strong>This field can be used to assign estimated hours to a task. (<strong>Note:</strong> This data will only be imported if you have the Business or Builder Edition plans with hourly estimation and time tracking.)</p><h4> <strong>Percent complete:&nbsp;</strong></h4><p>\n\t<strong></strong>This field can be used to indicate a task's percent of completion. For best results, indicate the percent complete as a whole number (e.g., \"75\" for 75% complete)</p><h4> <strong>Comments:&nbsp;</strong></h4><p>\n\t<strong></strong>This field allows you to post comments on the project, group, or task level. For example, you might include instructions on how to complete the task.&nbsp;</p><h4><strong style=\"background-color: initial; font-family: inherit;\">Task color:&nbsp;</strong></h4><p>\n\t<strong></strong>Looking to import colors with your tasks? Create a <em>Task Color </em>column in your CSV file, and use this breakdown:</p><ul>\n\t\n<li>\"blue2\" - This is Basic Blue&nbsp;</li>\t\n<li>\"green1\" - This is Golfer's Green&nbsp;</li>\t\n<li>\"purple\" - This is Productive Purple&nbsp;</li>\t\n<li>\"red1\" - This is Rosy Red&nbsp;</li>\t\n<li>\"orange\" - This is Operation Orange&nbsp;</li>\t\n<li>\"blue1\" - This is Blueberry&nbsp;</li>\t\n<li>\"grey1\" - This is Get it Done Grey&nbsp;</li>\t\n<li>\"yellow1\" - This is Mustard&nbsp;</li>\t\n<li>\"blue3\" - This is Blissful Blue&nbsp;</li>\t\n<li>\"magenta1\" - This is Magnifying Magenta&nbsp;</li>\t\n<li>\"pink\" - This is Pretty Pink&nbsp;</li>\t\n<li>\"green2\" - This is Great Green&nbsp;</li>\t\n<li>\"purple2\" - This is Prolific Purple&nbsp;</li>\t\n<li>\"orange2\" - This is Outstanding Orange&nbsp;</li>\t\n<li>\"brown1\" - This is Beneficial Brown&nbsp;</li>\t\n<li>\"green3\" - This is Gainful Green</li></ul><h4><strong>Fields that are not required:</strong></h4><ul>\n\t\n<li>Notes</li>\t\n<li>URL</li></ul><hr><p>\n\t<strong>Having trouble with importing your file?</strong> Email us at support@teamgantt.com. We'd be happy to help!</p><p>\n\t<strong>Looking for another way to sync your data with TeamGantt?</strong> Check out our <a href=\"https://support.teamgantt.com/article/152-teamgantt-integration-for-zapier\">integration with Zapier</a>!&nbsp;</p><p>\n\t<em style=\"background-color: initial;\"></em></p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Import a Project via CSV","number":20,"categories":["5284df24e4b027e0d843bca8"]}},{"node":{"slug":"baselines","text":"<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/85n99zwdlp?videoFoam=true\" title=\"Baselines__Intro Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><hr><p>\n\t Ever plan a project, fall behind, and wonder, “How did we get off track?” A baseline is a quick snapshot of the project at a given point in time, and TeamGantt’s&nbsp;baseline feature enables you to create as many sets as you need to monitor the progress of your project. Baselines are an available feature on our Business and Builder Edition plans.&nbsp;</p><h3>How do I create a baseline for my project?</h3><p>\n\t To create a baseline, simply open the project, and click\n\t<i style=\"background-color: initial;\">&nbsp;Baselines&nbsp;&gt;&nbsp;Create new baseline set</i>.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6722369aca07c36a6a17160d/file-RL3XvCM7HJ.png\"></p><p>\n\tThis will save a snapshot of the project tasks and their start/end dates. You can view a baseline anytime by clicking&nbsp;\n\t<em style=\"background-color: initial;\">&nbsp;Baselines </em>and then checking the box for the baseline you want to see.&nbsp;</p><p>\n\t Here's an example of how a project looks with baselines added. The light gray bar below the active taskbar represents your baseline.&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6722371cca07c36a6a17160e/file-Qeh3hWCOXC.png\">Use baselines to compare your original timeline projections&nbsp;with the actual timeline of the project. This will help you determine which tasks were performed&nbsp;on time or ahead of schedule and which ones got delayed.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67225056c8770a0e6b6588cc/file-KB06IuD5iz.png\"></p><p>\n\tHovering over a Baseline bar will show the start and end date and the percent completion of the task at the time the Baseline was created.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6722385391230b767524bb4e/file-e4FNQnnOeM.png\"></p><p>You can also view your start and end dates by enabling the Planned Start and End Date columns by going&nbsp;to<strong>&nbsp;View&nbsp;</strong><strong>&gt; Columns</strong>.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a999236246853be1edeb0af/file-JA3IzNpV4n.png\"></p><h3>How do I edit project baselines?</h3><p>\n\tTo edit or delete a baseline,&nbsp;click&nbsp;\n\t<i style=\"background-color: initial;\">Baselines </i>and hover over the baseline you'd like to change. Select the <em style=\"background-color: initial;\">edit </em>(pencil) icon to change the baseline's name or the <em style=\"background-color: initial;\">delete</em>&nbsp;(trashcan) icon to delete the baseline.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/672238d3c8770a0e6b65889b/file-1wccyrGfpR.png\"></p><h3><strong>How do I show the Baselines column on my gantt chart?</strong></h3><p>\n\tTo display the Baselines column, go to \n\t<em>View &gt; Columns &gt; Show baselines column.</em></p><p>\n\t<i style=\"background-color: initial;\"><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67223a0dc8770a0e6b65889d/file-fbsqczj7dE.png\"></i></p><p>\n\tThe Baselines column will show how many days ahead or behind the task is.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67223a893a0b506883e52e90/file-AOXTnBgBht.png\"></p><p>\n\t<strong>Note: </strong>Baselines can be used without enabling the Baselines column.</p><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Baselines (Planned vs. Actual Timeline)","number":48,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"reschedule-multiple-tasks","text":"<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 28px 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"//fast.wistia.net/embed/iframe/b94eo1s4rq?videoFoam=true\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" allowfullscreen=\"\" mozallowfullscreen=\"mozallowfullscreen\" webkitallowfullscreen=\"webkitallowfullscreen\" oallowfullscreen=\"oallowfullscreen\" msallowfullscreen=\"msallowfullscreen\" width=\"909\" height=\"512\" style=\"width: 909px; height: 512px;\" allow=\"fullscreen\">\n\t\t</iframe>\n\t</div></div><hr><p>\n\t At some point in the project, you may need to reschedule multiple tasks because of due date shifts or project changes. Instead of moving tasks one-by-one, you can save time by moving multiple tasks at the same time. Read on to learn how to move and reschedule multiple tasks at once.</p><hr><h3><strong>How do I reschedule my entire project?</strong></h3><p>\n\t Let's say you need to move your project out a month. Rescheduling it is easy!&nbsp;</p><p>\n\t At the top of your project, you'll find a thin, gray bar to the right of the project&nbsp;title that spans the entire length of the project. Simply slide the bar forward or backward to reschedule your project in its entirety.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/673dfed7268fb643f63a5c74/file-EAaVCHvjfm.png\"></p><p>\n\t<strong>\n\t</strong></p><h3><strong>How do I reschedule a task group?</strong></h3><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t Need to reschedule a group of tasks? Simply find the light gray bar that spans the length of the task group, and slide the gray bar forward or backward to reschedule it.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/673dfef7442d517d60d26db8/file-PHkwePT2b4.png\"></p><h3><strong>How do I reschedule&nbsp;multiple tasks across subgroups?</strong></h3><p>\n\t You can also easily reschedule multiple individual tasks in a project, no matter which task group they belong to. There are three ways to do this:</p><p>\n\t<strong>Option 1:&nbsp;</strong></p><ol>\n\t\n<li>Check the checkboxes of the tasks you would like to move</li>\t\n<li>Then, either drag the task bar to move it to a different date or drag one of the ends to adjust the task duration.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a95a8c49146944608cc7760/file-xmqoFPPk21.png\"></li></ol><p><strong style=\"background-color: initial;\">Option 2:</strong></p><ol>\n\t\n<li>Click the first task bar you would like to move.</li>\t\n<li>Hold&nbsp;<em style=\"background-color: initial;\">Command</em>&nbsp;(Mac) or&nbsp;<em style=\"background-color: initial;\">Ctrl&nbsp;</em>(Windows), and click another task.&nbsp;</li>\t\n<li>Repeat step #2 until you have selected as many tasks/milestones as you wish.&nbsp;</li>\t\n<li>You can then either drag the task bar to move it to a different date or drag one of the ends to adjust the task duration.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/673dffdd253ee02cb10712f6/file-KL6uCyslvy.png\"></li></ol><p>\n\t<strong style=\"background-color: initial;\">\n\t</strong></p><p>\n\t<strong style=\"background-color: initial;\"><strong style=\"background-color: initial;\">Option 3:</strong></strong></p><ol>\n\t\n<li>Click the first task bar that you would like to move.</li>\t\n<li>Hold <em style=\"background-color: initial;\">Shift</em> and click another task. This will select the two tasks you clicked and any tasks in between.&nbsp;</li>\t\n<li>You can then either drag the task bar to move it to a different date or drag one of the ends to adjust the task duration.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/673e0045442d517d60d26dba/file-Vi4SVJgTf1.png\"></li></ol><p>\n\t<strong style=\"background-color: initial;\">\n\t</strong></p><p>\n\t<strong style=\"background-color: initial;\"><strong style=\"background-color: initial;\">Tip: </strong>When selecting the tasks you wish to move, click on the colored task bar, not the task name.</strong></p><hr><p>\n\t Looking to assign multiple tasks at once? Read more \n\t<a href=\"https://support.teamgantt.com/article/49-assigning-multiple-tasks-at-once\">here</a>.</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Move and Reschedule Multiple Tasks","number":22,"categories":["5284df24e4b027e0d843bca8"]}},{"node":{"slug":"calendar-feed","text":"<p>\n\tWant to sync project tasks with your favorite calendar app? In TeamGantt, it's easy!&nbsp;</p><hr><h2>Which third-party calendars does TeamGantt integrate with?&nbsp;</h2><p>\n\tTeamGantt syncs up with&nbsp;3 popular calendar apps: Google Calendar, iCal, and Outlook.</p><hr><h2>How do I sync TeamGantt tasks with Google Calendar or Outlook?</h2><p>\n\t<strong>1) Open the Calendar Feed page:</strong><strong style=\"background-color: initial;\">&nbsp;</strong>Open a project in TeamGantt, and click <i style=\"background-color: initial;\"><strong>Menu</strong> &gt; <strong>Calendar Feed</strong></i>.</p><p>\n\t<strong>2) Choose to sync either all your projects or individual projects:&nbsp;</strong></p><ul>\n\t\n<li><strong>All tasks in one calendar (default option):</strong> This will take all the tasks/milestones that are assigned to you in TeamGantt and display them in Google Calendar or Outlook.</li>\t\n<li><strong>Individual projects: </strong>This option enables you to pick and choose which projects and tasks to sync to Google Calendar or Outlook.&nbsp;</li>\t\n<li><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/61798fa32b380503dfdfebd9/file-lAafc6W817.png\"></li>\t\n<li><strong></strong>\n\t\n<p>\n\t\t<strong>Click the&nbsp;+ icon </strong>next to each project you'd like to sync, and indicate whether TeamGantt should sync your&nbsp;remaining tasks and milestones, the entire project, or project milestones only.&nbsp;\n\t</p><p>\n\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/687552a19d0f1a2ba067c80a/file-9lACPnTkc4.png\">\n\t</p></li></ul><p>\n\t<em style=\"background-color: initial;\"></em></p><p>\n\t<strong style=\"background-color: initial;\">3) Get link:&nbsp;</strong>Once you've configured your calendar, click <em>Copy</em><em>&nbsp;Link</em>, and copy the link.<strong></strong></p><p>\n\t<strong><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/68755258a2ec0c65c90e062c/file-zgniMOCBXS.png\" style=\"width: 315px;\"></strong></p><p>\n\t<strong>4) Add link to Google Calendar or Outlook</strong></p><p>\n\tOpen&nbsp;Google Calendar or Outlook, then follow the instructions to add a new calendar. Select \n\t<em>From URL</em>, and paste the link you copied from TeamGantt into here.</p><p>\n\t You're all set! Your chosen calendar will automatically refresh every few hours\n\t<strong style=\"background-color: initial;\">.</strong></p><hr><h2>How do I sync TeamGantt tasks with iCal?</h2><p>\n\t<strong>1) Open the Calendar Feed page:</strong>&nbsp;</p><ul>\n\t\n<li>Open a project in TeamGantt, and click&nbsp;<em><strong>Menu</strong> &gt; <strong>Calendar Feed</strong></em>.</li></ul><p>\n\t<strong>2) Choose to sync either all your projects or individual projects:&nbsp;</strong></p><ul>\n\t\n<li><strong>All tasks in one calendar (default option):</strong>&nbsp;This will take all the tasks/milestones that are assigned to you in TeamGantt and display them in iCal.</li>\t\n<li><strong>Individual projects:</strong>&nbsp;This option enables you to pick and choose which projects and tasks to sync.&nbsp;</li>\t\n<li><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/61798fa32b380503dfdfebd9/file-lAafc6W817.png\"></li>\t\n<li><strong>Click the&nbsp;+ icon</strong>&nbsp;next to each project you'd like to sync, and indicate whether TeamGantt should sync your&nbsp;remaining tasks and milestones, the entire project, or project milestones only.&nbsp;</li>\t\n<li><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/617990592b380503dfdfebe2/file-56I65qam6G.png\"></li></ul><p>\n\t<strong>3) </strong><strong>Subscribe:</strong> Click <em>Subscribe to Calendar<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/617992b5efc78d0553e5411b/file-jGkdLkm0UL.png\" style=\"width: 460px;\"></em></p><p>\n\t<strong>4) Set the calendar refresh rate: </strong>Open your iCal preferences, and set your calendar refresh rate to&nbsp; \n\t<g>\n\tthe desired \n\t</g>&nbsp;setting. We recommend every 15 minutes or sooner.</p><p>\n\t You're all set!&nbsp;Your calendar will now automatically refresh and get the latest changes to your project.</p><hr><p>\n\t<strong>Tips:</strong>&nbsp;</p><ul>\n\t\n<li>In Google Calendar, you can sync tasks with a specific time by adding&nbsp;start/due times to the <a href=\"https://support.teamgantt.com/article/80-adding-comments\">sticky note within the task's comment window</a>. The required format is HH:MM&nbsp;(e.g., 12:00pm - 1:00pm). You may need to re-sync the feed to see immediate changes.</li>\t\n<li>In iCal, if you&nbsp; \n\t<g style=\"background-color: initial; color: rgb(57, 73, 86); font-size: 14px;\">\n\tdouble-click t \n\t</g>he task, you'll see a URL. Clicking that URL will open the project for you.</li></ul><p>\n\t<strong>Notes:</strong>&nbsp;</p><ul>\n\t\n<li>Outlook for Mac does not support Internet calendars.</li>\t\n<li>The sync is only one way. TeamGantt tasks can be synced to your calendar, but calendar events cannot be synced to TeamGantt.</li></ul><hr><p>\n\t<strong>Looking for another way to sync&nbsp;TeamGantt with your favorite tools?</strong>&nbsp;Check out our <a href=\"https://support.teamgantt.com/article/152-teamgantt-integration-for-zapier\">Zapier integration</a>!&nbsp;</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Sync with Google Calendar, iCal, or Outlook","number":12,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"subgroups","text":"<p>\n\tDo you like to get super-detailed with your projects? You're in luck! TeamGantt makes it easy to create subtasks or subgroups so you can keep everything nicely organized.&nbsp;</p><h2>How do I add a new subgroup?</h2><p>\n\tYou can directly create a subgroup via the task list column. Simply hover into the task list column until the (+) icons appear, and click the \"Add a new subgroup\" icon.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e0473f811a2434cb6d35ea/file-HsYpENY4R6.png\"></p><hr id=\"horizontalrule\"><h2>How do I convert a task into a subgroup?</h2><p>\n\tTo convert a task into a subgroup, hover over the task name to click the 3 dots icon, and then select \"Convert to subgroup\" from the drop-down.&nbsp;</p><p>\n\tLet's take a closer look&nbsp;by&nbsp;converting the tasks \"Flesh out design\" and \"Create videos + media\" into subgroups of \"Site Development + Testing.\"&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e0489cceae9468399d40e6/file-FKkMPgOdKz.png\"></p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e04851e6b2356def90930c/file-PQhSeqWUVk.png\"></p><p>\n\tHere, you can see how creating multiple subgroups within the same group helps you organize tasks and add structure to your project:</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e049a9811a2434cb6d35ec/file-GFd7t5LijN.png\"></p><p>\n\tWatch this video to see how you can use TeamGantt's drag-and-drop features to organize your subgroups:</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<div class=\"wistia_embed wistia_async_xdclllcfvs idType=ab-test seo=true videoFoam=true\" style=\"height:100%;position:relative;width:100%\">\n\t\t\t&nbsp;\n\t\t</div></div></div><hr><h2><strong>How do I nest tasks and subgroups?</strong></h2><p>\n\t So what if you've laid out your project plan and want to move a group of tasks up under another group? We call that nesting, and it's easy to do!&nbsp;Here's how it works:</p><p>\n\t 1)&nbsp;Hover your cursor over the group or subgroup you'd like to nest, and click on the \n\t<em>group details</em> icon to&nbsp;open the \n\t<em style=\"background-color: initial; color: rgb(73, 73, 73);\">Edit </em>window for the task group.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e04a61811a2434cb6d35ed/file-CdXAoS0t3d.png\"></p><p>\n\t2)&nbsp;Locate the&nbsp;\n\t<em style=\"background-color: initial;\">Parent</em>&nbsp;<em>Group&nbsp;</em>option, and select the group or subgroup you want to organize this group under.&nbsp;In this example, we're nesting&nbsp;the group \"Site Development + Testing\" under \"Wireframes + Site Architecture<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e04ae5811a2434cb6d35ee/file-Rjb5XEWg8M.png\"></p><p>\n\t<em style=\"background-color: initial;\"></em>3)&nbsp;Hit&nbsp;<em style=\"background-color: initial;\">Done</em>&nbsp;to save the changes.&nbsp;Now, the&nbsp;\"Site Development + Testing\" group is a subgroup nested under the \"Wireframes + Site Architecture\" group:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e04b60811a2434cb6d35ef/file-zpvFTsuQff.png\"></p><h2><strong>How do I outdent a subtask or group?</strong></h2><p>\n\t If your project changes or you need to remove your subgroup/subtask, you can use the \n\t<em>O</em><em>utdent </em>feature to adjust tasks.&nbsp;Simply follow these steps:</p><p>\n\t 1) Hover over the subgroup title.&nbsp; \n\t<br>\n\t 2) Click the 3 dots icon that appears to the right.&nbsp; \n\t<br>\n\t 3) Select \n\t<em>Outdent.</em></p><p>\n\t Let's say you decide to convert the&nbsp;\"Flesh out design\" and \"Create videos + media\" subgroups back to standalone task groups in the example below.&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e04c1144628317ef903820/file-wGN46Y6Vw7.png\"></p><p>\n\tHere's how that would look after you outdent them:\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e04c54dd5b956281ae4975/file-xfK17KI8XU.png\"></p><p><em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Subgroups","number":17,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"trello-powerup","text":"<h2>How do I use TeamGantt in Trello?</h2><p>\n\t The TeamGantt Power-up for Trello enables you to see your Trello cards in a beautiful project timeline, create dependencies between cards, and view workloads&mdash;all without ever leaving Trello. Watch the video below, or read this article to get started.</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/mnfplj7vna?videoFoam=true\" title=\"Wistia video player\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" allowfullscreen=\"\" mozallowfullscreen=\"mozallowfullscreen\" webkitallowfullscreen=\"webkitallowfullscreen\" oallowfullscreen=\"oallowfullscreen\" msallowfullscreen=\"msallowfullscreen\" width=\"860\" height=\"484\" style=\"width: 860px; height: 484px;\">\n\t\t</iframe>\n\t</div></div><h2></h2><hr><h2>Enabling the Power-Up &amp; linking your account</h2><p>\n\t First, open the Trello Board that you wish to sync with TeamGantt. Click on the&nbsp;\n\t<em>Power-Ups </em>icon and click <em>Add Power-ups.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa818cc309b9df383c77d3f/file-3cWc30o8Uh.png\"></em>Search for “TeamGantt” and click \n\t<em style=\"background-color: initial;\">Add</em>.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa81982edf30bb4bc1bd6a1/file-MWJ1SOJiko.png\">Confirm by clicking \n\t<em style=\"background-color: initial;\"> Add</em> again.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa819c182e120ce2eba7cb6/file-n3ia9DtHqH.png\"></p><p>\n\tSelect<em> Exclamation Point</em> (<em style=\"background-color: initial;\">Get Started with TeamGantt)</em> on the upper right side of your board.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa81bfa309b9df383c77d46/file-9J10idfMcE.png\"></p><p>\n\tIf you’re new to TeamGantt, <em>Create Free Account</em>. (Alternatively, if you have an existing TeamGantt account, select <em>Sign in here</em> and log in with your TeamGantt email address and password.)</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa81ce9321112bee9ae9604/file-CbpAtJQ6iK.png\"></p><p>\n\tAuthorize the Power-Up by selecting \n\t<em>Open Authorization Popup</em>, then <em>Allow</em>.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa81d5c309b9df383c77d4c/file-N0zNzEhEM6.png\"></p><p>\n\tSelect which sync you would like to use:&nbsp;</p><ul>\n\t\n<li>Auto -&nbsp;All cards from this Trello board are automatically synced to a new project in TeamGantt. Best option to view a timeline for all the cards in a single board.</li>\t\n<li>Manual -&nbsp;Pick and choose which cards are sent to TeamGantt and which gantt chart they go to. It’s a little extra work, but it gives you more flexibility.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa81e22d8fcfd47fea79f77/file-02wSKJvytJ.png\"></li></ul><p>\n\tAll done! You can select \n\t<em style=\"background-color: initial;\">TeamGantt</em> at the upper right side of your board to use the Power-Up with your board.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa81e8d309b9df383c77d52/file-0FWAETWdNw.png\"></p><p>\n\tNote: Existing cards on your Trello Board (created prior to setting up the Power-Up) will automatically sync to your selected TeamGantt project when the Power-Up is enabled. However, existing tasks in your TeamGantt project will not automatically sync to your Trello board.&nbsp;</p><p>\n\t If you’d like to pull pre-existing TeamGantt tasks into Trello, \n\t<a href=\"https://support.teamgantt.com/article/118-trello-troubleshooting#my-teamgantt-project-is-not-syncing-with-trello\">there’s a workaround</a>. If you need any further help with it, feel free to contact support at <a href=\"mailto:support@teamgantt.com\">support@teamgantt.com</a>,&nbsp;</p><p>\n\t After the Power-Up has been enabled, all cards created in Trello and tasks created in TeamGantt will automatically sync between the 2 platforms.&nbsp;</p><hr><h3>Viewing &amp; interacting with your timeline</h3><p>\n\t To view your timeline, click the \n\t<em>TeamGantt icon</em>&nbsp;in the top right corner of the Trello window. Select the projects you want to see in a gantt chart, then click <em>View in gantt chart</em>. This will open your TeamGantt projects.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa81efb321112bee9ae9610/file-b2zuiziHAY.png\">Any Trello cards that were synced to TeamGantt will always be added to the bottom of your TeamGantt tasklist. And to note, any TeamGantt task synced to Trello will always be added as the last card in the first column.</p><p>\n\t To add a timeline bar, drag your mouse into the chart area that aligns with the task row and click into the chart. You can drag the ends of the timeline bar to set the start and end dates.&nbsp;</p><p>\n\t<img src=\"https://lh6.googleusercontent.com/DZj3rZbNq9AEDdKEPzsRugSbbCKiGMf4fz59keU0v93KNFwPiNTLwLFPlXETkwWJIw2ZGx6HkF3gcJe4z5mGRqua1p1oMZWSMvnd46Jwt3s3AEA9FxQP08_ZbiaWpJYELlFjzntu\" width=\"624\" height=\"373\" style=\"margin-top: 0px;\"></p><p>\n\t Then, you can \n\t<a href=\"https://support.teamgantt.com/article/8-dependencies\">add dependencies</a>, <a href=\"https://support.teamgantt.com/article/6-inviting-people#assign-a-single-task-to-a-user\">assign it to a person or label</a>, and <a href=\"https://support.teamgantt.com/article/107-percentage-complete-calculated\">update your progress</a>.&nbsp; All of the details&mdash;the task’s name, start and end dates, percent complete, and dependencies&mdash; are automatically synced to your Trello card. You don't even have to click a save button!&nbsp;</p><p>\n\t You can update your progress, start and end date, and see assigned resources and dependencies right from your Trello card as well!\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa81fbdd8fcfd47fea79f7c/file-7iTkHfIER6.png\">For a full list of the data that does and doesn’t sync between Trello and TeamGantt, visit our \n\t<a href=\"https://support.teamgantt.com/article/117-trello-sync-options/#data-that-syncs-between-teamgantt-and-trello\">sync options help doc</a>.&nbsp;</p><hr><h2></h2><p>\n\t Have other questions about our Trello Power-Up? Just email support@teamgantt.com! Or, check out one of our other articles about Trello:&nbsp;</p><ul>\n\t\n<li><a href=\"https://support.teamgantt.com/article/117-trello-sync-options\">Trello - Sync Options</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/118-trello-troubleshooting\">Trello - Troubleshooting</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/123-syncing-trello-list-progress-with-teamgantt\">Syncing Trello List Progress with TeamGantt</a></li></ul><hr><p>\n\t<strong>Looking for another way to sync&nbsp;TeamGantt with your favorite tools?</strong>&nbsp;Check out our <a href=\"https://support.teamgantt.com/article/152-teamgantt-integration-for-zapier\">Zapier integration</a>!&nbsp;</p><hr><p>\n\t<em><strong>To learn more about using TeamGantt and Trello together, join us for our <a href=\"https://www.teamgantt.com/live-classes/teamgantt-power-up-for-trello-15\">free class</a>!&nbsp;</strong></em></p>","name":"TeamGantt Power-Up for Trello","number":116,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"what-information-will-be-on-my-pdf","text":"<h2>How do I export my project to a PDF?</h2><p>\n\t Exporting your project to a PDF is one of the primary ways you can \n\t<a href=\"https://support.teamgantt.com/article/89-sharing-your-project\">share your project with others</a>.&nbsp;</p><p>\n\t To export your project to a PDF file, click your project's \n\t<em>Menu,&nbsp;</em>and select <em>Print/Export PDF </em>from the drop-down.&nbsp;</p><h2> <strong>How do I customize my PDF export settings?</strong></h2><p>\n\t TeamGantt gives you lots of options for customizing your PDF export. You can customize everything from the paper size and orientation&nbsp;to how resources, dependencies, and tasks appear within the PDF.&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6717a84c44fbd7540103ba10/file-yhVA9zWJmU.png\"></p><p>If you entered information in a different language using symbols, you can adjust the <em>Face</em> located under <em>Font Settings</em>.</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a7cb52abdad84857311a7e9/file-RdZc8TDI3Z.png\"><br></p><h3>\n<strong style=\"background-color: initial; font-family: inherit; font-size: 21px;\">Advanced options</strong></h3><p>\n\t Of course, those aren't the only options you have available. To see the full range of PDF possibilities, click&nbsp;\n\t<em>Show Advanced Options</em>.&nbsp;</p><p>\n\t These additional customizations enable you to adjust the width of your task column (by adjusting the \n\t<em>Task Details Width</em> to large or extra-large), which is helpful when your task names are cut off in the export. You can also&nbsp;alter <em>Printed Date Format</em> and choose the date range you want to print for your project.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6717a8c68af27b34842c06c5/file-1zeXTkUDoQ.png\"><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6717a8ee44fbd7540103ba13/file-aotCRVSyOL.png\"></p><p>\n\t<strong style=\"background-color: initial;\"><br>\n\t</strong></p><p>\n\t<strong style=\"background-color: initial;\">Tip:&nbsp;</strong>TeamGantt will auto-zoom your PDF to fit on 1 exported page. If you need to zoom in or out of your project, we recommend adjusting the font size or printing your project in multiple “phases” by leveraging the date range feature.&nbsp;</p><p>\n\t For example, if you want to view a year-long project in more detail, page 1 could encompass January-June, and page 2 could cover July-December.&nbsp;</p><hr>\n<strong>Note:&nbsp;</strong>The indication that your PDF is a SAMPLE shows while in trial mode. It will disappear&nbsp;once you purchase a subscription to TeamGantt.<hr><h2><strong>How do I add a company logo to my PDF?</strong></h2><p>\n\t To upload a personalized&nbsp;logo to your exported&nbsp;TeamGantt projects, a manager with account admin status can go to \n\t<em>Account Settings&nbsp;</em>&gt;<em> Company Details:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6717a98644628317ef905827/file-3889jSdZ3q.png\"></em></p><p>\n\tUnder \n\t<em style=\"background-color: initial;\">Company Settings</em>, click&nbsp;<em style=\"background-color: initial;\">Upload Photo</em>, and&nbsp;select a JPG, PNG, or GIF file of the logo you'd like to upload:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6717a9c48af27b34842c06c6/file-odoE5m87jR.png\"></p><p>\n\tOnce this information has been saved, your logo will appear on the top left side of the project when exported to PDF.&nbsp;</p><p>\n\t<strong>Note:</strong> This feature is only available if your account is on a paid subscription.&nbsp;</p><hr><p>\n\t Trying to export a view other than Gantt view? Read more about \n\t<a href=\"https://support.teamgantt.com/article/133-exporting-your-project-gantt-list-calendar-views\">exporting the other views</a>!</p><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p><p style=\"font-weight: bold;\"></p>","name":"PDF Options and Customizations","number":45,"categories":["5284de2fe4b027e0d843bc97"]}},{"node":{"slug":"collborator-or-label","text":"<h2>What is a Manager?</h2><p>\n\t A manager is any individual invited to the TeamGantt account by email address and designated with manager permission. The benefits of inviting an individual as a manager include:&nbsp;</p><ul>\n\t\n<li>Create projects&nbsp;</li>\t\n<li>Invite collaborators</li>\t\n<li>Configure project settings</li>\t\n<li>Add, name, schedule, and edit tasks&nbsp;</li>\t\n<li>Optional account admin status to manage billing and add/remove managers</li></ul><p>\n\t If you're a manager&nbsp;and want to see an accurate count of users within your account, go to: \n\t<em>Account Settings </em>(click your profile a the bottom of the sidebar)<em> &gt;&nbsp;Manage users.</em>&nbsp;</p><p>\n\t<strong><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a85ca483ba1da22f9de6fb0/file-YRywR6wTxj.png\"></strong></p><p><strong>T</strong><strong>ip: </strong>Need help inviting users to a project? Read <a href=\"https://support.teamgantt.com/article/6-inviting-people\">Inviting People</a>.</p><hr><h2>What is a Collaborator?</h2><p>\n\t Collaborators are users who can be invited to your projects. Benefits include:</p><ul>\n\t\n<li>No limit on how many projects they can be invited to</li>\t\n<li>Able to update % completion for tasks they are assigned to</li>\t\n<li>Able to update checklist items&nbsp;for tasks they are assigned to</li>\t\n<li>Able to comment and upload/download documentation</li>\t\n<li>Can track time to tasks</li>\t\n<li>Receive notifications and comment mentions&nbsp;</li></ul><p>\n\t If you're a manager and want to see an accurate count of collaborators within your account, go to:&nbsp; \n\t<em>Account Settings&nbsp;</em>(from the circle icon at the upper right-hand corner of TeamGantt)<em>&nbsp;&gt;&nbsp;Manage users.</em>&nbsp;</p><h2><hr>\n</h2><h2>What is a label?</h2><p>\n\t A \n\t<a href=\"https://support.teamgantt.com/article/83-add-edit-resources/\">label</a> (formerly known as a 'resource')&nbsp;is a tag added to projects for organizational or scheduling purposes.&nbsp;Here are just a few ways you can use labels to tag tasks in your projects:</p><ul>\n\t\n<li>Team/department responsible (Example: Marketing team)</li>\t\n<li>Job role responsible (Example: Web designer)</li>\t\n<li>Freelance/contract resource responsible (Example: Freelance writer)</li>\t\n<li>Client/company name that the task pertains to (Example: Acme Inc.)</li>\t\n<li>Project phase or sprint that the task belongs to (Example: Design phase)</li>\t\n<li>Priority level of a task (Example: Urgent)</li></ul><p>\n\t Unlike a user, a label used in place of a person (i.e., Web designer) will not have access to the project in TeamGantt. And since a label isn't associated with an email address, it also won't receive email notifications.</p><p>\n\t To view existing labels or to&nbsp;add a label to your project,&nbsp;simply go to the \n\t<em style=\"background-color: initial;\">Peopl</em>e tab &gt; <em>Labels:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a85caaccffb5047ce9d981d/file-8Azn8UhmCU.png\"></em></p><p>All paid subscription plans allow you to add an unlimited number of labels to your projects!</p><hr><h2></h2><h2></h2><p>\n\t Want to learn more about users and labels? Check out the links below!</p><ul>\n\t\n<li><a href=\"https://support.teamgantt.com/article/6-inviting-people\">Invite Users &amp; Assign Tasks</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/49-assigning-multiple-tasks-at-once\">Assign Multiple Tasks at Once</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/83-add-edit-resources/\">Add, Edit, and Remove&nbsp;Labels</a></li></ul><hr><p>\n\t<strong><em style=\"background-color: initial;\">To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/webinars/\">webinars</a>!&nbsp;</em></strong></p>","name":"Manager, Collaborator, and Label Defined","number":75,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"permissions","text":"<h2>How do I manage user roles and permissions in TeamGantt?</h2><p>\n\tTeamGantt offers global permissions that are the same on the account and project level:</p><ul>\n\t\n<li><strong>Manager:</strong>&nbsp;Can create and edit <a href=\"https://support.teamgantt.com/article/106-projects\">projects</a>, as well as invite <a href=\"https://support.teamgantt.com/article/75-collborator-or-label\">collaborators</a> to projects. They are also able to edit project settings.&nbsp;</li>\t\n<li><strong>Manager with Account Admin Status</strong><strong>:&nbsp;&nbsp;</strong>Can access any project on the account (<a href=\"https://support.teamgantt.com/article/101-for-account-holders\">like this</a>).&nbsp;\n\t\n<p style=\"display: inline !important;\">\n\t\tAccount admin status allows managers to edit subscriptions, update payment information, and purchase additional manager licenses.&nbsp;\n\t</p><p>\n\t\tThey are also able to invite and edit other managers to the account. To invite or upgrade more users to managers, go to\n\t\t<em>&nbsp;Account Settings</em>&nbsp;&gt;&nbsp;<em>Manage users</em>. Account Admin status is set in the Manage users page:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a7c9917bdad84857311a759/file-eqtZBUGocY.png\"><strong style=\"background-color: initial;\">Collaborator: </strong>Only<strong style=\"background-color: initial;\">&nbsp;</strong>able to be invited to projects and&nbsp;assigned to tasks. Are able to update progress (%) and check off checklist items on tasks they are assigned to. Able to comment, upload/download documents and track time on any task in a project they are invited to. Are not able to change dates or edit task attributes.</p></li></ul><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"User Permissions","number":5,"categories":["57e9e78d9033602e61d4835c"]}},{"node":{"slug":"sharing-your-project","text":"<p>\n\t Want to share project updates with contract workers, clients, or other stakeholders without adding them as a user to your project or account?&nbsp;TeamGantt gives you 3 options for doing this.</p><ol>\n\t\n<li>Invite someone as a collaborator</li>\t\n<li>Share a view-only URL of your project (paid plans only)</li>\t\n<li>Share a PDF of your project</li></ol><p>\n\tLet's take a look at how each one works.</p><hr><h2> <strong>How do I invite someone as a collaborator?</strong></h2><p>\n\t In TeamGantt, a collaborator is only able to access projects they have been invited into. They will not be able to create new projects on the account. For example, let's say you hire a freelance writer to create content for a website project. Inviting the freelance writer as a collaborator on the project enables them to see and comment on tasks.&nbsp;</p><p>\n\t<strong style=\"background-color: initial;\">Here's how to invite someone as a collaborator to your project</strong></p><p><strong style=\"background-color: initial;\"></strong>1. Click the&nbsp;\n\t<em style=\"background-color: initial;\">Share</em> &gt;&nbsp;<em style=\"background-color: initial;\">Invite People&nbsp;</em>button at the upper right corner of your project<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a849d7b4f742c5313c50593/file-fvBBbwjBr0.png\"></p><p>\n\t2. From your project’s&nbsp; \n\t<em style=\"background-color: initial;\">People</em>&nbsp;page, click the +&nbsp;<em style=\"background-color: initial;\">Invite users&nbsp;</em>link.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a7dddaf3c57d45466b9ce80/file-ywRLnsf0rZ.png\"></p><p>\n\t3. Click the&nbsp;<em style=\"background-color: initial;\">Create new user</em>&nbsp;link to add a person who is not yet invited to your account.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a7dddf5997ac821904e287f/file-Q2XanYxvO1.png\"></p><p>\n\t4. Next, enter the person’s name and email address, and set their permission to\n\t<em style=\"background-color: initial;\">&nbsp;Collaborator</em>.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a069bbc4d142b755b5022e/file-pG7XTG7WjP.png\"></p><p>\n\t5. Click the&nbsp; \n\t<em style=\"background-color: initial;\">Add Person</em>&nbsp;button. This will add the person to the account and the project.</p><p>\n\tFor more information on inviting others to your projects, please visit: \n\t<a href=\"https://support.teamgantt.com/article/6-inviting-people\">Inviting People</a></p><p>\n\t<a href=\"http://support.teamgantt.com/article/6-inviting-people\"></a></p><hr><h2> <strong>How do I share a view-only&nbsp;link to my gantt chart?</strong></h2><p>\n\t You also have the ability to share a personalized URL for your project with non-TeamGantt users, if you're on a paid plan or premium trial. This option is great if you want to enable a client or stakeholder to monitor project progress without inviting them to become a user on your account.&nbsp;</p><p>\n\t You have 2 different options for accessing the URL:</p><ol>\n\t\n<li>Open your project and go to <em>Menu &gt; Embed/Share link</em></li>\t\n<li>Open your project, and select <em>Share &gt; Copy Link to Chart</em>&nbsp;at the bottom of your browser window<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a849dacaa237701519b9a02/file-UurwTzt2V8.png\"></li></ol><h3>How do I share multiple TeamGantt projects with a single view-only URL?</h3><p>\n\tStart by \n\t<a href=\"https://support.teamgantt.com/article/25-viewing-multiple-projects\">opening multiple projects in gantt view</a>. Then go to&nbsp;<em style=\"background-color: initial;\">Menu &gt; Embed</em>, select all projects, and copy the URL.</p><hr><h2> <strong>How do I export and share a PDF of my project timeline?</strong></h2><p>\n\t You can also export a customized, print-ready PDF of your project to share with others. This option is perfect for giving clients and stakeholders a quick snapshot of a project because it enables you to \n\t<a href=\"https://support.teamgantt.com/article/24-filters\">&nbsp;filter a project</a> first and show only the information you want to share.&nbsp;</p><p>\n\t To generate a PDF of your project, open the project, and go to \n\t<em>Menu &gt; Print/Export PDF</em>.&nbsp;</p><hr><h2>Can I customize what external users see when I share a TeamGantt project?</h2><p>\n\tYes, you can \n\t<a href=\"https://support.teamgantt.com/article/24-filters\">apply filters to your project</a> and customize the display settings before sharing a view-only link or exporting a PDF.</p><ul>\n\t\n<li>To learn more about customization options for your&nbsp;URL, please visit: <a href=\"https://support.teamgantt.com/article/46-embedding-your-projects\">Embedding your projects</a></li>\t\n<li>\n\tFor more information about PDF exports, please visit:&nbsp; \n\t<a href=\"https://support.teamgantt.com/article/45-what-information-will-be-on-my-pdf\">PDF Options and Customizations</a></li></ul><p>\n\t<a href=\"https://support.teamgantt.com/article/45-what-information-will-be-on-my-pdf\"></a></p><hr><p>\n\t Want to tell others about TeamGantt? You can also share TeamGantt on Facebook or Twitter using this quick link as well!</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Share Your Project with External Users","number":89,"categories":["5284de2fe4b027e0d843bc97"]}},{"node":{"slug":"adding-company-holidays","text":"<p>\n\t Managing your company's holidays is an important part of scheduling tasks.&nbsp;</p><p>\n\t With TeamGantt, you can add company holidays, off days, and/or other closures to your gantt chart to keep tasks from getting scheduled on days when you and your team are unavailable.&nbsp;</p><hr><h2>How do I add a company holiday?</h2><p>Account Admins can set company-wide closures and/or holidays by going to&nbsp;\n\t<em style=\"background-color: initial; font-size: 14px;\">Account Settings &gt; Manage Holidays</em>.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a95aaeb0b3932344381fd0b/file-6h8nKb0HCC.png\">Enter the holiday name, and choose a date.&nbsp;If the closure/holiday happens on the same day each year, you can select the&nbsp;\n\t<em style=\"background-color: initial;\">Repeats each year </em>option.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a95ab39fb02544561c5c8b2/file-4LsHzegnCc.png\"></p><p>\n\t<strong style=\"background-color: initial;\">Note: </strong>At this time, only individual dates can be selected. A date range cannot be selected.&nbsp;</p><hr><h2>Can I choose to display holidays in my project?</h2><p>\n\tYes. Your chart will default to hiding company holidays to avoid accidentally scheduling tasks on days your company is closed. However, you can change this setting on any project.</p><p>\n\tIf you want to show holidays in your project, simply go to&nbsp;\n\t<em style=\"background-color: initial;\">Menu &gt; Open Project Details,</em>&nbsp;and toggle&nbsp;<em style=\"background-color: initial;\">Show&nbsp;Company Holidays</em> to on<em style=\"background-color: initial;\">.</em></p><p>\n\t<em><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/673e05ac1f08a960420033aa/file-v7W7qcdY8W.png\"></em></p><p>\n\tIf a task is scheduled on a date that's later designated as a holiday (and hidden from the calendar), that task will appear on the last available day that's visible on the gantt chart.</p><hr><h2>How do I add vacation days for a team member?</h2><p>\n\t Want to note when a team member or label will be unavailable? We recommend creating&nbsp;a group of tasks within your project (or even a standalone project) specifically for vacation days.</p><p>\n\t Then users can simply create a task for their days off and assign themselves to it. When you view the \n\t<em>Availability</em> tab, you'll be able to see that John, for example, is scheduled for \"Vacation\" from June 16-20.</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Add a Holiday or Vacation Day","number":35,"categories":["5284df24e4b027e0d843bca8"]}},{"node":{"slug":"how-can-i-save-my-data","text":"<p>\n\tTeamGantt saves&nbsp;changes to your project as you go. Each time you update a project&mdash;whether adding new tasks or adjusting the percent complete&mdash;your data is automatically saved.&nbsp;</p><p>\n\t And because we know just how important your project information is to you, we run an automated backup of your account content 365 days a year. If a significant loss or error occurs, you can rest assured knowing we can restore project information for a fee.</p><p>\n\t Have a question about project restoration fees or expected timeline? Send us a note at \n\t<a href=\"mailto:support@teamgantt.com\">support@teamgantt.com</a>.</p><hr><h2>How do I export my data from TeamGantt?</h2><p>\n\t Want to save a backup of your project information to your computer? Exporting your project to PDF or CSV is easy! Simply open the project you want to export, and go to&nbsp;\n\t<em style=\"background-color: initial; font-size: 14px;\">Menu &gt; Print/Export PDF</em> or <em style=\"background-color: initial; font-size: 14px;\">Menu &gt; Export CSV</em>.&nbsp;</p><p>\n\t An exported CSV can be reimported anytime.&nbsp;You can find all the details on importing a CSV file to TeamGantt by visiting \n\t<a href=\"https://support.teamgantt.com/article/20-importing-a-csv\">Importing Your CSV</a>.&nbsp;</p><hr id=\"horizontalrule\"><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/webinars/\">webinars</a>!&nbsp;</strong></em></p>","name":"Save Your Project Data","number":68,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"view-options","text":"<p>\n\tTeamGantt enables you to customize the information displayed in your project view.&nbsp;Simply click on the \n\t<em style=\"background-color: initial;\">View</em>&nbsp;drop-down to use any combination of these options:</p><p>\n\t1. \n\t<em style=\"background-color: initial;\">&nbsp;</em><strong style=\"background-color: initial;\">Hiding or showing columns</strong>:&nbsp;Choose to display or hide columns.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a4ffdb0c985582245f027b7/file-0BDjqMGwcT.png\"></p><p>\n\t2.&nbsp; \n\t<em>&nbsp;</em><strong>Task bars</strong><strong style=\"background-color: initial;\">: </strong>Choose to display the task name in bars, the task name next to bars, assigned people and labels, and percentage in bars.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a97166926f9ffe83c5d107c/file-Jj4acyFwQ5.png\"><strong></strong></p><p>\n\t3. <strong>Materials:</strong> Choose to display material lead times on the Gantt chart. Only available on the Builder's Edition.<strong>&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a97179426f9ffe83c5d107f/file-TNk55090jM.png\"></strong></p><p>\n\t4.<strong>&nbsp; Zoom</strong><strong style=\"background-color: initial;\">:</strong>&nbsp;&nbsp;Located under the&nbsp;<em style=\"background-color: initial;\">View</em>&nbsp;drop-down (as well as in the top right of the chart via the&nbsp;<em>Magnifying Glass icon</em><em style=\"background-color: initial;\">)</em>, you can adjust your zoom level, plus choose to view your project by day, week, or month. The default is&nbsp;<em style=\"background-color: initial;\">Day View</em>&nbsp;at 100%.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a9717c70b393234438201d6/file-gPDXW45XeY.png\"></p><p>\n\t5. \n\t&nbsp;\n\t<strong style=\"background-color: initial;\">Date Format</strong><strong style=\"background-color: initial;\">:</strong>&nbsp;Choose from any of the options shown below:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a9718230b393234438201d9/file-g9JPhhuJON.png\"></p><p>\n\t6. \n\t<strong style=\"background-color: initial;\">Font size:</strong>&nbsp;Adjust the font size on your project view to suit your personal needs or preference. (Note: The default font size is 12px.)<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a97195c0b393234438201dd/file-c5luYnUIoK.png\">7.&nbsp; \n\t<strong style=\"background-color: initial;\">Timeline</strong><strong style=\"background-color: initial;\">:</strong>&nbsp;Choose to display week numbers or show the today indicator.&nbsp;</p><ul>\n\t\n<li>Week Numbers - You can choose to display week numbers at the top of your Gantt chart. Week numbers align with calendar weeks (i.e. the first week of January would be w1).&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a971a37de9db37df4024c12/file-DtCGxPa0Ip.png\"></li>\t\n<li>Today Indicator - A blue line will appear to indicate today's date.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a971a940b393234438201e6/file-yKZJJFaxiA.png\"></li></ul><p>\n\t8. \n\t<strong style=\"background-color: initial;\">Expand all groups: </strong>When this is selected, all groups in your project will be expanded.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a971b294254e779581a5181/file-MsP3896UAQ.png\">9. \n\t<strong style=\"background-color: initial;\">Collapse all groups: </strong>When this is selected, all groups within your project will be collapsed.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a971b5f26f9ffe83c5d109a/file-HKlaDPDMD3.png\"></p><p>\n\t10. \n\t<strong>Open Workloads:</strong> When selected, this will open the <em>Workloads</em> view at the bottom of the project.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a971ba00b393234438201e9/file-hmwEQw9b1i.png\"></p><p>\n\t<strong style=\"background-color: initial;\">Tip</strong>: If you've just made changes to your Gantt chart view and it doesn't automatically reflect them, refresh your page and see if the Gantt chart displays the right view settings now.</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Adjust the View of Your Project","number":9,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"projects","text":"<p>\n\t<a></a></p><h2>How do I create a new project?</h2><p>\n\t Creating a project is the first step to getting work done in TeamGantt! If you're a \n\t<a href=\"https://support.teamgantt.com/article/5-permissions\">manager</a><strong style=\"background-color: initial;\">, </strong>you have the ability to add new projects.&nbsp;</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/c8sv68o06w?videoFoam=true\" title=\"1_Creating a new project Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><p>\n\tThere are 2 different ways to do this:</p><p>\n\t<strong>Method #1:&nbsp;</strong>From&nbsp;the left-hand sidebar menu, click the <em>Create</em>&nbsp;button<em>&nbsp;</em>and select<em> New Project.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a86108a79433f0f0772d8bf/file-d5bNrEN64t.png\"></em></p><p>\n\t<strong style=\"background-color: initial;\">Method #2:</strong> Select&nbsp;<em style=\"background-color: initial;\">Projects</em>&nbsp;from the left-hand sidebar menu, and click the <em style=\"background-color: initial;\">New Project</em>&nbsp;button.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a86110379433f0f0772d8c3/file-3NAkXWGXot.png\"></p><p>\n\tFrom there, you can choose from the following 4 options:&nbsp;</p><ol>\n\t\n<li>Create a new project (If this is your first time creating a project, click on the blue&nbsp;<i style=\"background-color: initial;\">Create New Project</i>&nbsp;button to get started.)</li>\t\n<li>Duplicate an existing project</li>\t\n<li>Create a project from a <a href=\"https://support.teamgantt.com/article/20-importing-a-csv\" target=\"_blank\">CSV</a>, <a href=\"https://support.teamgantt.com/article/161-import-from-microsoft-project\">Microsoft Project</a>, or <a href=\"https://support.teamgantt.com/article/185-import-a-project-from-primavera-p6\">Primavera P6</a>.&nbsp;</li>\t\n<li>Create a project from the <a href=\"https://support.teamgantt.com/article/184-creating-a-project-with-teamgantt-ai-assistant\">AI Project Creation tool</a>.&nbsp;</li></ol><p>\n\t Then it's time to provide some basic project details! Here's what every new project needs:</p><ul>\n\t\n<li>Project name</li>\t\n<li>Template\n\t\n<ul>\n\t\t\n<li>Either start with a new blank project or <a href=\"https://support.teamgantt.com/article/137-use-a-template\">choose a template</a></li>\t</ul></li>\t\n<li><a href=\"https://support.teamgantt.com/article/137-use-a-template\"></a>Start Date</li>\t\n<li><a href=\"https://support.teamgantt.com/article/154-setting-a-default-view\">Default view</a> for all invitees&nbsp;</li>\t\n<li>Days of the week work will be scheduled</li>\t\n<li>Any items you wish to import</li></ul><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a8611963ba1da22f9de713d/file-Mmgnbwg7DX.png\">When you're done, click the&nbsp;\n\t<em style=\"background-color: initial;\">Create new project</em>&nbsp;button to add your new project.</p><p>\n\t<strong>Tip</strong>: If you created <a href=\"https://support.teamgantt.com/article/19-templates\" target=\"_blank\">a template</a> out of an existing project, you can create a new project based on this template. This saves time and effort so you don't have to create everything from scratch.</p><hr><h2>How do I create a new project if I belong to&nbsp;multiple accounts?</h2><p>\n\tIf you're a <a href=\"https://support.teamgantt.com/article/5-permissions\" style=\"font-size: 14px;\">manager</a> on 2 or more accounts, you'll see a <em style=\"background-color: initial; font-size: 14px;\">Company</em>&nbsp;drop-down on the <i style=\"background-color: initial; font-size: 14px;\">Create a New Project</i> page. This menu enables you to assign each new project to the right account.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a86123d7efce3520093a0b7/file-R8ua0HcjeM.png\"></p><p>\n\tSimply choose the right account from the list, and click the \n\t<em style=\"background-color: initial;\">Create&nbsp;New Project </em>button.&nbsp;</p><p>\n\t<strong>Note:&nbsp;</strong>Once a project's created in one account, it can't be moved to another. Be sure to double-check the <em>Company</em>&nbsp;drop-down before making your new project!</p><hr><h2>How do I rename a project?</h2><p>\n\t If you're the \n\t<a href=\"https://support.teamgantt.com/article/5-permissions\">manager on a project</a>, you can give your project a new name by following the steps below.&nbsp;</p><p>\n\t1) From the gantt view, hover over the project name, and select the \n\t<em style=\"background-color: initial;\">Open project details</em>&nbsp;icon.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a8612a279433f0f0772d8ce/file-IsY6ja16de.png\"></p><p>\n\t2) A project detail window will pop up. Simply click into the project name text field to edit it. Once finished, simply click the \"X\" that will appear in the upper right corner.&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67093b846d43ca7b17b2bc62/file-sEDf0P6Gqp.png\"></p><p>\n\tYou should see the new project name show up on the project and your&nbsp;\n\t<em style=\"background-color: initial;\">My Projects</em> page&nbsp;right away.</p><hr><h2>How do I delete a project?</h2><p>\n\t<strong>Note: Only users with&nbsp;</strong><a href=\"https://support.teamgantt.com/article/5-permissions\">manager</a><strong>&nbsp;permissions on the project are allowed to delete a project.</strong>&nbsp;</p><p>\n\t Some projects fizzle out before they're finished. If this happens, there are 2 ways to delete a project from your TeamGantt account.&nbsp;</p><p>\n\t<strong>Method #1 -&nbsp;</strong><strong>From the <em>My Projects</em>&nbsp;list:</strong></p><p>\n\t Click \n\t<em>My Projects</em>&nbsp;from the left-hand sidebar menu. Hover over the project you want to delete, and click&nbsp;<em>Options &gt;&nbsp;</em><em>Delete Project</em>.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a8612f079433f0f0772d8d0/file-8TIyNSI8gA.png\"></p><p>\n\t<strong style=\"background-color: initial;\"></strong></p><p>\n\t<strong style=\"background-color: initial;\">Method #2</strong><strong style=\"background-color: initial;\"> -&nbsp;</strong><strong style=\"background-color: initial;\">From within a project:</strong></p><p>\n\t Select&nbsp; \n\t<em>Menu &gt; Project Settings,</em>&nbsp;and click&nbsp;<em>Delete Project</em>.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67093c0a15d0b822330653eb/file-lTXTElnyFS.png\"></p><p>\n\t<em>Having trouble creating projects in TeamGantt? Email us at&nbsp;</em><a href=\"mailto:mailto:support@teamgantt.com\">support@teamgantt.com</a>,&nbsp;<em>and we'll help you out!</em></p><p>\n\t<em style=\"background-color: initial;\"><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/webinars/\">webinars</a>!&nbsp;</strong></em></p>","name":"Projects","number":106,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"key-steps-for-getting-your-team-to-use-teamgantt","text":"<p>\n\t If you’re just getting started in TeamGantt, be sure to learn about \n\t<a href=\"https://support.teamgantt.com/article/77-welcome-to-teamgantt/\">the basics</a> first.&nbsp;</p><p>\n\t Ready to introduce TeamGantt to your team, but they've never used a gantt chart? Send them this \n\t<a href=\"https://teamgantt.wistia.com/medias/xnhih39exc\" target=\"_blank\">video on understanding gantt charts</a> so that they're more comfortable with diving in.&nbsp;</p><h4><p style=\"text-align: center;\">\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5633852090336002f86d929f/file-o4kwtYwIxA.png\"></p></h4><hr><blockquote style=\"text-align: right;\">\n  “[TeamGantt] is truly a fluid solution that works for us on a day in and day out basis.” &nbsp;– Brad Jones, VP of Design, \n\t<a href=\"https://adventmovespeople.com/\" target=\"_blank\">Advent</a>, Nashville, TN&nbsp;&nbsp;\n</blockquote><hr><p>\n\t You’re the resident TeamGantt expert, so you already know how to create your first project, \n\t<a href=\"https://support.teamgantt.com/article/4-adding-tasks\" target=\"_blank\">add some tasks</a>, and <a href=\"https://support.teamgantt.com/article/6-inviting-people\" target=\"_blank\">invite people</a>.&nbsp;Now it’s time to introduce your team to TeamGantt.&nbsp;&nbsp;</p><hr><h2><h2>What steps should I take to onboard my team?</h2></h2><h3>1. Create a project that includes tasks for everyone on your team.&nbsp;&nbsp;</h3><p>\n\t It's easier to onboard your team if there are tasks ready for them as soon as they create their accounts. \n\t<a href=\"https://support.teamgantt.com/article/106-projects\">Create a project</a> that includes tasks for everyone.&nbsp;</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/0cnt2hzoo1?videoFoam=true\" title=\"Adding Tasks Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><hr><blockquote style=\"text-align: right;\">\n  “It is so intuitive and easy to use, even non-project managers are using it.” &nbsp;– Tracy Krebs, Director, Financial Operations, \n\t<a href=\"http://expedia.com/\" target=\"_blank\">Expedia</a>\n\t<br>\n</blockquote><h2><hr>\n</h2><h3>2. Send out invitations to your team.</h3><p>\n\t<a href=\"https://support.teamgantt.com/article/6-inviting-people\">Inviting people</a> is easy. Just use the <em>Invite People</em> button from the timeline view of your project. Simply drop in their email address, personalize the invite, and click <em>Send Invitation</em>. Personalizing your invitations is a good way to make sure your project invitation doesn’t get lost in their inbox. It’s also a great chance for you to mention a few great benefits of using TeamGantt.&nbsp; &nbsp;</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/4ikjxefjwe?videoFoam=true\" title=\"Invite People to Your Project Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><p>\n\t<strong>Perk:</strong> Once everyone has accepted their TeamGantt invitation, feel free to say goodbye to email for project communication. TeamGantt’s documents and <a href=\"https://support.teamgantt.com/article/80-adding-comments\">comments</a> features allow you to communicate and share files for projects and individual tasks. This keeps all of your project communication in one place and accessible for everyone. &nbsp;</p><h2><hr>\n</h2><h3>3. Assign tasks to your team. &nbsp;</h3><p>\n\t You can \n\t<a href=\"https://support.teamgantt.com/article/6-inviting-people#assign-a-single-task-to-a-user\">assign tasks</a> to people even before they accept the TeamGantt invitation and create their account. It’s best to assign them tasks as soon as possible. Your team can use the <a href=\"https://support.teamgantt.com/article/130-my-tasks\" target=\"_blank\"><em>My Tasks</em> view</a> to see exactly what they should be working on and when it’s due and to update their progress.</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/cinre3h6d1?videoFoam=true\" title=\"Team Collaboration Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><hr><blockquote style=\"text-align: right;\">\n  \"[TeamGantt] allows me to quickly see what projects we are all working on.\"&nbsp; – \n\t<a href=\"https://twitter.com/boris\">Boris Veldhuijzen Van Zanten</a>, CEO and Co-Founder, \n\t<a href=\"http://thenextweb.com/\">The Next Web</a>\n</blockquote><hr><h2> </h2><h3>4. Schedule a kickoff meeting.</h3><p>\n\t Plan a time when the whole team can meet to go over the benefits of using TeamGantt. The ideal meeting is less than 30 minutes and&nbsp;gives your team a chance to get specific answers to any questions they may have.</p><p>\n\t You could even \n\t<a href=\"https://calendly.com/d/c2vp-tms/30-minute-teamgantt-demo\" target=\"_blank\">schedule a live walkthrough with a TeamGantt Product Specialist</a>. This will give your team an overview of all the great features available to them. &nbsp;</p><p>\n\t Here are some \n\t<a href=\"https://support.teamgantt.com/article/95-teamgantt-kickoff-meeting-resources\">kickoff meeting resources</a> to help make your meeting as efficient as possible.&nbsp;&nbsp;</p><hr><h3>5. Work your project.</h3><p>\n\t Now that your team is excited about using TeamGantt, it’s time to go to work. Make sure you’re keeping \n\t<a href=\"https://support.teamgantt.com/article/107-percentage-complete-calculated\">task progress</a> updated, <a href=\"https://support.teamgantt.com/article/4-adding-tasks\">adding new tasks</a> as needed, and checking off <a href=\"https://support.teamgantt.com/article/28-milestone\">milestones</a>. &nbsp;</p><p>\n\t<strong>Tip:</strong> It can be tempting to go back to email for project communications. TeamGantt can handle all of your project and task communication needs. Keep the conversation going inside of TeamGantt.</p><hr><blockquote style=\"text-align: right;\">\n  “We love TeamGantt. We couldn’t have launched Treehouse successfully without it!” – \n\t<a href=\"https://twitter.com/ryancarson\" target=\"_blank\">Ryan Carson</a>, \n\t<a href=\"https://teamtreehouse.com/\" target=\"_blank\">Team Treehouse</a>\n</blockquote><h2><hr>\n</h2><h2></h2><p>\n\t<br>\n\t<strong><em style=\"background-color: initial;\">To learn more about TeamGantt, join us for one of our&nbsp;</em></strong><a href=\"https://www.teamgantt.com/classes\">classes</a><strong><em style=\"background-color: initial;\">!&nbsp;</em></strong></p>","name":"Onboarding Your Team to TeamGantt","number":93,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"inviting-people","text":"<p>\n\t Communication is critical to any successful project. Lucky for you, TeamGantt makes it easy to keep everyone in the loop as your project progresses!&nbsp;</p><p>\n\t To start collaborating with others, simply invite them to your project.&nbsp;Each person invited to your project will count as a user in your account, regardless of their account permissions.</p><h5>Watch this video to learn more about inviting people to your projects.</h5>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/i7mrq4amoq?videoFoam=true\" title=\"8_Invite people to your project Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><hr><h5><strong style=\"background-color: initial; font-family: inherit; font-size: 24px;\">Invite users to your project</strong></h5><p>\n\t As a manager, you have 3 ways to invite new users to your projects:</p><ul>\n\t\n<li><strong>Method 1: </strong>Open the project you want to invite people to, and click&nbsp;<em>Menu &gt; Manage People and Labels</em>.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a85c63522b82a0f3b96d557/file-lVmVMijSbT.png\"></li>\t\n<li><strong style=\"background-color: initial;\">Method 2</strong>:&nbsp;Click the&nbsp;<em style=\"background-color: initial;\">People</em>&nbsp;tab at the top of your project.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/670e7e998af27b34842c0279/file-fuJi2OGjlz.png\"></li>\t\n<li><strong style=\"background-color: initial;\">Method&nbsp;</strong><strong style=\"background-color: initial;\">3:</strong> Click <em style=\"background-color: initial;\">Share &gt;</em>&nbsp;<em style=\"background-color: initial;\">Invite People </em>button at the upper right corner of your project:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a85c6b4cffb5047ce9d9806/file-4GSaZa0LCw.png\"></li></ul><p>Whichever method you choose, you’ll end up on your project’s \n\t<em style=\"background-color: initial;\">People</em> page. From here, click the blue&nbsp;<em style=\"background-color: initial;\">Invite users&nbsp;</em>link, located just above the list of people who are already part of your project.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a85c711cffb5047ce9d9809/file-QDIIH72NLP.png\"></p><p>&nbsp;<strong style=\"background-color: initial; font-family: inherit; font-size: 21px;\">If the user already exists in your account:</strong>Simply select the blue arrow next to the person you want to add to your project.&nbsp;This person will automatically receive an invitation to log into TeamGantt and access the project. Once you have selected everyone you wish to invite to the project, simply click \"Close\" in the bottom right of the window.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a85c7c222b82a0f3b96d55f/file-XiChS07g0V.png\"></p><h3><strong></strong></h3><p>\n\tNote: You can also choose to \"Select all\" users on the account as well.&nbsp;</p><h3><strong>If the user does not exist in your account yet:</strong></h3><h3><span style=\"background-color: initial; font-size: 14px;\">1. Click the \n\t<em style=\"background-color: initial; font-size: 14px;\">\"Create new user\"</em></span><span style=\"font-weight: normal;\">&nbsp;link.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a85c7f17efce35200939f2f/file-70cfN7XBxG.png\"></span></h3><h3><span style=\"background-color: initial; font-size: 14px;\">2. Next, enter the person’s name and email address, and select their <a href=\"https://support.teamgantt.com/article/5-permissions/\" style=\"font-size: 14px;\">Company&nbsp;Permission</a></span><span style=\"font-weight: normal;\">.</span></h3><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a06834c60795985144c1dc/file-XZnbp4EVHs.png\"></p><p>\n\t3. Click the&nbsp;\n\t<em style=\"background-color: initial;\">Add Person</em>&nbsp;button. If you need to add multiple people, you can select \"Add another person\" to add additional people.&nbsp;</p><p>\n\t 4. Once you click on \n\t<em>Add Person</em>, this will add them to the account and project.</p><p>\n\t<strong style=\"background-color: initial; font-family: inherit; font-size: 24px;\">Project Permissions</strong></p><p>\n\t TeamGantt enables you to control what users can access and edit at both the account and project level. You can learn how these permissions work on our\n\t<em>&nbsp;</em><a href=\"https://support.teamgantt.com/article/5-permissions\">Account and Project Permissions</a><em>&nbsp;</em>page.</p><p>\n\t Here’s a quick overview of the 2 permission levels:</p><ul>\n\t\n<li><strong>Collaborator</strong>&nbsp;- Can be invited to projects, assigned tasks, update progress (%) on tasks, upload files and comment on tasks, and check off checklist items.</li>\t\n<li><strong>Managers</strong>&nbsp;- Can modify the chart, invite and remove users, edit project settings, and delete the project.</li></ul><p>\n\tPermissions are managed at the account level. As a manager with account admin status, you can change global permissions on the Manage users page by clicking on the user's name.</p><h2><strong>Assign a single task</strong> to a user</h2><h2><p>\n\tAny user who has been added to your project can be assigned to tasks. Once you assign tasks to someone, you can easily identify who's responsible for each task.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/670e802b6d43ca7b17b2be88/file-KrHHNkB3vK.png\"></p></h2><p>\n\tYou can assign tasks to people or other resources in two ways.</p><ul>\n\t\n<li><strong>Method 1:</strong>&nbsp;Click the person icon to the right of any taskbar to select a user or label to assign the task to. (Hover your mouse over that row to see the icon appear.)</li></ul><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/670e80801198281bd8609fb6/file-J2jA24kgfK.png\"></p><ul>\n\t\n<li><strong>Method 2:&nbsp;</strong>From the <em>Assigned</em>&nbsp;column, click&nbsp;<em>Assign</em>&nbsp;to select a user or label to assign the task to.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/670e81038af27b34842c027d/file-NyTiORix07.png\"></li></ul><p>\n\tBoth methods will display a drop-down menu that features the names of the people and labels available to work on that task. Choose the person or label you want to assign from the drop-down, or click&nbsp; \n\t<em style=\"background-color: initial;\">Add new person/label</em>. Then, click <em style=\"background-color: initial;\">Done.</em></p><p>\n\t<strong>Tip: </strong>After assigning tasks to people, you can use the <em>Everyone</em> filter to see only the tasks that are assigned to a particular person or label.&nbsp;</p><p>\n\t<em>Looking to get more granular with assignments? <a href=\"https://support.teamgantt.com/article/155-raci-assigning-task-roles\">Check out our RACI feature!</a></em></p><h3><hr>\n</h3><h2><strong style=\"background-color: initial; font-family: inherit;\">Assign multiple tasks to a user at once</strong></h2><p>\n\t When building out your project, you might need to assign multiple tasks to the same user or label. Here are three simple ways to divvy out multiple assignments at once:</p><p>\n\t<strong>Option 1:&nbsp;</strong></p><ol><li>Check the checkboxes of the tasks you'd like to assign</li><li>Click <em>Assign&nbsp;</em>in the toolbar at the top of the screen.</li><li>Choose the person and/or label you want to assign to the selected tasks.</li></ol><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a85c96eb2235d79db9adf82/file-jR4EO1HwDp.png\" style=\"background-color: initial;\"><strong style=\"background-color: initial;\">Option 2:&nbsp;</strong></p><ol>\n\t\n<li>Click the taskbar for the first task you'd like to assign.</li>\t\n<li>Hold&nbsp;<em>Command</em>&nbsp;(Mac) or&nbsp;<em>Ctrl (</em>Windows), and click another task.&nbsp;&nbsp;</li>\t\n<li>Repeat step #2 until you've selected all the tasks/milestones you need to assign to the person or label.&nbsp;&nbsp;</li>\t\n<li>Click the person icon in the toolbar at the bottom of the screen.</li>\t\n<li>Choose the person and/or label you want to assign to the selected tasks.</li></ol><p>\n\t<strong style=\"background-color: initial;\">Option 3</strong>:</p><ol>\n\t\n<li>Click the taskbar for the first task you'd like to assign.&nbsp;</li>\t\n<li>Hold&nbsp;<em>Shift,&nbsp;</em>and click another task. This will select the 2 tasks you clicked and any tasks in between.&nbsp;&nbsp;</li>\t\n<li>Click the person icon in the toolbar at the bottom of the screen.&nbsp;</li>\t\n<li>Choose the person and/or label you want to assign to the selected tasks.</li></ol><p>\n\tFor more information about setting&nbsp;project-level permissions, check out our \n\t<a href=\"http://teamgantt.helpscoutdocs.com/article/5-permissions\">Permissions</a> tutorial.&nbsp;</p><p>\n\tLooking to get more granular with assignments? \n\t<a href=\"https://support.teamgantt.com/article/155-raci-assigning-task-roles\">Check out our RACI feature!</a></p><hr><p>\n\t<strong><em>To learn more about TeamGantt, join us for one of our&nbsp;</em></strong><a href=\"https://www.teamgantt.com/webinars/\"><strong><em>webinars</em></strong></a><strong><em>!</em></strong></p>","name":"Invite People (Users) & Assign Tasks","number":6,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"subscribe-plan-teamgantt","text":"<p>\n\t TeamGantt is a subscription service offering plans based on the number of managers associated with your account. Both monthly and annual payment options are available. Choosing to pay annually saves you nearly 20%!</p><h2>What are the different pricing plans available?</h2><p>\n\t<strong>TeamGantt Pricing Overview</strong></p><p>\n\tTeamGantt offers three plans designed to fit teams of different sizes and needs. All plans are billed monthly and scale with the number of projects you manage. We offer 20% discount for annual plans on all 3.</p><hr><p>\n\t<strong>Basic &mdash; Starting at $24/month</strong><br>\n\t Built for small teams that need straightforward project tracking. Includes 2 projects, 1 manager, up to 10 collaborators, and 150 tasks per project. You can add projects for $12/month each, up to a 5-project limit. Covers all core features like Gantt charts, calendar and list views, file management, and project communication.</p><p>\n\t<strong>Business &mdash; Starting at $120/month</strong><br>\n\t Designed for busier teams that need more power and flexibility. Includes 5 projects, unlimited managers and collaborators, and 500 tasks per project. Additional projects run $24/month each, up to a 20-project limit. Adds advanced tools like workload management, critical path, portfolio management, Kanban view, time tracking, and more.</p><p>\n\t<strong>Builder Edition &mdash; Starting at $199/month</strong><br>\n\t Purpose-built for construction professionals. Includes 10 projects, unlimited managers, collaborators, and tasks, plus personalized onboarding. Includes everything in Business, along with construction-specific features like lookahead scheduling, material delay prevention, financial forecasting, Procore sync, RACI assignments, lockable milestones, and confirm schedule changes.</p><hr><p>\n\tNot sure which plan is right for you, or want a custom plan? \n\t<a href=\"https://meetings.hubspot.com/manny-smirnov/teamgantt-book-a-demo-universal-link?utm_source=pricing_2_page&amp;uuid=d5c7e378-d1a3-4869-8b4e-363f691d282a\" target=\"_blank\">Set up a time with us</a> &mdash; we're happy to help you find the best fit.</p><p>\n\tFor more information about the individual features included in each plan, please visit \n\t<a href=\"https://www.teamgantt.com/pricing\">www.teamgantt.com/pricing</a>.</p><p>\n\t<strong>Note:</strong></p><ul>\n\t\n<li>TeamGantt will automatically renew your subscription on a monthly or annual basis. There's no minimum purchase required, and you can cancel anytime.</li></ul><hr><h2>Collaborator vs Manager</h2><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t A&nbsp; collaborator is able to be invited to projects, assigned to tasks, receive notifications, update the progress and check off checklist items on tasks they are assigned to, leave comments, and&nbsp;upload or download documentation to a task or project. There is no limit on how many projects or tasks a collaborator can be invited or assigned to.&nbsp;\n\t<br>\n\t<br>\n\tA&nbsp;Manager can create and edit \n\t<a href=\"https://support.teamgantt.com/article/106-projects\">projects</a>, as well as invite <a href=\"https://support.teamgantt.com/article/75-collborator-or-label\">collaborators</a> to projects. They are also able to edit project settings.&nbsp;</p><p>\n\tBASIC plans include 1 manager and 10 collaborators, and the Builder and Business Plans allow unlimited managers and collaborators.</p><h2>\n<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/632b2a19e5ea7f482dc3d7e2/file-pD5ULl4UvI.png\"><hr>\nWhere can I see the number of managers and collaborators on my account?\n</h2><p>\n\tTo see a current count of managers and collaborators on your account, the Account Admin can go to: \n\t<em>Account Settings</em> &gt; <em>Manage users</em>.&nbsp;</p><hr><h2>How do I upgrade my plan?</h2><p>\n\tTo upgrade your subscription, the Managers (with billing permission) can go to:&nbsp;\n\t<em>Account Settings</em>&nbsp;&gt; <em>Plan Details</em>.&nbsp;</p><hr><h2>What payment types do you accept?</h2><p>\n\tWe accept all major debit/credit cards as well as PayPal.&nbsp;</p><hr><p>\n\t For more information about TeamGantt plans and pricing, please visit \n\t<a href=\"https://www.teamgantt.com/pricing\">www.teamgantt.com/pricing</a>.</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p><p style=\"font-weight: bold;\"></p>","name":"Subscription Options","number":50,"categories":["57e9e78d9033602e61d4835c"]}},{"node":{"slug":"templates","text":"<h2>Can I create templates for recurring projects?</h2><p>\n\tYes, you can save any TeamGantt project as a template.</p><p>\n\tTemplates save you lots of time on setup&mdash;whether you constantly duplicate projects or have projects with&nbsp;similar elements that just need minor changes.&nbsp;</p><p>\n\tLet's walk through&nbsp;how templates work in TeamGantt.</p><hr>\n<h2>How do I save a project as a template?</h2><p>\n\t In TeamGantt, you can use a template as many times as you want. That way you don't have to build a project from scratch every time. It's also a great way to duplicate a project.</p><p>\n\t Here's how to save a project as a template:</p><ol>\n\t<li>Open the project.&nbsp;</li>\t<li>Go to&nbsp;<em>Menu &gt; Save as Template.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/670936428af27b34842c0043/file-MnjkNl76dy.png\"></em></li></ol><hr id=\"horizontalrule\">\n<h2>How do I create a new project from a template?</h2><p>\n\t Once you've saved your project as a template, you can use it to jumpstart setup next time you create a project. Simply follow these steps:&nbsp;</p><p>\n\t 1. Go to&nbsp;\n\t<em>My Projects&nbsp;</em>(in the left sidebar menu) and select&nbsp;<em>New Project &gt; Create a New Project.</em></p><p>2. Click the&nbsp;<em style=\"background-color: initial;\">Template</em>&nbsp;field under <i style=\"background-color: initial;\">Advanced Settings&nbsp;</i>to open the full template drop-down list and choose a template. Or, click the&nbsp;<em style=\"background-color: initial;\">Preview Templates&nbsp;</em>link to see what the different templates look like before choosing one.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a7de57073778c51e837e9d1/file-E0v6UNC4Yr.png\"></p><p>\n\tIf you select the&nbsp;\n\t<em style=\"background-color: initial;\">Preview templates&nbsp;</em>link, a new window will pop up.&nbsp;Select a template option from the list on the left to see a preview on the right.&nbsp;</p><p>\n\t Then, click \n\t<em>Use Template</em> to apply it to your new project.</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/65f0a4d327186a68700ff71e/file-nDZF9KVkfQ.png\">3.&nbsp;Once you’ve chosen a template, enter a start date for your project. If you leave it blank, the project start date defaults to the current date. You can then choose which days of the week you'd like to include in your project. You can also select a Default view for your project.</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a7de4a3997ac821904e28a1/file-WRIzS7CiWv.png\">&nbsp;4.&nbsp;Choose the details you want to import from the template.</p><p>\n\t5.&nbsp;Complete the rest of the new project details, then click&nbsp;\n\t<em style=\"background-color: initial;\">Create new project</em>&nbsp;to go to your gantt chart.</p><h2>\n<hr>\n</h2><h2> <strong>How do I edit or delete a template?</strong></h2><p>\n\t A template is connected to the project it is saved from. To edit or delete a template, you simply need to edit or delete the original project you used to create the template.&nbsp;</p><p>\n\t Keep in mind that you must have \n\t<em>Admin </em>permission in a project in order to delete it.&nbsp;</p><hr>\n<h2>Template tips</h2><ul>\n\t<li>When you create a template, it adds a project to your account. If the template's status is set to&nbsp;<em>Active</em>&nbsp;or <em>On hold</em>, it&nbsp;will count toward your allowed plan totals. Changing the status of your template to <em>Completed</em>&nbsp;will enable you to use the template for new projects without it counting toward your total active projects.</li>\t<li>Creating a new project from a template is currently the only way to duplicate <a href=\"https://support.teamgantt.com/article/115-checklists\">checklists</a>.</li>\t<li>To create a new project from a template, you must have Manager<em style=\"background-color: initial;\">&nbsp;</em>permission on the account and must be invited to the original project.</li></ul><hr>\n<p>\n\t<br>\n\t<strong><em style=\"background-color: initial;\">To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</em></strong></p>","name":"Create a Template","number":19,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"milestone","text":"<p>\n\tA milestone is a gold,&nbsp;diamond-shaped icon used to represent a major point or goal in a project.&nbsp;They're&nbsp;great for indicating a project kickoff or important deadline.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e1ac0ae6b2356def909444/file-WnmSfn2pYr.png\"></p><h2>\n\tWhat is the difference between a task and a milestone in TeamGantt?</h2><p>\n\tWhile you have the ability to change task colors, milestones are different. They always appear in gold to ensure they stand out from the rest of your project tasks. Think of them as your very own project bling!&nbsp;</p><h2>\n</h2><h2>How do I add a milestone to my project?</h2><p>\n\t<span style=\"font-weight: normal;\">Here's how to create and schedule a milestone in your project:</span></p><p>\n\t 1) Click on the&nbsp;\n\t<em>Milestone</em>&nbsp;link.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e1ab26811a2434cb6d3731/file-JPZGEJrlKm.png\"></p><p>\n\t 2) Type the milestone name.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e1abc544628317ef903961/file-hGh9vYpsi8.png\"></p><p>\n\t3) Drag the milestone icon across the Gantt chart to schedule it.&nbsp;</p><h2>How do I lock milestones in place?</h2><p>\n\tMilestones have the option to be locked into their current date. A manager can go to \n\t<strong>Menu</strong> &gt; <strong>Project Settings</strong>, and toggle the \"Lock milestone dates\" option. When milestones are locked, they are unable to be rescheduled by a user or dependencies.&nbsp;<br>\n\t<br>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6596ed845428390b5eedb90e/file-M8bSfdjxST.png\">&nbsp;</p><p>\n\t<br>\n\tTo read more about milestones, check out our \n\t<a href=\"https://www.teamgantt.com/blog/what-is-a-milestone-in-a-gantt-chart/\" style=\"font-size: 14px;\">blog post</a>!</p><hr id=\"horizontalrule\"><p>\n\t<em>Having trouble creating and scheduling milestones? Shoot us a message at <a href=\"mailto:mailto:support@teamgantt.com\">support@teamgantt.com</a>!</em><em>&nbsp;</em></p><p>\n\t<em style=\"background-color: initial;\"><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/webinars/\">webinars</a>!&nbsp;</strong></em></p>","name":"Create a Milestone","number":28,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"task-colors","text":"<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/1fqvk36501?videoFoam=true\" title=\"5_Add Color Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div>\n</div><p>\n\t Colors enable you to customize TeamGantt to fit your organization's needs. Here are just a few fun ways you can use color to add some project jazz:</p><ul>\n\t<li>Distinguish between departments/teams (e.g., all Marketing Department tasks are purple)</li>\t<li>Identify user assignments (e.g., all of John's tasks are blue)</li>\t<li>Set priority level (e.g., all red tasks are urgent, green are low priority)</li></ul><p>\n\t Let's take a closer look at how to assign and change task colors for better project organization.&nbsp;</p><hr>\n<h2> <strong>How do I change a task's color?</strong></h2><p>\n\t You have 16 preset task colors at your fingertips in TeamGantt.&nbsp;There are 2 methods for changing a task's color.&nbsp;</p><h3>\n<strong>Method 1: From gantt view</strong></h3><p><strong></strong>Hover over the task, and click the color block icon that appears to the right of the task bar to select a new color.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a906c019f65cc0cc64d6845/file-XqBN8655Hr.png\">You can also change the color of an entire task group with a single click. Simply hover over the task group line, and click the color block icon that appears to the right to change the color.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a906c744b84f76cf81bf136/file-qAW4ZCl88j.png\"></p><p>\n\tWant to color-code a bunch of tasks that aren't grouped together? That's easy too! Here's how to change the color of multiple ungrouped tasks simultaneously:</p><ol>\n\t<li>Check the desired tasks using the multi-select column to the left of the task names.&nbsp;</li>\t<li>Then, select the color palette icon in the top toolbar.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a906d04ce92cdaba13d04ae/file-OzKtMl0nut.png\"></li></ol><p>\n\t<strong>Note</strong>: While you can change task colors all day long, it's not possible to change the color of <a href=\"https://support.teamgantt.com/article/28-milestone\" target=\"_blank\">a milestone</a>.</p><h3>\n<strong>Method 2: From the task's <em>e</em><em>dit </em>window</strong></h3><p><strong></strong>Double click the task bar to open up the \n\t<em style=\"background-color: initial; font-size: 14px;\"> edit</em>&nbsp;window for the task. Then, choose a new color for the task by selecting a color block option:&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a906d47ce92cdaba13d04b2/file-NROst6bnmr.png\"></p><hr>\n<h2> <strong>How do I assign a default task color to a user or label?</strong></h2><p><strong></strong>To set a default color for each person on your team,&nbsp;select the&nbsp; \n\t<em style=\"background-color: initial; font-size: 14px;\">People&nbsp;</em>tab&nbsp;at the top of your project, then click the <em>color</em> icon&nbsp;next to the user/label you'd like to assign a color to.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a90704ace92cdaba13d04c0/file-zXcfdi9NQO.png\"></p><p>\n\tOnce you do this, each task you assign to that person or label will automatically be the color you selected. You can either assign the color to future tasks only or to both previously created and future tasks.&nbsp;</p><p>\n\t What if more than one person's assigned to a task? In that case, the last person assigned to the task will determine the task bar color. Of course, you can change the task color manually anytime you want.</p><p>\n\t<strong>Note: </strong>Selecting a default task color from the <em>People</em> tab will only change the color of tasks for that&nbsp;selected project.&nbsp;</p><hr>\n<h2>How do I filter my project by task color?</h2><p>Want to filter your project view by color? Click the&nbsp;<em style=\"background-color: initial; font-size: 14px;\">Filter</em><em style=\"background-color: initial; font-size: 14px;\">&nbsp;</em>drop-down menu at the top of your gantt or list view, and select the color filter(s) you'd like to apply to your chart.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a9070a2039b617b174282cb/file-yEbzEHAI5T.png\"></p><p>\n\tWant more info about filters? You can learn more \n\t<a href=\"https://support.teamgantt.com/article/24-filters\" target=\"_blank\">here</a>.&nbsp;</p><hr>\n<p>\n\t<strong>Note: </strong>It's not possible to change color names at this time.</p><hr>\n<p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Task Colors","number":18,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"hourly-estimation","text":"<p>\n\t For projects where daily tasks are not detailed enough, TeamGantt offers hourly estimation. This feature is available in the following plans: Business and Builder Edition plans, as well as in our Enterprise solutions</p><p>\n\tWatch this video to see hourly estimation in action:</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/bs13gfry2e?videoFoam=true\" title=\"Hourly Estimation Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><hr><h2>How do I enable <em>Estimated Hours</em> on my project?</h2><p>\n\t To enable \n\t<em>Estimated Hours</em> on a project, go to <em>Menu &gt; Project Settings &gt; Enable Hours,&nbsp;</em>and select <em>Yes</em>:</p><p>\n\t<strong style=\"background-color: initial;\"><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2d02c7a663fc1668433c4/file-NZzJqH2Bpe.png\"><br>\n\t</strong></p><p>\n\t<strong style=\"background-color: initial;\">Note: </strong>You must have manager permission on a&nbsp;project to change the project's settings.</p><hr><h2>How do I add&nbsp;<em>Estimated Hours</em> to a task?</h2><p>\n\t To view and assign estimated hours to tasks, enable the \n\t<em>Estimated Hours </em>column by clicking&nbsp;<em>View &gt; Columns &gt; Show estimated hours column:&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2d0ae90b6d3564bc8f5bb/file-wn2z2rIQRU.png\"></em></p><p>\n\tTo assign hours to a task, simply click into the text field in the \n\t<em>Estimated Hours </em>column, and enter your estimate:&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2d0fbfc9520d13c1d46bd/file-yQ4We8YAb3.png\"></p><h2>How do I assign hours to project resources?</h2><p>\n\t One of the biggest benefits of using the hourly estimation feature is being able to determine your team's workload more accurately.&nbsp;&nbsp;</p><h3> <strong> Assigning hours to users on your team</strong></h3><p>\n\t There are 3 different ways to add hourly estimates for people or labels that have been assigned to tasks in TeamGantt. It all depends on your particular project scenario. Let's take a look.</p><p>\n\t<strong> 1) Assign both users and estimated hours to a task at the same time:</strong></p><p>\n\t First, hover over the task, and click \n\t<em>Assign People</em><em>&nbsp;</em>in the <em>Assigned </em>column or the person icon that appears next to the task bar:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2d29cfc9520d13c1d470c/file-OzChTUJHl6.png\"></p><p>\n\tNext, select the resources you'd like to assign to the task, and enter either the <em style=\"background-color: initial;\">Avg Hours/Day</em> or <em style=\"background-color: initial;\">Total Hours</em>. (The other field will populate automatically.)<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2d33d7a663fc166843431/file-CAJ4XDfQrA.png\"></p><p>\n\t<strong style=\"background-color: initial;\">2) If users have already been assigned to a task:</strong></p><p>\n\t Hover over the \n\t<em>Estimated Hours </em>column, and then click into the text field&nbsp;to enter the total estimated hours for the task.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2d38e90b6d3564bc8f645/file-bsYSgQlhOW.png\"></p><p>\n\tA pop-up window will appear, asking if you'd like to adjust the hours for the users/labels assigned the task. If you select the checkbox before clicking <em style=\"background-color: initial;\">Yes</em>&nbsp;or <em style=\"background-color: initial;\">No</em>, your preference will be noted for all future instances. (You can adjust this preference anytime by going to <a href=\"https://support.teamgantt.com/article/98-my-preferences-dependencies\">My Preferences</a><em style=\"background-color: initial;\">.</em>)<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2d3c790b6d3564bc8f64a/file-Yg0wibSzK5.png\"></p><p>\n\t<strong style=\"background-color: initial;\">3) </strong><strong style=\"background-color: initial;\">If hours have already been assigned to a task, but users have not:</strong></p><p>\n\t First, hover over the task, and select \n\t<em>assign&nbsp;</em>in the&nbsp;<em>Assigned&nbsp;</em>column or the person icon that appears next to the&nbsp; \n\t<g>\n\ttaskbar \n\t</g>:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2d4dd7851bd3fd9580c74/file-6mXPzl7IQN.png\"></p><p>\n\tNext, click either the <em style=\"background-color: initial;\">Fix&nbsp;</em>button at the bottom of the user assignment window or simply select users to assign hours to:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2d6227851bd3fd9580c7d/file-2Ovv629Pz1.png\"><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2d6754b1e6137dce822f7/file-ScMsOY5r1k.png\"></p><p>\n\t<strong>Note: </strong>When a task's length is changed&mdash;for instance, a 2-day task is extended to a 4-day task or vice versa&mdash;you'll be prompted to choose between increasing/decreasing users' assigned hours accordingly or leaving the daily assigned hours as-is. Go <a href=\"https://support.teamgantt.com/article/98-my-preferences-dependencies\">here</a> for more information about setting your hourly scheduling preferences.</p><hr><h2> <strong>How do I use estimated hours to determine resource availability?</strong></h2><p>\n\t<strong></strong>Now that your team has been assigned to hours, you'll have an even better understanding of how busy everyone is. Just click the&nbsp;<em style=\"background-color: initial;\">Availability </em>tab found at the bottom of your project's gantt chart, and toggle to <em style=\"background-color: initial;\">Hours Per Day:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2d77290b6d3564bc8f66a/file-8HFavQNARD.png\"></em></p><p>\n\t<em style=\"background-color: initial;\"></em></p><p>\n\t Any day that includes over 8 hours of work will automatically be highlighted in red to indicate a potential overload.&nbsp;</p><p>\n\t Read more about \n\t<a href=\"https://support.teamgantt.com/article/138-workloads\">workloads</a> and <a href=\"https://support.teamgantt.com/article/16-team-availability\">team availability</a>!</p><hr><p>\n\t<strong><em style=\"background-color: initial;\">To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</em></strong></p>","name":"Hourly Estimation (Available in Business and Builder)","number":79,"categories":["5284dea7e4b04fbdf2ac3a02"]}},{"node":{"slug":"uploading-documents","text":"<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/7bms7g8fpz?videoFoam=true\" title=\"6_Upload a file Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><hr><h2>How do I upload a document to a comment?</h2><p>\n\t Documents and files can be uploaded for easy collaboration in the comment window of a task, task group, or project.&nbsp;</p><p>\n\t Here's how to attach a document to a comment:</p><ol>\n\t\n<li>Hover over a task, task group, or project, and select the speech bubble icon to the left to open the comment window.&nbsp;</li>\t\n<li>Let team members know what the document is and why it's important to the task or project by typing a comment where it says <em style=\"background-color: initial;\">“Enter comment here&hellip;”</em>&nbsp;&nbsp;</li>\t\n<li>Once you've entered your comment, select the&nbsp;<em>paperclip icon </em>or <em>upload a file&nbsp;</em>to attach the file.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a849f6e3db50143df5c86b0/file-TpYOBG16eu.png\"></li></ol><p>\n\tP.S. If your account is on a Premium trial or paid subscription, you can also \n\t<a href=\"https://support.teamgantt.com/article/149-file-sharing-integrations\">upload files from Dropbox</a>!&nbsp;</p><hr><h2>Where can I view documents all in one place?</h2><p>\n\t The \n\t<em>Files</em> tab&nbsp;lets you see all your uploaded documents for a project in one place. This is also a convenient hub for adding more documents to your project.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a849f2caa237701519b9a0d/file-m1EsF3WIOo.png\"></p><p>\n\tWhat file types can I upload to TeamGantt?</p><p>\n\t The following file types can be uploaded:</p><p>\n\t .3dm \n\t<br>\n\t .aac \n\t<br>\n\t .ai \n\t<br>\n\t .aif \n\t<br>\n\t .aiff \n\t<br>\n\t .anc \n\t<br>\n\t .ass \n\t<br>\n\t .atom \n\t<br>\n\t .avi \n\t<br>\n\t .bmp \n\t<br>\n\t .bz2 \n\t<br>\n\t .cdr \n\t<br>\n\t .css \n\t<br>\n\t .csv \n\t<br>\n\t .dmg \n\t<br>\n\t .doc \n\t<br>\n\t .docx \n\t<br>\n\t .dwf \n\t<br>\n\t .dwg \n\t<br>\n\t .dxf \n\t<br>\n\t .eml \n\t<br>\n\t .emlx \n\t<br>\n\t .eps \n\t<br>\n\t .fla \n\t<br>\n\t .flv \n\t<br>\n\t .gif \n\t<br>\n\t .gz \n\t<br>\n\t .gzip \n\t<br>\n\t .htm \n\t<br>\n\t .html \n\t<br>\n\t .ics \n\t<br>\n\t .idml \n\t<br>\n\t .iges \n\t<br>\n\t .indd \n\t<br>\n\t .inf \n\t<br>\n\t .jar \n\t<br>\n\t .jpe \n\t<br>\n\t .jpeg \n\t<br>\n\t .jpg \n\t<br>\n\t .js \n\t<br>\n\t .json \n\t<br>\n\t .keynote \n\t<br>\n\t .kmz \n\t<br>\n\t .m4a \n\t<br>\n\t .mov \n\t<br>\n\t .mp3 \n\t<br>\n\t .mp4 \n\t<br>\n\t .mpeg \n\t<br>\n\t .mpg \n\t<br>\n\t .mpp \n\t<br>\n\t .msg \n\t<br>\n\t .numbers \n\t<br>\n\t .odp \n\t<br>\n\t .ods \n\t<br>\n\t .odt \n\t<br>\n\t .ogg \n\t<br>\n\t .one \n\t<br>\n\t .otf \n\t<br>\n\t .pages \n\t<br>\n\t .pdf \n\t<br>\n\t .php \n\t<br>\n\t .png \n\t<br>\n\t .potx \n\t<br>\n\t .ppt \n\t<br>\n\t .pptx \n\t<br>\n\t .psd \n\t<br>\n\t .qt \n\t<br>\n\t .rar \n\t<br>\n\t .raw \n\t<br>\n\t .rss \n\t<br>\n\t .rtf \n\t<br>\n\t .sketch \n\t<br>\n\t .skp \n\t<br>\n\t .sql \n\t<br>\n\t .srt \n\t<br>\n\t .stl \n\t<br>\n\t .svg \n\t<br>\n\t .tar \n\t<br>\n\t .tif \n\t<br>\n\t .tiff \n\t<br>\n\t .tld \n\t<br>\n\t .ttf \n\t<br>\n\t .twd \n\t<br>\n\t .txt \n\t<br>\n\t .url \n\t<br>\n\t .vsdx \n\t<br>\n\t .vtt \n\t<br>\n\t .wav \n\t<br>\n\t .webloc \n\t<br>\n\t .wma \n\t<br>\n\t .wmv \n\t<br>\n\t .xla \n\t<br>\n\t .xlam \n\t<br>\n\t .xlb \n\t<br>\n\t .xlc \n\t<br>\n\t .xld \n\t<br>\n\t .xlk \n\t<br>\n\t .xll \n\t<br>\n\t .xlm \n\t<br>\n\t .xls \n\t<br>\n\t .xlsb \n\t<br>\n\t .xlsm \n\t<br>\n\t .xlsx \n\t<br>\n\t .xlt \n\t<br>\n\t .xltm \n\t<br>\n\t .xlv \n\t<br>\n\t .xlw \n\t<br>\n\t .xml \n\t<br>\n\t .zip&nbsp;</p><hr><p>\n\t<strong>Tip</strong>: Need to upload a file type that's not listed above? Send us a note at <a href=\"mailto:support@teamgantt.com\">support@teamgantt.com</a> to have it added to our list, or&nbsp;create a .zip of the file to upload.</p><p>\n\t To upload a Google doc, simply add the document link to the comment/note section of a task or project.</p><hr><h2>How do I delete a file from a task or project?</h2><p>\n\t To delete an uploaded file, locate the task the file was originally uploaded to. Then, open the comment window, and click the trashcan icon next to the file you want to remove.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a849fc64f742c5313c505a8/file-FSH3TrQXce.png\"></p><p><strong style=\"background-color: initial;\">Tip:&nbsp;</strong>Currently, it's not possible to delete uploaded files from the <em style=\"background-color: initial;\">Files</em> tab.</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Upload and Delete Files","number":67,"categories":["5284de2fe4b027e0d843bc97"]}},{"node":{"slug":"frequently-asked-questions","text":"<h2>TeamGantt FAQ</h2><h2><strong style=\"font-size: 14px;\">Here are some common questions that may pop up as you use TeamGantt:&nbsp;</strong></h2><h4>How do I save my data?&nbsp;</h4><p>\n\t TeamGantt saves&nbsp;changes to your project as you go. Each time you update a project&mdash;whether adding new tasks or adjusting the percent complete&mdash;your data is automatically saved and ready for you next time you log in.&nbsp;</p><hr><h4> How can I reset my password?</h4><p>\n\t Resetting your password is simple! Visit&nbsp;the login page and click \n\t<em>Forgot Password.</em><a href=\"https://app.teamgantt.com/forgot-password\"></a></p><p>\n\t Enter the email address you use to log into&nbsp;TeamGantt, and click&nbsp;\n\t<em style=\"background-color: initial;\">Reset Password</em>. An email will be sent to you with instructions on how to reset your password. Please note: Your password will not update until you&nbsp;complete the steps in the email.</p><p>\n\t If you have trouble resetting your password, please email \n\t<a href=\"mailto:support@teamgantt.com\">support@teamgantt.com</a> using the email address associated with your account.&nbsp;</p><hr><h4>How can I translate TeamGantt to my language?&nbsp;</h4><p>\n\t You can enter project and task details in any language in TeamGantt to ensure clear communication with your team. However, we only offer our software in English.&nbsp;</p><p>\n\t If you'd like to see the menus and other text on TeamGantt in another language, your best option is to use Google Chrome's live translate feature.&nbsp;You can find out more by visiting: \n\t<a href=\"https://support.google.com/chrome/answer/173424?hl=en\">Translate a page to your language</a>.</p><p>\n\t We hope to add a native translation option in the future!</p><hr><h4>How do I set a project start and end date?</h4><p>\n\t There's no option for formally setting a start and end date for your project. A project's start date is simply wherever the first \n\t<a href=\"https://support.teamgantt.com/article/4-adding-tasks#scheduling-tasks\">task is scheduled</a> to begin. The end date is where the last task is scheduled to end.&nbsp;</p><p>\n\t If you'd like to call attention to important dates, like a project's kickoff or finally delivery, we recommend using \n\t<a href=\"https://support.teamgantt.com/article/28-milestone\">milestones</a>.&nbsp;&nbsp;</p><p>\n\t Read more about start and end dates \n\t<a href=\"https://support.teamgantt.com/article/146-project-start-and-end-dates\">here</a>.&nbsp;</p><hr><h4> How do I share or export my project?&nbsp;</h4><p>\n\t Right now we support a few different options:&nbsp;</p><ul>\n\t\n<li>Exporting your project as a PDF (Here's more on <a href=\"https://support.teamgantt.com/article/133-exporting-your-project-gantt-list-calendar-views\">how to export each view</a>.)</li><li>Exporting your project data as a CSV (<em style=\"background-color: initial;\">Menu &gt; Export CSV)</em></li>\t\n<li>Sharing <a href=\"https://support.teamgantt.com/article/46-embedding-your-projects#how-to-embed-a-project\">embedded version</a> of your project or a <a href=\"https://support.teamgantt.com/article/46-embedding-your-projects#alternative-way-to-share-a-view-only-url-of-your-project\">view-only URL</a> to your project</li>\t\n<li>Inviting someone to your account as a <a href=\"https://support.teamgantt.com/article/75-user-or-resource\">user.</a></li></ul><hr><h4>How do I duplicate a project?</h4><p>\n\t We support both \n\t<a href=\"https://support.teamgantt.com/article/111-duplicate-a-project#duplicate-an-existing-project\">duplicating projects</a> and <a href=\"https://support.teamgantt.com/article/111-duplicate-a-project#create-a-new-project-from-a-template\">saving an existing project as a template</a> and then using it to create a new project. We typically advise that you try the latter option because it will allow you more flexibility during the setup process for the new project, such as choosing a different start date for the project.&nbsp;&nbsp;</p><hr><h4> How do I remove users from my project/account?&nbsp;</h4><p>\n\t To remove a user from a project, you must be a manager on the project. Go to the \n\t<em>People </em>page at the top of your project, click the triple dot icon to the far right of the user name. Then, select <em>Remove from project</em>.&nbsp;</p><p>\n\t To remove a user from the account, you must be a manager. Go to&nbsp;\n\t<em style=\"background-color: initial;\">Account Settings</em>&nbsp;(from your circular profile icon at the upper right) &gt;&nbsp;<em style=\"background-color: initial;\">Manage users&nbsp;</em>and then select the triple dot icon&nbsp;next to the user that you wish to remove to select <em>Delete user</em>.&nbsp;</p><p>\n\t Read more about account and project-level permissions \n\t<a href=\"https://support.teamgantt.com/article/5-permissions\">here</a>.&nbsp;</p><hr><h4>Can I open more than 1 project at once?</h4><p>\n\t Yes! To open more than one project (while within a project):</p><ol>\n\t\n<li>Go to&nbsp;<em>Menu &gt; Open Projects</em>.&nbsp;</li>\t\n<li>Select the projects you want to open, and they'll automatically be added to your gantt chart.&nbsp;</li></ol><p>\n\t Here's more on \n\t<a href=\"https://support.teamgantt.com/article/25-viewing-multiple-projects\">opening multiple projects at once</a>.&nbsp;</p><hr><h4> How can I change the date format?&nbsp;</h4><p>\n\t Don't want to use the standard US format of MM/DD/YY? No problem! We support several different date formats.</p><p>\n\t To change the date format, go to the \n\t<em>View </em>drop-down located at the upper left side of your gantt chart. Then, select <em>Date format </em>to see all of the options.&nbsp;</p><p>\n\t Here's more on all of the different ways you can \n\t<a href=\"https://support.teamgantt.com/article/9-view-options\">adjust the view of your project</a>.&nbsp;</p><hr><h4>How can I show my project in a format other than days (i.e. weeks or months)?</h4><p>\n\t Currently, we support a daily format and a weekly format in \n\t<em>Gantt </em>view<em>. </em>Both formats allow for several zoom levels, depending on how much of your chart you wish to see at once.&nbsp;</p><p>\n\t The zoom options are located under the&nbsp;\n\t<em>View</em>&nbsp;drop-down (as well as in the top right of the chart via the&nbsp;<em>Zoom&nbsp;</em>drop-down<em>)</em>. The default is&nbsp;<em>Day View</em>&nbsp;at 100%.</p><hr><h4>How do I add weekend days to the Gantt chart?</h4><p>\n\t To change the days of the week in your project, navigate to \n\t<em>Menu </em>(upper left side of chart) &gt; <em>Open Project Details&nbsp;</em>and select the \"Days in Week\" (on the right side of the window).&nbsp;</p><p>\n\t Here's more on \n\t<a href=\"https://support.teamgantt.com/article/72-customizing-days-in-your-projects\">selecting the days of the week for your project</a>.&nbsp;</p><hr><h4>How do I show critical path?</h4><p>\n\tCritical path is now included in our new Gantt 2.0. You can read about it more \n\t<a href=\"https://support.teamgantt.com/article/165-critical-path\">here!&nbsp;</a></p><hr><h4>How do I set recurring tasks?&nbsp;</h4><p>\n\t Currently, we don't directly support recurring tasks. However, we do have suggestion for a workaround \n\t<a href=\"https://support.teamgantt.com/article/105-recurring-tasks#set-up-recurring-tasks-for-a-project\">here</a>.</p><hr><h4>How do I cancel my account?&nbsp;</h4><p>\n\t If you're a manager with account admin status, you can cancel the account by going to \n\t<em>Account Settings </em>(via your circular profile icon in the upper right) &gt; <em>Plan Details &gt; Cancel plan.&nbsp;</em></p><p>\n\t There are 2 options - (1) Placing your account on hold for $5/month or (2) Canceling outright. If you choose to cancel outright, your subscription will be canceled, and your project data will be deleted at the end of your subscription term.&nbsp;</p><hr><h4>How do I add more users to my subscription?</h4><p>\n\tAs a manager with account admin status, to add more users, you can either \n\t<a href=\"https://support.teamgantt.com/article/6-inviting-people#invite-users-to-your-project\">invite them directly to a project</a> or <a href=\"https://support.teamgantt.com/article/114-changing-account-level-permissions\">invite them to the account</a> so that they're available to be added within projects.</p><p>\n\t Read more about account and project level permissions \n\t<a href=\"https://support.teamgantt.com/article/5-permissions\">here</a>.&nbsp;</p><hr><h4>How do I update user permissions?&nbsp;</h4><p>\n\tTo update a person's permission on the account, go to&nbsp;\n\t<em>Account Settings</em>&nbsp;&gt;&nbsp;<em>Manage users</em>. Read more about permission levels <a href=\"https://support.teamgantt.com/article/5-permissions/\">here</a>. (Note: You must be a manager with account admin status&nbsp;to do this.)</p><hr><h4>How do I sync TeamGantt with another tool?</h4><p>\n\t There are several different ways to sync TeamGantt data externally:</p><ul>\n\t\n<li><a href=\"https://support.teamgantt.com/article/132-teamgantt-api\">TeamGantt API</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/152-teamgantt-integration-for-zapier\">TeamGantt Zapier integration</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/12-calendar-feed\">Calendar feed for Google Calendar, iCal, and Outlook</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/116-trello-powerup\">TeamGantt Power-Up for Trello</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/37-basecamp\">TeamGantt Basecamp 2 integration</a></li></ul>","name":"Frequently Asked Questions","number":147,"categories":["6a021cfef97dd896ebfc81ba"]}},{"node":{"slug":"embedding-your-projects","text":"<p>\n\t Whether prepping for a client meeting or a public presentation, you may want to share a TeamGantt project with someone who hasn't been invited to the project.&nbsp;</p><p>\n\t You have 2 options for giving non-TeamGantt users read-only access to your project:</p><ul>\n\t\n<li>Embed a project using Javascript or iFrame</li>\t\n<li>Share a view-only URL&nbsp;</li></ul><p>\n\t<em>Note: These options are only available on our&nbsp;</em><a href=\"https://support.teamgantt.com/article/50-subscribe-plan-teamgantt\"><em>paid plans</em></a><em>. </em></p><hr><h2>How do I embed a TeamGantt project using an iFrame?</h2>\n<div>\n  1) Open the project.\n</div><div>\n  2) Go to:&nbsp; \n\t<em>Menu &gt; Embed.&nbsp;</em>(If you don't see this option, you may have to scroll down.)<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6717ab4844fbd7540103ba18/file-dMkfnT0tHC.png\">\n</div><div>3) Click on \"View legacy share link settings\".&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a065abc4d142b755b5018c/file-dFiKVLzJkx.png\"></div><div>4) Then, choose&nbsp;\n\t<em style=\"background-color: initial;\">Embeddable iFrame</em>&nbsp;as your format. Then, click the&nbsp;<em>Copy</em>&nbsp;button to copy the iFrame code.\n</div><div>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6862e30f07cc414af6e16b84/file-5IexSx9Ow6.png\">&nbsp;\n</div><div>5) If you would like to customize the view before embedding your project, click the&nbsp;\n\t<em>Customize </em>button.\n</div><div>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6862e341214b947094e97eb1/file-q2SC59Dim8.png\"><br>\n</div><div>\n\t<p>\n\t\tOnce you've customized the settings, you can then click the&nbsp;\n\t\t<em>Copy</em> button at the bottom&nbsp;to copy the Embeddable iFrame code.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6894fb67cc94a96f86d43f3a/file-W0ozxSk5PR.png\">\n\t</p>\n\t<p>\n\t\tCan I test what my project looks like in read-only view?\n\t</p>\n</div><div>\n\tYes!&nbsp;Here's how to check your project's read-only view before sharing it with others:\n</div><ol>\n\t\n<li>Go to&nbsp;<em>Menu &gt; Embed.</em></li>\t\n<li>Select <em>URL</em> as your format, and&nbsp;copy the URL of the gantt chart.&nbsp;</li>\t\n<li>Open an incognito window in your browser, and paste the URL onto the address bar.</li>\t\n<li>Hit <i style=\"background-color: initial;\">Enter</i> to view your project.&nbsp;&nbsp;</li></ol><hr><h2>Can I embed multiple TeamGantt projects in one iFrame?</h2><p>\n\tYes, you can share multiple projects in one iFrame.&nbsp;</p><ol>\n\t\n<li>Start by <a href=\"https://support.teamgantt.com/article/25-viewing-multiple-projects\">opening multiple projects in gantt view</a>.&nbsp;</li>\t\n<li>Then go to <em style=\"background-color: initial;\">Menu &gt; Embed/Share link.</em></li>\t\n<li>Select all projects in the customization settings.</li>\t\n<li>Finally, copy the Embeddable iFrame code.&nbsp;</li></ol><h2><hr>\n</h2><h2>Alternate way to share a view-only&nbsp;URL or iFrame of your project</h2><p>\n\tOpen your project, and select&nbsp;\n\t<em style=\"background-color: initial; font-size: 14px;\">Share &gt; Copy Link to Chart</em>&nbsp;at the upper right of your browser window.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6717aaa215d0b82233065a1e/file-Txq5EZNZPe.png\"></p><p>\n\tTo learn more about options available for sharing projects with non-TeamGantt users, please visit: \n\t<a href=\"https://support.teamgantt.com/article/89-sharing-your-project\">Share Your Project with Non-TeamGantt Users</a></p><hr><p>\n\t<em style=\"background-color: initial;\"><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Embed Your Project Using an iFrame","number":46,"categories":["5284de2fe4b027e0d843bc97"]}},{"node":{"slug":"customizing-days-in-your-projects","text":"<p>\n\t With TeamGantt, you have the flexibility to decide which days of the week you want to schedule project work. That way tasks don't accidentally get scheduled on an off day.&nbsp;You can choose to schedule tasks 7 days a week, on weekdays only, or even on a Monday/Wednesday/Friday rotation&mdash;whatever fits your \n\t<a href=\"https://support.teamgantt.com/article/106-projects\">project</a> needs best.&nbsp;</p><hr><h2>How do I set work days for my project?</h2><p>\n\t To customize the days of the week you want to appear in your gantt chart view, go to&nbsp; \n\t<em style=\"background-color: initial;\">Menu &gt; Open Project Details.</em>&nbsp;This will open up your project details screen.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/671908aaca07c36a6a170fe2/file-4LLgXgjPvD.png\"></p><p>\n\tSimply check the days you want to be able to schedule work for this project. Changes will save automatically as they're made. Click anywhere on your project/gantt chart again to close the project details screen.</p><hr><h2>How do I add weekends on TeamGantt?</h2><p>\n\tTo add weekend days to your gantt chart schedule,&nbsp;go to&nbsp;&nbsp;\n\t<em>Menu &gt; Open Project Details</em>, and select Saturday and/or Sunday as available work days.</p><p>\n\t<strong>Note:&nbsp;</strong>TeamGantt defines weekends as Saturday and Sunday.&nbsp;If weekends are displayed on your chart, they'll appear grayed out. But don't worry! It's still possible to add tasks on these days.</p><hr>\n<em><p><em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p></em><p></p>","name":"Select the Days of the Week for Your Project","number":72,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"time-tracking","text":"<h2> <strong>How do I track time on tasks in TeamGantt?&nbsp;</strong></h2><p>\n\t TeamGantt now takes the guesswork out of tracking the amount of time you spend working on a task. To make it easy, there are multiple places where you can start tracking your time.&nbsp;</p><hr><h3> <strong>From <em>Gantt </em>or <em>List&nbsp;</em>view in your project</strong></h3><p>\n\t You have 2 options for tracking time directly from your project's \n\t<em>Gantt</em>&nbsp;or <em>List</em>&nbsp;view:</p><ul>\n\t\n<li>Hover over the task, and click the gray clock icon in the <em>Shortcuts </em>column (View &gt; Columns &gt; Tools &gt; Shortcuts)&nbsp;that appears to the left of the task's name.</li>\t\n<li>Or, click the gray clock icon at the top&nbsp;of your project.</li></ul><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa80e7582e120ce2eba7c6c/file-rgdULsURHv.png\">Select&nbsp;\n\t<em style=\"background-color: initial;\">Start Timer&nbsp;</em>to start the clock! (Or you can manually enter time for a task you've already worked on.)</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa80ee6edf30bb4bc1bd652/file-tD6Cjnjn64.png\">The timer will continue recording the time spent on a task until you click&nbsp;\n\t<em style=\"background-color: initial;\">Stop Timer</em>.&nbsp;To stop the timer, select the green ticker at the top of your window&mdash;or&nbsp;the gray clock icon that appears next to your task's name&mdash;and \"click here.\"&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa80f6d82e120ce2eba7c71/file-2QPSP9Cb1K.png\"></p><p>\n\tIf you stop the time tracker by using the green ticker, you also have the option to attribute your tracked time to a different task, update your task's overall percent complete, and/or add a comment to the task.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa80fcf0885a032e5ca5d20/file-3V144wC0Wl.png\"></p><h3><strong>Where can I view all my tracked time in TeamGantt?</strong></h3><p>\n\t Your \n\t<em>Time Sheet</em>&nbsp;is a comprehensive dashboard of your tracked time across all projects. Access your <em>Time Sheet </em>from the left sidebar menu:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa810b8321112bee9ae95bb/file-jtJKuHKndZ.png\"></p><p>\n\tFrom here, you'll be taken to a screen that shows the tasks assigned to you for the current week. Use the toggle to view time tracked for previous or future weeks.&nbsp;</p><p>\n\t In the example below, you can see that 4 hours were spent on \"Perform Initial Testing\" and 6 minutes were spent on \"Build wireframes\" on Monday, September 14th:&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa8118082e120ce2eba7c83/file-88Aiz2BiNe.png\"></p><h2>\n</h2><h2>Can I manually enter time in TeamGantt?</h2><p>\n\t Want to add or edit time for a task? Simply click into the time field, and enter the hours and minutes (H:MM) you worked on the task.&nbsp;</p><hr>\nHow do I see tracked time in a project's gantt chart?<p>\n\t To easily view all tracked time in your project, enable the \n\t<em>Actual Hours </em>column from your&nbsp;<em>View </em>menu:&nbsp;</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa812c90885a032e5ca5d34/file-RkUVWcttXa.png\">This will show you all tracked time for each task and task group, as well as the project as a whole.&nbsp;</p><hr style=\"font-weight: bold;\"><h2>Can I run time tracking reports in TeamGantt?</h2><p>\n\t Managers have the ability to pull time tracking reports in TeamGantt. To learn more, visit our \n\t<a href=\"https://support.teamgantt.com/article/129-time-tracking-report\">Time Tracking Report</a> help doc.&nbsp;</p><p>\n\tWant to see how your task progress is stacking up against hours that have been tracked to your tasks? Check out our \n\t<a href=\"https://support.teamgantt.com/article/139-hourly-progress-v-task-progress\">Hourly Progress v. Task Progress</a> help doc!</p><hr>\n<div>\n\t<p>\n\t\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em>\n\t</p>\n</div><p>\n\t<br>\n\t<strong></strong></p>","name":"Time Tracking (Available in Business and Builder Edition plans)","number":102,"categories":["5284dea7e4b04fbdf2ac3a02"]}},{"node":{"slug":"duplicating-a-group","text":"<p>\n\t Does your project repeat the same tasks across the timeline? Or do you wish you could copy a group of tasks from one project to another?&nbsp;Good news! In TeamGantt, it's easy to duplicate tasks and task groups.&nbsp;</p><p>\n\t Let's walk through the basics so you can save more time on project setup.&nbsp;</p><hr><h3>How do I duplicate a task?</h3><p>\n\t There are 2 different ways to duplicate a task in a TeamGantt project.</p><ul>\n\t\n<li><strong>Method 1:</strong>&nbsp;Hover your cursor over the task name, and click the 3-dot icon to the right of the task name. Then, select&nbsp;<i style=\"background-color: initial;\">Duplicate.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67190bf34d8d375180ed1005/file-5gCZfHWD4o.png\"></i></li></ul><ul>\n\t\n<li><strong>Method 2:</strong>&nbsp;Right-click on the task's name, and&nbsp;select&nbsp;<em>Duplicate</em>&nbsp;from the drop-down menu.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67190c19ca07c36a6a170fe7/file-sDVYxZszm3.png\"></li></ul><h3>\n</h3><h3><b style=\"background-color: initial;\">How do I duplicate a group of tasks?</b></h3><p>\n\t There are 2 different ways to duplicate a group of tasks in a TeamGantt project. Both methods&nbsp;create a copy of the task group directly below the original group, so the choice is yours!</p><ul>\n\t\n<li><b style=\"background-color: initial;\">Method 1:</b>&nbsp;Hover your cursor over the group, and click the 3-dot icon to the right of the group name. Then, select <i style=\"background-color: initial;\">Duplicate.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67190c8991230b767524b526/file-zpyxhSzFYL.png\"></i></li>\t\n<li><strong style=\"background-color: initial;\">Method 2:</strong>&nbsp;Right-click on the group's name, and&nbsp;select&nbsp;<em style=\"background-color: initial;\">Duplicate</em>&nbsp;from the drop-down menu.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67190cabc8770a0e6b658246/file-71eITlzckn.png\"></li></ul><h3>\n</h3><h3><strong>How do I copy a group of tasks from one project to another?</strong></h3><p>\n\t Copying a task group from one project to another can come in handy if your projects tend to involve the same steps. Here's how to make it work for you:</p><ol>\n\t\n<li>Duplicate the task group in your original project using one of the options above.&nbsp;</li>\t\n<li>Go to <em>Menu &gt; Open Projects,&nbsp;</em>and select the project you'd like to move the newly duplicated task group to. This will open the second project within your original project's gantt chart. <em>(</em>Read more on <a href=\"https://support.teamgantt.com/article/25-viewing-multiple-projects\" target=\"_blank\">how to open and view multiple projects at once</a>.)</li>\t\n<li>Click and drag the duplicated task group to its proper place in your second project. You can do this by selecting the triple dot icons to the left of the group name.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a906a0cd926334a741edf8b/file-yfKi6OIYLB.png\"></li>\t\n<li>Now give yourself a pat on the back for a job well-done!</li></ol><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Duplicate a Task or Group of Tasks","number":26,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"workloads-project","text":"<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/s73kf9ja6s?videoFoam=true\" title=\"Manage Workloads__Intro Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><hr><h2>How do I use the <em>Workloads</em> view?</h2><p>\n\t In TeamGantt, you can easily view how many tasks (or hours, if your account is on our Business or Builder Edition plan) a person or label is assigned to on any given day. Simply click the \n\t<em>Workloads</em> tab at the bottom of your gantt chart. This feature is available on all paid plans and premium trials.&nbsp;&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e05ab7e6b2356def909323/file-Mjii9TQ1AC.png\">The&nbsp;<i style=\"background-color: initial;\">Workloads</i>&nbsp;window will expand, showing you all users and labels that have currently been <a href=\"https://support.teamgantt.com/article/6-inviting-people\">invited to the project</a>. Each colored cell represents a calendar day, and the number within the cell is the&nbsp;number of tasks (or hours) assigned to the user or label on that day. As a user or label gets busier, the cell will get darker. Think of it like your very own workload heat map!&nbsp;</p><p>\n\t You can choose to view:&nbsp;</p><ul>\n\t\n<li>The number of tasks or <a href=\"https://support.teamgantt.com/article/79-hourly-estimation\">estimated hours</a> assigned to a user or label on any given day</li>\t\n<li>Task assignments in the current project only or across all active projects</li></ul><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e06089dd5b956281ae4995/file-BIa9akMgdW.png\"></p><p>\n\tSelect any cell to see a popup of all tasks assigned to that person or label on that particular day:\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e060efdd5b956281ae4996/file-GFh5F6g4Dt.png\"></p><p>\n\tIf you invite Teams to your project, your \n\t<em>Workloads</em> view will be organized by teams.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e0624d15d0b82233063a14/file-ZPqIMKsvzu.png\">Workload's scale will be based on your Zoom level. For example, if your project is in a monthly view, you will see&nbsp;the total number of tasks per month.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e19f10dd5b956281ae4aa5/file-iBWiJiZTEh.png\"></p><p>\n\t<b class=\"\">Tips:</b></p><ul>\n\t\n<li>Workloads updates in real time! Simply drag and drop an assigned task to a new date in the gantt chart to see how it affects your team's availability.&nbsp;</li>\t\n<li>Any tasks shown as&nbsp;<em>Private&nbsp;</em>are simply tasks that exist in projects you're not invited to.</li></ul><p>\n\t Want to see this same view but for all users and labels on the account? If you're a Manager, you can see it in the \n\t<a href=\"https://teamgantt.helpscoutdocs.com/article/138-workloads\"><em>Workloads</em></a> report!</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Workload in a Project","number":16,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"viewing-multiple-projects","text":"<iframe src=\"//fast.wistia.net/embed/iframe/xflw0oe8m3\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" allowfullscreen=\"allowfullscreen\" mozallowfullscreen=\"mozallowfullscreen\" webkitallowfullscreen=\"webkitallowfullscreen\" oallowfullscreen=\"oallowfullscreen\" msallowfullscreen=\"msallowfullscreen\" width=\"640\" height=\"388\">\n</iframe><p>\n\t TeamGantt gives you the ability to open multiple projects in the same gantt chart.&nbsp;This can come in handy if you have 2 projects that depend on each other or if you're trying to manage people's availability across multiple projects.</p><hr><h2>How do I view multiple projects in a single gantt chart?</h2><p>\n\t There are 2 ways to open and view multiple projects at once in TeamGantt. Here's how each option works:</p><h3>\n<strong>Option #1: From the <em>My Projects </em>page</strong></h3><ol>\n\t\n<li>Click on&nbsp;<em>My Projects</em>&nbsp;from the sidebar menu. </li>\t\n<li>Check the boxes next to the projects that you'd like to open. </li>\t\n<li>Click the&nbsp;<em>Open Selected Projects</em>&nbsp;button at the bottom of the page.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a90659bd926334a741edf6f/file-CLNMLQkuom.png\"></li></ol><p><strong style=\"background-color: initial; font-family: inherit; font-size: 21px;\">Option #2:&nbsp; From a project's <em>Menu</em></strong></p><p>\n\tThis method enables you to&nbsp;open on-hold and completed projects as well.&nbsp;</p><ol>\n\t\n<li>While inside a project, go to&nbsp;<em style=\"background-color: initial;\">Menu &gt; Open multiple projects</em>.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a90662bd926334a741edf7b/file-8Yvqa3Wj7D.png\"></li>\t\n<li>Select the projects you want to open, and TeamGantt will automatically add them to the gantt chart.&nbsp;</li></ol><hr><h2>Does project order matter when opening multiple gantt charts?</h2><p>\n\tYes, projects will appear in the gantt chart based on the order you choose them from the multi-project selector.</p><p>\n\tHaving trouble opening multiple projects on TeamGantt? Shoot us an email at&nbsp; \n\t<a href=\"mailto:mailto:support@teamgantt.com\">support@teamgantt.com</a>, and we'll be happy to help!&nbsp;</p><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Open and View Multiple Projects at Once","number":25,"categories":["5284df24e4b027e0d843bca8"]}},{"node":{"slug":"changing-the-status-of-a-project","text":"<p>Changing a project's status makes it easier to manage your project list.&nbsp;Let's break down the 3 project status options you have available in TeamGantt:</p><ul>\n\t\n<li><strong>Active:&nbsp;</strong>This is the default status of any project that's currently in progress.&nbsp;</li>\t\n<li><strong>On hold:</strong>&nbsp;If a project is stalled or postponed, placing it “on hold” temporarily stops daily communications until activity on the project resumes. On-hold&nbsp;projects count towards the total number of projects on your account.&nbsp;</li>\t\n<li><strong>Complete:</strong>&nbsp;This archives&nbsp;a view-only version of the project once it crosses the finish line. If you want to put a completed project back in action, simply change the status of the project back to <em>Active.</em></li></ul><hr><h2></h2><h2>How do I change the status of my project?</h2><p>\n\t In TeamGantt, only a project's Admin(s) can change the status of a \n\t<a href=\"https://support.teamgantt.com/article/106-projects\">project</a>. There are 2 ways to change a project's status.&nbsp;</p><p>\n\t<strong>Method #1: From the <em>My Projects </em>page</strong></p><p>\n\t From \n\t<em>My&nbsp;Projects</em>, hover over the project you want to update, and click the <em>Options</em>&nbsp;drop-down to the right of the project name.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67190dc84d8d375180ed1008/file-Clri8OQekB.png\"></p><p>\n\t<strong style=\"background-color: initial;\">Method #2: From inside the project</strong></p><p>\n\t Go to&nbsp;\n\t<em>Menu &gt; Project Settings</em>, and select a new status.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67190ea04d8d375180ed1009/file-xM6WhaskhV.png\"></p><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Update Your Project's Status","number":65,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"markdown-formatting-for-comments","text":"<h2><b style=\"background-color: initial;\">How do I format comments using markdown?</b></h2><p>\n\t<b style=\"background-color: initial;\">Markdown</b>&nbsp;is a simple way to format text. With it, you can format on the fly as you type your comments in TeamGantt. Here is a quick reference&nbsp;guide to help you.</p><p>\n\tJust to note,&nbsp;there are&nbsp;default formatting options in the notes section now! This toolbar has not been extended to comments.&nbsp;</p>\n<table class=\"markdown-reference\">\n<thead>\n<tr>\n\t<th>\n\t\t Type\n\t</th>\n\t<th class=\"second-example\">\n\t\t Or\n\t</th>\n\t<th>\n\t\t &hellip; to Get\n\t</th>\n</tr>\n</thead>\n<tbody>\n<tr>\n\t<td class=\"preformatted\">\n\t\t *Italic*\n\t</td>\n\t<td class=\"preformatted second-example\">\n\t\t _Italic_\n\t</td>\n\t<td>\n\t\t<em>Italic</em>\n\t</td>\n</tr>\n<tr>\n\t<td class=\"preformatted\">\n\t\t **Bold**\n\t</td>\n\t<td class=\"preformatted second-example\">\n\t\t __Bold__\n\t</td>\n\t<td>\n\t\t<strong>Bold</strong>\n\t</td>\n</tr>\n<tr>\n\t<td class=\"preformatted\">\n\t\t # Heading 1\n\t</td>\n\t<td class=\"preformatted second-example\">\n\t\t Heading 1 \n\t\t<br>\n\t\t =========\n\t</td>\n\t<td>\n\t\t<h1 class=\"smaller-h1\">Heading 1</h1>\n\t</td>\n</tr>\n<tr>\n\t<td class=\"preformatted\">\n\t\t ## Heading 2\n\t</td>\n\t<td class=\"preformatted second-example\">\n\t\t Heading 2 \n\t\t<br>\n\t\t ---------\n\t</td>\n\t<td>\n\t\t<h2 class=\"smaller-h2\">Heading 2</h2>\n\t</td>\n</tr>\n<tr>\n\t<td class=\"preformatted\">\n\t\t [Link](https://www.teamgantt.com)\n\t</td>\n\t<td class=\"preformatted second-example\">\n\t\t [Link][1] \n\t\t<br>\n\t\t ⋮ \n\t\t<br>\n\t\t [1]: \n\t\t<a href=\"https://www.teamgantt.com\">https://www.teamgantt.com</a>\n\t</td>\n\t<td>\n\t\t<a href=\"https://www.teamgantt.com\">Link</a>\n\t</td>\n</tr>\n<tr>\n\t<td class=\"preformatted\">\n\t\t ![Image](http://url/tglogo.png)\n\t</td>\n\t<td class=\"preformatted second-example\">\n\t\t ![Image][1] \n\t\t<br>\n\t\t ⋮ \n\t\t<br>\n\t\t [1]: \n\t\t<a href=\"http://url/tglogo.jpg\">http://url/tglogo.jpg</a>\n\t</td>\n\t<td>\n\t\t<p>\n\t\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/59e8dbb8042863025361ff2e/file-sEEgcI6PFQ.png\" style=\"width: 31px;\">\n\t\t</p>\n\t</td>\n</tr>\n<tr>\n\t<td class=\"preformatted\">\n\t\t &gt; Blockquote\n\t</td>\n\t<td class=\"preformatted second-example\">\n\t\t &nbsp;\n\t</td>\n\t<td>\n\t\t<blockquote>\n      Blockquote\n\t\t</blockquote>\n\t</td>\n</tr>\n<tr>\n\t<td class=\"preformatted\">\n\t\t<p>\n\t\t\t * List \n\t\t\t<br>\n\t\t\t * List \n\t\t\t<br>\n\t\t\t * List\n\t\t</p>\n\t</td>\n\t<td class=\"preformatted second-example\">\n\t\t<p>\n\t\t\t - List \n\t\t\t<br>\n\t\t\t - List \n\t\t\t<br>\n\t\t\t - List \n\t\t\t<br>\n\t\t</p>\n\t</td>\n\t<td>\n\t\t<ul>\n\t\t\t<li>List</li>\n\t\t\t<li>List</li>\n\t\t\t<li>List</li>\n\t\t</ul>\n\t</td>\n</tr>\n<tr>\n\t<td class=\"preformatted\">\n\t\t<p>\n\t\t\t 1. One \n\t\t\t<br>\n\t\t\t 2. Two \n\t\t\t<br>\n\t\t\t 3. Three\n\t\t</p>\n\t</td>\n\t<td class=\"preformatted second-example\">\n\t\t<p>\n\t\t\t 1) One \n\t\t\t<br>\n\t\t\t 2) Two \n\t\t\t<br>\n\t\t\t 3) Three\n\t\t</p>\n\t</td>\n\t<td>\n\t\t<ol>\n\t\t\t<li>One</li>\n\t\t\t<li>Two</li>\n\t\t\t<li>Three</li>\n\t\t</ol>\n\t</td>\n</tr>\n<tr>\n\t<td class=\"preformatted\">\n\t\t Horizontal Rule \n\t\t<br>\n\t\t<br>\n\t\t ---\n\t</td>\n\t<td class=\"preformatted second-example\">\n\t\t Horizontal Rule \n\t\t<br>\n\t\t<br>\n\t\t ***\n\t</td>\n\t<td>\n\t\t Horizontal Rule\n\t\t<hr class=\"custom-hr\">\n\t</td>\n</tr>\n<tr>\n\t<td class=\"preformatted\">\n\t\t `Inline code` with backticks\n\t</td>\n\t<td class=\"preformatted second-example\">\n\t\t &nbsp;\n\t</td>\n\t<td>\n\t\t<code class=\"preformatted\">Inline code</code> with backticks\n\t</td>\n</tr>\n<tr>\n\t<td class=\"preformatted\">\n\t\t ``` \n\t\t<br>\n\t\t # code block \n\t\t<br>\n\t\t print '3 backticks or' \n\t\t<br>\n\t\t print 'indent 4 spaces' \n\t\t<br>\n\t\t ```\n\t</td>\n\t<td class=\"preformatted second-example\">\n\t\t<span class=\"spaces\">····</span># code block<br>\n\t\t<span class=\"spaces\">····</span>print '3 backticks or'<br>\n\t\t<span class=\"spaces\">····</span>print 'indent 4 spaces'\n\t</td>\n\t<td>\n\t\t<div class=\"code-block\" style=\"background: #F1F1F1;border: 1px solid #E1E1E1;border-radius: 4px;font-size: 90%;padding: .2rem .5rem;\">\n      # code block \n\t\t\t<br>\n\t\t\t print '3 backticks or' \n\t\t\t<br>\n\t\t\t print 'indent 4 spaces'\n\t\t</div></td></tr></tbody></table><p>\n\t These represent the most common formatting in markdown. For more advanced formatting including tables and more \n\t<a href=\"https://jonschlinkert.github.io/remarkable/demo/\" target=\"_blank\">click here</a>.</p><hr><h2>How do I create to-do lists with markdown?</h2><p>\n\tWe now offer the option to create to-do lists within a note section or comment attached to a task.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5ef0cd742c7d3a10cba95b7e/file-mZDMI97xro.png\">1) Simply enter:&nbsp;\n\t<strong style=\"background-color: initial;\">- [ ] </strong>(<em style=\"background-color: initial;\">hyphen, space, left bracket, space, right bracket)</em></p><p>\n\t2) Then, enter the text for your item.&nbsp;</p><p>\n\t3) If the checklist is in a comment, hit \n\t<em>Reply</em>&nbsp;for changes to go into effect. If the checklist is in the gray note section, simply click out of the note to see changes.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5ef0cd6004286306f805935e/file-Iq9LsIHAvp.png\"></p><p>\n\tThe benefit of creating to-do lists this way is that it allows you to break tasks down in to even smaller to-dos. There's also flexibility in the hierarchy of how these to-do items are structured. For instance, you can structure a list like below:&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5ef0ce352c7d3a10cba95b92/file-06QJLZtiwT.png\"></p><p>\n\tWant to formalize to-dos by adding them to the \n\t<a href=\"https://support.teamgantt.com/article/115-checklists\">task's checklist</a>? If the list in a comment, no problem! Simply hover over the comment and select the checklist icon that appears at the top right. This will send all of your to-do items to the checklist on the right hand side.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5ef0cda204286306f8059363/file-qckPvASo99.png\"></p><hr><p><em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Markdown Formatting for Comments","number":120,"categories":["5284de2fe4b027e0d843bc97"]}},{"node":{"slug":"how-to-edit-delete-and-complete-a-task","text":"<p>\n\t As your project progresses, you may need to make changes to \n\t<a href=\"https://support.teamgantt.com/article/4-adding-tasks\">tasks</a> or update task completion. Here's how to edit, delete, and update a task.&nbsp;</p><h2> <strong> How do I edit a task?</strong></h2><p>\n\t To rename a task, simply click on the task name to edit it. TeamGantt automatically saves the change once you hit \n\t<em>Enter</em>.&nbsp;</p><p>\n\tIf you need to make more significant changes, hover your cursor over the task, and click on the <em>pencil</em><i style=\"background-color: initial;\">&nbsp;</i>icon to open up the task edit window. From there, you can:&nbsp;</p><ul>\n\t\n<li>Edit the task name</li>\t\n<li>Add/delete <a href=\"https://support.teamgantt.com/article/80-adding-comments\">comments</a></li>\t\n<li>Assign start and end dates</li>\t\n<li>Attach <a href=\"https://support.teamgantt.com/article/67-uploading-documents\">documents</a></li>\t\n<li>Change the <a href=\"https://support.teamgantt.com/article/18-task-colors\">task color</a></li>\t\n<li>Post sticky notes</li>\t\n<li>Edit task <a href=\"https://support.teamgantt.com/article/8-dependencies\">dependencies</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/6-inviting-people\">Assign/reassign</a> users&nbsp;or labels</li>\t\n<li>Indicate <a href=\"https://support.teamgantt.com/article/79-hourly-estimation\">estimated hours</a> (Pro plan only)</li>\t\n<li>Indicate the number of days it'll take to complete the task</li>\t\n<li>Update the&nbsp;<em><a href=\"https://support.teamgantt.com/article/107-percentage-complete-calculated/\">Progress</a> </em>percentage</li>\t\n<li>Update the task's <a href=\"https://support.teamgantt.com/article/115-checklists\">checklist</a></li></ul><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67223dde4d8d375180ed1606/file-6gOoEsqSGj.png\"></p><p>\n\t<strong style=\"background-color: initial;\"></strong>You can undo any changes you've made to a task by scrolling down to the task's activity log and clicking on the <em style=\"background-color: initial;\">undo change </em>link.&nbsp; &nbsp;</p><hr><h2> <strong>How do I delete a task?</strong></h2><p><span style=\"background-color: initial; font-size: 14px;\">At some point in the project, you may want to remove tasks that are no longer relevant or necessary. To delete a task, simply&nbsp;</span><span style=\"background-color: initial; font-size: 14px;\">hover your cursor over a task, and click on the \n\t<em style=\"background-color: initial; font-size: 14px;\">trashcan</em></span><span style=\"font-weight: normal;\">&nbsp;icon&nbsp;</span></p><h2><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a906a956f9f378e74c1fc45/file-8gEutb8UhM.png\"></h2><p>\n\tA pop-up window will appear confirming you want to delete the task. Click&nbsp;\n\t<em style=\"background-color: initial;\">Yes</em> to proceed.&nbsp;</p><hr><h2>How do I recover a deleted task?</h2><p>\n\t Need to bring a task back? Head on over to \n\t<em>Menu &gt; Undo</em>, and click <em>undo change</em> to return the task to the group.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a906b17039b617b174282b3/file-EzWWROq6HG.png\"></p><h2> <strong>How to update progress or mark a task as complete?</strong></h2><p>\n\t You can track project progress by updating each task's \n\t<em>Progress</em>. A task shows as done when it's marked as 100% complete.&nbsp;</p><p>\n\t There are 3 ways to update task progress and/or complete a task:</p><p>1 \n\t<b style=\"background-color: initial;\">. From</b><strong style=\"background-color: initial;\">&nbsp;gantt view</strong>: Go to the <em style=\"background-color: initial;\">View </em>menu, and enable the <i style=\"background-color: initial;\">Progress&nbsp;</i>column. Then, enter a value between 1 and 100 directly in the <em style=\"background-color: initial;\">Progress</em><em style=\"background-color: initial;\">&nbsp;</em>column to update the task's progress.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a906b914b84f76cf81bf12e/file-71Xsd6OJvU.png\"></p><p>\n\t2. \n\t<strong style=\"background-color: initial;\">&nbsp;From list view:</strong> Click on the <i style=\"background-color: initial;\">Progress</i>&nbsp;field, and enter a value between 1 and 100. You can click the \"checkmark\" to mark the task 100% complete.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/672243693a0b506883e52e9d/file-sRD8DV7eXV.png\"></p><p>\n\t3. \n\t<strong style=\"background-color: initial;\"> From the task edit screen:</strong> Hover your cursor over the task, and click the <em>open task detail</em>&nbsp;icon. Once the task edit screen pops up, add a value between 1 and 100 in the <i style=\"background-color: initial;\">Progress</i>&nbsp;field.&nbsp;</p><p>\n\t<strong style=\"background-color: initial;\"><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/672243e6f539bb6e3c7c70ca/file-j7i4wkWquf.png\"><br>\n\t</strong></p><p>\n\t<strong style=\"background-color: initial;\">Note</strong>: A task's <i style=\"background-color: initial;\">Progress</i>&nbsp;percentage only affects the project's overall percentage of completion if the task has start and end dates assigned.&nbsp;</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Edit, Delete, or Complete a Task","number":104,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"trello-troubleshooting","text":"<p>\n\t Are you experiencing an issue with the TeamGantt Power-Up for Trello? If so, check the list below to see if there's a workaround that might help.</p><h4>My TeamGantt project is not syncing with Trello.</h4><p>\n\t Existing TeamGantt tasks that were created prior to syncing with Trello won't automatically sync to your Trello board.&nbsp;</p><p>\n\t A workaround for pushing existing tasks to your synced Trello board is by \n\t<a href=\"https://support.teamgantt.com/article/26-duplicating-a-group\">duplicating the task/group of tasks</a> and then deleting the originals from your TeamGantt project. Any duplicated tasks will be considered new tasks, and parallel cards will be created in Trello.&nbsp;</p><hr><h4>I'm having trouble accessing my TeamGantt project via the Power-Up.&nbsp;</h4><p>\n\t Here are a few quick things to check!</p><p>\n\t 1. It's pretty common to be invited to more than TeamGantt account (especially factoring in free trial accounts). Be sure that you're logging into the Power-Up with the same exact login credentials that you use to access that project in TeamGantt.&nbsp;</p><p>\n\t 2. You must be an Admin on the Trello board to manage the Power-Up. You can check this in your board's settings.&nbsp;</p><p>\n\t 3. If someone else created the project in TeamGantt and want you to be able to see it, they must invite you to the project. If you simply add the Power-Up to your board, you will not be able to see that specific project.&nbsp;</p><hr><h4>How do I invite other people to my project?&nbsp;</h4><p>\n\t The Power-Up is user-specific, meaning that if you enable it on a board, the other users on your board will not automatically be able to see and access it.&nbsp;</p><p>\n\t To get other users in the loop, you must first log into your account via \n\t<a href=\"https://www.teamgantt.com/\">teamgantt.com</a>. There you can invite other people to your project in TeamGantt (<a href=\"https://support.teamgantt.com/article/6-inviting-people/\">here’s how</a>). When you invite a person, we’ll send them an email to set up login credentials and access the project.&nbsp;</p><p>\n\t Then, they must enable the TeamGantt Power-Up on the board in their account by adding the Power-Up and logging in with their sparkly new TeamGantt credentials.&nbsp;</p><h4></h4><h4><hr>\n</h4><h4>My cards are not showing up in my TeamGantt project.</h4><p>\n\t When a card is sent to a TeamGantt project, an associated task is created for it, and the card in Trello should get an attachment representing the associated task. You should see the following card badges when the process works properly:</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5a7c8def2c7d3a4a4198f293/file-NA66CcjAI6.png\" alt=\"\" style=\"display: block; margin: auto; width: 336.979px;\"></p><p>\n\t If those badges don't show up, try adding the card to a TeamGantt project manually by opening a card in Trello, and using the TeamGantt button in the card back sidebar.</p><p>\n\t If you get an error when manually sending a card to TeamGantt, consult the remainder of this guide for help, or reach out to us at support@teamgantt.com for further support.</p><h4></h4><h4><hr>\n</h4><h4>I got this error message: \"TeamGantt was unable fetch the specified card from Trello.\"</h4><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5a78bd010428634376cfd277/file-LNnuU2lqhb.png\" alt=\"\" style=\"display: block; margin: auto;\"></p><p>\n\t If you see this error when trying to add a Trello card to a project in TeamGantt, it's the result of an invalid authorization token. Please reach out to us at support@teamgantt.com, and we'll be happy to reset your token for you. If you've manually removed TeamGantt from the list of authorized applications in Trello, please include that in your support request. \n\t<br>\n\t<br>\n\t Once that's done, you'll need to perform the following steps:</p><ol>\n\t\n<li>Open the Trello Power-Up menu, and find the TeamGantt Power-Up.</li>\t\n<li>Select <em>Remove Personal Settings</em> from the Power-Up cog menu.</li>\t\n<li>Select <em>Get started with TeamGantt</em> from the top of the board, and sign into TeamGantt again.</li>\t\n<li>Open the <em>Authorization</em> pop-up, which grants TeamGantt access to update your Trello cards for you (for board/project sync).</li></ol><p>\n\t We're working with Trello to understand the cause of these invalid tokens and to avoid the circumstances that lead to storing them.</p><hr><h4>I want to sync my board to a new project in TeamGantt.</h4><p>\n\t Synced with the wrong project or finished one and ready to sync with the next? Here’s how to choose a new project to sync with.</p><ol>\n\t\n<li>If you'd like to start with a blank slate &mdash;Log into your account at teamgantt.com and <a href=\"https://support.teamgantt.com/article/106-projects\">create a new blank project</a>. (If you’re on the Free version of TeamGantt, you can only have 1 active project at a time, so you’ll need to delete or mark your existing project as Complete first.)</li>\t\n<li>Go to the TeamGantt Power-Up settings and set the Sync With Project to \"None\".</li>\t\n<li>Select the Reset board link.&nbsp;</li>\t\n<li>Choose a new project to sync with.</li></ol><p>\n\t Done!&nbsp;</p><h4></h4><h4></h4><h4></h4><h4><hr>\n</h4><h4>I want to sync my card to a different project in TeamGantt.</h4><p>\n\t Each Trello card can only be linked to a single project in TeamGantt. If your card is already linked to TeamGantt but you want to link it to a different project, you'll need to remove the existing card link first. If you're syncing your entire board with a project and want to change the selected project, you'll need to unlink each card before the sync process sends it to the newly selected project.</p><p>\n\tYou can remove the link between the card and project simply by deleting the associated task in TeamGantt. If you can't find the task, a simple way of doing this is to select \n\t<em>Unlink</em> at the top of the TeamGantt Task section on the card back. You will be given the option to delete the associated TeamGantt task when unlinking the Trello card. After the link is broken, you should then be able to sync the card to a project again.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a171d3ffa574df3f6e6fb93/file-lMn0BkbEYh.png\"></p><h4><hr>\n</h4><h4>I want to remove the TeamGantt Power-Up from Trello.</h4><p>\n\t You can easily remove the Power-up from your board by going to \n\t<em>Menu &gt; Power-Ups </em>in Trello, but note that this will only remove&nbsp;your ability to see TeamGantt card badges and editable task sections on your card back. It does not automatically disable syncing.</p><p>\n\t To disable syncing, start by opening the TeamGantt Power-up settings screen ( \n\t<em>Menu &gt; TeamGantt &gt; Edit Power-Up Settings</em>)&nbsp;and select&nbsp;<em>Manual Sync</em>&nbsp;from the <em>Project Sync Setting&nbsp;</em>dropdown. This will prevent new tasks in your TeamGantt project from being added as cards here.</p><p style=\"text-align: center;\"><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a171e4cfa574df3f6e6fb96/file-JDQt1XO2Wy.png\"></p><p>Additionally, you can revoke TeamGantt's access to your Trello boards by clicking on your profile image in Trello (top-right) \n\t<em style=\"font-size: 14px;\">&gt; Settings &gt; Applications,</em> and clicking the <em style=\"font-size: 14px;\">Revoke</em> button next to TeamGantt. This will prevent TeamGantt from automatically making any changes to your Trello cards on your behalf. If you're on a team, other team members may have to do the same to prevent data syncing.</p><hr><h4>If I copy a card in Trello, why isn't a new task created in TeamGantt?</h4><p>When using&nbsp;<em>Manual Sync</em>, every card needs to be manually synced to a project in TeamGantt.<br><br>If you want this to happen automatically, choose a TeamGantt project in the Power-Up settings, and any new cards added to your board will be automatically added as tasks to that project in TeamGantt.</p><hr><h4>\n</h4><h4>My Trello card isn't showing the TeamGantt task details.</h4><p>\n\t If your card is linked to TeamGantt (indicated by the presence of the badge icon on the card), but not showing any details when you open the card, it may be due to your browser's cookie settings.</p><p>\n\t<strong>If you see this</strong> (less the emoji):</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5aa7ee6e2c7d3a2c4982fbf2/file-yGWJEuPndB.png\" alt=\"\" style=\"display: block; margin: auto; width: 1345.98px;\"></p><p>\n\t Verify that \n\t<strong>app.teamgantt.com</strong>, <strong>prod.teamgantt.com</strong>, and&nbsp;<strong>teamgantt.com</strong> are allowed to store cookies on your browser. Some browsers, like Chrome, will allow you to enable all TeamGantt subdomains with&nbsp;[*.]teamgantt.com.</p><p>\n\t Here are some links to browser-specific articles on managing cookies.&nbsp;</p><ul>\n\t\n<li><strong>Chrome</strong><strong>:&nbsp;</strong><a href=\"https://support.google.com/chrome/answer/95647\">https://support.google.com/chrome/answer/95647</a></li>\t\n<li><strong>Internet Explorer:</strong> <a href=\"https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies\">https://support.microsoft.com/en-us/help/17442/windows-internet-explorer-delete-manage-cookies</a></li>\t\n<li><strong>Firefox:&nbsp;</strong><a href=\"https://support.mozilla.org/en-US/kb/websites-say-cookies-are-blocked-unblock-them\">https://support.mozilla.org/en-US/kb/websites-say-cookies-are-blocked-unblock-them</a></li>\t\n<li><strong>Safari</strong>: <a href=\"https://support.apple.com/kb/ph21411\">https://support.apple.com/kb/ph21411</a></li></ul><hr><h4>I can't set up the sync (using Safari).</h4><p>\n\t There is a setting in Safari Privacy preferences that is blocking Trello from saving the cookies for the TeamGantt authorization. Its called \"Prevent cross-site tracking\" and it needs to be unchecked for the Power-Up to work.&nbsp;Try unchecking that, and see if it works!</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/608af5028af76a714bfdc9f4/file-mp3gU156K7.png\"></p><hr><p>\n\t Have other questions about our Trello Power-Up? Just email support@teamgantt.com! Or check out one of our other articles about Trello:&nbsp;</p><ul>\n\t\n<li><a href=\"https://support.teamgantt.com/article/116-trello-powerup\">TeamGantt Power-Up for Trello</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/117-trello-sync-options\">Trello - Sync Options</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/123-syncing-trello-list-progress-with-teamgantt\">Syncing Trello List Progress with TeamGantt</a></li></ul><hr><p>\n\t<em><strong>To learn more about using TeamGantt and Trello together, join us for our <a href=\"https://www.teamgantt.com/live-classes/teamgantt-power-up-for-trello-15\">free class</a>!&nbsp;</strong></em></p>","name":"Trello - Troubleshooting","number":118,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"basecamp","text":"<h2> <strong>How does TeamGantt's Basecamp 2 integration work?</strong></h2><p>\n\t TeamGantt's Basecamp 2 integration enables you to easily transfer projects and information from the Basecamp \n\t<em>To-dos</em> format to the gantt chart in TeamGantt. Once integrated, your Basecamp 2&nbsp;<em>To-dos</em>&nbsp;will update&nbsp;automatically&nbsp;as you add, remove, and reschedule tasks in TeamGantt. Likewise, any&nbsp;<i style=\"background-color: initial;\">To-dos</i> you add in Basecamp 2 will appear in TeamGantt.</p><p>\n\t For an overview of the Basecamp 2/TeamGantt integration, please visit: \n\t<a href=\"https://www.teamgantt.com/basecamp-gantt-charts\" target=\"_blank\">https://www.teamgantt.com/basecamp-gantt-charts</a></p><p>\n\t ( \n\t<strong>Note</strong>: TeamGantt integrates with Basecamp 2, but does <strong>not</strong> integrate with Basecamp Classic, Basecamp 3, or other programs).</p><hr><h2> <strong>How do I set up the Basecamp 2 integration with TeamGantt?</strong></h2><p>\n\t To integrate your Basecamp 2 account with TeamGantt, log into TeamGantt, and go to:&nbsp;\n\t<em>Account Settings &gt; Integrations &gt; Link your Basecamp projects to TeamGantt</em>.</p><p>\n\t If you're not already logged into your Basecamp account, you'll be prompted to log in:</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/528b9053e4b0bb9de0e9a239/file-XBmkmHrBau.png\" style=\"width: 443px;\"></p><p>\n\t Once you're logged into Basecamp, you'll need to give TeamGantt permission to access your Basecamp 2 account:</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5b4616182c7d3a099f2e6d7c/file-k5AdN4NaYW.png\" style=\"width: 439px;\"></p><p>\n\t Once access has been granted, go to: \n\t<em style=\"background-color: initial;\">Account Settings &gt; Integrations &gt; Manage Basecamp Projects</em>.</p><p>\n\t Choose which Basecamp projects you'd like to integrate with TeamGantt, and select the items you want to sync. Currently, we support syncing \n\t<em>To-dos</em> and <em>Calendar</em> events, both of which will be synced to your TeamGantt project as tasks.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/528b92c8e4b0bb9de0e9a23f/file-usXqcYoYqV.png\" style=\"background-color: initial; width: 664px;\"></p><hr><h2>How do I import users from Basecamp 2 to TeamGantt?</h2><p>\n\t For the sync between TeamGantt and Basecamp 2 to work properly, all users from Basecamp 2 should be imported to TeamGantt. This can easily&nbsp;be done when you initially establish the sync.&nbsp;</p><p>\n\t As part of the import, you'll want to make sure you're syncing your Basecamp project to the right TeamGantt account. This is also the place in TeamGantt&nbsp;where you can set project-level \n\t<a href=\"https://support.teamgantt.com/article/5-permissions\">permissions</a> for your users.&nbsp;(The default is always&nbsp;<em>Can Edit Chart.</em>)</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5b4615482c7d3a099f2e6d6a/file-y6wPEeSRoa.png\" style=\"width: 735px;\"></p><p>\n\t Select&nbsp;\n\t<em>Import Project,</em>&nbsp;and your Basecamp 2 project will sync all the appropriate users to TeamGantt.&nbsp;</p><p>\n\t<strong>Note:</strong>&nbsp;Importing a user from Basecamp 2 to TeamGantt invites a user to TeamGantt. As a result, all imported users will automatically receive an invitation email from TeamGantt. (Consider it one less email you have to send!)</p><hr><h2>How do I sync TeamGantt projects to Basecamp 2?</h2><h3>Sync a new TeamGantt project to Basecamp 2 upon creation</h3><p>\n\t Did you know you can create a new project in TeamGantt and sync it to Basecamp 2 all in one step? Here's how it works:</p><p>\n\t 1) Go to&nbsp;\n\t<em>My Projects &gt; New Project &gt; Create a New Project</em>.&nbsp;</p><p>\n\t 2) Name your new project, and select your team’s account from the \n\t<em>Basecamp2</em> drop-down.&nbsp;(<b style=\"background-color: initial;\">Note:</b> Your team’s Basecamp&nbsp;information will look different than ours!)</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5b3bd3f20428630abc0baef9/file-aUfl8QhPfZ.png\" style=\"width: 651px;\"></p><p>\n\t 3) Click&nbsp;\n\t<em>Create New Project,</em> and you’re all set!</p><h3>Sync an existing TeamGantt project to Basecamp 2</h3><p>\n\t If you already have a project in TeamGantt and want to sync it to Basecamp 2, simply follow these steps:&nbsp;\n\t<br>\n\t<br>\n\t 1) Create a new blank project in Basecamp 2, and sync it to TeamGantt. This will create a new blank project in TeamGantt.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/530648b0e4b078f4bda9b406/file-eZJv6nP0l8.png\"></p><p>\n\t 2) Open both the original TeamGantt project you'd like to sync to Basecamp 2 and the newly created blank project in TeamGantt at the same time. (Need help? \n\t<a href=\"https://support.teamgantt.com/article/25-viewing-multiple-projects\" target=\"_blank\">See how to open and view multiple TeamGantt projects at once.</a>)&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5b3e6d7a2c7d3a099f2e38fd/file-CbvQQW3GbV.png\"></p><p>\n\t Here's what you'll see when you open both projects in TeamGantt at once.&nbsp;</p><ul>\n\t\n<li>The top project in the example below is the original TeamGantt project you want to sync to Basecamp 2.&nbsp;</li>\t\n<li>The bottom project is the newly created blank project that was synced to TeamGantt from Basecamp 2.</li></ul><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5b3e6ebb2c7d3a099f2e3908/file-NPPLIg5Gpp.png\"></p><p>\n\t 3) Drag the tasks and/or task groups from the original project and drop them into the newly created project below. (See tips on moving and rescheduling multiple tasks \n\t<a href=\"https://support.teamgantt.com/article/22-reschedule-multiple-tasks\">here</a>.) Any tasks you move into the newly synced TeamGantt project will now appear in Basecamp 2!</p><hr>\n<strong>Tips:&nbsp;</strong><p>\n\t &nbsp;- You must be a Manager in TeamGantt for this functionality to work properly.</p><p>\n\t - TeamGantt does not currently sync with any other Basecamp version. Basecamp 2 is the only version that integrates with TeamGantt.&nbsp;</p><p>\n\t - Want to learn more? Check out our additional support docs on \n\t<a href=\"https://support.teamgantt.com/article/84-integration-errors-and-resolutions\">troubleshooting</a> and <a href=\"https://support.teamgantt.com/article/54-disabling-the-teamgantt-basecamp-sync\">disabling</a> the Basecamp 2 sync.</p><hr><p>\n\t<strong>Looking for another way to sync&nbsp;TeamGantt with your favorite tools?&nbsp;</strong>Check out our <a href=\"https://support.teamgantt.com/article/152-teamgantt-integration-for-zapier\">Zapier integration</a>!&nbsp;</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Establishing Sync with Basecamp 2","number":37,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"add-edit-resources","text":"<h2>What are project labels in TeamGantt?</h2><p>\n\t A label is a tag added to projects for organizational and scheduling purposes only.&nbsp;Here are just a few ways you can use labels to tag tasks in your projects:</p><ul>\n\t\n<li>Team/department responsible (Example: Marketing team)</li>\t\n<li>Job role responsible (Example: Web designer)</li>\t\n<li>Freelance/contract resource responsible (Example: Freelance writer)</li>\t\n<li>Client/company name that the task pertains to (Example: Acme Inc.)</li>\t\n<li>Project phase or sprint that the task belongs to (Example: Design phase)</li>\t\n<li>Priority level of a task (Example: Urgent)</li></ul><p>\n\t Unlike <a href=\"https://support.teamgantt.com/article/75-user-or-resource\">a user</a>, a label used in place of a person (i.e., Web designer) will not have access to the project in TeamGantt. And since a label isn't associated with an email address, it also won't receive email notifications.</p><p>\n\t If you're on a paid plan, you can create as many labels as you need, and they won't count against your current plan's total number of users.</p><p>\n\t (\n\t<em>Note: Labels were formerly known as \"Resources\" in TeamGantt.</em>)</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/4hyoib7ire?videoFoam=true\" title=\"7_Add some labels Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><hr id=\"horizontalrule\"><h2>How do I add custom labels to a project?</h2><h2><br><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a84a1cf3db50143df5c86c1/file-w04ZLoS97i.png\"></h2><p>\n\tTo add a new label, click&nbsp;\n\t<em style=\"background-color: initial;\">Add labels</em>, and either:&nbsp;</p><p>\n\t 1. Click the \n\t<em>blue arrow </em>next to an existing label. This will add the label to the project</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a06b69c60795985144c23f/file-LnJArbcpKD.png\"></p><p>\n\t 2. Click&nbsp;\n\t<em>Create new labels, and</em>&nbsp;enter the label name. Then, click on <em>Create and add to project</em>. To add multiple new labels, simply click <em>Create another</em>.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a06ba8c60795985144c25d/file-ySwF0gosVk.png\"></p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a06becc4d142b755b5027a/file-MaTKU5WD0N.png\">Want to be able to assign a label to multiple projects? Be sure&nbsp;\n\t<em style=\"background-color: initial;\">A</em><em style=\"background-color: initial;\">vailable to all projects</em>&nbsp;<em style=\"background-color: initial;\">in [account name]</em>&nbsp;is selected when adding the label. This ability can't be added retroactively, so we recommend choosing this option for every new label you create.</p><p>\n\t Making a label available to all projects prevents the creation of duplicate labels, giving you a more accurate view of a label's availability.&nbsp;</p><hr><h2>How do I edit or remove a custom label?</h2><h3><strong>Method 1: From within a project</strong></h3><p>\n\t If you're a project's Admin, you can edit and remove labels to fit your project's needs. Here's how to keep your project's label list up-to-date:</p><p>\n\t From the \n\t<em>People</em> tab, hover your cursor over the label you want to edit, and click the <em>triple dot</em>&nbsp;icon.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a06cdac4d142b755b502b7/file-kqgaubyk8S.png\"></p><p>\n\tTo remove or delete a label, simply click \n\t<em>Remove label from project</em>:</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a06caac4d142b755b502ad/file-w31TWlg0tU.png\"></p><p>\n\t<strong style=\"background-color: initial; font-family: inherit; font-size: 18px;\">Method 2: In <em>Account Settings</em></strong></p><p>\n\t If you're an Account Admin, you can take it one step further and manage all company-level labels (i.e., labels that have been made available to all projects).&nbsp;Here's how:</p><p>\n\t 1. Click on your name in the bottom left of the sidebar.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a84a27c4f742c5313c505b2/file-2Msozcch5z.png\"></p><p>\n\t<i style=\"background-color: initial;\">2. </i>Select&nbsp;<em>Account Settings.</em></p><p>\n\t 3. Select \n\t<em>Manage Company Labels.</em></p><p>\n\tFrom the \n\t<em style=\"background-color: initial;\">Manage Company Labels&nbsp;</em>page, you'll be able to edit, delete, and add new labels to your account.&nbsp;</p><hr><p>\n\t<em style=\"background-color: initial;\"><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/webinars/\">webinars</a>!&nbsp;</strong></em></p>","name":"Add, Edit, and Remove Labels","number":83,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"email-updates","text":"<p>\n\t TeamGantt sends 3 primary types of email updates:&nbsp;</p><ol>\n\t\n<li><strong>Daily project summary email (aka: Your Daily Digest):</strong> A round-up of activity across all your active projects</li>\t\n<li><strong>Task-specific notifications:</strong> Notifications about your tasks&nbsp;</li>\t\n<li><strong>Client Portal notifications: </strong>Your projects have unread Client Portal messages. (Only available on <a href=\"https://support.teamgantt.com/article/50-subscribe-plan-teamgantt\">select plans</a>)</li></ol><p>\n\t All email notifications can be managed by the individual user in \n\t<em>Account Settings &gt; Edit My Profile.&nbsp;</em></p><p>\n\t<em><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a20349f6440b9a7594ea952/file-GsRlwI21wV.png\"><br>\n\t</em></p><hr><h2> <strong>Daily project summary email (aka: Your Daily Digest)</strong></h2><p>\n\t<strong></strong>TeamGantt sends a daily email to each user summarizing the latest activity on the projects they're assigned to. This email provides a quick overview of your in-progress tasks, as well as a recap of what happened yesterday across all projects.That way it's easy to stay up-to-date on all your project work.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/59415ce504286305c68d1232/file-YviniWsWsK.png\" alt=\"\" style=\"width: 415px; margin: auto;\"></p><p>\n\t You can opt in or out by going to&nbsp;\n\t<em style=\"background-color: initial;\">Edit My Profile &gt; Notifications</em>.&nbsp;</p><p>\n\tBy default, the daily project summary email only includes active tasks assigned to you. Tasks are considered&nbsp;active during or after a task’s start date and no more than 1 week after the end date.</p><p>\n\t<strong style=\"background-color: initial;\">Tip</strong>: You can customize the time daily emails are sent by going to&nbsp;<i style=\"background-color: initial;\">Edit My Profile &gt; Send daily email at &gt; (Choose specific time)</i>.</p><hr><h2> <strong>Task-specific notifications</strong></h2><p>\n\t TeamGantt makes it easy to stay on top of your tasks by automatically sending you 4 types of task-related notifications. These emails alert you to the following updates:</p><ol>\n\t\n<li>You've been assigned to a task.</li>\t\n<li>Your task has been rescheduled.</li>\t\n<li>Progress has been made on your project.</li>\t\n<li>You have some items due tomorrow.Each user is opted into all of these notifications by default. To update your preferences, go to \n\t<em style=\"background-color: initial;\">Edit My Profile &gt; Notifications</em>.&nbsp;</li></ol><hr><h2>\nClient Portal notifications</h2><p>\n\tIf the \n\t<a href=\"https://support.teamgantt.com/article/174-client-portal-builders-edition-only\">Client Portal feature</a> is enabled on your account, you'll have the option to get notified when there are new, unread messages available.&nbsp;</p><hr><p>\n\t<strong style=\"background-color: initial; font-family: inherit; font-size: 24px;\">Unsubscribing from project notifications</strong></p><p>\n\t Want to receive fewer communications? Here are 2 ways to opt out of TeamGantt project notifications:</p><ol>\n\t\n<li>To unsubscribe from email notifications,&nbsp;go to&nbsp;<em>Edit My Profile &gt; Notifications</em>, and un-toggle the notifications you no longer want to receive.&nbsp;</li>\t\n<li>Click the&nbsp;<em>Unsubscribe</em>&nbsp;link at the bottom of any notification email to stop receiving that type of update from TeamGantt.</li></ol><hr><h2><strong>Suspending task-specific email notifications</strong></h2><p>\n\t There may be times you need to make a bunch of project changes but don't want to bombard your team with notifications. In those cases, you may want to put a temporary stop on task-specific notifications across the board.&nbsp;</p><p>\n\t Here's how it works: Simply change the project status from \n\t<em style=\"background-color: initial;\">Active</em> to <em style=\"background-color: initial;\">On hold</em>. Email updates&mdash;with the exception of project invitations&mdash;will be suspended until the project is moved back to <em style=\"background-color: initial;\">Active</em> status.&nbsp;</p><p>\n\t For more information on how to change the status of your project, please visit \n\t<a href=\"https://support.teamgantt.com/article/65-changing-the-status-of-a-project\">Changing the status of a project</a>.</p><hr><h2><strong> Not receiving any emails from TeamGantt?&nbsp;</strong></h2><p>\n\t Contact us at support@teamgantt.com, and we'll be happy to help you out.&nbsp;</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p><p style=\"font-weight: bold;\"></p>","name":"Email Notifications","number":14,"categories":["5284de2fe4b027e0d843bc97"]}},{"node":{"slug":"how-do-i-delete-comments-from-my-project","text":"<h2>How do I delete unwanted comments from my project?</h2><h3>Remove a single comment from a task</h3><p>\n\t If you just want to remove a single comment or document, you can do that from the task itself. Just keep in mind that only the person who added the comment or document can delete it from the task. That way, important information doesn't accidentally get deleted.</p><p>\n\t To do this, click on the speech bubble icon to open up the discussion window. Hover your cursor over the comment, and click on the trash icon:&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6717af9f44628317ef90582f/file-UYuM2tPwLA.png\"></p><h3> <strong>Remove all comments from a task</strong></h3><p>\n\t Need to remove all comments from a task? Duplicating the task&mdash;and then deleting the original one&mdash;is the quickest way to go. That's because comments from the original task aren't carried over to the duplicate.</p><p>\n\t Here's how it works:&nbsp;</p><ol>\n\t\n<li>Hover your cursor over the task you'd like to duplicate.</li>\t\n<li>Click on the 3 dots icon that appears to the right. A list of options will appear.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2cbb47851bd3fd9580bc2/file-E6Yg0sSlPj.png\">&nbsp;</li>\t\n<li>Click&nbsp;<em style=\"background-color: initial;\">Duplicate</em>&nbsp;to duplicate the task. You'll now see the duplicate task&mdash;fresh with no comments&mdash;and can remove the original task from your project.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6717b0b61198281bd860a438/file-0cnQBUh1Si.png\"></li></ol><h3> <strong>Remove all comments and documents from a project&nbsp;</strong></h3><p>\n\t Want to give your whole project a clean comment slate? Here's how to&nbsp;recreate a project without including&nbsp;the original comments or uploaded documents:</p><p>\n\t 1. Start by saving the original project as a template. To do so, simply open your existing project, and go to&nbsp; \n\t<em>Menu&nbsp;&gt;&nbsp;Save as Template</em>.</p><p>\n\t 2. Next, mark the original project as complete by clicking&nbsp; \n\t<em>Menu &gt; Project Settings &gt; Status: Complete.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a7cb42b997ac821904e244b/file-gqyE984l34.png\"></em>3. Then, create a new project using the template you just saved. You can do this by going to \n\t<em style=\"background-color: initial;\">My Projects &gt; New Project &gt;&nbsp;Create a New Project</em>, and choosing your original project template from the&nbsp;<em style=\"background-color: initial;\">Template</em>&nbsp;drop-down.&nbsp;Be sure to uncheck everything under the <em style=\"background-color: initial;\">Import</em> section to ensure you start with a truly clean slate.&nbsp;</p><p>\n\t4. Finally, click the&nbsp;\n\t<em style=\"background-color: initial;\">Create new project </em>button. Your new project should be identical to the original one, minus the notes and comments.</p><p>\n\t<strong>Please note</strong>: You must have the account permission of<em> Account Admin</em>&nbsp;or <em>Manager&nbsp;</em>to be able to complete these steps.</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Delete comments","number":53,"categories":["5284de2fe4b027e0d843bc97"]}},{"node":{"slug":"recurring-tasks","text":"<p>\n\t There may be times you need to split a task across different time frames with a break in the middle or set up recurring project tasks.&nbsp;</p><p>\n\t Here’s how to tackle each scenario in TeamGantt.</p><hr><h2>How do I split tasks in TeamGantt?</h2><p>\n\t To split tasks across different time frames in TeamGantt, simply create a separate task for each period of time you need to track in your project.</p><p>\n\t Here’s an example:&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/673e0b8107276709d1e57272/file-VF8S33EFtV.png\"></p><p>\n\t<strong style=\"background-color: initial;\">Note:</strong> It’s not currently possible to split a single task into 2 different time frames or taskbars in TeamGantt.</p><hr><h2>How do I set up recurring tasks in a project?</h2><p>\n\t Here’s how to add recurring tasks to your project:</p><ol>\n\t\n<li>Create a task group labeled specifically for your repeating task.</li>\t\n<li>Add each recurring instance as its own task within the task group.</li></ol><p>\n\t This will allow you to map out the repeating task throughout the duration of your project, while also giving you the ability to collapse the group and avoid visually overwhelming your project.</p><p>\n\t In the example below, we’ve set up a task group for the project’s recurring Monday meeting, with each meeting date added as a single task with the larger task group.&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/673e0b6707276709d1e57271/file-xTM8MPnof2.png\"></p><p>\n\t<i style=\"background-color: initial;\"></i></p><p>\n\t<strong>Note: </strong>We don't currently support an&nbsp;automatic process for recurring tasks.&nbsp;</p><hr><p><em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Recurring and Split Tasks","number":105,"categories":["5284df24e4b027e0d843bca8"]}},{"node":{"slug":"project-associated-with-a-trial","text":"<h2>What can I do during my TeamGantt trial?</h2><p>\n\t You can choose to give our plans a trial run via our 14-day Premium trial option. During the trial, there are no project or user limitations, so feel free to create as many projects and invite as many people as you want.&nbsp;</p><hr><h2>What happens when my TeamGantt trial ends?</h2><p>\n\tWhen your trial expires, you have 2 options for continuing to use TeamGantt:</p><ol>\n\t\n<li>Upgrade to a paid <a href=\"https://support.teamgantt.com/article/50-subscribe-plan-teamgantt/\">subscription</a>.&nbsp;</li>\t\n<li><a href=\"https://support.teamgantt.com/article/134-convert-to-the-free-plan\">Downgrade&nbsp;to the Free plan</a>.</li></ol><p>\n\t<strong>Note</strong>: You must be an Account Admin to make changes to the subscription.</p><hr><h2>What happens to my projects when the trial ends?&nbsp;</h2><p>\n\t When you go from a trial to a subscription account, all your project and user data moves along with you so you can manage TeamGantt projects without skipping a beat.&nbsp;</p><p>\n\t If your trial expires before you choose a subscription option, don't worry! We'll hold onto all your account data for up to 30 days. That way, you can spring right into project action if you decide to upgrade to a subscription during that time.&nbsp;</p><p>\n\t<strong>Note:</strong>&nbsp;If you want to have your data deleted immediately, simply email your request to support@teamgantt.com.</p><hr><h2>What if I'm assigned to a project that's on a trial account?</h2><p>\n\t If you've been invited to projects across multiple TeamGantt accounts, you may run into a project that's part of a trial account. Here's how to tell:&nbsp;</p><ul>\n\t\n<li>You see the following message on your <em>My Projects </em>page: <em>This project is associated with a trial account with&nbsp;X&nbsp;days remaining. </em>This means the project lives in an active trial account. &nbsp;</li>\t\n<li>The project information is&nbsp;grayed out on your <em>My Projects </em>page. This means the project lives in an expired trial account.&nbsp;</li></ul><p>\n\t If the trial account has expired&mdash;or is close to expiring&mdash;and you'd like to continue using the project(s), there are a couple of ways to resolve this:</p><ol>\n\t\n<li>The manager for the trial account can upgrade to a paid subscription.</li>\t\n<li>The trial account can be merged into another active account. Contact our Customer Success team at support@teamgantt.com to discuss this option.&nbsp;</li></ol><hr><p>\n\t<em style=\"background-color: initial;\"><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Trial Accounts","number":30,"categories":["57e9e78d9033602e61d4835c"]}},{"node":{"slug":"assigning-multiple-tasks-at-once","text":"<p>Need to make the same update to several tasks? TeamGantt makes it easy to select multiple tasks and update them in a single action. You can assign people or labels, move or reschedule tasks, change task colors, or delete tasks in bulk.</p><hr> \n<h2>How do I select multiple tasks?</h2><p>There are a few ways to select multiple tasks in your project:</p><p><strong>Option 1: Use task checkboxes</strong></p><ol> \n<li>Check the boxes next to the tasks you want to update.</li><li>Use the light blue toolbar at the top of your project to choose your bulk action.</li></ol><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a4ffb0bc985582245f02778/file-rM19RwMcrJ.png\"></p><p><strong>Option 2: Select individual taskbars with your keyboard</strong></p><ol> \n<li>Click the taskbar for the first task you want to select.</li><li>Hold Command (Mac) or Ctrl (Windows), and click another taskbar.</li><li>Repeat until you have selected all the tasks or milestones you want to update.</li><li>Use the light blue toolbar at the top of your project to choose your bulk action.</li></ol><p><strong>Option 3: Select a range of taskbars&nbsp;with your keyboard</strong></p><ol> \n<li>Click the first taskbar in the range you want to select.</li><li>Hold Shift, and click another taskbar.</li><li>TeamGantt will select the two tasks you clicked and any tasks in between.</li><li>Use the light blue toolbar at the top of your project to choose your bulk action.</li></ol><p>Tip: When selecting tasks from the gantt chart, click the colored taskbar rather than the task name.</p><hr> \n<h2>How do I assign multiple tasks at once?</h2><p>Use bulk assignment when several tasks need the same person or label assigned.</p><ol> \n<li>Select the tasks you want to update.</li><li>Click the person icon in the toolbar at the top of your project.</li><li>Choose the person and/or label you want to assign to the selected tasks.</li></ol><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a4ffb88f457003c1f085dab/file-gxa7EyKG38.png\"></p><hr> \n<h2>How do I change the color of multiple tasks at once?</h2><p>You can also update the color of several tasks at the same time. This is helpful when you want to color-code related work or quickly clean up the look of your project.</p><ol> \n<li>Select the tasks you want to update.</li><li>Click the color icon in the toolbar at the top of your project.&nbsp;</li><li>Choose the color you want to apply.</li><li>The selected tasks will update to the new color.</li></ol><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a4ffb9257be4eea8c37f761/file-IAhfKCTBH4.png\"></p><hr> \n<h2>How do I delete multiple tasks at once?</h2><p>Need to remove several tasks from a project? You can select them and delete them together instead of deleting each task one by one.</p><ol> \n<li>Select the tasks you want to delete.</li><li>Click the delete or trash icon in the toolbar at the top of your project.</li><li>Review the selected tasks, then confirm the deletion.</li></ol><p>Note: Deleting tasks removes them from your project. Make sure you have selected the correct tasks before confirming.</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a4ffbd3f457003c1f085db5/file-LKlfHDxEzn.png\"></p><hr> \n<h2>FAQ</h2><p><strong>What bulk actions are available?</strong></p><p>After selecting multiple tasks, you can use the bulk action toolbar to:</p><ul> \n<li>Assign a person or label to selected tasks</li><li>Move or reschedule selected tasks</li><li>Change the color of selected tasks</li><li>Delete selected tasks</li></ul><p><strong>Why don’t I see the bulk action toolbar?</strong></p><p>The bulk action toolbar appears once you have selected one or more tasks. If you do not see it, make sure you have selected the task checkbox or clicked directly on the taskbar in the gantt chart.</p><hr> \n<h2>Related articles</h2><ul> \n<li><a href=\"https://support.teamgantt.com/article/18-task-colors\">Task Colors</a></li><li><a href=\"https://support.teamgantt.com/article/22-reschedule-multiple-tasks\">Move and Reschedule Multiple Tasks</a></li><li><a href=\"https://support.teamgantt.com/article/104-how-to-edit-delete-and-complete-a-task\">Edit, Delete, or Complete a Task</a></li><li><a href=\"https://support.teamgantt.com/article/23-keyboard-shortcuts\">Keyboard Shortcuts</a></li></ul>","name":"Assign, Update, and Delete Multiple Tasks at Once","number":49,"categories":["5284df24e4b027e0d843bca8"]}},{"node":{"slug":"teamgantt-kickoff-meeting-resources","text":"<ol>\n\t\n<h2>What should I cover in my TeamGantt kickoff meeting?</h2><p>\n\t\tBeing prepared for your kickoff meeting is important. We’ve compiled some resources in this document to help!\n\t</p><h3> First, explain the benefits of using TeamGantt to your team.&nbsp;</h3><p>\n\t\t Here are just a few of the many benefits you can tell them about:\n\t</p><ul>\n\t\t\n<li>Easy collaboration with file sharing and discussion threads at both the project and task levels</li>\t\t\n<li>Customizable views that let you see tasks by day or in a calendar, simple list, or gantt chart view</li>\t\t\n<li>Automatic daily email reminders</li>\t\t\n<li>Easy progress updates on tasks</li>\t</ul><h3>Next, walk your team through the 4 steps below.&nbsp;</h3><p>\n\t\t This will help them get comfortable with using and navigating TeamGantt.\n\t</p><hr>\n\t\n<ol>\n\t\t\n<h2> </h2></ol><h4>1. Create your account</h4><ol>\n\t\t\n<p>\n\t\t\t It’s as simple as clicking the \n\t\t\t<em>Go to Your Project</em> button in the invitation email.&nbsp;\n\t\t</p><p>\n\t\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5d1a4c2304286305cb87f3f5/file-zaLqXQ84B2.png\" alt=\"\" style=\"display: block; margin: auto;\">\n\t\t</p><p>\n\t\t\t Next, set a password for your account:\n\t\t</p><p>\n\t\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5d1a4c4404286305cb87f3f6/file-rflFsdgpHh.png\" alt=\"\" style=\"display: block; margin: auto;\">\n\t\t</p><p>\n\t\t\t That’s it! You’re ready to start using TeamGantt!\n\t\t</p><hr>\n\t\t\n<h4>2. Log in and use the <em>My Tasks</em> screen&nbsp;to see the tasks assigned to you.</h4><p>\n\t\t\t Select \n\t\t\t<em>My Tasks</em> from your sidebar menu&nbsp;to see a simple, detailed list of your assigned tasks, when they’re due, and the completion status of each task. <a href=\"https://support.teamgantt.com/article/130-my-tasks\">Learn more about&nbsp;My Tasks here</a>.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a9056ee4b84f76cf81bf0aa/file-lIu2tNFtPy.png\"></p><p>3. Update your progress</p><p>\n\t\t\t To update your progress on your assigned tasks, simply click the \n\t\t\t<a href=\"https://support.teamgantt.com/article/107-percentage-complete-calculated\">Progress&nbsp;field</a>, and enter your progress. Then pat yourself on the back for a job well done!&nbsp; &nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/670934ee44628317ef9051d8/file-7s9oKOrMVe.png\">\n\t\t</p><h4>\n\t\t4. Leave a comment\n\t\t</h4><p>\n\t\t\t You can leave comments at the project or task level in TeamGantt so everyone stays up-to-date. Simply click the chat bubble to the left of the project or task name to leave a comment. Then choose who you want to notify, and send it. Easy peasy! To learn more about documents and comments,\n\t\t\t<a href=\"https://support.teamgantt.com/article/80-adding-comments\"> read this helpful how-to</a>.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6709354b8af27b34842c0042/file-8XCaOdEzth.png\">\n\t\t</p><p>\n\t\t\tWant to view the entire project?<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a90575f9f65cc0cc64d67b6/file-GHWbgmKW87.png\"></p><p>If you'd like to see the entire project in one screen, simply go to your \n\t\t<em style=\"background-color: initial;\">My Projects </em>page (via the \"<em style=\"background-color: initial;\">Me</em>\" icon in sidebar menu) and&nbsp;click the name of a project to open the project in <em style=\"background-color: initial;\">Gantt </em>view.</p></ol><p>\n\t\t Want to open multiple projects at once? \n\t\t<a href=\"https://support.teamgantt.com/article/25-viewing-multiple-projects\">Here's how!</a>\n\t</p><hr>\n\t\n<h3> Here's a list of more helpful how-to resources:</h3><p>\n\t\t<a href=\"https://support.teamgantt.com/article/6-inviting-people\">Inviting People to Your Project</a>\n\t</p><p>\n\t\t<a href=\"https://support.teamgantt.com/article/4-adding-tasks\">Adding Tasks</a>\n\t</p><p>\n\t\t<a href=\"https://support.teamgantt.com/article/80-adding-comments\">Documents and Comments</a>\n\t</p><p>\n\t\t<a href=\"https://support.teamgantt.com/article/8-dependencies\">Using Dependencies</a>\n\t</p><hr>\n\t\n<p>\n\t\t<strong><em style=\"background-color: initial;\">To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">webinars</a>!&nbsp;</em></strong>\n\t</p></ol>","name":"TeamGantt Kickoff Meeting Resources","number":95,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"percentage-complete-calculated","text":"<p>\n\tAs your project rolls along, \n\t<em style=\"background-color: initial; font-size: 14px;\">Progress</em>&nbsp;is the best way to communicate how much work has been completed on a task.&nbsp;</p><hr><h2>How do I track progress on my tasks?</h2><p>\n\t To update a task's \n\t<em>Progress</em>, simply click into the <em>Progress</em>&nbsp;column, and type in the current percentage of completion:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67224513ca07c36a6a17161f/file-mZTxfL6UNB.png\"></p><p>\n\tA darker color will fill in the taskbar to reflect the updated percentage of completion:&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6722450491230b767524bb61/file-1egtQ7V6YL.png\"></p><p>\n\t<strong style=\"background-color: initial;\"></strong></p><hr><h2>How do I update progress on my projects?</h2><p>\n\tWhen the&nbsp;\n\t<em style=\"background-color: initial; font-size: 14px; font-family: inherit;\">Progress&nbsp;</em>percentage&nbsp;is updated on a task, TeamGantt automatically updates the percentage of completion for the task group and the overall project in real time.&nbsp;That way you always have a current snapshot of your project's progress.</p><h2><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/672244973a0b506883e52ea1/file-ZxYukdZQed.png\"></p></h2><h2><hr>\n</h2><h2>How do I track milestone progress?</h2><p>\n\t<strong style=\"background-color: initial;\"></strong>Milestone progress can only be represented as 0% (unchecked) or 100% (checked). Simply check the milestone off to show it's complete.</p><h3><hr>\n</h3><h3>How is <em>Progress</em>&nbsp;calculated in TeamGantt?</h3><p>\n\t<span style=\"background-color: initial;\">In TeamGantt, <em>Progress</em>&nbsp;is based on the duration of the tasks in the gantt chart.&nbsp;</span>For example, a 1-day task will have half the weight as a 2-day task. It also factors in the number of tasks in the group or project and the <em>Progress</em>&nbsp;assigned to each task.&nbsp;</p><p>\n\t Tasks that haven't been scheduled yet or don't have a due date won't be factored into the \n\t<em>Progress</em>&nbsp;calculation. That's because the system can't appropriately determine the weight of the task in relation to the rest of the project.&nbsp;</p><p>\n\t Let's take a look at an example.&nbsp;</p><p>\n\t In the screenshot below, you'll notice that the overall \n\t<em>Progress </em>percentage&nbsp;for this task group is 10%&mdash;even though&nbsp;tasks B and C are marked as 100% and 90% done. That's because 2 out of 3 tasks in the group don't have any dates assigned yet. TeamGantt only considers task A as part of the calculation since it's the only one scheduled on the gantt chart.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67224584ca07c36a6a171621/file-KZrxX9xNew.png\"></p><p>\n\tIt's also important to note that the \n\t<em style=\"background-color: initial;\">Progress</em>&nbsp;calculation doesn't take a task's estimated hours or checklist items into account.&nbsp;</p><hr><p>\n\t Want to request a progress&nbsp;update from your team? Click \n\t<a href=\"https://support.teamgantt.com/article/81-requesting-progress-updates\">here</a> to learn how.&nbsp;</p><p>\n\tWant to see how your task progress is stacking up against hours that have been tracked to your tasks? Check out our \n\t<a href=\"https://support.teamgantt.com/article/139-hourly-progress-v-task-progress\">Hourly Progress v. Task Progress</a> help doc! (Note: This only applies to Business and Builder Edition plan accounts.)</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Progress (% Complete)","number":107,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"changing-account-level-permissions","text":"<p>\n\t As a manager with account admin permission, you can change account level permissions and add or remove users from the account.&nbsp;</p><hr><h2>How do I manage users in my TeamGantt account?</h2><p>\n\tTo manage users on your account, click&nbsp;your circular profile icon at the upper right and&nbsp;go to&nbsp;\n\t<strong>Account Settings</strong>&nbsp;&gt; <strong>Manage users</strong><em>. </em>There<em style=\"background-color: initial;\">&nbsp;</em>you'll find the following options:</p><ul>\n\t\n<li>Add person</li>\t\n<li>Permissions</li>\t\n<li>Delete</li>\t\n<li>Deactivate<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a7c8c91714de94e758babfd/file-2sTz5ilqnv.png\"></li></ul><h2>How do I add a new user to the account?</h2><p>\n\tClick the \n\t<strong>Add user</strong>&nbsp;button to add a new person to your account at the account level. You'll still need <a href=\"https://support.teamgantt.com/article/6-inviting-people\">to invite them to each project</a> or add them to a <a href=\"https://support.teamgantt.com/article/151-manage-teams\">team</a>.</p><hr><h2>How do I adjust a user's account permissions?</h2><p>\n\tTo change the account-level \n\t<a href=\"https://support.teamgantt.com/article/5-permissions\">permission</a> for a user, click the <strong>Permissions</strong> dropdown for that user and choose one of the following options:</p><ul>\n\t\n<li>Manager with&nbsp;Account Admin</li>\t\n<li>Manager</li>\t\n<li>Collaborator</li></ul><hr><h2>How do I delete a user from the account?</h2><p>\n\tClick the 3-dot icon, and select \n\t<strong>D</strong><strong>elete user</strong><em>&nbsp;</em>to remove a&nbsp;user from the entire account and all projects within the account. This is a great way to free up space to add new people to your account.</p><hr><h2>How do I deactivate a user?</h2><p>\n\tClick the 3-dot icon, and select \n\t<strong>Deactivate user</strong>&nbsp;to deactivate a user's login. This will keep all of the user's historical data on the account and free up space to add new people to your account.&nbsp;</p><hr><p>\n\t<strong>Note:</strong>&nbsp;Removing a user from the account will also remove all their previous task assignments and hours.</p><p>\n\t For more information on permissions, please visit our \n\t<a href=\"https://support.teamgantt.com/article/5-permissions\">Permissions</a> support page.</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Manage People (For Managers)","number":114,"categories":["57e9e78d9033602e61d4835c"]}},{"node":{"slug":"syncing-trello-list-progress-with-teamgantt","text":"<p>\n\tIf you use Trello lists to track your card statuses, our Trello integration makes it easy to keep those lists in sync with your TeamGantt project tasks.</p><p>\n\tWith this integration, you can:</p><ul>\n\t<li>Automatically update TeamGantt task progress based on Trello card movements.</li>\t<li>Move Trello cards between lists automatically when TeamGantt task completion changes.</li></ul>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/1b867efyiw?videoFoam=true\" title=\"Task Progress Sync with Trello Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div>\n</div><hr>\n<h3></h3><h2>\n\tHow do I access the TeamGantt Power-Up settings in Trello?&nbsp;</h2><p>\n\tTo get started, open the TeamGantt Power-Up settings:</p><ol>\n\t<li>Click on the <strong>TeamGantt </strong>icon<strong>&nbsp;</strong>from your Trello board.</li>\t<li>Then click the&nbsp;<strong>Settings&nbsp;</strong>link.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa81794edf30bb4bc1bd698/file-BbpjuWfcSt.png\"></li></ol>\n<h2></h2><h2>\n\tHow do I sync Trello lists to task progress in TeamGantt?&nbsp;</h2><p>\n\tIn the settings modal, you'll find two settings for each Trello list&mdash;<strong>Percent Complete&nbsp;</strong>and&nbsp;<strong>Automatically Move Card</strong>. These settings let you define exactly how your Trello lists and TeamGantt tasks sync together.</p><h3>What does the Percent Complete setting do?</h3><p>\n\tWhen a Trello card moves into a specified list, TeamGantt automatically updates the associated task's percent complete to the amount you've set.</p><p>\n\t<em>For example, if your \"Done\" list is set to 100%, moving a card into that list will mark the corresponding TeamGantt task as fully complete.</em></p><h3>What does the Automatically Move Card setting do?</h3><p>\n\tThis setting moves your Trello cards based on updates to task progress in TeamGantt. When enabled, TeamGantt will automatically move a task's Trello card into the selected list whenever the task’s percent complete reaches or exceeds the specified value.</p><p>\n\t<em>For example, if your \"Doing\" list is set at 5%, a task updated to at least 5% complete in TeamGantt will automatically move its card into the \"Doing\" list in Trello.</em></p><h4>\n\t<strong>Important:&nbsp;</strong></h4><p><strong></strong>To enable the <strong>Automatically Move Card</strong> feature, you must first specify a percentage in the&nbsp;<strong>Percent Complete&nbsp;</strong>setting for the same list.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5a78b4760428634376cfd205/file-aKS86qXPgu.png\" style=\"width: 856px;\"></p><p><span style=\"font-weight: normal;\">In the board below, the integration has been set up with the following behaviors:</span></p><ul>\n\t<li>\"To Do\" list has no percent set, so no automatic syncing occurs.</li>\t<li>\"Doing\" is set at 5%. If a task is updated to at least 5% in TeamGantt, the corresponding Trello card automatically moves into \"Doing.\"</li>\t<li>\"Done\" is set at 100%. Dragging a card into \"Done\" in Trello automatically marks the task as 100% complete in TeamGantt.</li></ul><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5a78b49e2c7d3a4a4198d0a3/file-Pj59ujhwbU.png\" style=\"width: 853px;\"></p><p>\n\t That's all there is to it! We hope this feature continues to help you and your teams crush your deadlines!</p><hr>\n<p>\n\t Have other questions about our Trello Power-Up? Just email support@teamgantt.com! Or, check out one of our other articles about Trello:&nbsp;</p><ul>\n\t<li><a href=\"https://support.teamgantt.com/article/116-trello-powerup\">TeamGantt Power-Up for Trello</a></li>\t<li><a href=\"https://support.teamgantt.com/article/117-trello-sync-options\">Trello - Sync Options</a></li>\t<li><a href=\"https://support.teamgantt.com/article/118-trello-troubleshooting\">Trello - Troubleshooting</a></li></ul><hr>\n<p>\n\t<em><strong>To learn more about using TeamGantt and Trello together, join us for our <a href=\"https://www.teamgantt.com/live-classes/teamgantt-power-up-for-trello-15\">free class</a>!&nbsp;</strong></em></p>","name":"Syncing Trello List Progress with TeamGantt","number":123,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"how-do-i-create-a-new-project","text":"<h2>Why can't I create a new project?</h2><p>\n\t Want to add a new project? Your account permission will need to be set to manager. In that case, creating a project is as simple as going to <em>Projects &gt; New Project.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a84a08e4f742c5313c505ab/file-Fov8KSI2MX.png\"></em></p><p>If you don't see the <em style=\"background-color: initial;\">New Project</em>&nbsp;button&nbsp;on your homepage, that means you were either invited to the account as a collaborator or your subscription needs to be upgraded to a paid plan.&nbsp;</p><h2>How do I check my TeamGantt account permissions?</h2><p>\n\t To confirm your \n\t<a href=\"https://support.teamgantt.com/article/5-permissions\">account permission</a>, please contact your manager with account admin status or send us a note at <a href=\"mailto:support@teamgantt.com\">support@teamgantt.com</a>.&nbsp;</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/webinars/\">webinars</a>!&nbsp;</strong></em></p>","name":"Why can't I create a new project?","number":59,"categories":["6a021cfef97dd896ebfc81ba"]}},{"node":{"slug":"how-to-clear-remove-filters","text":"<h2>Why can't I see all of my tasks in TeamGantt?</h2><p>\n\tHaving trouble finding a specific task? Or does it seem like your tasks just disappeared from your project?</p><p>\n\t<strong></strong>Filters are a great way to sort and view your data. But they can make it look like recently made changes didn't save. This can feel frustrating or defeating when you've spent time updating your project.</p><p>\n\t If tasks or other project details aren't showing up as expected, there are a few steps you can take to ensure you're not accidentally filtering information you want to see out of your chart.</p><hr><p>\n\t<strong>1</strong><strong>.&nbsp;Remove the filter by project status (In Progress vs. Complete)</strong></p><p>\n\t<strong></strong>When recently completed tasks appear to vanish, a good first step is to ensure the <em>Hide Completed</em> box in the top toolbar is unselected. This will bring all tasks back to the chart, no matter their completion status.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66df3d9ce6b2356def90922d/file-WclFLQrn6N.png\"></p><p>\n\t<strong style=\"background-color: initial;\">2. Remove filters by people or labels</strong></p><p>\n\t<strong></strong>If <em>Hide Completed</em> is unselected and your tasks still don't appear on your chart, you may be filtering your project by people or labels. To ensure you're viewing your full project with no filters applied, click on the <em>Filter&nbsp;</em>drop-down, and either uncheck the selected members or click&nbsp;<em>Clear.&nbsp;</em><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66df3e11ceae9468399d4021/file-OhOIODIY7V.png\"></p><p>\n\t<strong style=\"background-color: initial;\">3. Remove the filter by dates</strong></p><p>\n\t<strong></strong>Projects can also be filtered by dates. To ensure you're viewing your project's full date range, click the Filter&nbsp;drop-down, and select \"clear\" by Dates<em>.</em></p><p>\n\t<em><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66df3eb5e6b2356def909231/file-4rO1TZ0JSi.png\"><br>\n\t</em></p><p>\n\t<strong style=\"background-color: initial;\">4. Remove the filter by task colors</strong></p><p>\n\t<strong></strong>Is your project only displaying certain task colors? To remove task color filters, simply click on the Filter<em>&nbsp;</em>drop-down, and select <em>Clear.</em></p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66df3f6015d0b82233063921/file-jNzI84oKRa.png\"></p><p>\n\t<strong>5. Remove individual filters</strong></p><p>\n\tApplied filters will appear as chips at the top of the Gantt chart. You can clear individual filters by clicking the \"x\" of the desired filter.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e19b40dd5b956281ae4aa0/file-zxHNL3qx5Q.png\"></p><p>\n\t<strong>6. Remove all filters</strong></p><p>\n\tYou can easily remove all filters from a project by clicking \n\t<em>Clear all </em>from the <em>Filter </em>menu or the \"x\" on the <em>Filter </em>menu.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66e19b84811a2434cb6d371a/file-UpTMw1nUpT.png\"></p><p>\n\t Want to learn more about filters? Read on \n\t<a href=\"https://support.teamgantt.com/article/24-filters\">here</a>.&nbsp;</p><p>\n\t Still can't find tasks or other project information? Email us at \n\t<a href=\"mailto:mailto:support@teamgantt.com\">support@teamgantt.com</a> for help.</p><p><em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Clear or Remove Filters from Your Project","number":39,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"requesting-progress-updates","text":"<h2>\nHow do I remind team members to update progress?</h2><p>\n\tNeed to know where someone stands on a particular task? TeamGantt makes it easy to do a quick status check and remind team members to update their progress.</p><p>\n\t Here's how it works:&nbsp;</p><ol>\n\t\n<li>Click the chat bubble to the left of the task to open the comment window.</li>\t\n<li>Click&nbsp;<i style=\"background-color: initial;\">Request a progress update</i>&nbsp;at the top of the comment window<i style=\"background-color: initial;\">.&nbsp;</i></li>\t\n<li>TeamGantt will send anyone who's assigned to that task an email requesting them to update their <a href=\"https://support.teamgantt.com/article/107-percentage-complete-calculated\"><em>Progress</em></a>.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66df01bd44628317ef903713/file-jw0UV1ozdW.png\"></li></ol><h3><strong></strong></h3><p>\n\tRequest a progress update can also be found via the Discussions tab and the task edit window:&nbsp;</p><p>\n\t<em style=\"background-color: initial;\"><strong><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66df084015d0b822330638f6/file-29iBCMTcyu.png\"></strong></em></p><p>\n\t<em style=\"background-color: initial;\"><strong><br>\n\t</strong></em></p><p>\n\t<em style=\"background-color: initial;\"><strong><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66df08acceae9468399d3ff7/file-YbmFO1KzT8.png\"></strong></em></p><p><em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Request Progress Updates","number":81,"categories":["5284de2fe4b027e0d843bc97"]}},{"node":{"slug":"adding-comments","text":"<p>\n\t TeamGantt does more than just&nbsp;project scheduling.&nbsp;It’s a collaborative platform that allows you to keep all your files and conversations in one place, right where you need them.&nbsp;</p><h2>How do I add comments to tasks or projects?</h2><p>\n\tIn TeamGantt, comments can be accessed by clicking the comment bubble next to the project title or task name or by double-clicking a task bar in the gantt chart to open the task detail window.</p><p>\n\t Watch this quick video to get a little tour.</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/blmmg6beb1?videoFoam=true\" title=\"Discussions Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><hr><p>\n\tComments are user-specific and can be used to keep relevant task, group, and project-related communications easily accessible&mdash;all in one place.&nbsp;</p><h2>How do I notify teammates when leaving a comment?</h2><p>\n\t Comments work best when others know you left it there. Here's how to notify your team when adding a comment:</p><ul>\n\t\n<li>To notify all project participants, begin your comment with @project.&nbsp;</li>\t\n<li>To notify only users assigned to the task, begin your comment with @assigned.&nbsp;</li>\t\n<li>To notify a specific team member,&nbsp;select the user's name from the <em>Want to notify anyone</em> drop-down list, or begin your comment with @username. You can notify as many or as few people as you need!<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6717b2646d43ca7b17b2c2bf/file-r4j08zPMk3.png\"></li></ul><h2>\nCan I upload files to comments?</h2><p>\n\t Yes, you can upload documents directly to task, group, and project-level comments.&nbsp;TeamGantt supports version control, so it's easy to update the latest version of any document.&nbsp;</p><p>\n\t For more information about uploading files, see \n\t<a href=\"https://support.teamgantt.com/article/67-uploading-documents\">Upload and Delete Files</a>.&nbsp;</p><h2>How do I react to a comment?</h2><p>\n\tTo react to a comment, hover over the comment, then click the \n\t<em>smiley face icon</em> in the top right. From there, you can select which reaction you would like to leave.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67feb342dd7a733e58c1e9fa/file-8YN6uTtVhr.png\"></p><h2><hr>\n</h2><h2>What are notes in TeamGantt, and how are they used?</h2><p>\n\t<span style=\"font-weight: normal;\">Each task contains a single sticky note that can be used for general project highlights. You could use this feature to outline high-level notes on project scope or to share the URL to an important project file, such as a link to a Google Doc or DropBox file. The note is \"pinned\" to the top of each comment thread and can be edited by any user.</span></p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67feb436ff3ed2539f9f5bed/file-A0c5IPWOT0.png\"></p><h2><strong>How do I create a note template?</strong></h2><p>\n\tWe now support creating templates for your notes. To create a template from the note section, click on the\n\t<em> insert</em>&nbsp;<em>template icon</em> and select <em>Add Template</em>. This will bring you to the Template page,&nbsp;where you can create and manage your templates. You can also access the Template page by going to <em>Account Settings &gt; Manage note templates</em>. Just to note, you will need to be listed as an Account Admin to create and manage templates.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6810d6bce41ca43dd7b3d8ea/file-QTv6Xnb6jj.png\"><strong>Tip: You can also add a template by entering \"/\" and the name of the template.&nbsp;</strong></p><p>\n\tOnce you are on the Template page, you can click on \n\t<em style=\"background-color: initial;\">Add Template</em> to create a new template.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a8476cdfe85491fcf32c42a/file-zDtmLYBDFG.png\"></p><p>\n\tThe template window will appear. You will name the template, choose to make the template public or private, and create the template. Then, simply click \n\t<em>Save</em>.&nbsp;</p><h2><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/681241ba07cebf027a4777c8/file-y9nUlbg0pS.png\">How do I insert a note template into a task?</h2><p><span style=\"background-color: initial; font-size: 14px;\">To insert a Note Template, simply click the \n\t<em style=\"background-color: initial; font-size: 14px;\">template </em></span><span style=\"font-weight: normal;\">icon. Then, select the template you would like to insert and click \"Insert into note\".<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa28ffed0ab33957f799fce/file-vnZx73WbIP.png\"></span></p><h2>How do I edit, duplicate, or delete a note template?</h2><p>You can manage your templates by going to\n\t<em style=\"background-color: initial; font-size: 14px;\"> Account Settings &gt; Manage note templates</em>.&nbsp;If you click the <em style=\"background-color: initial; font-size: 14px;\">triple-dot </em>icon on the far right, you can choose to <em style=\"background-color: initial; font-size: 14px;\">edit, duplicate, or delete</em>&nbsp;a template.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa290717851bd3fd9580aaf/file-vaSm28wbSe.png\"></p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a8476a45d0caeca8fcaccb4/file-Ua4JbVMFsb.png\"><em style=\"background-color: initial;\"><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Communicate on Your Tasks with Comments and Notes","number":80,"categories":["5284de2fe4b027e0d843bc97"]}},{"node":{"slug":"duplicate-a-project","text":"<h3>How do I duplicate a project in TeamGantt?</h3><p>\n\t TeamGantt makes it easy to save time on project setup by duplicating existing projects. Here's how it works:</p><p>\n\t 1. From the \n\t<em style=\"background-color: initial;\">My Projects</em> page, simply click the blue <em style=\"background-color: initial;\">New Project</em> button in the upper right corner.&nbsp;</p><p>2. Then click the&nbsp;\n\t<em style=\"background-color: initial;\">Duplicate a project</em>&nbsp;button.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a90637d039b617b1742827d/file-YX7ghKKd6d.png\"></p><p>\n\t3. Select the existing project you'd like to duplicate.</p><p>\n\t 4. Check&nbsp;\n\t<em style=\"background-color: initial;\">Include&nbsp;</em><em style=\"background-color: initial;\">P</em><em style=\"background-color: initial;\">ercent Complete</em>&nbsp;if&nbsp;you want to copy the existing project's task progress over to the new duplicated project.</p><p>\n\t 5. Finally, click the blue&nbsp;\n\t<em style=\"background-color: initial;\">Duplicate Existing Project</em>&nbsp;button.</p><p>\n\t You're done! The duplicate project will immediately appear in your \n\t<em style=\"background-color: initial;\">Active</em>&nbsp;list in <em style=\"background-color: initial;\">My Projects.&nbsp;</em></p><hr><h3>Can I create a new project from a template?</h3><p>\n\t Yes, you can use an existing project template to save time on setup when creating a new project.&nbsp;A template comes in handy because it allows you to set a new \n\t<em style=\"background-color: initial;\">Start Date</em>&nbsp;and choose which information to carry over into your new project (e.g.,&nbsp;<em style=\"background-color: initial;\">Comments</em>).</p><p>\n\t To create a new project from a template, go to&nbsp;\n\t<em style=\"background-color: initial;\">My Projects&nbsp;</em>(in the left sidebar menu) and select&nbsp;<em style=\"background-color: initial;\">New Project &gt; Create a New Project.</em></p><p>\n\t Learn more about:</p><ul>\n\t\n<li><a href=\"https://support.teamgantt.com/article/19-templates\">Creating a project template</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/137-use-a-template\">Using a project template<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a9063e9039b617b1742827f/file-d5wgkWUui0.png\"></a></li></ul><p><a href=\"https://support.teamgantt.com/article/137-use-a-template\"></a><em style=\"background-color: initial;\"><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Duplicate a Project","number":111,"categories":["5284df24e4b027e0d843bca8"]}},{"node":{"slug":"teamgantt-app-for-android","text":"<h2>How do I use TeamGantt's mobile app for Android?</h2><p>\n\t TeamGantt for Android lets you manage projects on the go. You can update projects and communicate with your team directly from the app.</p><h3>Downloading the App</h3><p>\n\t To download the TeamGantt app:</p><ol>\n\t\n<li><img src=\"https://lh3.googleusercontent.com/0120eCemijjZszltSrBLYjS1MMm7VVySXGy_CyvRlYy0vwWzHJ8H5nRAOpG1wulT_ZU=w1652-h806-rw\" alt=\"Screenshot Image\" style=\"float: right; width: 283px; margin-top: 0px; margin-bottom: 10px; margin-left: 10px;\">Search&nbsp;<em>TeamGantt</em>&nbsp;in the <a href=\"https://play.google.com/store/apps/details?id=com.teamgantt\">Google Play Store</a>.</li>\t\n<li>Select <em>Install</em>.</li>\t\n<li>Launch the TeamGantt app by selecting <em>Open</em>.</li></ol><hr><h3>Getting Started</h3><p>\n\t The TeamGantt app is a free companion app for your TeamGantt account. The app is ideal for updating projects and collaborating with your team. For full functionality, including creating new projects and updating account information, use our web app ( \n\t<a href=\"https://www.teamgantt.com/\">www.teamgantt.com</a>).</p><p>\n\t Once the app is downloaded, log in with your existing TeamGantt account credentials.</p><p>\n\t If you do not have an existing TeamGantt account, you can create one in the Android app.</p><hr><h3> </h3><h3>Navigating the App</h3><p>\n\t Navigate&nbsp; \n\t<g>\n\tthrough \n\t</g>&nbsp;the app using the left sidebar menu.</p><h4>My Projects</h4><p>\n\t Exactly like your&nbsp;\n\t<em>My Projects&nbsp;</em>page on TeamGantt.com,&nbsp;<em>My Projects&nbsp;</em>will show you a list of all projects you're currently invited to in the account. Toggle between Active, On Hold, and Complete projects.&nbsp;</p><p>\n\t To view and update a project, simply select the project from the&nbsp;\n\t<em>My</em>&nbsp;<em>Projects</em>&nbsp;list.&nbsp;Alternatively, you can click directly into any of your&nbsp;<em style=\"background-color: initial;\">Active&nbsp;</em>projects listed under&nbsp;<em style=\"background-color: initial;\">Projects&nbsp;</em>in the sidebar.&nbsp;Your <a href=\"https://support.teamgantt.com/article/5-permissions\">permission level</a> with each project is the same as in <a href=\"https://teamgantt.com/\">TeamGantt.com</a>.</p><p>\n\t Within a project you can:</p><ul>\n\t\n<li>Expand and collapse task groups</li>\t\n<li>Add a new group of tasks</li>\t\n<li>Drag and drop tasks to reorder them</li>\t\n<li>Update the task view to show as a percentage or a checkbox</li>\t\n<li>Update the task view to hide completed tasks</li></ul><p>\n\t Within a task you can:</p><ul>\n\t\n<li>Update task names</li>\t\n<li>Assign existing people and labels to the task</li>\t\n<li>Update % complete</li>\t\n<li>Update task dates</li>\t\n<li>Edit checklists</li>\t\n<li>Leave comments</li>\t\n<li>Attach files and images</li>\t\n<li>Change task colors</li>\t\n<li>Add estimated hours (Business and Builder Edition plans only)</li>\t\n<li>Track time (Business and Builder Edition&nbsp;plans only)</li>\t\n<li>Delete tasks</li></ul><h4>My Tasks</h4><p>\n\t The app’s default view is the&nbsp;\n\t<em>My Tasks</em>&nbsp;page. This page shows all tasks, across all active projects, that are currently assigned to you.</p><h4>Discussions</h4><p>\n\t The&nbsp; \n\t<em>Discussions</em>&nbsp;page allows you to view and respond to active comment threads. You can toggle between discussions on all projects you are invited to (<em>All Projects</em>), discussions on tasks specifically assigned to you (<em>My Tasks</em>), and discussions on starred projects (<em>Starred</em>).</p><p>\n\t Start a new discussion on any of your projects by selecting the (+) at the upper right corner of the screen.</p><h4>Calendar</h4><p>\n\t Get a running list of all of current tasks across all of your projects with the mobile-only&nbsp;\n\t<em>Calendar</em> page.&nbsp;</p><h4>Settings</h4><p>\n\t Choose which&nbsp;\n\t<em>Notifications</em>&nbsp;you would like to receive from the app. Currently, the only notification available is&nbsp;<em>Mentioned in Comments</em>. We anticipate launching more notification types in the near future.</p><p>\n\t You can also choose to&nbsp; \n\t<em>Logout</em>&nbsp;from your TeamGantt account.</p><hr><h3>FAQ</h3><ul>\n\t\n<li><em>Can I view the project in a&nbsp;gantt or \n\t<g></g> calendar view?&nbsp;</em>\n\t\n<ul>\n\t\t\n<li>Currently, a simple list view is the only way to view projects within the mobile app. To view your projects in a&nbsp; \n\t\t<g>\n\t\tgantt \n\t\t</g>or calendar format, log in to your account via <a href=\"https://teamgantt.com/\">TeamGantt.com</a>.</li>\t</ul></li>\t\n<li><em>Do I have to pay for the app?&nbsp;</em>\n\t\n<ul>\n\t\t\n<li>Nope! The TeamGantt companion app is completely free and can be used with any TeamGantt plan.</li>\t</ul></li>\t\n<li><em>Can I update a project’s status from the app?&nbsp;</em>\n\t\n<ul>\n\t\t\n<li>At this time, project status (<em>Active</em>,&nbsp;<em>On Hold</em>, or&nbsp;<em>Complete</em>) has to be updated using <a href=\"https://teamgantt.com/\">TeamGantt.com</a></li>\t</ul></li>\t\n<li><em>Can I update my account from the app?</em>\n\t\n<ul>\n\t\t\n<li>Updating&nbsp;<em>Account Settings</em>, such as adding/managing users and updating billing information has to be done using <a href=\"https://teamgantt.com/\">TeamGantt.com</a></li>\t</ul></li>\t\n<li><em>Will the app automatically sync changes to&nbsp;</em><a href=\"https://teamgantt.com/\"><em>TeamGantt.com</em></a><em>?&nbsp;</em>\n\t\n<ul>\n\t\t\n<li>Yes! All changes made in the app are reflected in real-time on <a href=\"https://teamgantt.com/\">TeamGantt.com</a>. This is also true for projects that are integrated with Trello or Basecamp 2.</li>\t</ul></li>\t\n<li><em>How do I change a task’s color?</em>\n\t\n<ul>\n\t\t\n<li>To change a task’s color, open the task and select “&hellip;” from the upper right-hand corner of your screen</li>\t</ul></li>\t\n<li><em style=\"background-color: initial;\">How do I set dependencies?</em>\n\t\n<ul>\n\t\t\n<li><em style=\"background-color: initial;\"></em>At this time, dependencies can only be viewed and added to tasks using <a href=\"https://teamgantt.com/\">TeamGantt.com</a></li>\t</ul></li>\t\n<li><em style=\"background-color: initial;\">How do I view Availability from the app?</em></li>\t\n<li>\n\t\n<ul>\n\t\t\n<li><em style=\"background-color: initial;\"></em>The best way to view team availability is within <a href=\"https://teamgantt.com/\">TeamGantt.com</a>.</li>\t</ul></li></ul><hr><p>\n\t<em style=\"background-color: initial;\">Have more questions about the TeamGantt app? Reach out to the Customer Success Team any time by emailing support@teamgantt.com!</em></p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"TeamGantt App for Android","number":126,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"my-preferences-dependencies","text":"<p>\n\t TeamGantt enables you to control how certain tasks, dependencies, and hourly estimation actions are handled. Simply click&nbsp;the \n\t<i style=\"background-color: initial;\">Menu</i> drop-down within your project and select<em> My Preferences</em> to manage your preferences.&nbsp;</p><p>\n\t Let's take a closer look at how each preference option works.&nbsp;</p><hr><h3>Task Creation</h3><p>\n\t This preference determines how TeamGantt handles the addition of new tasks to your gantt chart.</p><ul>\n\t\n<li><strong>Manually draw task bar:&nbsp;</strong>A task bar will not be automatically created. You will need to manually draw the task bar.</li>\t\n<li><strong>Automatically add task bar below above task:</strong>&nbsp;A&nbsp;new taskbar will be automatically created below the above task.</li></ul><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/686d71a34d9eb57424767c69/file-LYr2v1XqWP.png\"></p><ul>\n\t\n<li><strong style=\"background-color: initial;\">Please note:</strong>&nbsp;If hourly scheduling&nbsp;is&nbsp;enabled, all tasks are added without dates. To disable hourly scheduling, go to&nbsp;<em style=\"background-color: initial;\">Menu &gt; Project Settings &gt; Enable Hours &gt; No.</em></li></ul><hr><h3><strong>Dependencies</strong></h3><p>Customize how TeamGantt manages dependent tasks when you make changes to your schedule. These options help you control how dependent tasks are rescheduled, how lead and lag times are applied, and how existing task spacing is handled when creating or updating dependencies.</p><h3><strong>Remove float&nbsp;when dragging</strong></h3><p>\n\t When \n\t<em>Remove float when dragging predecessor tasks</em>&nbsp;is selected, this option eliminates any float between dependent tasks as the parent task is moved.&nbsp;This makes rescheduling a snap&nbsp;if you have a sequence of tasks that should occur right after another without any gap in between.&nbsp;</p><p>\n\tFor example, if a task finishes several days early, moving up its finish date will move the dependent tasks up so they can start sooner. And because they were rescheduled via the dependency, the people assigned to the dependent tasks will get notified and see the rescheduled tasks on their \n\t<em>My Tasks</em>&nbsp;page.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a8726086c88fbca57ab9d67/file-VwxTOa9N41.png\"></p><h3>Apply lead/lag changes immediately on the chart</h3><p>\n\tWhen <em>Apply lead/lag changes immediately on the chart</em><em>&nbsp;</em>is selected, as lead/lag times are updated, the changes will be applied to your schedule in real time.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a8727628565417004fc50bf/file-TCpMhpBalG.png\"></p><h3>Infer lead/lag from existing task spacing when creating a dependency</h3><p>\n\tWhen <i style=\"background-color: initial; font-size: 14px;\">Infer lead/lag from existing task spacing when creating a dependency </i>is selected, the lead/lag time will be inferred and set from the current spacing of tasks on the chart.&nbsp;</p><p>\n\t<br>\n\tFor example, if Task A ends 3 days before Task B begins, creating a dependency between them would infer a lag time of 3 days.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a8728fdbd966477d4ac87e4/file-Hisn5euzv5.png\"></p><h3>\n\tAutomatically fix invalid dependencies when task dates are edited</h3><p>When <i style=\"background-color: initial; font-size: 14px;\">Automatically fix invalid dependencies when task dates are edited </i>is selected, downstream tasks will automatically be rescheduled to accommodate any changes that are impacted by schedule changes.&nbsp;</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a872b708565417004fc50db/file-7s6yBQq9An.png\"></p><h3>\n\tHourly scheduling</h3><p>\n\t When estimated hours are enabled, this setting allows you to choose whether or not the total number of hours will increase when you extend the duration of a task.&nbsp;</p><p>\n\tYou have 3 options for this setting:</p><ul>\n\t\n<li>Ask</li>\t\n<li>Automatically adjust total hours</li>\t\n<li>Leave total hours intact</li></ul><p>\n\tLet's say you estimate 12 hours for a task with a 3-day duration. That breaks down to an estimated 4 hours per day. If you choose to adjust hours with the duration of the task and then extend the task's duration to 5 days, TeamGantt will add another 4-hour increment to each additional day. That brings the new total estimated hours to 20.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a872d4db930fa0fc62cfd4d/file-hdCD2FOns9.png\"></p><p>\n\t For more information on hourly estimation, please visit \n\t<a href=\"https://support.teamgantt.com/article/79-hourly-estimation\">here</a>.</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"My Preferences (For Dependencies and Hourly Estimation)","number":98,"categories":["5284df24e4b027e0d843bca8"]}},{"node":{"slug":"keyboard-shortcuts","text":"<h2>What keyboard shortcuts can I use in TeamGantt?</h2><p>\n\tUse these easy keyboard shortcuts to turbocharge your project setup so you can get more done in less time!</p><hr><h3>\nCreating tasks &amp; milestones&nbsp;</h3><p>\n\t\tAdd a new task, then hit \n\t<em>Enter</em>.&nbsp;A new task will be added below the one you just created.</p><p>\n\t\tNeed to add a milestone instead? Simply click S\n\t<em style=\"background-color: initial;\">hift+Enter</em> after adding a new task.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/673e0fd5268fb643f63a5c88/file-zGttDgMeXW.png\"></p><p>\n\tWhen you're done adding tasks, simply click out of the task name field.</p><hr><h3>\nSelecting multiple tasks at once</h3><h4>\nOption 1:</h4><ol>\n\t\n<li>Click the first taskbar you'd like to select.</li>\t\n<li>Hold&nbsp;<em style=\"background-color: initial;\">Command</em>&nbsp;(Mac) or&nbsp;<em style=\"background-color: initial;\">Ctrl&nbsp;</em>(Windows), and click another task.&nbsp;</li>\t\n<li>Repeat step #2 until you've selected as many tasks/milestones as you wish.&nbsp;</li></ol><h4>\nOption 2:</h4><ol>\n\t\n<li>Click the first taskbar you'd like to select</li>\t\n<li>Hold&nbsp;<em style=\"background-color: initial;\">Shift,</em>&nbsp;and click another task. This will select the 2 tasks you clicked and any tasks in between.&nbsp;</li></ol><p>\n\t<strong>Tip:&nbsp;</strong>When selecting tasks you need to move, click on the colored taskbar, not the task name.</p><hr><h3>\nCreating dependencies</h3><ol>\n\t\n<li>Select the tasks you want to connect with dependencies.</li>\t\n<li>Press&nbsp;<em style=\"background-color: initial;\">Shift+D</em>&nbsp;on your keyboard. This will create a dependency between each subsequent task you've selected (Task 1 &gt; Task 2 &gt; Task 3 &gt;&nbsp;Task 4, etc.).</li></ol><hr><p><em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Keyboard Shortcuts","number":23,"categories":["5284df24e4b027e0d843bca8"]}},{"node":{"slug":"filters","text":"<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<div class=\"wistia_embed wistia_async_t3xp45nc61 idType=ab-test seo=true videoFoam=true\" style=\"height:100%;position:relative;width:100%\">\n    &nbsp;\n\t\t</div></div></div><h2>How do I filter tasks?</h2><p>\n\tAs your project grows, you may want to customize your view to see&nbsp;certain tasks. In TeamGantt, you can do this by using the filters located at the top of your project.&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a97201d4254e779581a5192/file-sNMYlYn7lS.png\"></p><p>\n\tThe&nbsp;\n\t<em>People</em>&nbsp;filter enables you to filter the project by user.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a98401cfb02544561c5d1a8/file-SgK6rcWBXU.png\"></p><p>\n\tThe \n\t<em style=\"background-color: initial;\">Labels</em>&nbsp;filter enables you to filter the project by a label.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a98404b26f9ffe83c5d1486/file-5G1cOAx7SH.png\"></p><p>\n\tThe \n\t<i style=\"background-color: initial;\">Dates</i>&nbsp;filter gives you several options for customizing your task view. You can choose to filter tasks based on when they're either starting or due. You can also filter tasks by status&mdash;in progress, overdue, completed, or not scheduled. If you only want to see milestones, there's a filter for that too!<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a9840809146944608cc806a/file-S1TXOJGJfA.png\"></p><p>\n\tThe <em>Materials</em>&nbsp;filter allows you to filter tasks based on the status of the materials needed: order, not ordered, overdue to be ordered, and delivered. You can also easily see the materials that need to be ordered within 1 week, 1 month, 2 months, 3 months, or 6 months.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a9841c44254e779581a557e/file-0zkSitZXjX.png\"></p><p>\n\tThe <em>Schedule Confirmations </em>filter allows you to easily see tasks that have been confirmed not notified, pending, declined, and confirmed.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a984226de9db37df4024fe5/file-3cPMKPJWw3.png\"></p><p>\n\tThe \n\t<em style=\"background-color: initial;\">Colors</em>&nbsp;filter enables you to filter the project based&nbsp;on the color assigned to the task:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a9842a2de9db37df4024fe9/file-A6H4zMqGPQ.png\">The \n\t<em style=\"background-color: initial;\">Hide Completed&nbsp;</em>box to hide tasks and milestones you've already knocked out from view. A completed item is a task marked at 100% complete or a <a href=\"https://support.teamgantt.com/article/28-milestone\">milestone</a> that's been checked off.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a9842ea26f9ffe83c5d148d/file-oHXq9jC4Np.png\">Simply unselect the \n\t<em style=\"background-color: initial;\">Hide Completed</em>&nbsp;box&nbsp;to bring all your tasks and milestones back into view again!</p><p>\n\tYou'll know a filter is applied to your project when a number appears next to the \"Filter\" drop-down. You'll also see a prompt explaining which filters are applied.&nbsp;To clear all applied filters in a single click, simply select the&nbsp;&nbsp;<em style=\"background-color: initial;\">(x) </em>on the \"Filter\" drop-down:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a98435e9146944608cc8075/file-0Qh6d3uGOu.png\"></p><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Filters","number":24,"categories":["5f510e62c9e77c0016384617"]}},{"node":{"slug":"how-do-i-create-another-account-using-an-existing-teamgantt-log-in","text":"<h2>Can I use the same email address for more than one TeamGantt account?</h2><p>\n\t Yes, you can have multiple TeamGantt accounts under a single set of login credentials.&nbsp;To set it up, simply email us at support@teamgantt.com, and we'll&nbsp;establish a separate account with a free 14-day trial&nbsp;for you.&nbsp;</p><p>\n\t Want to access TeamGantt via your new account after the 14-day trial is up? Go to&nbsp;\n\t<em>Account Settings &gt; Plan Details&nbsp;</em>to&nbsp;upgrade to a paid subscription.</p><hr id=\"horizontalrule\"><p>\n\t Find out how to start a new project when you're a member of more than one TeamGantt account \n\t<a href=\"https://support.teamgantt.com/article/106-projects\">here</a>.</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Using One Email Address for Multiple TeamGantt Accounts","number":86,"categories":["57e9e78d9033602e61d4835c","6a021cfef97dd896ebfc81ba"]}},{"node":{"slug":"translate-teamgantt","text":"<h2>Does TeamGantt support multiple languages?</h2><p>\n\tYou can enter project and task details in any language in TeamGantt to ensure clear communication with your team. However, we only offer our software in English.</p><hr><h2>How can I translate TeamGantt’s menus and interface into another language?</h2><p>\n\t If you'd like to see the menus and other text on TeamGantt in another language, your best option is to use Google Chrome's live translate feature.&nbsp;You can find out more by visiting: \n\t<a href=\"https://support.google.com/chrome/answer/173424?hl=en\">Translate a page to your language</a>.</p><hr><h2>Can I export TeamGantt PDFs in other languages or character sets?</h2><p>\n\tYes. To choose a different alphabet for PDF exports, go to&nbsp;\n\t<em style=\"background-color: initial;\">PDF Settings &gt; Font Settings.&nbsp;</em></p><p>\n\t<em style=\"background-color: initial;\"></em>Currently, TeamGantt supports the following characters in PDF exports:</p><ul>\n\t\n<li>Chinese Simplified&nbsp;</li>\t\n<li>Chinese Traditional&nbsp;</li>\t\n<li>Japanese&nbsp;</li>\t\n<li>Korean<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a7de0a6714de94e758bb188/file-Yk8fM5OqzZ.png\"><em style=\"background-color: initial;\"><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/webinars/\">webinars</a>!&nbsp;</strong></em></li></ul>","name":"How can I translate TeamGantt?","number":29,"categories":["6a021cfef97dd896ebfc81ba"]}},{"node":{"slug":"workloads","text":"<h2>How do I use the <em>Workloads</em> report?</h2><p>\n\t<em style=\"background-color: initial;\">Workloads</em>&nbsp;was specifically designed for Managers and can be accessed from the left sidebar in the <em>Reports </em>section. This enables you to see the availability of every resource on the account&mdash;both users and labels.&nbsp;This dashboard is only available on the Business and Builder Edition plans.&nbsp;</p><p>\n\t The drop-down options across the top of the&nbsp;\n\t<em>Workloads</em>&nbsp;page&nbsp;allow you to:</p><ul>\n\t\n<li>Choose to display workloads as number of tasks or hours</li>\t\n<li>Toggle between day and week view</li>\t\n<li>Filter out users without assignments and tasks that have already been completed</li>\t\n<li>Export a PDF of your estimated tasks or hours per user</li></ul>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/byknf12z6m?videoFoam=true\" title=\"10_Review team workloads Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/672b91ca7c4c114a230aefd1/file-0jZn3wed2E.png\" style=\"background-color: initial;\"></p><p>\n\t The&nbsp; \n\t<em>Workloads</em>&nbsp;page works just like a&nbsp;project's <a href=\"https://teamgantt.helpscoutdocs.com/article/16-team-availability\"><em>View Availability</em></a><em>&nbsp;</em>window. Click on a cell to see details about the tasks/hours assigned to a particular user or label at any given time. Click on the task name to open its parent project in a new browser tab/window!&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/672b94437c22c57b1ca69bdf/file-bUE9GX356b.png\"></p><p>\n\tClick the blue Export CSV button in the upper right in order to export a CSV file of your workload data. You will be prompted to choose a date range before exporting your CSV file.&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/672b94a977f27013219ac37e/file-dT13xFXeLv.png\"></p><p>\n\t Tips:</p><ul>\n\t\n<li>Click on a user's name to see all tasks assigned to them across all projects.</li>\t\n<li>Any tasks shown as&nbsp;<em>Private&nbsp;</em>are simply tasks that exist in projects you're not invited to.</li>\t\n<li>Workload updates in real time! Simply drag and drop an assigned task to a new date in the gantt chart to see how it affects your team's workload.&nbsp;</li></ul><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Workloads Report","number":138,"categories":["5afb35e42c7d3a640ed6de95"]}},{"node":{"slug":"history-list","text":"<h2>Can you undo in TeamGantt?</h2><p>\n\tYes, TeamGantt takes the worry out of working in&nbsp;a collaborative environment by tracking project changes and making it easy to undo them.&nbsp;</p><hr><h2>Where can I see a history of all project changes?</h2><p>\n\tTo view play-by-play changes and updates to a project, go to the <i style=\"background-color: initial; font-size: 14px;\">History</i>&nbsp;tab at the top of your Gantt chart.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a959b8f0b3932344381fcac/file-xtUGjhi6me.png\"></p><hr><h2>How do I undo a change?</h2><p>\n\tReversing a change is as simple as clicking the \n\t<em>undo</em>&nbsp;link.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a959c4326f9ffe83c5d0b4c/file-JQmEMOtpGX.png\"></p><p>\n\t<strong style=\"background-color: initial; font-family: inherit; font-size: 21px;\">Note about undoing changes:</strong></p><p>\n\t<strong></strong>The <em>undo</em>&nbsp;feature works best for small individual changes, as undoing a complex project update may only restore partial information.&nbsp;</p><p>\n\tFor example, let's say someone deleted a task, and you want to bring it back to life. Undoing a task deletion will restore basic task info, like task name, percent complete, color, and dates, but not&nbsp;associated information, like comments, documents, assignments, or dependencies.&nbsp;</p><p>\n\t Please note that you cannot undo a document deletion at this time.</p><hr id=\"horizontalrule\"><p><em style=\"background-color: initial;\"><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p><p>\n\t<em><br>\n\t</em></p>","name":"Undo a Change","number":63,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"for-account-holders","text":"<p>As a&nbsp;manager with&nbsp;account admin status, you can access all projects within your account, even if the creator of the project did not invite you.&nbsp;This is a great way to keep track of projects created within the account.</p><hr><h2>How do I view all projects in my account?</h2><p>\n\t To see a full list of projects in your account, go to \n\t<em>My Projects </em>and&nbsp;click on the <em>other projects</em>&nbsp;link found below your projects list. You'll then be taken to your <em>Other Account Projects</em> list where you can access active, on-hold, and completed account projects created by members of your team.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a846abaaf9fffd6a8975eb9/file-iJnM62c2k5.png\">From here, you can add yourself to the project if you'd like. Just click on the&nbsp;\n\t<em style=\"background-color: initial;\">Join&nbsp;</em>button, and you're in!</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p><p>\n\t<strong></strong></p><p style=\"font-weight: bold;\"></p>","name":"Access All Projects on the Account (For Managers)","number":101,"categories":["57e9e78d9033602e61d4835c"]}},{"node":{"slug":"teamgantt-app-for-ios","text":"<ul>\n\t\n<h2>\n\t\n<p>\n\t\t<strong style=\"background-color: initial; font-family: inherit; font-size: 24px;\">Can I use TeamGantt on my iPhone?</strong>\n\t</p></h2><p>\n\tYes, TeamGantt for iOS lets you manage projects on the go right from your iPhone. You can update projects and communicate with your team directly from the mobile app.\n\t</p><p>\n\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5a563d17042863193800c4d9/file-9wyCCyg3zW.png\" alt=\"TeamGantt for iOS\" style=\"display: block; margin: 0px 0px 10px 10px; width: 229px; float: right;\">\n\t</p><hr>\n\t\n<h2><strong>How do I download the TeamGantt app for iOS?</strong></h2><p>\n\t To download TeamGantt's iPhone app:\n\t</p><ol>\n\t\t\n<li>Search <em>TeamGantt</em> in the <a href=\" https://itunes.apple.com/us/app/teamgantt/id1275159012?mt=8\">App Store</a>.</li>\t\t\n<li>Select <em>Get</em>.</li>\t\t\n<li>Launch the TeamGantt app by selecting <em>Open</em>.</li>\t</ol><hr>\n\t\n<h2>\n\t<strong style=\"background-color: initial; font-family: inherit; font-size: 21px;\">Do I need a TeamGantt account to use the iOS app?</strong></h2><p>\n\tYes, TeamGantt's mobile app is a free companion app for your TeamGantt account.&nbsp;Once you've downloaded the app, simply log in with your existing TeamGantt account credentials.\n\t</p><p>\n\tIf you don't have an existing TeamGantt account, you can create one in the iOS app.\n\t</p><hr>\n\t\n<h2>What can I do in&nbsp;TeamGantt's mobile app?</h2><p>\n\tTeamGantt's iOS app is ideal for updating projects and collaborating with your team.&nbsp;\n\t</p><p>\n\tFor full functionality, including creating new projects and updating account information, use our web app ( \n\t\t<a href=\"https://www.teamgantt.com/\">www.teamgantt.com</a>).\n\t</p><h3>\n\t\n<hr>\n\t</h3><h2><strong>How do I navigate TeamGantt's mobile app?</strong></h2><p>\n\t Navigate through the app using the left sidebar menu.\n\t</p><h3><strong>My Projects</strong></h3><p>\n\t Exactly like your&nbsp; \n\t\t<em>My Projects </em>page on TeamGantt.com, <em>My Projects </em>will show you a list of all projects you're currently invited to in the account. Toggle between Active, On Hold, and Complete projects.&nbsp;\n\t</p><p>\n\t To view and update a project, simply select the project from the \n\t\t<em>My</em>&nbsp;<em>Projects</em>&nbsp;list. Alternatively, you can click directly into any of your <em>Active </em>projects listed under <em>Projects </em>in the sidebar.&nbsp;Your <a href=\"https://support.teamgantt.com/article/5-permissions\">permission level</a> with each project is the same as in <a href=\"https://teamgantt.com/\">TeamGantt.com</a>.&nbsp;\n\t</p><h4>\n\tWithin a project you can:</h4><ul>\n\t\t\n<li>Expand and collapse task groups</li>\t\t\n<li>Add a new group of tasks</li>\t\t\n<li>Drag and drop tasks to reorder them</li>\t\t\n<li>Update the task view to show as a percentage or a checkbox</li>\t\t\n<li>Update the task view to hide completed tasks</li>\t</ul><h4>\n\tWithin a task you can:</h4><ul>\n\t\t\n<li>Update task names</li>\t\t\n<li>Assign existing people and labels to the task</li>\t\t\n<li>Update % complete</li>\t\t\n<li>Update task dates</li>\t\t\n<li>Edit checklists</li>\t\t\n<li>Leave comments</li>\t\t\n<li>Attach files and images</li>\t\t\n<li>Change task colors</li>\t\t\n<li>Add estimated hours (Business and Builder Edition plans only)</li>\t\t\n<li>Track time (Business and Builder Edition plans only)</li>\t\t\n<li>Delete tasks</li>\t</ul><h3><strong>My Tasks</strong></h3><p>\n\t The app’s default view is the \n\t\t<em>My Tasks</em> page. This page shows all tasks, across all active projects, that are currently assigned to you.\n\t</p><h3><strong>Discussions</strong></h3><p>\n\t The \n\t\t<em>Discussions</em> page allows you to view and respond to active comment threads. You can toggle between discussions on all projects you are invited to (<em>All Projects</em>), discussions on tasks specifically assigned to you (<em>My Tasks</em>), and discussions on starred projects (<em>Starred</em>).\n\t</p><p>\n\t Start a new discussion on any of your projects by selecting the (+) at the upper right corner of the screen.\n\t</p><h3> Calendar</h3><p>\n\t Get a running list of all of current tasks across all of your projects with the mobile-only \n\t\t<em>Calendar page</em>.&nbsp;\n\t</p><h3><strong>Settings</strong></h3><p>\n\t Choose which \n\t\t<em>Notifications</em> you would like to receive from the app. Currently, the only notification available is <em>Mentioned in Comments</em>. We anticipate launching more notification types in the near future.\n\t</p><p>\n\t You can also choose to \n\t\t<em>Logout</em> from your TeamGantt account.\n\t</p><hr>\n\t\n<h3><strong>FAQs</strong></h3><ul>\n\t\t\n<li><em style=\"background-color: initial;\">Can I view the project in a gantt or calendar view?&nbsp;</em>\n\t\t\n<ul>\n\t\t\t\n<li>Currently, a simple list view is the only way to view projects within the mobile app. To view your projects in a gantt or calendar format, log in to your account via <a href=\"https://teamgantt.com/\">TeamGantt.com</a>.</li>\t\t</ul></li>\t\t\n<li><em style=\"background-color: initial;\">Do I have to pay for the app?&nbsp;</em>\n\t\t\n<ul>\n\t\t\t\n<li>Nope! The TeamGantt companion app is completely free and can be used with any TeamGantt plan.</li>\t\t</ul></li>\t\t\n<li><em style=\"background-color: initial;\">Can I update a project’s status from the app?&nbsp;</em>\n\t\t\n<ul>\n\t\t\t\n<li>At this time, project status (<em>Active</em>, <em>On Hold</em>, or <em>Complete</em>) has to be updated using <a href=\"https://teamgantt.com/\">TeamGantt.com</a></li>\t\t</ul></li>\t\t\n<li><em style=\"background-color: initial;\">Can I update my account from the app?</em>\n\t\t\n<ul>\n\t\t\t\n<li><em style=\"background-color: initial;\">&nbsp;</em>Updating <em style=\"background-color: initial;\">Account Settings</em>, such as adding/managing users and updating billing information has to be done using <a href=\"https://teamgantt.com/\">TeamGantt.com</a></li>\t\t</ul></li>\t\t\n<li><em style=\"background-color: initial;\">Will the app automatically sync changes to </em><a href=\"https://teamgantt.com/\"><em>TeamGantt.com</em></a><em style=\"background-color: initial;\">?&nbsp;</em>\n\t\t\n<ul>\n\t\t\t\n<li>Yes! All changes made in the app are reflected in real-time on <a href=\"https://teamgantt.com/\">TeamGantt.com</a>. This is also true for projects that are integrated with Trello or Basecamp 2.</li>\t\t</ul></li>\t\t\n<li><em style=\"background-color: initial;\">How do I change a task’s color?</em>\n\t\t\n<ul>\n\t\t\t\n<li>To change a task’s color, open the task and select “&hellip;” from the upper right-hand corner of your screen.</li>\t\t</ul></li>\t\t\n<li><em style=\"background-color: initial;\">How do I set dependencies?</em>\n\t\t\n<ul>\n\t\t\t\n<li><em style=\"background-color: initial;\"></em>At this time, dependencies can only be viewed and added to tasks using <a href=\"https://teamgantt.com/\">TeamGantt.com</a>.&nbsp;</li>\t\t</ul></li>\t\t\n<li><em style=\"background-color: initial;\">How do I view Availability from the app?</em>\n\t\t\n<ul>\n\t\t\t\n<li><em style=\"background-color: initial;\"></em>The best way to view team availability is within <a href=\"https://teamgantt.com/\">TeamGantt.com</a>.</li>\t\t</ul></li>\t</ul><hr>\n\t\n<p>\n\t\t<em>Have more questions about the TeamGantt app? Reach out to the Customer Success Team any time by emailing support@teamgantt.com!</em>\n\t</p><hr>\n\t\n<p>\n\t\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em>\n\t</p></ul>","name":"TeamGantt App for iOS","number":121,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"exporting-your-project-gantt-list-calendar-views","text":"<p>\n\tTeamGantt gives you&nbsp;3 options for printing&mdash;or exporting a printable PDF&mdash;of your project:</p><ul>\n\t\n<li>Gantt view</li>\t\n<li>List view</li>\t\n<li>Calendar view</li></ul><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a971ca00b393234438201ef/file-wNZ2xIfYeT.png\">Gantt view will always be the default view when opening a project. You can find the other view options in the top navigation bar of your project:&nbsp;</p><h3>How do I print my project Gantt chart?</h3><p>Gantt view is the default view for your project. This view allows for easy drag-and-drop scheduling and is the go-to for project planning. It's&nbsp;also the only view where you can see \n\t<a href=\"https://support.teamgantt.com/article/16-team-availability\" style=\"font-size: 14px;\">team availability</a> information.&nbsp;</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a971cf4de9db37df4024c1b/file-JZVyxx10lI.png\">To print or export a project's gantt view&nbsp;to PDF, go to&nbsp;\n\t<em style=\"background-color: initial;\">Menu &gt; Print/Export PDF.&nbsp;</em>(Learn more about <a href=\"https://support.teamgantt.com/article/45-what-information-will-be-on-my-pdf\">PDF options and customizations</a>.)</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a971d5d26f9ffe83c5d10a2/file-pYSsVGmVyf.png\"></p><h3>How do I print my project task list?</h3><p>List view displays your project details in list format. This easy-to-read option is great for meetings and project review and&nbsp;is the only view that displays start and end date columns for each task.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a971db10b393234438201f3/file-LAbUeCFvLy.png\"></p><p>\n\tTo print a project's&nbsp;list view (or export it to PDF), go to&nbsp;\n\t<em style=\"background-color: initial;\">Menu &gt; Print List View<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a971de94254e779581a5188/file-zjxBsUKgrC.png\"></em></p><p>\n\t<em style=\"background-color: initial;\"><br>\n\t</em></p><hr><h3>How do I print my project calendar?</h3><p>Calendar view displays your project data in a calendar format. This view is ideal for seeing how tasks stack up on a particular day, week, or month. You can see previous and upcoming months by toggling the \n\t<i style=\"background-color: initial; font-size: 14px;\">This Week</i> filter at the top of the calendar.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a971e104254e779581a518a/file-VcBgSlIK5E.png\"></p><p>\n\tTo print a project's calendar&nbsp;(or export this view to PDF), go to&nbsp;&nbsp;\n\t<em>Menu &gt; Print Calendar view.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a971e7fde9db37df4024c20/file-4JXhCu7Hrt.png\"></em></p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Print Your Project in Gantt, List, or Calendar View","number":133,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"checklists","text":"<p>\n\t Do some of your tasks involve multiple steps or simply need more detail? Good news! TeamGantt's checklist feature makes it easy to give your team clear direction on any task. Here's how it works.</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/x846pk2xp8?videoFoam=true\" title=\"11_Add a checklist Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><h3> </h3><hr id=\"horizontalrule\"><h2>How do I add a checklist to a task?</h2><p>\n\t TeamGantt gives you 2 different options for adding checklists to a task.</p><h3> <strong> Option 1: From your&nbsp;<em>My Tasks</em> tab:&nbsp;</strong></h3><ol>\n\t\n<li>Hover over a task, and click the checklist icon that appears under the task name to open the checklist window.&nbsp;</li>\t\n<li>Add your checklist item, and hit&nbsp;<em>Enter </em>on your keyboard.&nbsp;The checklist item you just added&nbsp;will automatically&nbsp;save, and a new checklist item will appear under it.&nbsp;</li>\t\n<li>As each checklist item gets knocked out, simply check the box the left of the item to mark it as complete.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67224ac0f539bb6e3c7c70d8/file-kRA4Xf5uAr.png\"></li></ol><h3>\n<strong style=\"background-color: initial; font-family: inherit; font-size: 21px;\">Option 2: From the gantt chart view:&nbsp;</strong></h3><ol>\n\t\n<li>Hover over a task, and click on the checklist icon that appears to the right of the task name.</li>\t\n<li>Add your checklist item, and hit&nbsp;<em>Enter&nbsp;</em>on your keyboard.&nbsp;The&nbsp;checklist item&nbsp;you just added&nbsp;will automatically&nbsp;save, and a new checklist item will appear under it.&nbsp;</li>\t\n<li>As each checklist item gets knocked out, simply check the box the left of the item to mark it as complete.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67224b53c8770a0e6b6588c0/file-XMQ57nYE1z.png\"></li></ol><p>\n\t<strong style=\"background-color: initial;\">Note</strong>:&nbsp;Any user in the project will have <em style=\"background-color: initial;\">View</em> access to your checklist.&nbsp;&nbsp;</p><hr><h2>How do I duplicate a task checklist?</h2><p>\n\tChecklists can be duplicated by \n\t<a href=\"https://support.teamgantt.com/article/26-duplicating-a-group\">duplicating a task or task group</a> that has a checklist associated with it.&nbsp;</p><p>\n\t Additionally, you can duplicate checklists when you duplicate a project or create a new project from a template. Click \n\t<a href=\"https://support.teamgantt.com/article/111-duplicate-a-project\">here</a> for more info on duplicating projects.</p><hr><p>\n\t<strong>Do you need a higher level of detail? Check out our <a href=\"https://support.teamgantt.com/article/120-markdown-formatting-for-comments\">to-do list option using markdown</a>!</strong></p><p>\n\t<strong><em style=\"background-color: initial;\">To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">classes</a>!&nbsp;</em> </strong></p>","name":"Checklists","number":115,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"use-a-template","text":"<h3>How do I use a template to create a new project?</h3><p>\n\t Starting a new project with a template is easy! Here's how:</p><p>\n\t 1. Go to \n\t<em>My Projects </em>(in the left sidebar menu)<em>&nbsp;</em>and select&nbsp;<em>New Project &gt; Create a New Project.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a905adc9f65cc0cc64d67d3/file-p3G8pA28vR.png\"></em>2. Click the <em style=\"background-color: initial;\">Template</em> field to open the full template drop-down list and choose a template. Or, click the&nbsp;<i style=\"background-color: initial;\">Preview templates&nbsp;</i>link to see what the different templates look like before choosing one.&nbsp;</p><p>\n\tIf you select the&nbsp; \n\t<em style=\"background-color: initial;\">Preview templates </em>link, a new window will pop up.&nbsp;Select a template option from the list on the left to see a preview on the right.&nbsp;</p><p>\n\t Then, click&nbsp; \n\t<em>Use Template </em>to apply the template to your new project.</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/65f1d955c7af9d69c480af09/file-YmRsgmDqEK.png\">3.&nbsp;Once you’ve chosen a template, enter a start date for your project. If you leave it blank, the project start date defaults to the current date. You can also choose which days of the week you'd like to include in your project.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a905b239f65cc0cc64d67d5/file-oIxJTcsV7i.png\">4.&nbsp;Choose the details you want to import from the template. (Note: We recommend enabling all import options if you're using one of our pre-built templates for the first time.)<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a905b73d926334a741edf27/file-8QFA3ipY4H.png\"></p><p>\n\t5.&nbsp;Complete the rest of the new project details, then click \n\t<em style=\"background-color: initial;\">Create new project</em> to go to your gantt chart.</p><h3><hr>\n</h3><h3>Can I create templates for recurring projects?</h3><p>\n\tYes, TeamGantt makes it easy to save your project as a template if you create the same kinds of projects over and over again. That way, you don't have to build a project from scratch every time.&nbsp;</p><p>\n\t Here's \n\t<a href=\"https://support.teamgantt.com/article/19-templates\">how to save a project as a template</a>:</p><ol>\n\t\n<li>Open the project.&nbsp;</li>\t\n<li>Go to <em>Menu &gt; Save as Template.</em></li></ol><p>\n\t It’s as simple as that!&nbsp;</p><p>\n\t Once you’ve saved a project as a template, you can access it anytime under \n\t<em>My Templates</em> in the Templates drop-down or under <em>Team Templates</em> on the templates hub page when creating a new project.</p><hr><h3>How do I apply pre-built templates to a new project?</h3><p>\n\t Ever wish you could speed up the project planning process? Good news!&nbsp;We're now offering pre-built templates in the following categories:</p><ul>\n\t\n<li>Getting Started</li>\t\n<li>Marketing &amp; Design</li>\t\n<li>Development &amp; Engineering</li>\t\n<li>Industry-specific</li>\t\n<li>Admin</li>\t\n<li>Personal</li></ul><p>\n\t Access pre-built templates anytime under \n\t<em>Default</em><em style=\"background-color: initial;\">&nbsp;Templates</em>&nbsp;in the Templates drop-down or under <em>Project</em><em style=\"background-color: initial;\">&nbsp;Templates</em>&nbsp;on the templates hub page when creating a new project.</p><h4>Here are the gantt chart templates available at your fingertips now:</h4><ol>\n\t\n<li><strong>Blank Project: </strong>This one’s been a standard go-to in TeamGantt for a while now, but it’s worth mentioning. Start fresh with an empty project you can make your own. The possibilities are endless!</li>\t\n<li><strong>Basic Project:</strong>&nbsp;This template has also been available as an option on TeamGantt for a while. We’ve plugged in some basic project elements so you can get a jumpstart on project planning.</li>\t\n<li><strong>Get Started with TeamGantt:&nbsp;</strong>If you’re new to TeamGantt, this is a great place to start. More tutorial than template, each task walks you through a simple action so you can learn how TeamGantt works before diving into your own project.</li>\t\n<li><strong>Website Design:</strong> Use this template for agency web projects or websites that go beyond the basics. You’ll find tasks for video and photography, plus milestones for client review and approval.</li>\t\n<li><strong>Website Design (Simple):</strong>&nbsp;Plan your website without extra bloat using this template. Keep your plan simple, or build it out to cover your project bases. This one’s perfect for internal web projects.</li>\t\n<li><strong>Content Calendar:</strong> Many creative teams publish a steady stream of content and are always on deadline. This gantt chart example is structured like an editorial calendar so it’s easy to see what’s coming up next on the schedule.&nbsp;</li>\t\n<li><strong>Blog Content Calendar:&nbsp;</strong>A blog calendar is an organized plan for publishing content on your blog. This helps you establish a regular posting schedule and strategize topics so content stays fresh and engaging.</li>\t\n<li><strong>Video Production</strong>: Create videos right on schedule with ready-made tasks that take you from pre- to post-production.</li>\t\n<li><strong>Event Plan</strong>: Use this template to stay on top of all the little details for your next corporate event. Keep all your tasks organized and on track so every event you plan goes off without a hitch.</li>\t\n<li><strong>Conference Event Plan:&nbsp;</strong>Make your conference a big success! Use this template to plan and manage all the logistics that go into a large-scale event.</li>\t\n<li><strong>Event Marketing &amp; Promotion:</strong>&nbsp;An event won’t be successful if no one shows up. Use this gantt chart example to boost registration and attendance numbers before your event.&nbsp;</li>\t\n<li><strong>Digital Marketing Plan:&nbsp;</strong>Build out every aspect of your digital marketing strategy in one easy-to-use plan so you can turn your vision into action and keep stakeholders in the loop.</li>\t\n<li><strong>Strategic Marketing Plan:&nbsp;</strong>Writing your first marketing plan can feel daunting, so this example gives you an easy place to start. It lays out the tasks you’ll need to tackle to develop a solid marketing plan, with space to document high-level strategic objectives.&nbsp;</li>\t\n<li><strong>Social Media Schedule:</strong>&nbsp;Build out your social media calendar with this easy-to-use template. Schedule posts for each day of the week across all your social media channels.</li>\t\n<li><strong>Social Media Strategy Plan:</strong>&nbsp;Get your social media strategy off the ground with this template. It’s the perfect place to plan and track your major social campaigns.</li>\t\n<li><strong>Digital Marketing Campaign:</strong> Launch and execute your next digital campaign by creating a streamlined plan across all your important marketing channels.</li>\t\n<li><strong>Tactical Marketing Plan:</strong>&nbsp;Schedule and track the key tasks that need to get done to ensure your team hits your marketing goals right on target.</li>\t\n<li><strong>Marketing Schedule:&nbsp;</strong>Track go-live dates for important marketing deliverables by creating a simple schedule your team can share.</li>\t\n<li><strong>Software Developmen</strong><strong>t Plan</strong>: Taking a hybrid approach to a software project? Use this simple template to track Agile sprints without losing sight of the timeline.&nbsp;</li>\t\n<li><strong>Product Roadmap:&nbsp;</strong>Strategic planning is just as important as sprint planning. This gantt chart sample enables you to lay out a long-term strategy for your software product so you can communicate and keep track of product goals and initiatives.&nbsp;</li>\t\n<li><strong>Bug Tracker:</strong> If you use a gantt chart to plan software products, why not use it to track bugs too? This example gives your team an easy place to submit bug reports so developers can get to the bottom of issues quickly.</li>\t\n<li><strong>Product Backlog:&nbsp;</strong>Keep a running list of user stories, feature enhancements, and software bugs so you can continue to make your product better.&nbsp;</li>\t\n<li><strong>Construction</strong>:&nbsp;Break ground on your next construction schedule with this quickstart template. Keep your plan high-level, or dig into details with a full project build-out. </li>\t\n<li><strong>Weekly Task List:&nbsp;</strong>Make setting up your weekly to-dos a breeze with this simple task list template.</li>\t\n<li><strong>Out of Office</strong>: Create a shared space for your team to log vacation and sick days so it’s easy to track paid time off and everyone’s in the loop about team availability.</li>\t\n<li><strong>Moving Plan</strong>:&nbsp;Keep a running list of all the to-dos that go into moving, and create a schedule you can stick to so you have plenty of time to get it all done.</li></ol><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Use a Template to Create a New Project","number":137,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"resetting-your-password","text":"<h2>How do I recover my password?</h2><p>\n\t Resetting your TeamGantt password is simple. Visit \n\t<a href=\"https://app.teamgantt.com/forgot-password\">https://app.teamgantt.com/forgot-password</a></p><p>\n\t Enter the email address you use to log into&nbsp;TeamGantt, and click&nbsp;\n\t<em>Reset Password</em>. An email will be sent to you with instructions on how to reset your password. Please note: Your password will not update until you&nbsp;complete the steps in the email.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a7c989c73778c51e837e473/file-Z2rZRyiti3.png\">If you have trouble resetting your password, please email \n\t<a href=\"mailto:support@teamgantt.com\">support@teamgantt.com</a> using the email address associated with your account.&nbsp;</p><hr><p>\n\t<strong>Note</strong>: Requests for password resets that come from an email address other than the one on file for your account will be declined.&nbsp;</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Reset Your Password","number":85,"categories":["57e9e78d9033602e61d4835c"]}},{"node":{"slug":"updatingyourbillinginformation","text":"<h2>How do I change my billing information?</h2><h3>Update payment method on file</h3><p>\n\t You can change your payment information at any time.&nbsp;</p><p>\n\tAny manager with account admin status can go to&nbsp;\n\t<em style=\"background-color: initial;\">Account Settings &gt; Plan Details&nbsp;</em>to&nbsp;update your payment method.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a846bda3db50143df5c853e/file-AYKFReaFEX.png\">Update the billing contact for e-receipts</p><p>\n\tTo update who receives your team's e-receipts, please email \n\t<a href=\"mailto:billing@teamgantt.com\">billing@teamgantt.com</a>. Currently, our system can only accommodate one email address at a time, and e-receipt recipients cannot be adjusted from within the application.</p><h2>How do I access company invoices?</h2><p>\n\t For your convenience, invoices are available online to Managers with account admin status at any time. To access all invoices, simply log into TeamGantt, and go to \n\t<em>Account Settings</em> &gt; <em>Plan Details</em><em>.<strong>&nbsp;</strong></em></p><h3>\n<em><strong></strong></em><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6819053f46d90100d67460a5/file-Rfoyw5rnzU.png\">How do I edit company invoices?</h3><p>\n\tTo edit your invoices, you can contact support at support@teamgantt.com or&nbsp;+1 888.417.9380.</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Access and Update Billing Information & Invoices","number":113,"categories":["57e9e78d9033602e61d4835c"]}},{"node":{"slug":"disabling-the-teamgantt-basecamp-sync","text":"<p>\n\t If you no longer want changes in Basecamp 2 to update the corresponding project in TeamGantt (or vice versa), you'll need to turn off the sync between the two programs.&nbsp;</p><p>\n\t<strong>Note:</strong>&nbsp;If you disable the sync between a Basecamp project and a&nbsp;TeamGantt project, there's no way to re-establish the sync between the two. Syncing the Basecamp project again will create a new project in TeamGantt.</p><hr><h2>How do I disable the sync between TeamGantt and Basecamp 2?</h2><p>\n\tTo disable the sync, simply follow these steps:</p><p>\n\t1) Go to <em>Account Settings &gt; Integrations &gt; Manage Basecamp Projects</em>.</p><p>\n\t 2) Click \n\t<em>Turn off Sync</em>&nbsp;for any&nbsp;project(s) you'd like to unsync.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5368051be4b0d833740d4830/file-EFhng7AizX.png\"></p><p>\n\t Once the sync has been disabled, changes in TeamGantt will no longer affect your Basecamp 2 project&nbsp;information, and Basecamp 2 updates won't affect your TeamGantt projects.&nbsp;</p><hr><p>\n\t<br>\n\t Have other questions about our Basecamp 2 integration? Just email support@teamgantt.com! Or check out one of our other articles about Basecamp:</p><ul>\n\t\n<li><a href=\"https://support.teamgantt.com/article/37-basecamp\">Establishing the Sync</a> </li>\t\n<li><a href=\"https://support.teamgantt.com/article/84-integration-errors-and-resolutions\">Basecamp Troubleshooting</a></li></ul><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Disabling Sync with Basecamp 2","number":54,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"bookmarks","text":"<p>\n\t Got a favorite project or view? Or do you apply the same filters every time you open a project? You're in luck! TeamGantt's bookmark and homepage features enable you to get to your favorites faster!</p><p>\n\tLet's take a closer look.</p><hr><h2>How do I bookmark a page?</h2><p>\n\t Saving your preferences as a bookmark is a great way to create a custom view for one (or all) of your projects.</p><p>\n\t Follow these easy steps to create a bookmark:</p><ol>\n\t\n<li>First, apply your preferred settings and/or filters to your project. (See more on filtering <a href=\"https://support.teamgantt.com/article/24-filters\">here</a>.)</li>\t\n<li>Click your&nbsp;<em>Profile</em> icon in the bottom left of the sidebar.&nbsp;&nbsp;</li>\t\n<li>Select <i style=\"background-color: initial;\">Bookmark Page</i>&nbsp;from your&nbsp;<em>Profile</em>&nbsp;menu.</li></ol><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a905882d926334a741edf1c/file-hXJqIHtYMO.png\">Once you create a bookmark, it will show up on your bookmark list, which is always accessible from your \n\t<em style=\"background-color: initial;\">Profile</em> icon. Feel free to create as many bookmarks as you like!</p><p>\n\tTo remove a bookmark, hover over the bookmark name, and click the small \"\n\t<em>x</em>\" to the right.&nbsp;</p><p>\n\t<strong>Note: </strong>Bookmarks are user, not account, specific.&nbsp;</p><hr><h2>How do I bookmark a report?</h2><p>\n\tAny time that you filter a report in a way that you like and save it as a bookmark, it will appear under \n\t<em>Bookmarked Reports.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a9059cfd926334a741edf1f/file-7CIPXP0FuK.png\"></em></p><hr><h2>How do I set a new default homepage?</h2><p>\n\t The \n\t<em>My </em><em>Projects </em>tab is the default homepage for all TeamGantt accounts. But you can change it to whatever page or view you like! For example, you might want to&nbsp;set the&nbsp;<em style=\"background-color: initial;\">My Tasks&nbsp;</em>tab as your homepage so you can see exactly what you need to work on every time you open your TeamGantt account.</p><p>\n\tChanging your homepage is as easy as 1-2-3! Here's how:</p><ol>\n\t\n<li>Go to the page or project you'd like to set as your homepage.</li>\t\n<li>Click your <i style=\"background-color: initial;\">Profile</i> icon in the bottom left of the sidebar.</li>\t\n<li>Select <i style=\"background-color: initial;\">Set as Homepage</i>&nbsp;from your&nbsp;<i style=\"background-color: initial;\">Profile</i>&nbsp;menu.</li></ol><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a905a2ad926334a741edf23/file-mhKomDECs4.png\">Voilà! Your new homepage is all set!</p><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">classes</a>!&nbsp;</strong></em></p>","name":"Bookmark a Page","number":90,"categories":["5284df24e4b027e0d843bca8"]}},{"node":{"slug":"raci-assigning-task-roles","text":"<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/s82os1phkn?videoFoam=true\" title=\"RACI Chart Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><p>\n\t Want to clear up confusion about who’s doing what on your project? TeamGantt’s RACI feature makes it easy to assign roles so everyone knows who’s Responsible, Accountable, Consulted, and Informed on each task.</p><p>\n\t With RACI, you can easily indicate the responsibility level for each user on every task, then keep those roles in view while you’re working on your project. This helps eliminate confusion and clarify exactly what everyone needs to do.</p><p>\n\t Looking for more context? \n\t<a href=\"https://www.teamgantt.com/blog/raci-chart-definition-tips-and-example\">Learn all about the RACI methodology and how to use RACI charts to map out roles and responsibilities.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6717b36444628317ef905833/file-3lHnc2g8L4.png\"></a></p><hr><h2>How do I access the RACI chart for my project?</h2><p>\n\t The RACI feature is only available on our Business and Builder Edition plans.&nbsp;</p><p>\n\t You must have manager permission on the project to edit the RACI chart. Users with collaborator permission can view the RACI chart but won’t be able to edit it.&nbsp;</p><p>\n\t To access the RACI chart, open your project, and toggle to the RACI tab in the top navigation bar.&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6717b3aa15d0b82233065a24/file-BR1SLrdlSs.png\"></p><p>\n\tThis will display all your project tasks in a list format (rows). On the right side of the chart, you’ll see a column for each user currently invited to the project with cells for each task in the project.&nbsp;</p><hr><h2>How do I assign RACI roles to tasks in my project?</h2><p>\n\t Assigning RACI roles to your project tasks is easy! Simply click the cell below each person who needs to be assigned a role on a task, and choose one of the RACI options from the drop-down. You can also clear existing RACI assignments here.\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6717b3e58af27b34842c06ce/file-vNmzDHjDCd.png\"></p><h3>\nHere’s a quick explainer of each RACI role available:&nbsp;</h3><h4>\nR - Responsible</h4><p>\n\t This team member does the work to complete the task. Every task needs at least one Responsible party, but it’s okay to assign more.</p><h4>\nA - Accountable</h4><p>\n\t This person delegates work and is the last one to review the task or deliverable before it’s deemed complete. On some tasks, the Responsible party may also serve as the Accountable one. Just be sure you only have one Accountable person assigned to each task or deliverable.</p><h4>\nC - Consulted</h4><p>\n\t Every deliverable is strengthened by review and consultation from more than one team member. Consulted parties are typically the people who provide input based on either how it will impact their future project work or their domain of expertise on the deliverable itself.</p><h4>\nI - Informed</h4><p>\n\t These team members simply need to be kept in the loop on project progress, rather than roped into the details of every deliverable.</p><hr><h2>Can I assign RACI roles from the group/task details window?</h2><p>\n\tYes, you can also assign RACI roles via the group or task details window. To open this window, simply hover your cursor over the group or task and click the details icon.&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6717b4286d43ca7b17b2c2c1/file-hbPJbWs31i.png\"></p><p>\n\tOnce the group or task details window is open, simply click on the RACI tab to start assigning roles. From this view, you are able to assign multiple roles to a single user.\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6717b4c715d0b82233065a25/file-kS4IQpDspT.png\"></p><hr><h2>Where can I see RACI assignments in my gantt chart?</h2><p>\n\t If a user is assigned to a task and has a RACI role on that task, the RACI value will appear in parentheses next to the user’s name on the gantt chart.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6143542212c07c18afdd4a88/file-pTLYeFbbZ7.jpg\"></p><p>\n\t<strong style=\"background-color: initial;\">Note:</strong> If a user’s been given a RACI role for a task but hasn’t been assigned to that task, their name won’t appear next to the task in Gantt view. You can always see your project’s full RACI chart by toggling to the RACI tab in the top navigation.</p><p>\n\t<strong>Pro tip:</strong> The best way to see all users assigned to project tasks on your gantt chart is by selecting the View drop-down menu and toggling on the Show Resource names next to bars option.&nbsp;</p><hr><p>\n\t<strong><em>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</em></strong></p>","name":"RACI (Assigning task roles)","number":155,"categories":["5284de2fe4b027e0d843bc97","526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"project-start-and-end-dates","text":"<p>\n\tLooking to indicate where your project starts and ends? Here's how!</p><hr id=\"horizontalrule\"><h2>How do I add start and end dates in TeamGantt?</h2><p>\n\tThere's no option for formally setting a start and end date for your project. A project's start date is simply wherever the first \n\t<a href=\"https://support.teamgantt.com/article/4-adding-tasks#scheduling-tasks\">task is scheduled</a> to begin. The end date is where the last task is scheduled to end.&nbsp;</p><p>\n\tIf you'd like to call attention to important dates, like a project's kickoff or finally delivery, we recommend using \n\t<a href=\"https://support.teamgantt.com/article/28-milestone\">milestones</a>.&nbsp;&nbsp;</p><hr><h2>How do I set a start date for my gantt chart?</h2><p>\n\tThe first time you create a project, a couple of extra months will be immediately available at the front of your timeline. There is no way to delete extra months from your timeline, but don't worry! Once you've begun to schedule tasks, your project will open up to the right spot the next time you open it up.&nbsp;</p><ul>\n\t\n<li>If your first task is scheduled in the past or present, the project will open up to \"Today\" (indicated by a light blue line in your timeline).&nbsp;</li>\t\n<li>If your first task is scheduled for future date, the project will open up to the date where that first task begins.&nbsp;</li></ul><p>\n\tIf you'd like to change the general start of your timeline, you can do so in \n\t<em>Menu &gt; Project Settings &gt; Start of Gantt. (</em>Note: This does not impact your scheduled tasks.)</p><hr><h2>How do I move my entire project to a new start date?</h2><p>\n\tIf you've already started scheduling out your project and the start date changes, no problem! You can move your entire project forward (or backward) in time, with click and drag.&nbsp;</p><p>\n\tAt the top of your project, you'll find a thin, gray bar to the right of the project&nbsp;title that spans the entire length of the project. Simply slide the bar forward or backward to reschedule your project in its entirety.\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/670934838af27b34842c0040/file-m6i7002CjY.png\"></p><p>\n\t<strong style=\"background-color: initial;\">Helpful tip</strong>: Projects can be long, so you may find it easier to zoom out a bit first. To zoom out, navigate to the upper right side of your timeline and select the <em style=\"background-color: initial;\">Zoom </em>drop-down. We typically recommend zooming out to <em style=\"background-color: initial;\">Week View</em> at 60% for maximum drag room.&nbsp;</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/webinars/\">webinars</a>!</strong></em></p>","name":"Project Start and End Dates","number":146,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"integration-errors-and-resolutions","text":"<h2>How do I re-authenticate the TeamGantt/Basecamp 2 sync?</h2><p>\n\t A number of factors can affect the TeamGantt/Basecamp 2 sync. If&nbsp;this happens, you'll receive a pop-up message like the&nbsp;one below. \n\t<strong>It’s important to avoid making any changes to your project in&nbsp;TeamGantt until the sync is re-authenticated.&nbsp;</strong></p><p>\n\t The good news is, re-authenticating the sync is easy! Simply ask the person who originally established the integration (maybe that's you!) to open TeamGantt, and go to&nbsp;\n\t<i style=\"background-color: initial;\">Account Settings &gt; Integrations &gt; Manage Basecamp Projects &gt; Re-Authenticate with Basecamp. </i>That should&nbsp;resolve the issue immediately.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5570906be4b027e1978e5316/file-sXZkiikwoB.png\" style=\"width: 563px;\"></p><hr><h2>Why are notifications coming from the wrong person?</h2><p>\n\t Is John making updates to your project,&nbsp;but the email notification comes from Jane? There's a quick and easy way to resolve this mismatch immediately and permanently. Simply ask each member of your team to log into TeamGantt, and go to&nbsp;\n\t<em>Account Settings &gt; Integrations &gt; Manage Basecamp Projects &gt; Re-authenticate with Basecamp.</em>&nbsp;Once that's done, you’re all set!</p><hr><h2>Which version of Basecamp does TeamGantt sync with?</h2><p>\n\t<g>\n\tCurrently, we\n\t</g>&nbsp;only support an integration with Basecamp 2.</p><hr><h2>Do documents uploaded in TeamGantt sync with Basecamp?</h2><p>\n\t Because of the way information flows back and forth between programs, documents uploaded to TeamGantt do not appear in Basecamp, and vice versa. If you need to have the same&nbsp;documents in&nbsp;both TeamGantt and Basecamp, be sure you upload the document(s) to each program separately.</p><hr><h2>My accounts are properly synced. Why can't I create a new project in TeamGantt from an existing Basecamp project?</h2><p>\n\t This is most likely a result of your TeamGantt account-level permission.&nbsp;</p><p>\n\t In TeamGantt, only Managers can create new projects. When a sync is properly established, either of these permission statuses will allow a user to sync an existing Basecamp project to a newly created TeamGantt project.&nbsp;</p><p>\n\t Collaborators, on the other hand, do not have permission to create a new project in TeamGantt, regardless of the account’s sync with Basecamp.</p><p>\n\t<em>For more information regarding permissions, </em><em><a href=\"http://teamgantt.helpscoutdocs.com/article/5-permissions\">check out this support doc</a>.</em></p><hr><h2>Can I choose which content to sync from Basecamp to TeamGantt?</h2><p>\n\t When a project in Basecamp is synced with TeamGantt, all the \n\t<em>To-dos</em> will sync to the TeamGantt project. This includes any hidden or private Basecamp <em>To-dos</em>. Right now, it's not possible to pick and choose which project information syncs.</p><p>\n\t<strong>Tip:</strong>&nbsp;If a project has sensitive information you don't want a&nbsp;client to see, instead of creating 1 project in Basecamp and hiding tasks, we recommend creating 2 projects: one that contains all public information and one that contains all private information. Then sync both projects to TeamGantt. Clients can be invited as users to the public project, while maintaining the security and privacy of the non-public information.&nbsp;</p><hr><h2>Do all Basecamp users need to also be TeamGantt users?</h2><p>\n\t Yes. For the sync to work properly, all users in Basecamp should be imported to TeamGantt when you initially establish the sync.</p><hr><h2>How does Basecamp 2 handle the sync when multiple users are assigned to a TeamGantt task?&nbsp;</h2><p>\n\t Since Basecamp supports only one user per to-do, TeamGantt will sync the first user assigned to the task in Basecamp. We suggest assigning the primary person responsible&nbsp;for&nbsp;the task in Basecamp.&nbsp;</p><hr><h2>How do I manually refresh the sync?</h2><p>\n\t Data between TeamGantt and Basecamp is synced automatically. However, a refresh will pull the latest Basecamp data into your TeamGantt project immediately. To refresh, simply click the Basecamp icon at the upper left side of your TeamGantt project.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5b4618082c7d3a099f2e6daa/file-wIksyyVQoF.png\" style=\"width: 696px;\"></p><hr><p>\n\t Have other questions about our Basecamp 2 integration? Just email support@teamgantt.com! Or check out one of our other articles about Basecamp:</p><ul>\n\t\n<li><a href=\"https://support.teamgantt.com/article/37-basecamp\">Establishing the Sync</a> </li>\t\n<li><a href=\"https://support.teamgantt.com/article/54-disabling-the-teamgantt-basecamp-sync\">Disabling the Sync</a></li></ul><hr><p>\n\t<em style=\"background-color: initial;\"><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p><p>\n\t<strong></strong></p><p style=\"font-weight: bold;\"></p>","name":"Basecamp - Troubleshooting","number":84,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"gantt-view","text":"<h2>How do I use <em>Gantt </em>view in TeamGantt?</h2><p>\n\t<em>Gantt&nbsp;</em><span style=\"font-weight: normal;\">view will always be the default view when opening a project. You can find the other view options in the top navigation bar of your project:&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99a7587f0afeda8fe674e8/file-vTcldp23v2.png\"></span></p><h3>\nVisualize the project plan</h3><p>The gantt chart is the best way to see your project’s big picture at a glance. This comes in handy for planning, as well as communicating the plan to your team and stakeholders. After all, everyone should understand how their work fits into the project as a whole so they know what happens if they’re late and how it impacts the overall project timeline.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99a7f4860194ca2f273120/file-saV0tEFSyY.png\"></p><h3>\nPlan and schedule project timelines</h3><p>\n\t Every project runs on a schedule, whether you do work in sprints or use a waterfall approach to knock out tasks. The gantt chart enables you to map out a project plan and adjust tasks and timing quickly with drag and drop scheduling.&nbsp;</p><p>\n\t Use these features to build your project timeline in the gantt chart:&nbsp;</p><ul>\n\t\n<li><a href=\"https://support.teamgantt.com/article/8-dependencies\">Dependencies</a>: Unique to Gantt view, dependencies enable you to identify dependent tasks on the plan so work gets done in the right order.&nbsp;</li>\t\n<li><a href=\"https://www.teamgantt.com/blog/the-how-and-why-of-using-milestones-in-your-project-plan\">Milestones</a>: Track important meetings, deadlines, approvals, and deliverables by adding milestones to your plan.&nbsp;</li>\t\n<li><a href=\"https://support.teamgantt.com/article/17-subgroups\">Task subgroups</a>: Make your plan super-skimmable by <a href=\"https://www.teamgantt.com/blog/organization-tips-for-a-successful-project-plan\">organizing tasks</a> into subgroups, and build your plan out more quickly by <a href=\"https://support.teamgantt.com/article/26-duplicating-a-group/\">duplicating task groups</a> in the gantt chart. </li></ul><h3>Manage team workloads</h3><p>\n\t Overloading your team leads to burnout and ultimately puts project deadlines at risk. Gantt view empowers you to make smart decisions about project schedules and assignments so your team stays productive without being overworked.</p><p>\n\t Simply open the \n\t<a href=\"https://support.teamgantt.com/article/16-team-availability\"><em>Workloads</em></a> tab at the bottom of your gantt chart for a heat map of your team’s workload. From there, you can see who’s busy when&mdash;and who’s got room to take on new tasks&mdash;across all your projects. (This feature is available on all paid plans and premium trials.)</p><h3>\nView your planned timeline vs. what actually happened</h3><p>\n\t Ever plan a project, fall behind, and wonder: How did we get off track? A baseline is a quick snapshot of the project at a given point in time, and it’s perfect for assessing what went well&mdash;and what didn’t.</p><p>\n\t<a href=\"https://support.teamgantt.com/article/48-baselines\">Use baselines</a> to compare your original timeline projections with the actual timeline of the project. This will help you determine which tasks delivered on time or ahead of schedule and which ones got delayed so you can improve your planning accuracy the next time around. Baselines are an available feature on all paid plans and premium trials.&nbsp;</p><hr><h2>How do I export my gantt chart from TeamGantt?</h2><p>\n\t Need to share your project with someone else? Export a copy of your project's gantt view to PDF by going to&nbsp;\n\t<em>Menu &gt; Print/Export PDF.&nbsp;</em>(Learn more about <a href=\"https://support.teamgantt.com/article/45-what-information-will-be-on-my-pdf\">PDF options and customizations</a>.)<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/66defdf3e6b2356def9091f6/file-dgx5IpA94p.png\"></p><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Gantt View","number":143,"categories":["5f510e62c9e77c0016384617"]}},{"node":{"slug":"project-health-report","text":"<p>\n\t When you’re in charge of multiple projects, it’s nice to know everything’s on track without having to dig through a bunch of reports. That’s why we think you’ll love TeamGantt’s Project Health report.</p><p>\n\t The Project Health report saves you time and effort by providing an easy snapshot of every active project you oversee.</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<iframe src=\"https://fast.wistia.net/embed/iframe/zl276uz24s?videoFoam=true\" title=\"12_Create a project health report Video\" allow=\"autoplay; fullscreen\" allowtransparency=\"true\" frameborder=\"0\" scrolling=\"no\" class=\"wistia_embed\" name=\"wistia_embed\" msallowfullscreen=\"\" width=\"100%\" height=\"100%\">\n\t\t</iframe>\n\t</div></div><p>\n\t<img src=\"https://assets.teamgantt.com/blog/2018/05/Project-Health-Snapshot.png\" alt=\"\" style=\"display: block; margin: auto;\"></p><p>\n\t With the Project Health report, you can:</p><ul>\n\t\n<li>Quickly identify problem areas and address risk as work progresses</li>\t\n<li>Share it on screen in meetings to keep your team or other stakeholders up-to-date</li></ul><p>\n\t Let’s take a closer look.</p><h2><hr>\n</h2><h2>How does TeamGantt's Project Health report work?</h2><p>\n\t The first thing you’ll need to know is where to find your Project Health report.</p><p>\n\t The Project Health report is available for users at the manager permission level. To access it in your TeamGantt account, simply click&nbsp;\n\t<em>Reports</em>&nbsp;in your left sidebar menu. Then select&nbsp;<em>Project Health</em>&nbsp;from your list of available reports, and you’re in<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2cc967a663fc166843397/file-jdGNr5HoIR.png\"><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2ccbd7a663fc16684339a/file-sHbl5bTfND.png\"></p><p>\n\t Now let’s break down the pieces and parts of the report itself. Here’s what you’ll find for each project listed on the Project Health report.</p><h3>Progress</h3><p>\n\t You’ll see a percentage to the right of each project name. This number represents total project completion so you know how close each project is to being done.</p><h3>Health Status</h3><p>\n\t We break each project down into 3 different health status levels: Ok, Behind, and Overdue. Simply click on the colored dot to pull up a list of the tasks for each level.&nbsp;</p><p>\n\t<a href=\"https://assets.teamgantt.com/blog/wp-content/uploads/2018/05/Project-Health-health-status-levels.png\"></a></p><p>\n\t Here’s what each health status means:</p><ul>\n\t\n<li><strong>Ok:</strong>&nbsp;Give these tasks a hearty pat on the back! The green light tells you these tasks are either ahead of deadline or right on schedule.</li>\t\n<li><strong>Behind:</strong>&nbsp;You’ll see a yellow caution light for tasks that are running behind schedule. There’s still time to meet the deadline, but you’ll have to rally to get ‘er done.</li>\t\n<li><strong>Overdue:</strong>&nbsp;Red tasks have missed the deadline and need your attention to keep any issues from bogging the whole project down.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2cde4f70fcb103b237c44/file-9ImVbrvSIM.png\"></li></ul><h3>Project Timeline</h3><p>\n\t The timeline feature provides a quick view of a project’s overall scope and start and end dates. You’ll also find an easy visual marker of where you stand today as far as work done and time remaining before deadline. You can click on a colored section to see a list of tasks that fall into that health status category.\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2ce3ff70fcb103b237c48/file-WCRp0BERxk.png\"></p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Project Health Report","number":124,"categories":["5afb35e42c7d3a640ed6de95"]}},{"node":{"slug":"calendar-view","text":"<h2>How do I use <em>Calendar</em> view in TeamGantt?</h2><p>\n\tYou can find \n\t<em style=\"background-color: initial;\">Calendar</em><em style=\"background-color: initial;\">&nbsp;</em>view&nbsp;in the top navigation bar of your project:&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/670e846a15d0b82233065602/file-JyQ1GXlMfw.png\"></p><p>\n\t<em style=\"background-color: initial;\">Calendar</em> view displays your project data in a calendar format. This view is ideal for seeing how tasks stack up on a particular day, week, or month. You can see previous and upcoming months by toggling the&nbsp;<em style=\"background-color: initial;\">This Week</em>&nbsp;filter at the top of the calendar.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/670e84b944628317ef9053fe/file-AeGFmZS0z6.png\"></p><h3>\nIdentify potential conflicts and bottlenecks</h3><p>\n\t Want to spot project collisions before they become an issue? \n\t<em>Calendar</em> view lets you see how tasks stack up over time so you can resolve project conflicts more easily. <a href=\"https://support.teamgantt.com/article/25-viewing-multiple-projects\">Open multiple projects at a time</a>, then switch to<em> Calendar</em> view to see where things get too crunchy for your team.&nbsp;</p><p>\n\t You can also view personal task assignments in \n\t<em>Calendar</em> view from <a href=\"https://support.teamgantt.com/article/130-my-tasks\"><em>My Tasks</em></a>. This is especially helpful for team members who want to keep an eye on their workload.&nbsp;</p><h3>Track major deadlines and launch dates</h3><p>\n\t Sometimes you need a simplified schedule of major milestones to share with your team. This \n\t<a href=\"https://www.teamgantt.com/design-and-creative-templates/content-calendar\">content calendar project template</a> is a great example of how to create a high-level publication schedule so everyone knows what’s going live when. It was made with <em>Calendar</em> view in mind.</p><h2></h2><h2>How do I print my project calendar or save it as a PDF?</h2><p>\n\tTo export the \n\t<em>Calendar</em> view, you can go to <em>Menu &gt; Print Calendar view</em>.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/670e85c044628317ef905400/file-NMJJQazAQG.png\"></p><p>\n\t In Chrome, be sure&nbsp;\n\t<em>Background graphics</em>&nbsp;under the&nbsp;<em>More settings&nbsp;</em>drop-down is selected.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/670e857c44fbd7540103b5b2/file-Sd7FbBhceB.png\"></p><hr><p>\n\t<strong><em>To learn more about TeamGantt, join us for one of our free <a href=\"https://www.teamgantt.com/classes\">classes</a>!&nbsp;</em>&nbsp;</strong></p>","name":"Calendar View","number":145,"categories":["5f510e62c9e77c0016384617"]}},{"node":{"slug":"teamgantt-integration-for-slack","text":"<p>\n\t<img src=\"https://global-uploads.webflow.com/5a690960b80baa0001e05b0f/5bc4a3fb30b2b670ed2c4a1f_blog_post_hero-slack-integration-2%402x.png\"></p><p>\n\t Here’s a quick look at the features TeamGantt for Slack brings to the table:</p>\n<div>\n\t<ul>\n\t\t<li><strong>Create new tasks in a flash:</strong> Add new tasks to your TeamGantt projects using actions or slash commands.</li>\n\t\t<li><strong>Stay on top of daily tasks</strong>: View your daily task list and update task progress right from Slack.</li>\n\t\t<li><strong>Quickly access active projects: </strong>Pull a list of active projects into Slack&mdash;and filter by search terms.</li>\n\t\t<li><strong>Manage your notifications:</strong> Choose when and how often you want to be notified about TeamGantt tasks.</li>\n\t\t<li><strong>Collaborate easily on tasks:</strong> Reply to comment mentions on TeamGantt tasks without ever leaving Slack.</li>\n\t</ul>\n\t<h2>\n\t<hr>\n\t</h2>\n\t<h2>How do I connect TeamGantt with Slack?</h2>\n\t<p>\n\t\t Ready to get started? Awesome! Here’s how to integrate TeamGantt with Slack.\n\t</p>\n\t<ol>\n\t\t<li>First things first, you’ll need a TeamGantt account to make the connection. If you don’t have one, you can <a href=\"https://www.teamgantt.com/signup\">sign up for free</a>.</li>\n\t\t<li>Your next step is simple:&nbsp;<em><a href=\"https://www.teamgantt.com/integrations/slack\" target=\"_blank\">Add to Slack</a>.</em></li>\n\t</ol>\n\t<p>\n\t\t You’ll need to give TeamGantt permission to share some basic info with Slack to make the integration work properly. Review those permissions, then click the green&nbsp; \n\t\t<em>Authorize</em>&nbsp;button to finalize the integration.\n\t</p>\n\t<figure>\n\t<div>\n\t\t<img src=\"https://uploads-ssl.webflow.com/5a690960b80baa0001e05b0f/5bc4871afaf7dc160f682673_Authorize%20TeamGantt%20Slack%20Integration.png\" alt=\"Authorizing the TeamGantt for Slack integration\" style=\"border-width: 0px; border-style: initial; border-color: initial; vertical-align: middle; box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 50px 0px; width: 663.984px; margin: 68px auto;\">\n\t</div></figure><h2>\n\t\n<hr>\n\t</h2><h2>How does TeamGantt’s Slack integration work?</h2><p>\n\t\t TeamGantt and Slack go together like peas and carrots. Here’s a quick rundown of the features available in TeamGantt’s Slack integration so you can make the most of this app connection.\n\t</p><h3>Create new tasks</h3><p>\n\t\t You have 2 options for creating TeamGantt tasks directly from Slack so nothing slips through the cracks.\n\t</p><h4>Option 1: Use Slack actions to create a new task.</h4><ol>\n\t\t\n<li>Hover over the Slack message you want to take action on, and click the 3 dots that appear to the right.</li>\t\t\n<li>Select&nbsp;<em>Create Task</em>&nbsp;from the action menu.</li>\t\t\n<li>The task name will default to the Slack message text. Go with the default, or give the task a name of your own.</li>\t\t\n<li>Choose the project you want to add the new task to.</li>\t\t\n<li>Click the green&nbsp;<em>Create</em>&nbsp;button to add the task to TeamGantt.</li>\t</ol>\n\t\n<figure>\n\t<div>\n\t\t<img src=\"https://uploads-ssl.webflow.com/5a690960b80baa0001e05b0f/5bc487ca82b52b1792365fe6_graphic-chats%402x.png\" alt=\"Creating a new TeamGantt task using Slack actions\" style=\"border-width: 0px; border-style: initial; border-color: initial; vertical-align: middle; box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 50px 0px; width: 663.984px; margin: 68px auto;\">\n\t</div></figure><h4>Option 2: Use the&nbsp;<em>/tg create task</em>&nbsp;slash command to add a task.</h4><ol>\n\t\t\n<li>Type&nbsp;<em>/tg create task</em>&nbsp;into a Slack message.</li>\t\t\n<li>Enter the task name, and choose the project you want to add it to.</li>\t\t\n<li>Click the green&nbsp;<em>Create</em>&nbsp;button to add the task to TeamGantt.</li>\t</ol>\n\t\n<figure>\n\t<div>\n\t\t<img src=\"https://uploads-ssl.webflow.com/5a690960b80baa0001e05b0f/5bc4873f603d7f2738694edb_Graphic-create%402x.png\" alt=\"Creating a new TeamGantt task using slash commands\" style=\"border-width: 0px; border-style: initial; border-color: initial; vertical-align: middle; box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 50px 0px; width: 425px; margin: 68px auto;\">\n\t</div></figure><p>\n\t\t<strong>Tip:</strong> Be sure to assign the task to a team member and schedule start and end dates in TeamGantt once the task has been added from Slack.\n\t</p><h3>View and update daily tasks</h3><p>\n\t\t Staying on top of your TeamGantt tasks is easy in Slack with 2 great options.&nbsp;\n\t</p><h4><strong>Option 1: Navigate to your TeamGantt home screen&nbsp;</strong></h4><p>\n\t\t With the home screen, you can view the tasks that you need to work on today (similar to \n\t\t<a href=\"https://support.teamgantt.com/article/130-my-tasks\"><em>My Tasks</em></a>), and:\n\t</p><ul>\n\t\t\n<li>Update a task’s percent complete</li>\t\t\n<li>Add a comment to a task</li>\t\t\n<li>Open a task in TeamGantt</li>\t</ul><p>\n\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/60c2218c96768369c70bc786/file-IByjgtvaBa.png\">\n\t</p><p>\n\t\t To access the home screen, select \n\t\t<em>Add apps </em>under the \"Apps\" section of your Slack sidebar menu. Then, search for and select the TeamGantt&nbsp;app.&nbsp;\n\t</p><p>\n\t\t Note:&nbsp;If you currently use the TeamGantt integration for Slack and are having trouble accessing this feature, click this install link to opt in: \n\t\t<a href=\"https://slack.teamgantt.com/direct-install.html\">https://slack.teamgantt.com/direct-install.html</a>.\n\t</p><p>\n\t\t<strong style=\"background-color: initial; font-family: inherit; font-size: 18px;\">Option 2: Use the <em>/tg today </em>slash command</strong>\n\t</p><ol>\n\t\t\n<li>Type&nbsp;<em>/tg today</em>&nbsp;into a Slack message, and hit&nbsp;<em>Enter</em>&nbsp;to view a list of your daily tasks.</li>\t\t\n<li>To update a task’s&nbsp;<em>Percent Complete</em>&nbsp;or add a comment to a task directly from Slack, click the&nbsp;<em>Quick Update</em>&nbsp;button.</li>\t\t\n<li>To view or update even more task information, click&nbsp;<em>Open in TeamGantt</em>&nbsp;to go to the task edit screen in TeamGantt.</li>\t</ol>\n\t\n<figure>\n\t<div>\n\t\t<img src=\"https://uploads-ssl.webflow.com/5a690960b80baa0001e05b0f/5bc487fe60dd9629975958fc_Graphic-daily-tasks%402x.png\" alt=\"Viewing and updating your daily task list in Slack\" style=\"border-width: 0px; border-style: initial; border-color: initial; vertical-align: middle; box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 50px 0px; width: 431px; margin: 68px auto;\">\n\t</div></figure><h3>Access active projects</h3><p>\n\t\t Want a direct line from Slack to your TeamGantt projects? Simply follow these steps.\n\t</p><ol>\n\t\t\n<li>Type&nbsp;<em>/tg projects</em>&nbsp;into a Slack message to pull up a list of your active projects in Slack.</li>\t\t\n<li>Want to filter your project list? Add a search term to the end of the slash command. For example, entering&nbsp;<em>/tg projects website</em>&nbsp;will narrow your list down to active projects with “website” in the name.</li>\t\t\n<li>From there, you can jump right to the project’s <em>Gantt, List, Calendar</em>, or <em>Discussion</em> view by clicking on the 3 dots to the right of the project you want to go to in TeamGantt.</li>\t</ol><p>\n\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/60c79e18af164f7b537ce19b/file-O3IhYQmfdT.jpg\">\n\t</p><figure></figure><h3>Schedule automated reminders for daily tasks</h3><p>\n\t\t TeamGantt’s Slack integration gives you the option to receive automated reminders about your daily tasks in Slack. Here’s how to configure your notification settings in Slack.\n\t</p><ol>\n\t\t\n<li>Type<em>&nbsp;/tg settings</em>&nbsp;into a Slack message.</li>\t\t\n<li>Select the frequency and time of day you’d like to be reminded about daily tasks in Slack.</li>\t\t\n<li>Click the green&nbsp;<em>Update&nbsp;</em>button to make it so.</li>\t</ol>\n\t\n<figure>\n\t<div>\n\t\t<img src=\"https://uploads-ssl.webflow.com/5a690960b80baa0001e05b0f/5bc48832b71671648a20fafd_Graphic-notifications%402x.png\" alt=\"Configuring your TeamGantt for Slack notification settings\" style=\"border-width: 0px; border-style: initial; border-color: initial; vertical-align: middle; box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 50px 0px; width: 462px; margin: 68px auto;\">\n\t</div></figure><h3>Get notified of task assignments and mentions</h3><p>\n\t\t Keep tasks from falling through the cracks with notifications! Once your TeamGantt account is synced with Slack, you'll automatically receive notifications in Slack any time that you've been \n\t\t<a href=\"https://support.teamgantt.com/article/6-inviting-people#assign-a-single-task-to-a-user\">assigned to a task</a> or <a href=\"https://support.teamgantt.com/article/80-adding-comments\">mentioned in a comment</a>.&nbsp;\n\t</p><p>\n\t\t If you'd like to disable these options, no problem! Simply type \n\t\t<em style=\"background-color: initial;\">&nbsp;/tg settings</em>&nbsp;into a Slack message and select \"No\" under the <em>Enable task assignment notifications</em> and/or <em>Enable comment mention notifications </em>drop-down&nbsp;options.&nbsp;\n\t</p><p>\n\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5ef3b1662c7d3a10cba982d5/file-TrvrC8ftod.png\" alt=\"\" style=\"display: block; margin: auto;\">\n\t</p><h3></h3><h3>Reply to TeamGantt comments directly from Slack</h3><p>\n\t\t You can reply to comments made in TeamGantt without ever leaving Slack!&nbsp;\n\t</p><p>\n\t\t When you're mentioned, you'll see a notification badge on the TeamGantt app. Simply click on TeamGantt to open the home screen, and then toggle to \n\t\t<em>Messages</em>&nbsp;to view and reply to mentions.&nbsp;\n\t</p><p>\n\t\t After you've replied to a message, the message will disappear, allowing you to always have a clear view of items that still need attention.&nbsp;\n\t</p><p>\n\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/60c2237696768369c70bc798/file-yknCwfF67V.jpg\">\n\t</p><p>\n\t\t Note: You must have comment mention notifications enabled to receive and reply to mentions. To update your notification settings, enter \n\t\t<i style=\"background-color: initial;\">/tg settings </i>into any slack channel.&nbsp;\n\t</p><h3></h3><h3>Get a handy slash command refresher</h3><p>\n\t\t Need a quick reminder of the TeamGantt actions you have available in Slack? Simply type&nbsp; \n\t\t<em>/tg help</em>&nbsp;into your Slack message to see a full list of TeamGantt for Slack slash commands.\n\t</p><figure>\n\t<img src=\"https://uploads-ssl.webflow.com/5a690960b80baa0001e05b0f/5bc4878005f2126edc95919b_Graphic-actions%402x.png\" alt=\"TeamGantt for Slack slash command reminders\" style=\"border-width: 0px; border-style: initial; border-color: initial; vertical-align: middle; box-shadow: rgba(0, 0, 0, 0.1) 0px 20px 50px 0px; width: 406px; margin: 68px auto;\">\n\t\n<hr>\n\t<em>Have questions about the integration? Reach out to our Customer Success team by email at Support@TeamGantt.com!</em>\n\t</figure><figure><em><br></em></figure><figure>\n\t</figure><figure>\n\t<em style=\"background-color: initial;\"><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em>\n\t<strong></strong>\n\t<br>\n\t</figure></div>","name":"TeamGantt Integration for Slack","number":131,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"teamgantt-api","text":"<h2>Does TeamGantt have a public API?</h2><p>\n\t Yes, you can complete CRUD (Create, Read, Update, Delete)&nbsp;actions&nbsp;between TeamGantt and your app using&nbsp;our RESTful API. This enables your developer to build custom integrations with TeamGantt.</p><hr><h2>Where can I find the TeamGantt API documentation?</h2><ul>\n\t\n<li>First, read our documentation on <a href=\"https://support.teamgantt.com/article/153-authenticating-with-teamgantt\">authenticating the API</a>.</li>\t\n<li>Next, visit our <a href=\"https://teamgantt.docs.apiary.io/#\">API documentation</a>.&nbsp;</li></ul><hr><h2>What data can I access through the TeamGantt API?</h2><p>\n\t Here's what's available data-wise:&nbsp;</p><ul>\n\t\n<li>Discussions</li>\t\n<li>Groups of tasks</li>\t\n<li>Projects</li>\t\n<li>Tasks</li>\t\n<li>Task dependencies</li>\t\n<li>Task resources (Users and labels)</li>\t\n<li>Tracked time</li>\t\n<li>Workloads</li>\t\n<li>Checklists</li>\t\n<li>Baselines</li></ul><p>\n\tIf you have any thoughts or feedback about our API, we'd love to hear it! Shoot us a note at dev@teamgantt.com.&nbsp;</p><hr><p>\n\t<strong>Looking for another way to sync&nbsp;TeamGantt with your favorite tools?</strong>&nbsp;Check out our <a href=\"https://support.teamgantt.com/article/152-teamgantt-integration-for-zapier\">Zapier integration</a>!&nbsp;</p><hr><p>\n\t<b style=\"font-style: italic;\">To learn more about TeamGantt, join us for one of our free</b><strong><em> <a href=\"https://www.teamgantt.com/classes\">classes</a></em></strong><a href=\"https://www.teamgantt.com/classes\"><strong></strong></a><a href=\"https://www.teamgantt.com/classes\" style=\"font-style: italic; font-weight: bold;\"></a><em><strong>!&nbsp;</strong></em></p>","name":"TeamGantt API","number":132,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"time-tracking-report","text":"<p>\n\t Need to calculate a freelancer's hours or see how a project's time is stacking up? In TeamGantt, managers with account admin permission can check in on hours tracked with time tracking reports.&nbsp;</p><h2>How does the time tracking report work in TeamGantt?</h2><p>\n\tOnly managers with account admin permission are able to access time tracking reports. To generate reports for an individual or team, click&nbsp;\n\t<em style=\"background-color: initial; font-size: 14px;\">Reports</em>&nbsp;in the left sidebar. Then, select<em style=\"background-color: initial; font-size: 14px;\">&nbsp;Time Tracking</em>:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2cf34f70fcb103b237c56/file-t7iPYqoUFi.png\"></p><p>\n\tFrom here, you can&nbsp;customize the report to fit your needs by filtering it&nbsp;by date range, person, and/or project. Once your parameters are set, click&nbsp;\n\t<em style=\"background-color: initial;\">Update Report&nbsp;</em>to calculate hourly totals:</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5b48a5850428630abc0c08c6/file-e0IkuTymiF.png\" style=\"width: 1263.98px; display: block; margin: auto;\" alt=\"\"></p>\n<div>\n  Want to download your time tracking data? Click&nbsp;\n\t<em>Download CSV</em> to save a copy of the report to your computer.\n</div><div>\n\t<hr>\n\t Read more about our time tracking feature \n\t<a href=\"https://support.teamgantt.com/article/102-time-tracking/\">here</a>.\n</div><div>\n\t<p>\n\t\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em>\n\t</p>\n</div>","name":"Time Tracking Report","number":129,"categories":["5afb35e42c7d3a640ed6de95"]}},{"node":{"slug":"my-tasks","text":"<h3> <em>My Tasks</em> is the best way to keep track of your day-to-day tasks across all projects you're working on.&nbsp;</h3><p>\n\t When you select \n\t<em style=\"background-color: initial;\">My Tasks </em>from the left sidebar menu or simply click the <em>Checkmark&nbsp;</em>icon in the sidebar,&nbsp;you'll automatically be brought to the <em style=\"background-color: initial;\">Daily </em>tab of your dashboard. This will show you all the tasks that are currently assigned to you and need to be actively worked on today.&nbsp;</p><p>\n\tThink of the&nbsp;\n\t<em style=\"background-color: initial;\">My Tasks</em>&nbsp;view as your own personal task list. You can see exactly where to focus your time and attention so nothing slips through the cracks. And updating tasks that are assigned to you is quick and easy!</p><p>\n\t Here are just a few of the changes you can make to your tasks from the \n\t<em>Daily </em>tab:&nbsp;</p><ul>\n\t\n<li>Update <em>Progress </em>percentage</li>\t\n<li>Comment on tasks and upload documents</li>\t\n<li>Update the checklists</li>\t\n<li>Track time (if your account is on our Business and Builder Edition plans)</li>\t\n<li>Assign the task to other users</li>\t\n<li>Reschedule the task</li></ul><p>\n\t<em> Note: Your ability to update the items above depends on your <a href=\"https://support.teamgantt.com/article/5-permissions\">permission level</a> within each project.</em></p><p>\n\t<strong style=\"background-color: initial; font-family: inherit; font-size: 21px;\">Filters</strong></p><p><strong style=\"background-color: initial; font-family: inherit; font-size: 21px;\"></strong>Star your most important tasks by hovering over the task and selecting the star that appears to the right. Then, select \n\t<em style=\"background-color: initial;\">Show only starred</em> to pull up all your must-dos for the day.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99a8f4860194ca2f27312d/file-3HtVBZG77X.png\">Choose between simply checking off tasks or updating the progress<em style=\"background-color: initial;\">&nbsp;</em>completion percentage.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99a92e740284c5b4cbcf82/file-JDBXx3Negj.png\"></p><p>\n\t<strong style=\"background-color: initial; font-family: inherit; font-size: 21px;\">Other views</strong></p><p><strong style=\"background-color: initial; font-family: inherit; font-size: 21px;\"></strong>Want a better way to visualize future tasks? View your tasks in \n\t<em style=\"background-color: initial;\">Calendar, List</em>, or <em style=\"background-color: initial;\">Gantt</em>&nbsp;view by selecting the appropriate tab at the top.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99a95f860194ca2f273131/file-uEnoxulT9O.png\"></p><p>\n\tIf \n\t<em style=\"background-color: initial;\">My Tasks </em>is your preferred view, we'd recommend <a href=\"https://support.teamgantt.com/article/90-bookmarks\">setting it as your homepage</a>.&nbsp;</p><hr><p>\n\t<strong><em style=\"background-color: initial;\">To learn more about TeamGantt, join us for one of our free <a href=\"https://www.teamgantt.com/classes\">classes</a>!&nbsp;</em>&nbsp;<br>\n\t</strong></p>","name":"My Tasks View","number":130,"categories":["5f510e62c9e77c0016384617"]}},{"node":{"slug":"displaying-and-hiding-columns","text":"<h1></h1><h2>Which columns can I display in TeamGantt?</h2><p>\n\tTeamGantt supports displaying the following columns in Gantt view:</p><ul>\n\t<li><strong style=\"background-color: initial;\">Baselines</strong>\n\t<ul>\n\t\t<li><strong style=\"background-color: initial;\"></strong><b style=\"background-color: initial;\">Baselines</b> - Allows you to see how many days ahead or behind your task is now scheduled.&nbsp;</li><li><strong>Planned Start Date </strong>- Allows you to see when your task was originally scheduled to start.&nbsp;</li><li><strong>Planned End Date </strong>- Allows you to see when your task was originally scheduled to end.&nbsp;</li>\t</ul></li>\t<li><strong>Dependencies</strong>\n\t<ul>\n\t\t<li><strong>Predecessors</strong> -&nbsp;Allows you to see the number of predecessors that the task has.</li>\t\t<li><strong>Successors</strong> - Allows you to see the number of successors that the task has.&nbsp;</li>\t</ul></li>\t<li><strong>Dates &amp; Time</strong>\n\t<ul>\n\t\t<li><strong></strong><strong>Due in </strong>- Allows you to see how many days til your task is due.&nbsp;</li>\t\t<li><strong>Duration </strong>- Allows you to see and enter the task duration in days.&nbsp;</li>\t\t<li><strong>Estimated Hours </strong>- Allows you to see or enter the estimated hours assigned to a task</li>\t\t<li><strong>Actual Hours</strong> - Allows you to see the sum of tracked time for a task.&nbsp;</li>\t\t<li><strong>Start Date</strong> - Allows you to see the start date of the project, groups, and tasks.&nbsp;</li>\t\t<li><strong style=\"background-color: initial;\">End Date </strong>- Allows you to see the end date of the project, groups, and tasks.&nbsp;</li>\t</ul></li>\t<li><strong>Financials</strong>\n\t<ul>\n\t\t<li><strong>Budgeted cost</strong> - Allows you to see and enter the budgeted costs assigned to the task.&nbsp;</li>\t\t<li><strong>Actual cost </strong>- Allows you to see and enter the actual costs assigned to the task.&nbsp;</li>\t\t<li><strong>CBS</strong> - Allows you to enter the Cost Breakdown Structure for the task</li>\t</ul></li>\t<li><strong>Task tracking</strong>\n\t<ul>\n\t\t<li><strong>Assigned</strong> - Allows you to see who is assigned to a task.&nbsp;</li>\t\t<li><strong>Confirmation</strong> - Allows you to see if the assignee has confirmed their task assignment.</li>\t\t<li><strong>Points </strong>- Allows you to see and enter points for tasks.&nbsp;</li>\t\t<li><strong style=\"background-color: initial;\">Progress </strong>- Allows you to see the % complete of the tasks.</li>\t</ul></li>\t<li><strong style=\"background-color: initial;\">Tools</strong>\n\t<ul>\n\t\t<li><strong style=\"background-color: initial;\">Selection - </strong>Allows you to select multiple tasks and groups</li>\t\t<li><strong>Shortcuts</strong> - Allows you to see the comments, tracked time, and checklists on your tasks.&nbsp;</li>\t\t<li><strong>Color</strong> - Allows you to see or change the task color assigned to the task.</li>\t\t<li><strong style=\"background-color: initial;\">WBS</strong>&nbsp;- Allows you to see the Work Breakdown Structure of your project.</li>\t</ul></li>\t<li><strong>Custom fields</strong>\n\t<ul>\n\t\t<li>If your plan supports the Custom fields feature, you will have the option to enable custom fields columns.&nbsp;</li>\t</ul></li></ul><p>\n\tJust to note, Columns that can be accessed will be determined by the features available on your plan.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99a4dc2c8bd26b0332fe21/file-mthoT79N2C.png\"></p>\n<h2>\nHow do I show or hide columns in my Gantt chart?</h2><p>\n\t<span style=\"background-color: initial; font-size: 14px;\">You can choose which columns to display by going to the \n\t<em style=\"background-color: initial; font-size: 14px;\">View</em>&nbsp;menu at the top of the Gantt chart and selecting the <em style=\"background-color: initial; font-size: 14px;\">Columns </em></span><span style=\"font-weight: normal;\">pop-out menu. Then, simply select which columns you would like to display.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99a5307f0afeda8fe674e1/file-J8bwCuRUYX.png\"></span></p><p><span style=\"font-weight: normal;\"></span>You can also open the \n\t<em style=\"background-color: initial;\">Columns</em>&nbsp;menu by clicking on the header of any open column.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99a564246853be1edeb110/file-JZE9702nzq.png\"></p><p>How do I hide all columns?</p><p>You can also easily hide all columns by clicking the \n\t<em style=\"background-color: initial;\">arrow</em> icon on the right side of the columns.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99a593860194ca2f273116/file-xZDUxLG7Id.png\"></p><hr>\n<h2>\nHow do I bring columns back after hiding them?</h2><p>Once all columns are hidden, you can easily bring the columns back by clicking the&nbsp;<em style=\"background-color: initial; font-size: 14px;\">arrow</em> icon on the left side of the Gantt chart.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99a5e1860194ca2f273118/file-BC9m7bTQuV.png\"></p><h2>\n<hr>\n</h2><h2>How do I reorder columns?&nbsp;</h2><p>\n\tTo reorder columns, click and drag the top of any column.&nbsp;</p><p>\n\tTo note, the first 4 columns--Selection, Shortcuts, Color, and Name-- will always maintain their default positions.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a50019857be4eea8c37f7a9/file-7yMLj1jsxV.png\"></p>","name":"Displaying and Hiding Columns","number":163,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"hourly-progress-v-task-progress","text":"<p>\n\t<strong>**Available in Gantt Classic only at this time**<br>\n\t</strong>Want your project to finish on time and on budget? Of course you do! That's why it's important to keep a close eye on how the actual work is tracking against your original plan.</p><p>\n\tIn TeamGantt, the thin striped line that appears inside each taskbar provides&nbsp;an easy&nbsp;visual for seeing how \n\t<a href=\"https://support.teamgantt.com/article/107-percentage-complete-calculated\">task progress</a> is pacing with <a href=\"https://support.teamgantt.com/article/102-time-tracking\">hours spent on a task</a>. It's a great way to catch potential overages before they throw your project completely off course.&nbsp;</p><p>\n\tLet's take a closer look at 2 different ways this simple striped line helps you compare task progress with your plan.</p><hr><h2>What does the color of the striped line indicate?</h2><p>\n\tIn TeamGantt, the color of the striped line in a taskbar shows you how estimated hours stack&nbsp;up against tracked hours so you can tell if (and when) tasks are over budget.</p><h3>🟢 If the striped line is green:&nbsp;</h3><p>\n\tYou're right on track! Actual time tracked has not exceeded the estimated hours for that task or group.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5d80fe062c7d3a7e9ae1405c/file-cDzicqUzq4.png\"></p><h3>🔴 If the striped line is red:&nbsp;</h3><p>\n\tYou've gone over the budgeted hours. Actual time tracked has exceeded the estimated hours for that task or group.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5d80fe1204286364bc8f34a0/file-TLCfqTIrCv.png\"></p><hr><h2>What does the length of the striped line indicate?</h2><p>\n\tThe length of the striped line in a taskbar shows you how the tracked time for a task or group stacks up against its % complete, making it easier to spot tasks that are at risk for overage.</p><h3>\nIf the striped bar is shorter than the progress indicator:&nbsp;</h3><p>\n\tThe time tracked for this task or group is&nbsp;pacing well and is not in danger of exceeding estimated hours. Hooray! Looks like your project will be on time and budget.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5d80febe04286364bc8f34bb/file-HC00qdSiug.png\"></p><h3>\nIf the striped bar is longer than the progress indicator:&nbsp;</h3><p>\n\tThis task or group is at risk for overage. This means the percentage of tracked vs. estimated hours is higher than the percentage of progress that's been made on the task or group to date. Be sure to investigate why this is happening. It'll help you plan better next time around!</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5d80fe722c7d3a7e9ae14069/file-5ftZmWiL4r.png\"></p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/webinars/\">classes</a>!&nbsp;</strong></em></p>","name":"Hourly Progress vs. Task Progress","number":139,"categories":["5284dea7e4b04fbdf2ac3a02"]}},{"node":{"slug":"portfolio-view","text":"<p>\n\tPortfolio view makes it easy to keep tabs on all the projects you manage from a single, centralized hub. Organize projects into folders&mdash;by team, department, client, project owner, quarter, and more&mdash;and regularly check project health to identify potential delays or roadblocks early.</p><h2><hr>\n Accessing \n<em>Portfolio</em> view</h2><p><em style=\"background-color: initial; font-size: 14px;\">Portfolio</em> view is available to any user on our Business and Builder Edition plans. To access it, simply click <em style=\"background-color: initial; font-size: 14px;\">Portfolio</em> in the sidebar menu. It’s listed as the first option after the search field.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99aacd740284c5b4cbcf84/file-8VoZGSydpy.png\"></p><p>\n\tReally digging \n\t<i style=\"background-color: initial;\">Portfolio</i> view for managing your projects? You can set this view as your new homepage. <a href=\"https://support.teamgantt.com/article/90-bookmarks#set-a-new-homepage\">Here’s how</a>.&nbsp;</p><hr><h2> </h2><h2>Navigating Portfolio view</h2><h3>Folders</h3><h4>How do folders work?</h4><p>\n\t<em>Portfolio</em> view features both your active projects and <a href=\"https://support.teamgantt.com/article/141-boards#custom-board-creating-a-board-from-multiple-projects\">custom boards</a> and automatically organizes them into the following default folders:&nbsp;</p><ul>\n\t\n<li><em>Favorites</em></li>\t\n<li><em>Custom Boards</em></li>\t\n<li><em>Projects</em></li></ul><p>These catch-all folders hold everything that hasn’t been moved into a custom folder yet.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99ab637a42362217c99e2d/file-1VENDZ4xgM.png\"></p><p>\n\tTo move a board or project to a different folder, simply drag and drop the item from one folder to another. It’s that easy!</p><p>\n\t Within a folder, everything is grouped by type, then sorted alphabetically. Favorite (starred) boards or projects will float to the top of the list, followed by any boards that exist in the folder, and, finally, projects.&nbsp;</p><h4>Who can view and use my folders?</h4><p>\n\t Creating a new folder adds it at the account level. This means everyone in your TeamGantt account will be able to see the folder in \n\t<em>Portfolio </em>view. However, users will only be able to see the boards or projects they’ve been invited to within each folder.</p><p>\n\t For instance, if a folder has 3 projects in it and the user has only been invited to 1 of them, they’ll only see that 1 project.</p><p>\n\t<strong>Bonus:</strong> Account Admins can view and join projects they're currently not a part of directly from <em>Portfolio</em> view.&nbsp;&nbsp;</p><h4>How do I create a new folder?</h4><p>Click the big blue plus (+) icon at the upper right of \n\t<em style=\"background-color: initial; font-size: 14px;\">Portfolio</em> view, and select <em style=\"background-color: initial; font-size: 14px;\">New Folder</em>. (You can also choose to create a new project or a new custom board here.)&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99abf07a42362217c99e2f/file-VQWRZrWRMh.png\"></p><p>\n\tSelecting the \n\t<i style=\"background-color: initial;\">New Folder</i> option will guide you through a quick wizard. Simply indicate which account you’d like to add your new folder to (if you’re a user on multiple accounts), and give your new folder a name. And voilà!<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99ac3b7a42362217c99e31/file-rgErm8JvKC.png\"></p><p><b style=\"background-color: initial;\">Note:</b> Every folder must have its own unique name within your company account. For instance, you can’t have 2 folders called “Important Projects” in the same account. This helps prevent confusion if multiple people create folders in your account.</p><h4></h4><h4>Portfolio health</h4><p>\n\t Good news! You can see \n\t<em>Project Health Report</em> data directly from <em>Portfolio</em> view! This enables you to quickly assess how a project is tracking and identify issues early to mitigate risk.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6005a792b9a8501b295d160d/file-vIiHX7XxPR.png\">Learn more about <a href=\"https://support.teamgantt.com/article/124-project-health-report\">how TeamGantt’s Project Health Report works</a>.&nbsp;</p><h3><em>Favorites</em></h3><p>\n\t Star your favorite projects, boards, and even entire folders to keep them at the top of your list in \n\t<em>Portfolio</em> view. Favorites are specific to you, so feel free to star as many items as you want.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6005a7b81c64ad47e4b70324/file-tQ6lGmhEfl.png\">When you favorite a project or a board, it will appear as a favorite everywhere in your user account&mdash;such as the sidebar menu and your <i style=\"background-color: initial;\">My Projects</i> page.</p><h3>Filtering</h3><h4>Filter</h4><p>\n\t<em>Portfolio</em> will always load with active projects displayed. However, you can use the <em>Filte</em>&nbsp;drop-down at the top of the page to toggle to the <em>On Hold</em> or <em>Complete</em> projects in your folders.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99ac73246853be1edeb12b/file-PZ5nEm7IBQ.png\"></p><h4><strong style=\"background-color: initial; font-size: 14px;\">Show empty folders</strong></h4><p>\n\t This filter allows you to hide empty folders in your \n\t<em>Portfolio</em>. You may want to use this option if you're a user who doesn't have access to any projects in one or more folders.</p><h5>Show projects I’m not on</h5><p>\n\t This filter allows you to hide projects you aren’t invited to across all of your folders so you can focus only on the projects that matter to you.&nbsp;</p><h5>Company</h5><p>\n\t This option allows you to filter your \n\t<em>Portfolio</em> view by company if you’re a user on multiple TeamGantt accounts. That way you can get clearer insight into the work for each account. And don’t worry: You can adjust your company filters anytime.&nbsp;</p><p>\n\t With the exception of the status filter (which is always set to \n\t<em>Active</em>), all filter preferences are specific to you and will be remembered the next time you log in.&nbsp;</p><h3>Managing folders</h3><h4>Collapsing folders</h4><p>\n\t Collapsing folders is an easy way to make your \n\t<em>Portfolio</em> view super-scannable. To collapse a folder, click the downward arrow that appears to the left of the folder name.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99ad197a42362217c99e35/file-sbIeTvGGyr.png\"></p><h4> </h4><h4>Additional folder actions</h4><p>\n\t You have a few more options available for managing folders in your \n\t<em>Portfolio</em> view. Here’s a rundown of the icons that appear on the upper right side of each custom folder.</p><h5>Create new (‘+’ icon):</h5><p>\n\t Clicking the ‘+’ icon enables you to choose from the following options:</p><ul>\n\t\n<li>Create a new project in this folder</li>\t\n<li>Create a new board in this folder<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99ad5d7f0afeda8fe67503/file-dAPU9U1q1P.png\"></li></ul><p><strong>Favorite (star icon):</strong>&nbsp;</p><p>\n\t Selecting the star icon adds the entire folder to your \n\t<em>Favorites</em> so it’s one of the first folders you see on your portfolio list.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99add17a42362217c99e36/file-zFMZBrgXvC.png\"></p><p>If you favorite multiple folders, they’ll be sorted alphabetically at the top of your portfolio.</p><h5>Open all (arrow icon):&nbsp;</h5><p>\n\t Clicking the icon with a square and upward arrow will open all the projects in that folder in a single gantt chart view.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99ae1f860194ca2f273140/file-gmcqvwUIvI.png\"></p><p>This is handy if you want to take a look at all the related projects (e.g., for a client or team) at the same time.&nbsp;</p><h5>3-dot menu:&nbsp;</h5><p>\n\t The 3-dot icon enables you to perform any of the actions above, with the additional options of renaming or deleting the folder. Simply click on the 3 dots to open up the menu.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6005a8e41c64ad47e4b7032a/file-puNGf4jYZq.png\" alt=\"\" style=\"display: block; margin: auto;\"><b style=\"background-color: initial;\"><br>\n\t</b></p><p>\n\t<b style=\"background-color: initial;\">Note:</b> Deleting a folder simply unfolders the projects in it. They’ll go back to the default <i style=\"background-color: initial;\">Projects</i> folder. You can choose to add them to a new folder in the future if you’d like.</p><h3>Managing projects/boards in <em>Portfolio</em> view</h3><h4>Open project(s)</h4><p>\n\t To open a project or board from \n\t<em>Portfolio</em> view, simply click on its name.&nbsp;</p><p>\n\t Boards can only be opened one at a time (either by selecting the board’s name or the board icon that appears next to the board’s name).&nbsp;</p><p>\n\t However, multiple projects can be opened at once by selecting the checkbox next to each project name and then clicking the \n\t<em>Open selected projects</em> button that appears at the bottom of your window.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99ae99860194ca2f273143/file-fyjyD3HZwd.png\"></p><p>Checked multiple projects by mistake? Click the <i style=\"background-color: initial;\">Clear selection</i> option to clear all checkboxes, or simply uncheck any individual projects you don’t want to open.&nbsp;</p><h4></h4><h4>Favorite (star icon):&nbsp;</h4><p>\n\t Favorite the projects and boards you use the most by clicking the star icon that appears on the far right side of the listing. Once favorited, the board or project will float to the starred section at the top of its current folder. It will also be added to the \n\t<em>Favorites</em> folder at the top of your portfolio for easy access.&nbsp;</p><p>\n\t Remember:&nbsp;</p><ul>\n\t\n<li>Favorites are specific to you, so don’t worry about starring things freely!&nbsp;</li>\t\n<li>When you favorite a project or board, it will appear as a favorite everywhere in your account&mdash;such as the sidebar menu and your <em>My Projects</em> page.</li></ul><h4></h4><h4>3-dot menu:&nbsp;</h4><p>\n\t Clicking the 3-dot icon to the right of a project or board will give you some additional menu options. Let’s walk through the menu options you’ll see for projects and boards in your portfolio.</p><h5>For projects<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99aedd860194ca2f273145/file-VOimohbfoo.png\"></h5><h5>View summary<span style=\"font-weight: normal;\">:</span><span style=\"font-weight: normal;\"> This option takes you to a dashboard where you can see all the project basics, like number of tasks, people invited, recent discussions, and more.&nbsp;</span></h5><ul>\t\n<li><strong>View schedule: </strong>This option opens your project in Gantt view.&nbsp;</li>\t\n<li><strong>View list: </strong>This option opens your project in List view.&nbsp;</li>\t\n<li><strong>Mark as Active:</strong> This option allows you to mark the project as Active.</li><li><strong>Mark as On Hold</strong>: This option allows you to mark the project as On Hold.</li><li><strong>Mark as Complete</strong>: This option allows you to mark the project as Complete.&nbsp;</li>\t\n<li><strong>Delete project </strong>(Admin only): This option deletes the project from your account.&nbsp;</li></ul><h5>For boards<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99af67246853be1edeb136/file-WiT9LLigU9.png\"></h5><h5></h5><ul><li><b style=\"background-color: initial;\">View board:</b> This option opens your board.&nbsp;</li>\t\n<li><strong>Leave board:</strong> This option allows you to remove yourself from the board.</li>\t\n<li><strong>Close board </strong>(Admin only): This option deletes the board from your account.&nbsp;</li></ul><hr><h2>Adding projects and boards to a folder outside <em>Portfolio</em> view</h2><p>\n\t There are a couple of ways to add projects and boards to folders in your portfolio from other places in TeamGantt. Here’s how:</p><h3>From your project or board settings:&nbsp;</h3><p>\n\t In a project, you can access settings by going to \n\t<em>Menu &gt; Project Settings</em>. Then, choose a folder from the <em>Folder</em> drop-down menu in the right column of the window.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/670e93ba8af27b34842c0287/file-egmrLHbQiX.png\"></p><p>\n\tIn a board, you can access settings by going to \n\t<i style=\"background-color: initial;\">Menu &gt; Edit Board</i>. Then, select a folder option from the <i style=\"background-color: initial;\">Folder</i> drop-down menu.&nbsp;</p><p>\n\t<strong>Note:</strong> These options only show up if you’re an Admin on the project or board.&nbsp;</p><h3></h3><h3>When creating a new project or board:</h3><p>\n\t When \n\t<a href=\"https://support.teamgantt.com/article/106-projects#how-to-create-a-project\">creating a new project</a> or <a href=\"https://support.teamgantt.com/article/141-boards#custom-board-creating-a-board-from-multiple-projects\">custom board</a>, choose a folder from the<em> Folder </em>drop-down menu to add it to that folder in your portfolio.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a99af91246853be1edeb137/file-9gLiMEuRVi.png\"></p><p>\n\t<strong><em>To learn more about TeamGantt, join us for one of our free <a href=\"https://www.teamgantt.com/classes\">classes</a>!&nbsp;</em>&nbsp;</strong></p>","name":"Portfolio View","number":150,"categories":["5f510e62c9e77c0016384617"]}},{"node":{"slug":"navigating-the-sidebar-menu","text":"<h2>What are the quick links in the sidebar, and what do they do?</h2><p><span style=\"font-weight: normal;\">There are 8 quick links along the far left of your sidebar: Create, My Tasks, Projects, Boards, Portfolio, Discussions, Time Sheet, and Reports.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa048684da0d5ace79cd1b2/file-bfud0mQOt5.png\"></span></p><p>\n\tLet’s take a closer look at each one.</p><h4>Search</h4><p>The search bar allows you to easily find projects, boards, groups, and tasks in your account.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa04c7e53cd5afec1c36d49/file-EbyHu8WZbs.png\"></p><h4>Create</h4><p>This quick link allows you to quickly reach the project creation page to create a new project. This option will only be available if you have Account Permission is set to Manager.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa048a1562701da44e7abed/file-1jEhOIi7z0.png\"></p><h4>My Tasks</h4><p>This quick link allows you to easily see all tasks assigned to you. This page allows you to see your assigned tasks that are Past due, In progress, Upcoming, and Unscheduled. You can also view this page in the Calendar, List, and Gantt views.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa048f07e56f2abb02adf20/file-Qj9hgNyLaj.png\"></p><h4>Projects</h4><p>This quick link easily allows you to see all the projects you have been invited to or created.<br><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa0491bc1db7b813395654c/file-7tIeRnRjRp.png\"></p><h4>Boards</h4><p>\n\tThis quick link allows you to easily see all your Custom Boards that you have created or been invited to. Custom Boards is only available on select plans.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa049b7c1db7b8133956552/file-DJczc9Vfts.png\"></p><h4>Portfolio</h4><p>\n\tThis quick link takes you to the Portfolio view where you can organize your projects into folders. Portfolio is only available on select plans.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa04a335a3830dc1f2f7272/file-fWRpX3I8tY.png\"></p><h4>Discussions</h4><p>This quick link makes staying on top of project communication a snap. &nbsp;If you see a little green dot next to \n\t<em style=\"background-color: initial; font-size: 14px;\">Discussions</em>, that means you’ve got an unread discussion to catch up on.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa04a5dc1db7b8133956558/file-0D7p6vFB4A.png\"></p><h4>Time Sheet</h4><p>\n\tThis quick link gives you a list of your assigned tasks for the week, making it easy to track the time you spend working on each task.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa04a874da0d5ace79cd1c3/file-jWvfhiEpB9.png\"></p><p>Reports</p><p>\n\t All the report-y things live together on a single \n\t<em>Reports</em> page you can get to quickly by clicking the Reports icon.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa04bec7e56f2abb02adf39/file-MFnP4BKyQu.png\"></p><p>How do I collapse or expand the sidebar?</p><p>\n\tIn your profile settings, you can easily choose to manually collapse or expand the sidebar or have the sidebar expand when hovering.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa04ba14da0d5ace79cd1c9/file-FOCkKBJP3d.png\"></p><h3>How do I edit the sidebar?&nbsp;</h3><p>\n\tYou can edit what shows in the sidebar by going to your profile settings.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa04bc64da0d5ace79cd1cb/file-NI2KXXJDG1.png\"></p><h5></h5><h5></h5>","name":"Navigating the Sidebar Menu","number":135,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"list-view","text":"<h2>How do I use <em>List</em> view in TeamGantt?</h2><p>\n\t You can find \n\t<em>List </em>view in the top navigation bar of your project:&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/670e82af6d43ca7b17b2be8c/file-53L0o5ZRtq.png\"></p><h3>\nUpdate tasks and review project status in meetings</h3><p>\n\t<em>List</em>&nbsp;view is designed for folks who want a clean and simple view of the project without having to navigate a gantt chart. You can drag and drop tasks to rearrange the order, update progress, track time, or collaborate on tasks easily from&nbsp;<em>List&nbsp;</em>view.</p><p>\n\t This easy-to-read option is especially great for meetings and project review and is the only view that displays start and end date columns for each task.\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/670e82ed6d43ca7b17b2be8d/file-fxo1VernFc.png\"></p><hr><h2>How do I export a task list in TeamGantt?</h2><p>\n\t To export a project's \n\t<em>List</em> view to PDF, go to&nbsp;<em>Menu &gt; Print List View.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/670e83148af27b34842c027e/file-CblIngu0Hy.png\"></em></p><hr><p>\n\t<strong><em style=\"background-color: initial;\">To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!</em></strong></p>","name":"List View","number":144,"categories":["5f510e62c9e77c0016384617"]}},{"node":{"slug":"import-from-microsoft-project","text":"<p>\n\tImporting a .mpp&nbsp;file is a great way to get a project started in TeamGantt when the data has already been created in Microsoft Project.&nbsp;</p><h3>\n<strong>How do I import a .mpp file to create a new project?</strong></h3><ol>\n\t\n<li>Click the&nbsp;<em>New Project&nbsp;</em>button in the top right of your&nbsp;<em>My Projects</em>&nbsp;page.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a8c55e70cc0787457b749ce/file-CyJddZlnWx.png\">&nbsp;</li>\t\t\n\t\n<li>Select&nbsp;<em>Import from Microsoft Project</em>&nbsp;to begin the import process.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a8c55268565417004fc5b07/file-IYo9HzRlER.png\"></li>\t\t\n\t\n<li>Choose your .mpp file by clicking <em>Upload a file</em>&nbsp;or by dragging and dropping the file into the <em>Upload a file</em>&nbsp;box</li>\t\t\n\t\n<li>Once the file has been uploaded, your Gantt chart will be created!</li></ol><hr><h2></h2><h2>What data can I import?</h2><ul>\n\t\n<li>Task Name</li>\t\n<li>Dependencies</li>\t\n<li>Start/End Dates</li>\t\n<li>Task Completion Percentages</li></ul><p>\n\t<strong style=\"background-color: initial; font-family: inherit; font-size: 24px;\">What data can't be imported?</strong></p><ul>\n\t\n<li>Task Resource Assignments</li>\t\n<li>Resources</li></ul><p>\n\tHaving trouble with importing your file?&nbsp;Email us at support@teamgantt.com. We'd be happy to help!</p><p>\n\tLooking for another way to sync your data with TeamGantt?&nbsp;Check out our \n\t<a href=\"https://support.teamgantt.com/article/152-teamgantt-integration-for-zapier\">integration with Zapier</a>!&nbsp;</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Import a Project from Microsoft Project","number":161,"categories":["5284df24e4b027e0d843bca8"]}},{"node":{"slug":"teamgantt-integration-for-zapier","text":"<p>\n\t Sync your TeamGantt project data with other platforms you regularly use by activating the \n\t<a href=\"https://zapier.com/apps/teamgantt/integrations\">TeamGantt integration for Zapier</a>.&nbsp;</p><h2><hr>\n How do I set up the TeamGantt integration for Zapier?\n</h2><p>\n\t You can access the TeamGantt integration via your account on Zapier.com. Simply click \n\t<em>Make a Zap,</em> and search for the TeamGantt app to connect it with your favorite platforms.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/602303b1fb34b55df443f08d/file-bJOKDFsjPg.png\"></p><p>\n\t Finish your integration setup by completing the following steps:</p><ol>\n\t\n<li>Log into your TeamGantt account.</li>\t\n<li>Select the <em>New project task</em> trigger event.&nbsp;\n\t\n<p>\n\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/602303d0a4cefb30ae5c91c2/file-QeEofnSYn1.png\">\n\t</p></li>\t\n<li>Choose the project you’d like to trigger actions for.&nbsp;\n\t\n<p>\n\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6023041afb34b55df443f093/file-hrEwiYUfBY.png\">\n\t</p></li>\t\n<li>Choose the app you want to sync with, and set up the actions you’d like Zapier to perform between TeamGantt and this app.&nbsp;</li></ol><p>\n\t Then get ready for the magic to happen 🤩</p><p>\n\t<em>If you’re not a Zapier user but would like to preview our integration, you can do so <a href=\"https://zapier.com/apps/teamgantt/integrations\">here</a>.&nbsp;</em></p><h3><hr>\n</h3><h2>What triggers are available for TeamGantt's Zapier integration?</h2><p>\n\t Here are the triggers that are currently available:</p><h3>New project task</h3><ul>\n\t\n<li>Triggers when a new task is created in a project</li></ul><h3><hr>\n</h3><h2>What actions does TeamGantt's Zapier integration support?</h2><p>\n\t Here are the actions the integration currently supports:&nbsp;</p><h3>Complete CRUD actions for tasks</h3><h4>Create task</h4><p>\n\t Creates a new task</p><h4>Get task</h4><p>\n\t Fetches a task (by ID)</p><h4>Update task</h4><p>\n\t Allows for editing task information, such as:</p><ul>\n\t\n<li>Task names</li>\t\n<li>Start and end dates</li>\t\n<li>Progress</li>\t\n<li>Task color</li>\t\n<li>Sort order</li>\t\n<li>Parent group and/or project</li>\t\n<li>Favorite/unfavorite</li></ul><h4>Delete task</h4><p>\n\t Deletes a task (by ID)</p><h3>Create projects</h3><h4>Create project</h4><p>\n\t Creates a new project</p><h3>Create, update, and delete <a href=\"https://support.teamgantt.com/article/115-checklists\">checklists</a></h3><h4>Create checklist</h4><p>\n\t Creates a checklist item on a task&nbsp;</p><h4>Update checklist</h4><p>\n\t Modifies a checklist:&nbsp;</p><ul>\n\t\n<li>Names</li>\t\n<li>Sort order</li>\t\n<li>Completion</li></ul><h4>Delete checklist</h4><p>\n\t Deletes a checklist item from a task</p><h3> Create groups of tasks</h3><h4>Create group</h4><p>\n\t Creates a new group of tasks</p><h3> Create comments at the task, group, and project level</h3><h4>Create task comment</h4><p>\n\t Creates a new comment on a task</p><h4>Create group comment</h4><p>\n\t Creates a comment on a task group</p><h4>Create project comment</h4><p>\n\t Creates a comment at the project level</p><hr><h2>Does TeamGantt offer any Zap templates?</h2><p>Yes, we currently offer almost 30 zap templates (and counting)! Zap templates allow you to sync TeamGantt with your favorite apps in a few easy clicks.&nbsp;</p><p>\n\t Sync with Jira, Google Sheets, Asana, and more.</p><p>\n\t Check out our full list \n\t<a href=\"https://zapier.com/apps/teamgantt/integrations\">here</a>!&nbsp;</p><hr id=\"horizontalrule\"><p>\n\t The TeamGantt integration for Zapier is currently in beta. Got requests for triggers, actions, or zap templates? Let us know by emailing support@teamgantt.com.</p><hr><p>\n\t<strong><em>To learn more about TeamGantt, join us for one of our free <a href=\"https://www.teamgantt.com/classes\">classes</a>!&nbsp;</em></strong></p>","name":"TeamGantt Integration for Zapier","number":152,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"move-tasks-to-another-project","text":"<div>\n  Need to move tasks from one project to another? Never fear! You've got a couple of easy options to do that in TeamGantt.&nbsp; \n\t<br>\n</div><div>\n\t<h2>How do I move tasks from one project to another?</h2>\n</div><div>\n  First, \n\t<a href=\"https://support.teamgantt.com/article/25-viewing-multiple-projects\">open both projects</a> in the same window. Then, choose one of the following options to move tasks from one project to another.&nbsp;&nbsp;\n</div><div>\n\t<hr>\n</div><h3> <strong>Method 1: Click and Drag</strong></h3><h4></h4><h4>To move a group of tasks:&nbsp;</h4><p>\n\t<b style=\"background-color: initial; font-size: 14px;\"></b>Click the dark gray bar for the task group you'd like to move, and drag it from its current project to the new one.&nbsp;In the example below, we're moving the <em style=\"background-color: initial;\">Assess and Plan</em> task group from the <em style=\"background-color: initial;\">Mobile App</em> project to the <em style=\"background-color: initial;\">Design New Website</em> project.</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a95a3a04254e779581a4c76/file-5tZXAdQT7E.png\"><br><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a95a381de9db37df4024729/file-UHCB76dHDg.png\"></p><h3></h3><h4>To move individual tasks:&nbsp;</h4><p>\n\tSelect the task you'd like to move from the selection column in the far left of the project. Once selected, clic and drag it from its current project to the new one. In the example below, we're moving the \n\t<em>Client kickoff meeting</em> task from the <em>Mobile App</em> project to the <em>Design New Website</em> project:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a95a437de9db37df4024731/file-lWXzLS0pKR.png\"></p><p><strong></strong></p><h2><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a95a4d326f9ffe83c5d0b7d/file-C3ON3mEvps.png\"><br><hr>\n</h2><h3> <strong>Method 2: Use the <em>Edit</em> window for the group or task&nbsp;</strong></h3><p>\n\t<strong></strong>Hover over the group (or task) name, and click the pencil icon to open up the <em>Edit</em> window. Then select the <em>Parent Group </em>drop-down to select a new project.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a95a58a26f9ffe83c5d0b80/file-4lGgSMCBqv.png\"></p><p>Want to make a copy of an existing group or task before moving it into another project? Simply \n\t<a href=\"https://support.teamgantt.com/article/26-duplicating-a-group\">duplicate the original</a>.&nbsp;</p><hr><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"Move Tasks to Another Project","number":128,"categories":["5284df24e4b027e0d843bca8"]}},{"node":{"slug":"api-personal-access-tokens","text":"<p>Available in all of our paid plans, API Personal Access Tokens allow you to authenticate with the TeamGantt API using a secure token instead of your username and password. This is useful for integrating with third-party applications, building custom tools, or automating tasks.</p><hr><h3>What is a Personal Access Token?&nbsp;</h3><p>\n\t<span style=\"font-weight: normal;\">Personal Access Tokens (PATs) are long-lived authentication credentials that provide access to your TeamGantt account. Each token is associated with your user account and can be used to make API requests on your behalf.</span></p><hr><h3>How to create a token?&nbsp;</h3><p>\n\tTo create a token, you must have the following requirements:&nbsp;</p><ul>\n\t\n<li>You must be logged into your TeamGantt account.</li>\t\n<li>The token name is required and must be a string.</li>\t\n<li>Choose a descriptive name to help you identify the token's purpose later.</li></ul><p>\n\tOnce you have the above requirements, you can complete the steps to create a token.&nbsp;</p><ol>\n\t\n<li>Navigate to the <strong>Account Settings</strong>&nbsp;page.</li>\t\n<li>Select <strong>API Personal Access Tokens.</strong></li>\t\n<li>Then, enter a descriptive name for your token (e.g., \"Mobile App Integration\", \"Automation Script\").</li>\t\n<li>Click <strong>Create Token.&nbsp;</strong></li></ol><p>\n\t<strong>NOTE:&nbsp;</strong> <strong>Copy and save your token immediately - it will only be shown once!</strong></p><h4><strong>Example:&nbsp;</strong></h4>\n<pre>```json\n{\n  \"token_name\": \"My Integration Token\"\n}\n```\n\n**Response:**\n```json\n{\n  \"token\": \"1|abc123def456ghi789jkl012mno345pqr678stu901vwx234yz\"\n}\n```&lt;br&gt;\n</pre><hr><h3>How to use your token?&nbsp;</h3><p>\n\tTo use your token,&nbsp;include your token in the `Authorization` header of your API requests:&nbsp;</p>\n<pre>```text Authorization: Bearer 1|abc123def456ghi789jkl012mno345pqr678stu901vwx234yz ```\n</pre><h4>Example Request:&nbsp;</h4>\n<pre>```bash\ncurl -X GET \"https://api.teamgantt.com/v1/current_user\" \\\n  -H \"Authorization: Bearer YOUR_TOKEN_HERE\" \\\n  -H \"Content-Type: application/json\"\n```\n</pre><hr><h2>Managing Your Tokens</h2><h3>How to view all tokens?&nbsp;</h3><p>\n\tYou can see a list of all your active tokens in the API personal access tokens section of your account settings. Each token shows:&nbsp;</p><ul>\n\t\n<li><strong>Name:</strong>&nbsp;The descriptive name you gave it.</li>\t\n<li><strong>Created:</strong> When the token was created.</li>\t\n<li><strong>Last Used:</strong> When the token was last used (if applicable).</li></ul><hr><h3>How to delete individual tokens?&nbsp;</h3><p>\n\tTo revoke access for a specific token, complete the following steps:&nbsp;</p><ol>\n\t\n<li>Find the token in your list.&nbsp;</li>\t\n<li>Click the <strong>Delete </strong>icon next to the token.&nbsp;</li>\t\n<li>Confirm the deletion.&nbsp;</li></ol><hr><h3>How to delete all tokens?&nbsp;</h3><p>\n\tTo revoke access for all your tokens at once, complete the following steps:&nbsp;</p><ol>\n\t\n<li>Go to <strong>Account Settings &gt; API Personal Access Tokens</strong>.</li>\t\n<li>Click <strong>Delete All Tokens</strong>.&nbsp;</li>\t\n<li>Confirm the action.&nbsp;</li></ol><hr><h2>Security Best Practices</h2><h3>How to keep tokens secure?&nbsp;</h3><ul>\n\t\n<li>Keep tokens secret - Treat your tokens like passwords.</li>\t\n<li>Store your tokens securely -&nbsp;Save your tokens in a secure password manager or encrypted storage.</li>\t\n<li>Use HTTPS - Always make API requests over HTTPS.&nbsp;</li>\t\n<li>Rotate your tokens regularly - Consider creating new tokens periodically and deleting old ones.&nbsp;</li></ul><hr><h3>How to name tokens?&nbsp;</h3><p>\n\tWhen naming tokens, use descriptive terms that help you identify the purpose. Below are some good and bad examples:&nbsp;</p><ul>\n\t\n<li>✅ \"Mobile App v2.1\"</li>\t\n<li> ✅ \"Automation Script - Project Updates\"&nbsp;</li>\t\n<li>✅ \"Integration with Slack\"&nbsp;</li>\t\n<li>❌ \"token1\"</li>\t\n<li>❌ \"test\"</li></ul><hr><h3>When should I delete a token?&nbsp;</h3><p>\n\tYou should delete a token for the following reasons:&nbsp;</p><ul>\n\t\n<li>No longer need the integration.</li>\t\n<li>Suspect a token has been compromised.</li>\t\n<li>Switching to a new token for the same purpose.</li>\t\n<li>To limit access to your account.</li></ul><hr><h2>Troubleshooting</h2><h2></h2><h3>What are some common issues that may happen with a personal access token?&nbsp;</h3><ul>\n\t\n<li><strong>\"Token name is required.\"</strong>\n\t\n<ul>\n\t\t\n<li>Make sure you've entered a name for your token before creating it.</li>\t</ul></li>\t\n<li><strong>\"Token name must be a string.\"</strong>\n\t\n<ul>\n\t\t\n<li>Ensure the token name is text, not a number or other data type.</li>\t</ul></li>\t\n<li><strong>\"Unauthorized\" error</strong>\n\t\n<ul>\n\t\t\n<li>Check that your token is correct and hasn't been deleted.</li>\t\t\n<li>Verify you're using the `Bearer` prefix in the Authorization header.</li>\t\t\n<li> Ensure the token hasn't expired (tokens don't expire by default).</li>\t</ul></li>\t\n<li><strong>Token not working</strong>\n\t\n<ul>\n\t\t\n<li>Try creating a new token.</li>\t\t\n<li>Check that you copied the entire token correctly.</li>\t\t\n<li>Verify you're using the correct API endpoint.</li>\t</ul></li></ul><hr><h3>How do I get help with my API access tokens?&nbsp;</h3><p>\n\tIf you're having trouble with API access tokens:</p><ol>\n\t\n<li>Check that you're using the correct authentication method.</li>\t\n<li>Verify your token is still active in your account settings.</li>\t\n<li>Try creating a new token if the current one isn't working.</li>\t\n<li>Contact support if you continue to have issues.</li></ol><hr><h3>What API endpoints are available?&nbsp;</h3><p>\n\tThe following endpoints are available for managing your tokens:</p><ul>\n\t\n<li>`POST /v1/current_user/tokens/create` - Create a new token</li>\t\n<li>`GET /v1/current_user/tokens` - List all your tokens&nbsp;&nbsp;</li>\t\n<li>`DELETE /v1/current_user/tokens/{tokenId}` - Delete a specific token&nbsp;</li>\t\n<li>`DELETE /v1/current_user/tokens/delete` - Delete all tokens</li></ul><h3></h3><h3></h3><p style=\"\"></p>","name":"API Personal Access Tokens","number":171,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"authenticating-with-teamgantt","text":"<h2>How do I authenticate with the TeamGantt API?</h2><p>\n\t 🎉&nbsp;Check out our interactive OAuth2 documentation here -- \n\t<a href=\"https://auth.teamgantt.com/docs/\" target=\"_blank\">https://auth.teamgantt.com/docs/</a>.</p><p>\n\t<strong>Overview</strong></p><ol>\n\t\n<li>Create an integration app (i.e. \"client\") with TeamGantt.</li>\t\n<li>Obtain your initial auth tokens via email and password.</li>\t\n<li>Authorize your requests to TeamGantt.&nbsp;</li>\t\n<li>Exchange your refresh token with our authorization server to get a new token as needed.</li>\t\n<li>Optionally revoke all refresh tokens</li></ol><p>\n\t<strong>1. Create Integration App</strong></p><p>\n\t Head on over to your account at TeamGantt and click on \n\t<a href=\"https://app.teamgantt.com/admin/app-tokens\" target=\"_blank\">Configure API Access (beta)</a>. All of your existing apps have been converted to work with our new auth flows. If you haven't created an app before, simply create a new one (the name must be unique for your account, and is only for your own reference). Once you have created an app, you will need the generated client_id and client_secret to build your request header.&nbsp;</p><p>\n\t<strong>2. Obtain Initial Auth Tokens</strong></p><p>\n\t First, you will need to exchange your email and password with our auth server in order to receive authorization tokens. In OAuth2 terms, this is called the password \"grant type\", in that you are obtaining access tokens based on your username/password credentials. An alternative to this will be using the refresh token grant type to get a new token.</p><p>\n\t For all grants, the endpoint will be:</p>\n<pre>https://auth.teamgantt.com/oauth2/token\n</pre><p>\n\tWhen obtaining your initial auth tokens, you will need to provide a basic authorization header generated from your client. Simply join the client_id and client_secret with a colon and base64 encode the result (this is a standard for HTTP Basic auth -- you can find this built in to tools like Postman)</p>\n<pre>const authHeader = `Basic ${btoa([clientId, clientSecret].join(\":\"))`; \n// Basic NDQwNzFlYTEtMjg1YS00ODc3LTlkZjctN2IyZTA3MTdjZWVjOmFzamtsbmRzYWtqbGRubWtzYWpkbmpzYWtkbiBrc2FqaDg5MnUxMzRqM3drbmV3cXUzMm53ZWprZXJuMjgzajQz\n</pre><pre>POST /oauth2/token HTTP/1.1\nHost: auth.teamgantt.com\nAuthorization: Basic yourBase64EncodedString\nContent-Type: application/x-www-form-urlencoded\n\ngrant_type=password&amp;username=john@doe.com&amp;password=topsecret\n</pre><p>\n\t These are the required parameters for a password grant. They must be \n\t<strong>x-www-form-urlencoded</strong> (encode each value, not the whole request). The parameters are joined on the query string, not sent in the body. If you're having issues getting past this step and have special characters in your password, you may want to double check your encoding.</p><ul>\n\t\n<li><strong>grant_type=password</strong></li>\t\n<li><strong>username=</strong>&nbsp;// your TeamGantt account email address</li>\t\n<li><strong>password= </strong>// your TeamGantt account password</li></ul><p>\n\t The response, is successful, will be a JSON object containing your auth tokens. Here's an overview of them.</p><ul>\n\t\n<li><strong>id_token</strong><br>\n\t This is the token you will use when making an authenticated request to any TeamGantt API routes. It is only valid for 1 hour after being issued. It is a standard JSON Web Token (JWT), and you can inspect the payload of this token for the \"exp\"&nbsp;claim to see when it will expire. \n\t</li>\t\n<li><strong>refresh_token</strong><br>\n\t This token should be securely stored by you and used to refresh your session and obtain a new id_token. Each refresh token has a 30 day expiration. You can choose to revoke all of your refresh tokens. \n\t</li>\t\n<li><strong>access_token</strong><br>\n\t This is special auth token used only to revoke all of your refresh tokens. \n\t</li></ul><p>\n\t<strong>3. Authorize Your Requests</strong></p><p>\n\t Now that you have an id_token, you will simply include this as the Bearer for your Authorization headers to TeamGantt.</p>\n<pre>GET /tasks HTTP/1.1\nHost: api.teamgantt.com\nAuthorization: Bearer your.id_token.jwt\n</pre><p>\n\t This will work as long as your id_token is valid. However, after an hour you will need to obtain a new id_token in order to continue using the API. This is where your refresh token comes in.</p><p>\n\t<strong>4. Exchange Refresh Token</strong></p><p>\n\t Refreshing your id_token is even simpler than using the password grant. The endpoint, method, and content type is the same, you just need to provide different parameters. Since you've already authenticated the client to obtain your refresh token, you do not need to send the authorization header this time.</p><ul>\n\t\n<li><strong>grant_type=refresh_token</strong></li>\t\n<li><strong>refresh_token=</strong>&nbsp;// your previously obtained refresh_token from the password grant</li></ul>\n<pre>POST /oauth2/token HTTP/1.1\nHost: auth.teamgantt.com\nContent-Type: application/x-www-form-urlencoded\n\ngrant_type=refresh_token&amp;refresh_token=your.refresh_token.jwt\n</pre><p>\n\t The response, if successful, will only contain an id_token and access_token, which can be used to make further requests to the TeamGantt API. If at anytime you need a new refresh_token, this can only be obtained through the password grant above.&nbsp;</p><p>\n\t<strong>5. Revoke Refresh Tokens</strong></p><p>\n\t If at any point you wish to revoke all refresh tokens that have been obtained using the password grant, you can do so with this request. Similar to the password grant, you will need to provide the basic authorization header with your client id and secret. Additionally, the request body will need to include a valid access_token from either a password or refresh grant response. This will revoke each and every refresh token that has been created for your user. There is not currently a way to revoke an individual token, though that should be supported in the future.</p>\n<pre>POST /revoke HTTP/1.1\nHost: auth.teamgantt.com\nAuthorization: Basic yourBase64EncodedClientId:Secret\nContent-Type: application/x-www-form-urlencoded\n\ntoken=your.access.token\n</pre>","name":"Authenticating with TeamGantt","number":153,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"use-zapier-to-sync-a-jira-project","text":"<h2>How do I sync a Jira project with TeamGantt?&nbsp;</h2><p>You can use Zapier to connect your Jira and TeamGantt projects. Follow the steps below to automatically create or update tasks in TeamGantt whenever an issue is created or updated in Jira.</p><hr><h4>1) Create a new project in TeamGantt\n</h4><ul>\n\t\n<li>Load <a href=\"https://app.teamgantt.com/\" target=\"_blank\">TeamGantt</a></li>\t\n<li> Log in or sign up</li>\t\n<li><a href=\"https://app.teamgantt.com/projects/new\" target=\"_blank\">Create a new project</a></li></ul><hr><h4>2) Create a custom field in Jira</h4><ul>\n\t\n<li>Load your Jira site\n\t</li>\t\n<li>Load the custom fields admin page: \"https://&lt;your-site-name&gt;.atlassian.net/secure/admin/ViewCustomFields.jspa\" (you will need to replace \"&lt;your-site-name&gt;\" with the name of your Jira site)</li>\t\n<li>Click \"Create custom field\"\n\t</li>\t\n<li>Specify \"Short text\"\n\t</li>\t\n<li>Name the field \"tg_id\" (see GIF below)</li></ul><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/655cf85d61a11f56e8753665/file-wVUID23UCE.gif\"></p><hr><h4>3) Add the new custom field to all of your Issue types</h4><ul>\n\t\n<li>Navigate back to your project\n\t</li>\t\n<li>From the sidebar, click \"Project settings\"\n\t</li>\t\n<li>Click \"Issue types\"\n\t</li>\t\n<li>Select the \"Task\" issue type\n\t</li>\t\n<li>Drag the \"tg_id\" field into the \"Description\" or \"Context\" section (see video)</li>\t\n<li>Repeat for all other Issue types (i.e. Epic, Bug, etc). If you don't add this field to all of your issue types, it could cause Zapier errors.&nbsp;</li></ul><h4>\n<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/655cf8c461a11f56e8753666/file-pYJxpDJw1i.gif\"><hr>\n4) Save the ID number of the new custom field\n</h4><ul>\n\t\n<li>Navigate back to the custom fields admin page: `https://&lt;your-site-name&gt;.atlassian.net/secure/admin/ViewCustomFields.jspa`\n\t</li>\t\n<li>Locate the \"tg_id\" field and click on its name\n\t</li>\t\n<li>Next, click \"Edit details\"\n\t</li>\t\n<li>Save the id field that is appended to the end of the URL in your browser window (see video)\n\t</li></ul><p>\n\t<em>You will need this ID to set up Zapier!</em></p><h4>\n<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/655cf8df79594218b99bbbdd/file-8wetnLgTbW.gif\"><hr>\n5) Create a Zap to keep TeamGantt in sync with new Jira issues\n</h4><ul>\n\t\n<li>Open <a href=\"https://zapier.com/app/zaps\" target=\"_blank\">Zapier</a> (contact <a href=\"mailto:mailto:matt@teamgantt.com\">matt@teamgantt.com</a> to request access to a Zapier template that will help get you started on this Zap)</li>\t\n<li>Click \"Create Zap\"\n\t</li>\t\n<li>Add a <strong>New Issue</strong> trigger from the Jira Software Cloud app\n\t</li>\t\n<li>Add a <strong>Create Task</strong> action from the TeamGantt app (specify whatever fields are needed. Select the project that you created above)\n\t</li>\t\n<li>Add an&nbsp;<strong>Update Issue</strong> action from the Jira Sofware Cloud app. In the \"Issue\" field, be sure to specify the key of the issue included in the trigger from Jira. Also, be sure to populate the \"tg_id\" field with the id of the task that was created in TeamGantt's <strong>Create Task&nbsp;</strong>action</li></ul><p style=\"margin-left: 20px;\">\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/655d0345d8c4315d1df50f21/file-LWlXmG2sLt.png\"></p><hr><h4>6) Create another Zap to keep TeamGantt in sync with updated Jira issues</h4><ul>\n\t\n<li>Open <a href=\"https://zapier.com/app/zaps\" target=\"_blank\">Zapier</a> (check out this <a href=\"https://zapier.com/shared/c1fdeec094badd6071765dcf53b7dbf832df6c7d\" target=\"_blank\">Zapier template</a> I created to get you started on this Zap)</li>\t\n<li>Click \"Create Zap\"\n\t</li>\t\n<li>Add an&nbsp;<strong>Updated Issue</strong> trigger from the Jira Software Cloud app\n\t</li>\t\n<li>Add an&nbsp;<strong>Update Task</strong> action from the TeamGantt app. For the \"Task id\" field, use the value associated with the \"tg_id\" custom field. The Jira app doesn't expose \"tg_id\" by name, but instead by its custom field id. Remember! You saved this in a previous step. Find it and select it (see below)</li></ul><p style=\"margin-left: 20px;\">\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/655d024e61a11f56e8753678/file-Anscc9Dsmd.png\"></p><h5>Troubleshoot issues</h5><ul>\n\t\n<li>I would recommend only creating a custom field from the custom fields screen in the <strong>account's</strong> admin settings section of your Jira site (I included the link to that above). I've noticed that if you create a custom field directly from the <strong>project's</strong>&nbsp;settings page, it's only available to the project you created it on (which isn't much of a problem unless you want to sync multiple Jira projects to one TeamGantt project). The real issue is that it's really hard to find the ID number for that custom field. I had to watch network batch requests to find it... oof.</li>\t\n<li>The \"Test\" step in Zapier is a challenge! If the test is failing. Make sure that the issue being pulled in from Jira in the trigger step is up to date.</li>\t\n<li>All of your Issue types must sync to TeamGantt in order to avoid errors being Triggered in Zapier. It would be helpful if Jira's Zapier app allowed users to exclude epics or other issue types. Unfortunately, this is not possible.&nbsp;</li></ul><h5>Take this further</h5><ul>\n\t\n<li>You might want to create a bi-directional sync so that updates in TeamGantt are reflected in Jira. You could accomplish that by creating additional zaps to handle task creation and updates in TeamGantt.&nbsp;</li>\t\n<li>You might want to sync multiple Jira projects to a single TeamGantt project. This could be possible with additional Zaps.&nbsp;</li>\t\n<li>You might have existing Issues in a Jira project that you want to sync to TeamGantt. This might require some manual entry, but it is possible. Reach out to our support team for ideas on how to accomplish this.&nbsp;</li></ul><h5></h5><h5></h5>","name":"Sync Jira to TeamGantt using Zapier","number":159,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"displaying-week-numbers","text":"<p>\n\tIn TeamGantt, you can choose to display week numbers at the top of your Gantt chart. Week numbers align with calendar weeks (i.e. the first week of January would be w1).&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a95aa4cde9db37df402474b/file-ButF59rtkE.png\"></p><h2>How do I show week numbers on my gantt chart?</h2><p>\n\tTo display week numbers, go to the&nbsp;\n\t<em>View </em>menu to select <em>Timeline &gt; Show week numbers.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a95aa260b3932344381fd0a/file-wGgXUMoceO.png\"></em></p>","name":"Displaying Week Numbers","number":164,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"manage-teams","text":"<p>\n\t Group users&mdash;by department, client company, office location, and more&mdash;with our \n\t<em>Teams</em> feature.&nbsp;</p><p>\n\t<em>Teams</em> allows you to:</p><ul>\n\t\n<li>Manage project access for multiple users at once&nbsp;</li>\t\n<li>View all your teams’ tasks across projects</li>\t\n<li>Easily onboard and offboard users by adding/removing them to/from multiple projects at once</li>\t\n<li>Easily transition people to a different team if there are changes at your company</li></ul><h2><hr>\n Who can view and manage teams in TeamGantt?\n</h2><p>\n\t This feature is available on our Business and Builder Edition plans. However, only users with manager \n\t<a href=\"https://support.teamgantt.com/article/5-permissions\">permission</a> can view and manage teams on your account.&nbsp;</p><hr><h2>How do I create and manage a team in TeamGantt?</h2><p>\n\t If you’re a manager, you can manage teams by clicking your profile icon in the upper right corner of the screen in TeamGantt. Then select \n\t<em>Account Settings</em> &gt; <em>Manage Teams</em>.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a06da0c4d142b755b502e1/file-vFLIawgaj7.png\"></p><p>\n\tTo create a new team, click the blue \n\t<em style=\"background-color: initial;\">Create team</em> button, then give your team a name. You might create teams for departments within your organization, team locations, temporary or external users, or even client groups.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a06e45c60795985144c30b/file-7W6QLT9eLR.png\"></p><p>\n\tHere are all of the team management options that are accessible from the 3-dot menu:</p><ul>\n\t\n<li><em>Edit Team</em>: This allows you to add or remove users from your team.</li>\t\n<li><em>View Team Calendar</em>: This displays all your team’s tasks in <em>Calendar</em> view so you can get an easy look at your team’s current and upcoming tasks.&nbsp;</li>\t\n<li><em>Delete Team</em>: This removes the team from your account. (However, it does not delete the users from your account.)</li></ul><hr><h2>How do I add or remove users from a team?</h2><p>\n\t To add users to your team, click the blue \n\t<em>Edit Team</em>&nbsp;link at the bottom of your team. (Or click the 3-dot menu at the upper right, then choose <em>Edit Team</em>.)</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a06eedc4d142b755b50308/file-C512fxi5sQ.png\"></p><p>\n\tA new window will pop up enabling you to add or remove users from the team. The left side of the window enables you to search for a user or select one from the list of available users, while the right side shows you everyone who’s currently assigned to the team.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a06edac60795985144c313/file-BGhyT4pofa.png\"></p><p>\n\t<strong style=\"background-color: initial;\"></strong></p><h3>\n<strong style=\"background-color: initial;\">To add a user to a team:</strong></h3><p>\n\t<strong></strong>Click the blue arrow next to a person’s name from the list on the left. When a new user is added to a team, they’re invited to all projects assigned to that team. This is a super-fast way to get new people on every applicable team project!<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a06f19c4d142b755b50314/file-nXyybYWIpT.png\"></p><p>\n\t Users can be added to multiple teams at once.</p><h3>\n<strong>To remove a user from a team:</strong></h3><p>\n\t Click the red X next to a user’s name from the list on the right. Removing a user from a team uninvites them from all projects assigned to that team, making it easy to offboard team members quickly. (Note: This does not remove them from the account.)\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a06f3ac4d142b755b50316/file-K16dcEB1Vy.png\"></p><hr><h2>How do I use <em>Teams</em> in projects?&nbsp;</h2><p>\n\t Now that you have a team, you can invite them to a project by opening the project and navigating to the \n\t<em>People</em> page.</p><h3>Inviting a team</h3><p>\n\tFrom the \n\t<em style=\"background-color: initial; font-size: 14px;\">People </em>page, click the <i style=\"background-color: initial; font-size: 14px;\">Invite teams</i>&nbsp;button from the Teams section on the People page.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a06fdbc4d142b755b50326/file-LYzOrZLg01.png\"></p><p>\n\tThen, select the team from the drop-down that appears. Each team listed in the drop-down will show the team’s name on the left and the people assigned to the team on the right:</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69a07004c60795985144c331/file-2YK8lsufag.png\"></p><p>\n\tWhen a team is added to a new project, everyone on that team will receive an email notification.&nbsp;</p><p>\n\t Note: Right now, you can only add teams to projects and project boards. This feature isn’t available yet in custom boards.</p><h4></h4><h3>Assigning team members to tasks</h3><p>\n\t Assigning teams to tasks isn’t currently supported in TeamGantt. When you click the \n\t<a href=\"https://support.teamgantt.com/article/6-inviting-people#assign-a-single-task-to-a-user\"><em>Assign People</em></a> link for a task, all of a team’s users are individually listed and available for assignment.&nbsp;</p><hr><p>\n\t<strong><em>To learn more about TeamGantt, join us for one of our free <a href=\"https://www.teamgantt.com/classes\">classes</a>!&nbsp;</em></strong></p>","name":"Manage Teams","number":151,"categories":["5284de2fe4b027e0d843bc97"]}},{"node":{"slug":"csv-feed-to-google-sheets","text":"<p>\n\tYou can use TeamGantt's CSV feed feature to export your TeamGantt project data to a Google Sheet. Changes you make in TeamGantt will be updated in your Google sheet automatically. It is a one way feed, so it is not possible to make changes in your Google Sheet and have them sync back to TeamGantt.</p><hr><h2>How do I sync my TeamGantt project with Google Sheets?</h2><p>\n\t To setup the CSV feed, first open your TeamGantt project (or projects) in Gantt chart view. Then go to \n\t<strong>Menu</strong> &gt; <strong>CSV Feed</strong>:<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a8c53a7979459a287f19b94/file-qY7iSbSEeQ.png\"></p><p>Then copy the resulting link:</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a8c53738565417004fc5b02/file-xVmcErtWNG.png\"></p><p>\n\t Next, open your empty Google Sheet. In the first cell (upper left), type in: \n\t<strong>=importdata(\"</strong><em>paste</em><em>yourlinkhere</em><strong>\")</strong> and press enter. Your TeamGantt project data in CSV format should populate the Google Sheet immediately. It should look like this:</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/63457dcb0f10306a37c0b3ff/file-Ra3Z3DWIGU.png\">Now you're done!&nbsp;Your Google Sheet will update the data from TeamGantt at regular intervals.&nbsp;</p><hr><h2>How frequently does Google Sheets update data from TeamGantt?</h2><p>\n\tGoogle's website currently suggests it could take up to 1 hour for Sheets to update the data.</p><hr><h2>Can I refresh data between automatic updates?</h2><p>\n\tYes. If you would like to force a refresh, simply click the first cell with your import formula, copy it, delete that cell, and then paste your formula back into it. This will force Google Sheets to pull fresh data from TeamGantt.</p><hr id=\"horizontalrule\"><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p><p>\n\t<a></a></p>","name":"Establish a CSV Feed to Google Sheets","number":156,"categories":["5284df24e4b027e0d843bca8"]}},{"node":{"slug":"exporting-importing-to-procore","text":"<p>\n\tThere are 2 ways to upload your TeamGantt projects to Procore:</p><p>\n\t1. Use the TeamGantt integration for Procore to sync project data.</p><p>\n\t2. Export your project to MPP format, and then upload it to Procore</p><h2>TeamGantt Integration for Procore</h2><h4>Enabling the integration and syncing to a project</h4><p>\n\tTo enable the integration, open your project in TeamGantt and select&nbsp;\n\t<strong>Menu &gt; Upload to Procore</strong><em>.&nbsp;</em></p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6793b3f707fb267f6255558d/file-Ft3JJXU1lV.png\"></p><h4><p>\n\tNext, authenticate your Procore account. Then, select your company in Procore and the project you'd like to sync with and click \n\t<em>Upload.</em></p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6793b4039d28813d0937bffc/file-ftFBBPIO6U.png\"></p></h4><h4>Viewing your timeline in Procore</h4><p>\n\tTo view your Gantt chart in Procore, log into your Procore account and navigate to the \n\t<em>Schedule</em> tab of your synced project.&nbsp;</p><p>\n\tAfter the initial upload, you don't need to manually push every schedule change.</p><p>\n\tTeamGantt automatically syncs schedule changes to Procore about <strong>10 minutes after your most recent update</strong>. Each new change resets the timer so Procore receives a single batch of updates instead of a separate sync for every edit.</p><h4>Syncing resources between TeamGantt and Procore</h4><p>\n\tOnce a TeamGantt project is synced to a project in Procore, you can map your TeamGantt users to your Procore resources.&nbsp;</p><p>\n\tTo do so, click the settings icon next to your project's name in Procore \n\t<em>Schedule</em> tab, and then select the <em>User Permissions </em>tab. Use the dropdown in the <em>Resource </em>column to map each resource.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67c9bb52d0f5694cc87e7633/file-VRGRLkKh6h.png\"></p><h4>Keeping your schedule up to date</h4><p>\n\tWhenever you make changes to your schedule in TeamGantt, you'll need to re-sync your project to Procore. To do so, select \n\t<strong>Menu &gt; Upload to Procore &gt; Upload. </strong>No need to reselect your company and project, since they've been synced previously.</p><h2>Import/Export Project Files</h2><p>\n\tIf you'd like to manually import your project into Procore, you can do so by exporting your TeamGantt project to a Procore-compatible format (.MPP).&nbsp;</p><h3>\nExport your TeamGantt project to Procore</h3><p>\n\tTo export your project to a Procore-compatible format, go to \n\t<strong>Menu &gt; Export to Procore </strong>(in Gantt Classic) or <strong>Menu &gt; Export to MPP </strong>(in Gantt 2.0).<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/667daab0dd0f8c60bb3fdaa3/file-4v9RK6rb6y.png\"></p><p>\n\tOnce you have downloaded the file, head over to&nbsp;Procore to import your project!&nbsp;</p><h2>Import your TeamGantt project to Procore</h2><p>\n\tTo import your TeamGantt project, open up your project's \n\t<em>Schedule</em> in Procore. Then, click &nbsp;\"\n\t<strong>+ Upload Schedule</strong>\". Finally, select your file and upload!</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/667dad45dd0f8c60bb3fdaa5/file-aaw1wEAyN6.png\">Just to note, once the file is imported, you may need to refresh your browser to see the entire schedule.</p>","name":"Exporting and Importing to Procore","number":162,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"teamgantt-feedback-policy","text":"<h2>Why feedback is important to us</h2><p>\n\tAs a small, bootstrapped company, feedback plays a crucial role in the growth and development of TeamGantt. We’re a product-led organization, and so we rely heavily on happy and engaged users to guide our growth and evolution.</p><p>\n\tUnderstanding that we operate with limited resources, we aim to efficiently manage and leverage feedback to enhance the user experience. We will use your feedback to identify pain points, ideas, and opportunities to ship more value to all of our users.&nbsp;</p><h2>How do I report a bug or submit feedback?</h2><p>\n\tWe prioritize making the feedback experience seamless and transparent. Here’s how to give us feedback:&nbsp;</p><h4>Canny</h4><p>\n\tOwned by: The TeamGantt Product team</p><p>\n\t<a href=\"https://teamgantt.canny.io/\">Canny</a> is a feedback forum where you can submit any and all feedback, 24/7. You can access it via your TeamGantt account by clicking on the “Feedback” link at the bottom of your page.&nbsp;</p><p>\n\tSubmit feedback on the following topics, or anything else you’d like to let us know about!</p><ul>\n\t\n<li>Gantt View</li>\t\n<li>Calendar View</li>\t\n<li>List View</li>\t\n<li>Board View</li>\t\n<li>Exporting &amp; Sharing</li>\t\n<li>Resourcing / Workloads</li>\t\n<li>Time Tracking &amp; Estimation&nbsp;</li>\t\n<li>Account Management</li>\t\n<li>Application Performance</li>\t\n<li>Mobile App</li>\t\n<li>Integrations&nbsp;</li>\t\n<li>Reporting</li></ul><p>\n\tCanny is groomed weekly by the product team to ensure that all incoming feedback is reviewed.&nbsp;</p><h4>NPS Rating</h4><p>\n\tOwned by: The TeamGantt Product team</p><p>\n\tYou may notice a survey that pops up at the bottom of the page, asking you to rate your satisfaction with TeamGantt on a scale of 1-10. The rating, as well as any additional comments, are captured by TeamGantt’s product team.&nbsp;</p><p>\n\tNPS feedback is monitored daily, and priority feedback is shared to the full product team and leadership.</p><h4>Chat &amp; Email&nbsp;</h4><p>\n\tOwned by: The TeamGantt Customer Success team</p><p>\n\tConnect with our Customer Success team!</p><p>\n\tChat us via Intercom, using the “Let’s chat” link at the bottom right corner of TeamGantt. Or, email us at \n\t<a href=\"mailto:support@teamgantt.com\">support@teamgantt.com</a>. We offer live support from Monday through Friday, from 7am ET to 7pm ET (New York).&nbsp;</p><p>\n\tCustomer Success will respond in a timely manner to all feedback requests–often within a matter of minutes during business hours! Incoming feedback will be logged to Canny on your behalf, if you have not already submitted feedback there. That way, the product team will have visibility into your feedback.&nbsp;</p><p>\n\tIf feedback is classified as a bug, it will be transferred to the engineering team for resolution.&nbsp;&nbsp;</p><h2>How we’ll communicate</h2><h4>Canny</h4><p>\n\tAs updates are released, we will update the status of the related post in Canny. Anyone who has upvoted or commented on a feature request post will receive a notification by email.&nbsp;</p><h4>Chat &amp; Email</h4><p>\n\tIf you are working with Customer Success to resolve an issue, you will be informed once the issue has an update or has been resolved.&nbsp;</p><h2>How we’ll measure the success of our feedback process</h2><p>\n\tWe strive to continually make TeamGantt better and make our users feel that their opinions matter. We’ll measure the success of our feedback process based on the following metrics:&nbsp;</p><ul>\n\t\n<li>Number of Canny posts replied to on a weekly basis</li>\t\n<li>Number of requested features that have been deployed</li></ul><p>\n\tThanks in advance for helping us make TeamGantt an awesome tool! We appreciate your support and, of course, feedback 🤩.</p>","name":"How can I submit product feedback?","number":160,"categories":["6a021cfef97dd896ebfc81ba"]}},{"node":{"slug":"setting-a-default-view","text":"<h2>How do I set a default view for new projects?</h2><p>\n\tYou can set a default view for new projects during <a href=\"https://support.teamgantt.com/article/106-projects\">the project setup flow</a>.&nbsp;</p><p>\n\tFor instance, if you set the default to&nbsp;\n\t<em>Board&nbsp;</em>view, new people invited into the project will be dropped directly into&nbsp;<em>Board</em>&nbsp;view. This ensures that everyone is looking at the same thing from the get-go.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6aa2caee7851bd3fd9580bb9/file-C9iJj2hYhT.png\"></p><p>\n\t<ic>\n\t<zws></zws>\n\t\n\t<zws></zws>\n\t</ic></p><p>\n\tIf you or a team member decides to work from another view, don't worry! TeamGantt will remember which view you were in last, so you don't have to always toggle to your favorite.</p><hr><p>\n\t<em>Have questions about using TeamGantt? Email us at&nbsp;</em><a href=\"mailto:mailto:support@teamgantt.com\">support@teamgantt.com</a>,&nbsp;<em>and we'll help you out!</em></p><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">classes</a>!&nbsp;</strong></em></p>","name":"Setting a Default View","number":154,"categories":["5f510e62c9e77c0016384617"]}},{"node":{"slug":"project-boards","text":"<p>\n\tProject Boards in TeamGantt offer a Kanban-style view of tasks that are fully synced with your project’s Gantt chart. This makes it easy to manage task workflows without sacrificing the big-picture timeline.</p><hr><h3><strong>What is a project Board in TeamGantt?</strong></h3><p>\n\tA project board is a visual board view that shows all the tasks in a single TeamGantt project. Each card on the board represents a task from your Gantt chart. Updates made in either view are automatically reflected in the other.</p><hr><h3><strong>How do I create a project Board from my Gantt chart?</strong></h3><p>\n\tTo create a Board:</p><p>1. Open the project in Gantt view.</p><p>2. Click the \n\t<strong style=\"background-color: initial;\">Board</strong> tab at the top of your project.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a90613e4b84f76cf81bf0f3/file-yR7eThdFRk.png\"></p><p>\n\t3. Name your&nbsp;Board columns.&nbsp;(For instance, you might want to use existing group names or status groups as column names.)&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/686e66e46d18737eb9caf4dd/file-XphlBem18W.png\"></p><p>\n\tOnce you’ve added all your columns, click the blue&nbsp;\n\t<em>Next</em>&nbsp;button. (Don’t worry: You can always add and edit columns later.)&nbsp;</p><p>\n\t4. Optional:&nbsp;Assign a&nbsp;\n\t<em style=\"background-color: initial;\">% complete</em>&nbsp;value to each column to automatically update task progress when a card is moved to that column. You can also move tasks to columns automatically when progress reaches the defined&nbsp;<em style=\"background-color: initial;\">% complete</em>&nbsp;by activating the&nbsp;<em style=\"background-color: initial;\">Auto move</em>&nbsp;toggle below each column.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/686e681b1fb237467ffb9856/file-WdOW2DusL7.png\"></p><p>\n\t5. Click \n\t<strong>Finish and Create Board</strong>.</p><p>\n\tWatch this video to see how to set up a Board in a project:</p><hr><h3><strong>What updates sync between my Gantt chart and project Board?</strong></h3><p>\n\tBecause project boards are directly tied to your Gantt chart, the following details remain in sync:</p><ul>\n\t\n<li>Task name</li>\t\n<li>Assigned people</li>\t\n<li>Start/end dates</li>\t\n<li>Percent complete</li>\t\n<li>Notes and comments</li>\t\n<li>Documents and checklist items</li></ul><hr><h3><strong>Can I edit tasks or add new cards in a project Board?</strong></h3><p>\n\tYes. Click a card to open its details and make updates.&nbsp;</p><p>\n\tTo create a new card in the Board view, simply click \"Add task\" in the column you'd like to add the task to.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a9061226f9f378e74c1fc12/file-j1uUvTVjXG.png\">New cards created in the Board view will automatically be added as tasks in the Gantt chart.</p><hr><h3><strong>Who can access a project board?</strong></h3><p>\n\tAnyone invited to the project will have access to both the Gantt chart and the project Board. Project Boards inherit permissions from the parent project.</p><hr><h3>What happens when I delete a project board?&nbsp;</h3><p>\n\tSince the project board is a view of the Gantt chart, deleting the project will delete both the Gantt chart and the board. However, you cannot delete the board on its own - It simply exists as another view of the project.</p><h3><span style=\"font-weight: normal;\"></span></h3>","name":"Using Project Boards in TeamGantt","number":168,"categories":["5f510e62c9e77c0016384617"]}},{"node":{"slug":"file-sharing-integrations","text":"<p>\n\t Want to pull documents in from your preferred file storage app? You can do that in TeamGantt!&nbsp;</p><p>\n\tThis feature is now available on all premium trials and paid plans&nbsp;💥.</p><hr><h2>How do I use TeamGantt's Dropbox integration?</h2><p>\n\t Here's how to use the Dropbox integration in TeamGantt:</p><p>\n\t 1) Open the \n\t<a href=\"https://support.teamgantt.com/article/80-adding-comments\">comment</a> for the task, group, or project to which you'd like to attach a file.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a846e025d0caeca8fcacc78/file-Fy1UPMVSLU.png\">2) Click the <em>paperclip icon</em><em style=\"background-color: initial;\">,</em> then&nbsp;<em style=\"background-color: initial;\">From</em>&nbsp;<em style=\"background-color: initial;\">Dropbox.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a846ea7aa237701519b98b8/file-bt5ls0PRqw.png\"></em>3) Sign into your Dropbox account and authorize the sync.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/5fa42f624cedfd001610a14d/file-8UPifeWNSZ.jpg\"></p><p>\n\t 4) Select the file(s) that you wish to attach and click \n\t<em>Choose. </em>This will attach the file(s) to your comment.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a847010aa237701519b98c5/file-adVBVzhCQd.png\">5) Add a comment about the file and click \n\t<em style=\"background-color: initial;\">Submit </em>to finalize the upload. That's it!&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a847055af9fffd6a8975ef0/file-s0PbKJ5taS.png\">If you toggle to the \n\t<em style=\"background-color: initial;\">Documents </em>tab in your comment, all files pulled from Dropbox will include a Dropbox icon. You can also upload Dropbox files directly to this tab by clicking&nbsp;<em style=\"background-color: initial;\">s</em><em style=\"background-color: initial;\">elect files</em>.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a84708d4f742c5313c50469/file-mL8jLCc8Y3.png\">Just to note, there are no file size limitations&nbsp;😎.</p><hr><h2></h2><p>\n\t<em><strong>To learn more about TeamGantt, join us for one of our <a href=\"https://www.teamgantt.com/classes\">free classes</a>!&nbsp;</strong></em></p>","name":"File Sharing Integrations - Dropbox","number":149,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"critical-path","text":"<p>\n\tYour project's critical path is the series of tasks that dictates the finish date of the project. If one task on the critical path moves, the end date of your project will move as well. Therefore, all tasks along this path are \"critical,\" and changes should be monitored carefully.&nbsp;</p><h2>How do I view my project's critical path in TeamGantt?</h2><p>\n\tIn Gantt 2.0, it's easy to view your project's critical path.&nbsp;</p><p>\n\tClick on the \n\t<em>Critical path</em> button in the menu bar. Then, choose whether you want to highlight the critical path or filter by it.&nbsp;</p><h3>Highlighting the critical path</h3><p>\n\tIf you choose the&nbsp;\n\t<em style=\"background-color: initial;\">Highlight critical path&nbsp;</em>option, tasks on the critical path will be highlighted and all other tasks will be dimmed.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67c9afb86898e960738163a0/file-wpUMyQko0C.png\"></p><h3>\nFiltering by the critical path</h3><p>\n\tIf you choose the&nbsp;\n\t<em>Filter by critical path&nbsp;</em>option, all tasks that are not on the critical path will be filtered out.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67c9afc16898e960738163a1/file-JK0ep3jMrR.png\"></p><hr><h2>How do I clear the critical path view?</h2><p>\n\tSimply click the 'x' in the&nbsp;\n\t<em style=\"background-color: initial;\">Critical path</em>&nbsp;button to clear the critical path view.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/67c9afcd4ac7fc0f6dc737bb/file-iRETFIVFNV.png\"></p>","name":"Critical Path","number":165,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"cost-loaded-scheduling","text":"<p>Cost-loaded scheduling can help you determine the&nbsp;cumulative cash flow in a given period of time, and how it changes as the project schedule changes.</p><h2>How to track cost on projects</h2><p>There are 2 options for adding cost to tasks:</p><ul>\n\t\n<li>Budgeted cost</li>\t\n<li>Actual cost </li></ul><p>\n\tTo enable these Cost columns, you can go to \n\t<em>View &gt; Columns&nbsp;</em></p><p>\n\tTo enter the cost for a task, simply click into either cost column to enter the amount budgeted for the task. Currency will be displayed based on your location.&nbsp;</p><h2>How to view cost totals</h2><p>\n\tOnce you have entered the cost for your tasks, you can view the total cost per month by clicking the \n\t<em style=\"background-color: initial;\">Cost </em>tab at the bottom of the Gantt chart. Toggle between <strong>Budgeted cost </strong>and <strong>Actual cost.&nbsp;</strong></p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a43ee16988bd8e977f24596/file-gAEKnVqzLz.png\" alt=\"\" style=\"display: block; margin: auto;\"></p><p>\n\tIn the Cost tab, you can view&nbsp;the cost totals for projects that are open in the Gantt view, as well as the total costs for all active company projects. At this time, costs can only be shown per month. As you update your tasks in your schedule, the changes will appear in real-time in the Cost tab.&nbsp;</p>","name":"Cost-Loaded Scheduling  (Available on select paid plans)","number":167,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"custom-boards","text":"<p>\n\tCustom boards allow you to create flexible workflows by pulling tasks from multiple projects into one centralized board. This is ideal for teams&nbsp;or department-specific boards.</p><hr><h3><strong>What is a custom board in TeamGantt?</strong></h3><p>\n\tA custom board is a Kanban-style board where you manually add tasks from any number of&nbsp;projects in your account. This lets you organize work by team, priority, or sprint&mdash;independent of project structure.</p><hr><h3><strong>How do I create a custom board?</strong></h3><ol>\n\t\n<li>Go to the left sidebar and click&nbsp;<strong>Create &gt; New custom board</strong>.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a905c41039b617b17428250/file-a41UHckR4Y.png\"></li>\t\n<li>Enter a name and choose a folder (if applicable).<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6882445d3d7e1209972ed97d/file-twY6HEF6gr.png\"></li>\t\n<li>Click <strong>Create board.</strong></li>\t\n<li>Create a column by clicking on the blue (+) icon on your board. Once columns are created, click <strong>Next: board settings</strong>.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/688245b20393ea39663cef00/file-19IrqHsuqZ.png\"></li>\t\n<li>Optional: Set the % complete for each column and click <strong>Finish</strong>.</li></ol><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/68824667337db07aa961d7f8/file-mVhYZpfjmc.png\"></p><hr><h3><strong>How do I add tasks to a custom board?</strong></h3><p><span style=\"background-color: initial; font-size: 14px;\">Open the board and click \n\tInbox\n</span><span style=\"font-weight: normal;\">. Use the search bar or apply filters to locate relevant tasks from active projects. Drag tasks from the Inbox into board columns to add them as cards.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a905d25039b617b1742825a/file-vbUDUo0btz.png\"></span><strong style=\"background-color: initial; font-size: 14px;\">Note:</strong>&nbsp;Once filters are set up, they remain in the&nbsp;<em style=\"background-color: initial; font-size: 14px;\">Inbox</em>&nbsp;until you clear them. That way, you can set them up once and never miss a relevant task. New tasks that meet the established criteria are brought into the<em style=\"background-color: initial; font-size: 14px;\">&nbsp;Inbox</em>&nbsp;automatically.</p><hr><h3><strong>How to create new tasks from a custom board?</strong></h3><ol>\n\t\n<li>Click <strong>Add task&nbsp;</strong>in the column where you'd like to create the new task.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a905d7c9f65cc0cc64d67e2/file-hgaBHxgJC4.png\">&nbsp;</li>\t\n<li>Enter the task name.</li>\t\n<li>Select the project you'd like to add the task to.&nbsp;</li>\t\n<li>Select the group within the project you'd like to add the task to.&nbsp;</li>\t\n<li>Click <strong>Add task.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a905dca6f9f378e74c1fc00/file-JEp6t0CQlO.png\"></strong></li></ol><hr><h3><strong>How do I edit&nbsp;the&nbsp;column % complete rules?</strong></h3><p><span style=\"background-color: initial; font-size: 14px;\">Click the 3-dot icon in the upper right of any column and select \n\tAuto % Complete Settings\n</span><span style=\"font-weight: normal;\">. Set a percent complete for each column, and optionally enable Auto Move to shift cards based on task progress.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a905e2a9f65cc0cc64d67ea/file-C8U1i4bI3x.png\"></span></p><p><span style=\"background-color: initial; font-size: 14px;\">You can also edit the % complete settings for a column by going to </span>Menu &gt; Edit Board Settings<span style=\"font-weight: normal;\">.</span></p><hr><h3><strong>How do I invite people to my Custom Board?&nbsp;</strong></h3><p><span style=\"font-weight: normal;\">To invite people to your board, click the Share</span>&nbsp;<span style=\"font-weight: normal;\">button in the upper right corner of your board, or&nbsp;</span><span style=\"font-size:14px;background-color:initial\">select&nbsp;Menu</span>&gt; Invite People<span style=\"font-weight: normal;\">.&nbsp;Any user with access to the projects you included can be invited to your custom board.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a905e98039b617b17428265/file-KWSnWkmc7b.png\"></span></p><hr><h3><strong>How do I delete a card or column?</strong></h3><p>\n\tTo delete a card, click on the 3-dot icon in the upper right corner of the card, and then select \n\t<strong>Remove from board </strong>or <strong>Delete Task</strong>.&nbsp;</p><ul>\n\t\n<li><strong>Remove from board: </strong>Allows you to remove the card from your board without deleting the underlying task.</li>\t\n<li><b style=\"background-color: initial;\">Delete Task:</b>&nbsp;Removes both the card from your board and the root task in the Gantt chart.</li></ul><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a905f24ce92cdaba13d045e/file-ramRqRG157.png\">To delete a column, click the 3-dot icon in the upper right corner of the column, and then click \n\t<strong style=\"background-color: initial;\">Delete Column</strong>. Deleting a column will not delete the tasks. It will only remove the tasks from the board.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a905f6f9f65cc0cc64d67f0/file-tPjMgvYy3y.png\"></p><hr><p>\n\t<strong style=\"background-color: initial; font-family: inherit; font-size: 21px;\">How do I close a custom board?<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a905fb44b84f76cf81bf0ea/file-I4uuOS8IAb.png\"></strong>Go to \n\t<strong style=\"background-color: initial;\">Menu &gt; Edit Board &gt; Board Status</strong>, and select <strong style=\"background-color: initial;\">Closed</strong>. This hides the board without deleting the underlying tasks or projects.</p>","name":"Using Custom Boards in TeamGantt","number":169,"categories":["5f510e62c9e77c0016384617"]}},{"node":{"slug":"material-lead-times","text":"<p>\n\tMaterial Lead Times helps construction project managers minimize the time and effort required to determine lead time for materials on the job. This feature allows you to improve planning, reduce delays, and keep projects on track.</p>\n<div class=\"wistia_responsive_padding\" style=\"padding:56.25% 0 0 0;position:relative;\">\n\t<div class=\"wistia_responsive_wrapper\" style=\"height:100%;left:0;position:absolute;top:0;width:100%;\">\n\t\t<div class=\"wistia_embed wistia_async_3aj8es8ggx seo=false videoFoam=true wistia_embed_initialized\" style=\"height:100%;position:relative;width:100%\" id=\"wistia-3aj8es8ggx-1\">\n\t\t\t<div id=\"wistia_chrome_23\" class=\"w-chrome notranslate\" tabindex=\"-1\" style=\"display: inline-block; height: 746.584px; line-height: normal; margin: 0px; padding: 0px; position: relative; vertical-align: top; width: 1327.27px; outline: none; overflow: hidden; box-sizing: content-box; border-radius: 0px;\">\n\t\t\t\t<div id=\"wistia_grid_29_wrapper\" style=\"display: block;\">\n\t\t\t\t\t<div id=\"wistia_grid_29_above\">\n\t\t\t\t\t</div>\t\t\t\t\t<div id=\"wistia_grid_29_main\">\n\t\t\t\t\t\t<div id=\"wistia_grid_29_behind\">\n\t\t\t\t\t\t</div>\t\t\t\t\t\t<div id=\"wistia_grid_29_center\">\n\t\t\t\t\t\t\t<div class=\"w-video-wrapper w-css-reset\" style=\"width: 100%; height: 100%; opacity: 1; background-color: rgb(0, 0, 0);\">\n\t\t\t\t\t\t\t\t<video id=\"wistia_simple_video_77\" crossorigin=\"anonymous\" poster=\"https://fast.wistia.net/assets/images/blank.gif\" aria-label=\"Material Lead Times\" src=\"blob:https://secure.helpscout.net/fb925858-7b88-4ab0-bb55-0c9d2a498feb\" controlslist=\"nodownload\" playsinline=\"\" preload=\"metadata\" type=\"video/m3u8\" x-webkit-airplay=\"allow\" style=\"background: transparent; display: block; height: 100%; max-height: none; max-width: none; position: static; visibility: visible; width: 100%; object-fit: fill;\"><source type=\"application/x-mpegURL\" src=\"https://fast.wistia.com/embed/medias/3aj8es8ggx.m3u8\"></video>\n\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t<div class=\"w-ui-container\" style=\"height: 100%; left: 0px; position: absolute; top: 0px; width: 100%; opacity: 1;\">\n\t\t\t\t\t\t\t\t<div class=\"w-vulcan-v2 w-css-reset\" id=\"w-vulcan-v2-28\" style=\"border-radius: 0px; box-sizing: border-box; cursor: default; direction: ltr; height: 100%; left: 0px; position: absolute; visibility: visible; top: 0px; width: 100%;\">\n\t\t\t\t\t\t\t\t\t<div class=\"w-vulcan--background w-css-reset\" style=\"height: 100%; left: 0px; position: absolute; top: 0px; width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" data-handle=\"statusBar\">\n\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" data-handle=\"backgroundFocus\">\n\t\t\t\t\t\t\t\t\t\t\t<button aria-label=\"Play Video: Material Lead Times\" class=\"w-css-reset w-vulcan-v2-button\" tabindex=\"0\" style=\"clip: rect(1px, 1px, 1px, 1px); height: 1px; overflow: hidden; position: absolute; white-space: nowrap; width: 1px; pointer-events: none;\"></button>\n\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" data-handle=\"thumbnail\">\n\t\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" style=\"filter: blur(5px); height: 100%; left: 0px; position: absolute; top: 0px; width: 100%; display: block;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<img class=\"w-css-reset\" srcset=\"\" src=\"https://fast.wistia.com/embed/medias/3aj8es8ggx/swatch\" alt=\"Video Thumbnail\" aria-hidden=\"true\" style=\"background-color: rgb(0, 0, 0); height: 100%; object-fit: contain; position: absolute; width: 100%; top: 0px; left: 0px; clip: auto; display: block; border-radius: 0px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" style=\"height: 100%; left: 0px; opacity: 1; position: absolute; top: 0px; width: 100%; display: block; transition: opacity 3s;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<img class=\"w-css-reset\" srcset=\"https://embed-ssl.wistia.com/deliveries/f060bd04a6485a237b67a2667127fb63.webp?image_crop_resized=640x360 320w, https://embed-ssl.wistia.com/deliveries/f060bd04a6485a237b67a2667127fb63.webp?image_crop_resized=640x360 640w, https://embed-ssl.wistia.com/deliveries/f060bd04a6485a237b67a2667127fb63.webp?image_crop_resized=960x540 960w, https://embed-ssl.wistia.com/deliveries/f060bd04a6485a237b67a2667127fb63.webp?image_crop_resized=1280x720 1280w, https://embed-ssl.wistia.com/deliveries/f060bd04a6485a237b67a2667127fb63.webp?image_crop_resized=1280x720 1920w, https://embed-ssl.wistia.com/deliveries/f060bd04a6485a237b67a2667127fb63.webp?image_crop_resized=1280x720 3840w\" src=\"https://embed-ssl.wistia.com/deliveries/f060bd04a6485a237b67a2667127fb63.webp?image_crop_resized=1280x720\" alt=\"Video Thumbnail\" style=\"background-color: rgb(0, 0, 0); height: 100%; object-fit: contain; position: absolute; width: 100%; top: 0px; left: 0px; clip: auto; display: block; border-radius: 0px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t</div></div></div></div>\n\t\t\t\t\t\t\t\t\t<div aria-live=\"polite\" class=\"w-vulcan--aria-live w-css-reset\" aria-atomic=\"true\" style=\"position: absolute; left: -99999em;\">\n\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\t<div class=\"w-vulcan-overlays-table w-css-reset\" style=\"display: table; pointer-events: none; position: absolute; width: 100%; height: calc(100% - 44px);\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"w-vulcan-overlays--left w-css-reset\" style=\"display: table-cell; height: auto; vertical-align: top; position: relative; width: 0px;\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" style=\"height: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t</div></div>\n\t\t\t\t\t\t\t\t\t\t<div class=\"w-vulcan-overlays--center w-css-reset\" style=\"display: table-cell; height: 100%; vertical-align: top; position: relative; width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" style=\"height: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" data-handle=\"bigPlayButton\" style=\"pointer-events: auto;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-bpb-wrapper w-css-reset w-css-reset-tree\" style=\"border-radius: 0px; display: block; left: calc(50%); margin-left: -81.25px; margin-top: -52px; overflow: hidden; position: absolute; top: calc(50% + 0px);\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class=\"w-big-play-button w-css-reset-button-important w-vulcan-v2-button\" aria-label=\"Play Video: Material Lead Times\" tabindex=\"0\" type=\"button\" style=\"background-color: transparent; border: 0px; cursor: pointer; height: 104px; box-shadow: none; width: 162.5px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div style=\"background: rgb(84, 187, 255); display: block; left: 0px; height: 104px; mix-blend-mode: darken; position: absolute; top: 0px; width: 162.5px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div style=\"background-color: rgba(84, 187, 255, 0.7); height: 104px; left: 0px; position: absolute; top: 0px; transition: background-color 150ms; width: 162.5px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<svg x=\"0px\" y=\"0px\" viewBox=\"0 0 125 80\" enable-background=\"new 0 0 125 80\" aria-hidden=\"true\" style=\"fill: rgb(255, 255, 255); height: 104px; left: 0px; stroke-width: 0px; top: 0px; width: 100%; position: absolute;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</p><p>\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" fill=\"#FFFFFF\" opacity=\"1\" transform=\"translate(44, 22)\" d=\"M12.138 2.173C10.812 1.254 9 2.203 9 3.817v28.366c0 1.613 1.812 2.563 3.138 1.644l20.487-14.183a2 2 0 0 0 0-3.288L12.138 2.173Z\"></path></p></button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div></div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" data-handle=\"clickForSoundButton\" style=\"pointer-events: auto;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset w-css-reset-tree\" data-handle=\"click-for-sound-backdrop\" style=\"display: none; height: 100%; left: 0px; pointer-events: auto; position: absolute; top: 0px; width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button aria-label=\"Click for sound\" class=\"w-vulcan-v2-button click-for-sound-btn\" style=\"background: rgba(0, 0, 0, 0.8); border: 2px solid transparent; border-radius: 60px; cursor: pointer; display: flex; justify-content: space-between; align-items: center; outline: none; pointer-events: auto; position: absolute; right: 27.25px; top: 27.25px; max-width: 1272.76px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div style=\"display: flex; align-items: center; justify-content: flex-end; white-space: nowrap; overflow: hidden; max-width: 0px; transition: max-width 200ms;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tClick for sound\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<svg viewBox=\"0 0 237 237\" width=\"68.25\" height=\"68.25\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t@keyframes VOLUME_SMALL_WAVE_FLASH {\n    0% { opacity: 0; }\n    33% { opacity: 1; }\n    66% { opacity: 1; }\n    100% { opacity: 0; }\n  }\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</p><p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  @keyframes VOLUME_LARGE_WAVE_FLASH {\n    0% { opacity: 0; }\n    33% { opacity: 1; }\n    66% { opacity: 1; }\n    100% { opacity: 0; }\n  }\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</p><p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  .volume__small-wave {\n    animation: VOLUME_SMALL_WAVE_FLASH 2s infinite;\n    opacity: 0;\n  }\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</p><p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  .volume__large-wave {\n    animation: VOLUME_LARGE_WAVE_FLASH 2s infinite .3s;\n    opacity: 0;\n  }\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</p><p>\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n<path fill=\"#fff\" d=\"M88 107H65v24h24l23 23V84z\"></path><g fill=\"none\" stroke=\"#fff\" stroke-linecap=\"round\" stroke-width=\"10\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n<path d=\"M142 86c9 21 9 44 0 65\" class=\"volume__small-wave\"></path>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n<path d=\"M165 74c13 23 13 66 0 89\" class=\"volume__large-wave\"></path></g></p></button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div></div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" data-handle=\"playPauseNotifier\" style=\"pointer-events: auto;\">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" data-handle=\"playPauseLoading\" style=\"pointer-events: auto;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset w-css-reset-tree\" style=\"height: 100%; left: 0px; pointer-events: none; position: absolute; top: 0px; width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button aria-label=\"Play Video\" class=\"w-vulcan-v2-button\" style=\"background: rgba(0, 0, 0, 0.6); border: 0px; border-radius: 50%; cursor: pointer; display: none; height: 182px; left: 50%; margin: 0px; padding: 0px; pointer-events: auto; position: absolute; opacity: 0; outline: none; top: 50%; transform: translate(-50%, -50%) scale(0.8); transition: opacity 200ms, transform 600ms; -webkit-tap-highlight-color: rgba(0, 0, 0, 0); width: 182px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div style=\"width: 100%; height: 100%; margin-left: 0px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<svg x=\"0px\" y=\"0px\" viewBox=\"0 0 40 34\" enable-background=\"new 0 0 40 34\" aria-hidden=\"true\" style=\"fill: rgb(255, 255, 255); height: 100%; left: 0px; stroke-width: 0px; top: 0px; width: 100%;\"><path d=\"M24.888 16.1913C25.4371 16.5906 25.4371 17.4094 24.888 17.8087L16.5882 23.845C15.9272 24.3257 15 23.8535 15 23.0362V10.9638C15 10.1465 15.9272 9.67433 16.5882 10.155L24.888 16.1913Z\" fill=\"white\"></path></svg>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div></button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div></div></div></div>\n\t\t\t\t\t\t\t\t\t\t<div class=\"w-vulcan-overlays--right w-css-reset\" style=\"display: table-cell; height: auto; vertical-align: top; position: relative; width: 0px;\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" style=\"height: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t</div></div></div>\n\t\t\t\t\t\t\t\t\t<div class=\"w-bottom-bar w-css-reset\" style=\"bottom: 0px; border-radius: 0px; border-collapse: collapse; display: table; height: 44px; pointer-events: none; position: absolute; padding-left: 0px; padding-right: 0px; right: 50%; table-layout: auto; transform: translate(50%); width: calc(100% + 0px); z-index: 1;\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"w-bottom-bar-lower w-css-reset\" style=\"position: relative;\">\n\t\t\t\t\t\t\t\t\t\t\t<div style=\"height: 100%; left: 0px; position: absolute; top: 0px; width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div style=\"background: rgb(84, 187, 255); display: none; height: 100%; mix-blend-mode: darken; left: 0px; opacity: 1; position: absolute; top: 0px; transition: opacity; width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\t\t\t\t<div style=\"background: rgba(84, 187, 255, 0.85); border-radius: 0px; height: 100%; opacity: 1; left: 0px; position: absolute; top: 0px; transition: opacity; width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t</div></div>\n\t\t\t\t\t\t\t\t\t\t\t<div style=\"display: none;\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div style=\"background: rgb(84, 187, 255); display: none; height: 100%; mix-blend-mode: darken; left: 0px; opacity: 1; position: absolute; top: 0px; transition: opacity; width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\t\t\t\t<div style=\"background: 100% rgba(84, 187, 255, 0.85); border-radius: 0px; height: 100%; opacity: 1; left: 0px; position: absolute; top: 0px; transition: opacity; width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t</div></div>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-bottom-bar-left w-css-reset\" style=\"display: table-cell; height: auto; vertical-align: top; position: relative; width: 0px; opacity: 1; transition: opacity;\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-bottom-bar-left-inner w-css-reset\" style=\"height: 44px; position: relative; pointer-events: auto; white-space: nowrap;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" data-handle=\"smallPlayButton\" style=\"display: inline-block; vertical-align: top;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-vulcan-button-wrapper w-css-reset\" style=\"display: inline-block; height: 44px; position: relative; vertical-align: top; width: 52px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class=\"w-vulcan-v2-button w-css-reset w-css-reset-tree w-css-reset-button-important\" tabindex=\"0\" aria-label=\"Play Video\" title=\"Play Video\" style=\"background-color: rgba(0, 0, 0, 0); border-radius: 0px; box-shadow: none; cursor: pointer; height: 100%; position: relative; transition: background-color 150ms; width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-vulcan-icon-wrapper\" data-handle=\"smallPlayButton_icon_wrapper\" style=\"box-sizing: border-box; height: 100%; position: relative; opacity: 1; transform: scale(1.001); transition: transform 200ms;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div style=\"width: 100%; height: 100%; margin-left: 1.95px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<svg x=\"0px\" y=\"0px\" viewBox=\"0 0 40 34\" enable-background=\"new 0 0 40 34\" aria-hidden=\"true\" style=\"fill: rgb(255, 255, 255); height: 100%; left: 0px; stroke-width: 0px; top: 0px; width: 100%; vertical-align: top;\"><path d=\"M24.888 16.1913C25.4371 16.5906 25.4371 17.4094 24.888 17.8087L16.5882 23.845C15.9272 24.3257 15 23.8535 15 23.0362V10.9638C15 10.1465 15.9272 9.67433 16.5882 10.155L24.888 16.1913Z\" fill=\"white\"></path></svg>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div></div></button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div></div></div></div>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-bottom-bar-middle w-css-reset\" style=\"display: table-cell; height: auto; vertical-align: top; position: relative; width: 100%; opacity: 1; transition: opacity;\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-bottom-bar-middle-inner w-css-reset\" style=\"height: 44px; position: relative; pointer-events: auto; white-space: nowrap; opacity: 1; transform: translateY(0px); transition: opacity, transform;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" data-handle=\"playbar\" style=\"height: 100%; position: relative;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-playbar-wrapper w-css-reset w-css-reset-tree\" style=\"display: flex; height: 100%; width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-playbar__time\" style=\"box-sizing: content-box; color: white; font-family: WistiaPlayerInterNumbersSemiBold, Helvetica, sans-serif; font-size: 16.9px; letter-spacing: 0.65px; line-height: 44px; padding-left: 6.5px; pointer-events: none; position: relative; text-align: center; width: 36.4px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t0:55\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div style=\"width: 100%; position: relative;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div aria-label=\"Playbar\" aria-orientation=\"horizontal\" aria-valuemax=\"54.76\" aria-valuemin=\"0\" aria-valuenow=\"0\" aria-valuetext=\"0 seconds\" role=\"slider\" tabindex=\"0\" style=\"cursor: pointer; flex: 1 1 0%; height: 44px; outline: none; margin-left: 19.5px; margin-right: 13px; position: relative;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<canvas height=\"48.40000104904175\" width=\"1183.996025662422\" style=\"height: 44px; left: -19.5px; position: absolute; top: 0px; width: 1076.36px;\"></canvas>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div style=\"border-radius: 50%; height: 14.56px; left: -7.28px; opacity: 0; position: absolute; top: 14.72px; width: 14.56px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div></div></div></div></div></div></div>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-bottom-bar-right w-css-reset\" style=\"display: table-cell; height: auto; vertical-align: top; position: relative; width: 0px; opacity: 1; transition: opacity; white-space: nowrap;\">\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-bottom-bar-right-inner-anchor w-css-reset\" style=\"height: 44px; position: relative; pointer-events: auto; white-space: nowrap; display: inline-block; right: 0px; top: 0px; vertical-align: top;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-bottom-bar-right-inner w-css-reset\" style=\"height: 44px; position: relative; pointer-events: auto; white-space: nowrap; display: inline-block; opacity: 1; right: 0px; top: 0px; transform: translateY(0px); transition: opacity, transform;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" data-handle=\"volumeButton\" style=\"display: inline-block; vertical-align: top;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-vulcan-button-wrapper w-css-reset\" style=\"display: inline-block; height: 44px; position: relative; vertical-align: top; width: 52px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class=\"w-vulcan-v2-button w-css-reset w-css-reset-tree w-css-reset-button-important\" tabindex=\"0\" aria-label=\"Mute\" title=\"Mute\" style=\"background-color: rgba(0, 0, 0, 0); border-radius: 0px; box-shadow: none; cursor: pointer; height: 100%; position: relative; transition: background-color 150ms; width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-vulcan-icon-wrapper\" data-handle=\"volumeButton_icon_wrapper\" style=\"box-sizing: border-box; height: 100%; position: relative; opacity: 1; transform: scale(1.001); transition: transform 200ms;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<svg x=\"0px\" y=\"0px\" viewBox=\"0 0 40 34\" enable-background=\"new 0 0 40 34\" aria-hidden=\"true\" style=\"fill: none; height: 100%; left: 0px; stroke-width: 0px; top: 0px; width: 100%;\"><g style=\"transform: translateX(1.25px); transition: transform 100ms;\"><path d=\"M15.8 13.9995C15.3 14.4995 14.4 14.7995 13.8 14.7995H12.2C11.5 14.7995 11 15.2995 11 15.9995V17.5995C11 18.2995 11.5 18.7995 12.2 18.7995H13.8C14.5 18.7995 15.4 19.1995 15.8 19.5995L18.2 21.3999C18.5296 21.6472 19 21.412 19 20.9999V12.154C19 11.7163 18.4774 11.4899 18.1581 11.7892L15.8 13.9995Z\" fill=\"white\"></path><g stroke=\"#fff\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M22 11.5C22 11.5 23.1 14 23.1 16.5C23.1 19 22 21.5 22 21.5\" style=\"opacity: 1; transition: opacity 100ms;\"></path><path d=\"M26 9C26 9 27.7 12.8 27.7 16.5C27.7 20.2 26 24 26 24\" style=\"opacity: 1; transition: opacity 100ms;\"></path><g style=\"opacity: 0; transition: opacity 100ms;\"><path d=\"M22 14L27 19\"></path><path d=\"M27 14L22 19\"></path></g></g></g></svg>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div></button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" data-handle=\"settingsButton\" style=\"display: inline-block; vertical-align: top;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-vulcan-button-wrapper w-css-reset\" style=\"display: inline-block; height: 44px; position: relative; vertical-align: top; width: 52px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class=\"w-vulcan-v2-button w-css-reset w-css-reset-tree w-css-reset-button-important\" tabindex=\"0\" aria-expanded=\"false\" aria-label=\"Show settings menu\" title=\"Show settings menu\" style=\"background-color: rgba(0, 0, 0, 0); border-radius: 0px; box-shadow: none; cursor: pointer; height: 100%; position: relative; transition: background-color 150ms; width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-vulcan-icon-wrapper\" data-handle=\"settingsButton_icon_wrapper\" style=\"box-sizing: border-box; height: 100%; position: relative; opacity: 1; transform: scale(1.001); transition: transform 200ms;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<svg x=\"0px\" y=\"0px\" viewBox=\"0 0 40 34\" enable-background=\"new 0 0 40 34\" aria-hidden=\"true\" style=\"fill: rgb(255, 255, 255); height: 100%; left: 0px; stroke-width: 0px; top: 0px; width: 100%;\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M26.4 15.4H28.3C28.7 15.4 29 15.7 29 16.1V16.7C29 17.1 28.7 17.4 28.3 17.4H26.4C26 17.4 25.6 17.7 25.5 18.1L25.1 19.2C25 19.5 25 20 25.3 20.3L26.6 21.6C26.9 21.9 26.9 22.3 26.6 22.6L26.2 23C25.9 23.3 25.5 23.3 25.2 23L23.9 21.7C23.6 21.5 23.1 21.4 22.8 21.6L21.7 22.1C21.3 22.2 21 22.6 21 23V24.7C21 25.1 20.7 25.4 20.3 25.4H19.7C19.3 25.4 19 25.1 19 24.7V23C19 22.6 18.7 22.2 18.3 22.1L17.1 21.6C16.8 21.5 16.3 21.5 16 21.8L14.8 23C14.5 23.3 14.1 23.3 13.8 23L13.4 22.6C13.1 22.3 13.1 21.9 13.4 21.6L14.6 20.4C14.8 20.1 14.9 19.6 14.7 19.3L14.2 18.1C14.1 17.7 13.7 17.4 13.3 17.4H11.7C11.3 17.4 11 17.1 11 16.7V16.1C11 15.7 11.3 15.4 11.7 15.4H13.3C13.7 15.4 14.1 15.1 14.2 14.7L14.7 13.5C14.9 13.2 14.9 12.7 14.6 12.4L13.4 11.2C13.1 10.9 13.1 10.5 13.4 10.2L13.8 9.8C14.1 9.5 14.5 9.5 14.8 9.8L16 11C16.3 11.3 16.8 11.4 17.1 11.2L18.3 10.7C18.7 10.6 19 10.2 19 9.8V8.1C19 7.7 19.3 7.4 19.7 7.4H20.3C20.7 7.4 21 7.7 21 8.1V9.8C21 10.2 21.3 10.6 21.7 10.7L22.8 11.2C23.1 11.4 23.6 11.4 23.9 11.1L25.2 9.8C25.5 9.5 25.9 9.5 26.2 9.8L26.6 10.2C26.9 10.5 26.9 10.9 26.6 11.2L25.3 12.5C25 12.8 24.9 13.3 25.1 13.6L25.5 14.7C25.6 15.1 26 15.4 26.4 15.4ZM19.9 20.4C22 20.4 23.8 18.7 23.8 16.5C23.8 14.3 22.1 12.6 19.9 12.6C17.7 12.6 16 14.4 16 16.5C16 18.6 17.7 20.4 19.9 20.4Z\" fill=\"white\"></path></svg>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div></button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" data-handle=\"fullscreenControl\" style=\"display: inline-block; vertical-align: top;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-vulcan-button-wrapper w-css-reset\" style=\"display: inline-block; height: 44px; position: relative; vertical-align: top; width: 52px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<button class=\"w-vulcan-v2-button w-css-reset w-css-reset-tree w-css-reset-button-important\" tabindex=\"0\" aria-label=\"Fullscreen\" title=\"Fullscreen\" style=\"background-color: rgba(0, 0, 0, 0); border-radius: 0px; box-shadow: none; cursor: pointer; height: 100%; position: relative; transition: background-color 150ms; width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-vulcan-icon-wrapper\" data-handle=\"fullscreenControl_icon_wrapper\" style=\"box-sizing: border-box; height: 100%; position: relative; opacity: 1; transform: scale(1.001); transition: transform 200ms;\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<svg x=\"0px\" y=\"0px\" viewBox=\"0 0 40 34\" enable-background=\"new 0 0 40 34\" aria-hidden=\"true\" style=\"fill: none; height: 100%; left: 0px; stroke-width: 0px; top: 0px; width: 100%;\"><rect x=\"14\" y=\"13\" width=\"12\" height=\"8\" rx=\"1.5\" stroke=\"white\" stroke-width=\"2\"></rect><g stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M10 13V11C10 9.89543 10.8954 9 12 9H14\"></path><path d=\"M30 13V11C30 9.89543 29.1046 9 28 9H26\"></path><path d=\"M30 21L30 23C30 24.1046 29.1046 25 28 25L26 25\"></path><path d=\"M10 21L10 23C10 24.1046 10.8954 25 12 25L14 25\"></path></g></svg>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div></button>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div></div></div></div>\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-wistia-logo w-css-reset\" style=\"height: 44px; position: relative; pointer-events: auto; white-space: nowrap; display: none; right: 0px; top: 0px;\">\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-ellipsis w-css-reset\" style=\"height: 44px; position: relative; pointer-events: auto; white-space: nowrap; display: none;\">\n\t\t\t\t\t\t\t\t\t\t\t\t</div></div></div><p>\n\t\t\t\t\t\t\t\t\t\t\t        @media (prefers-reduced-motion: no-preference) {\n          @keyframes w-control-bar-fade-in {\n            0% {\n              opacity: 0;\n              transform: translateX(50%) translateY(10px);\n            }\n            100% {\n              opacity: 1;\n              transform: translateX(50%) translateY(0px);\n            }\n          }\n        }\n\t\t\t\t\t\t\t\t\t\t</p></div>\n\t\t\t\t\t\t\t\t\t<div class=\"w-foreground w-css-reset\" style=\"height: 100%; left: 0px; pointer-events: none; position: absolute; top: 0px; width: 100%; z-index: 1;\">\n\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" data-handle=\"contextMenu\" style=\"pointer-events: auto;\">\n\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" data-handle=\"loadingHourglass\" style=\"pointer-events: auto;\">\n\t\t\t\t\t\t\t\t\t\t</div>\t\t\t\t\t\t\t\t\t\t<div class=\"w-css-reset\" data-handle=\"focusOutline\" style=\"pointer-events: auto;\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"w-focus-outline\" style=\"box-shadow: rgb(255, 255, 255) 0px 0px 0px 2px inset; border-radius: 0px; display: none; height: 100%; left: 0px; pointer-events: none; position: absolute; right: 0px; width: 100%;\">\n\t\t\t\t\t\t\t\t\t\t\t</div></div></div></div><p>\n\t\t\t\t\t\t\t\t\t      #wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset{font-size:14px;}\n#wistia_chrome_23 #wistia_grid_29_wrapper div.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper span.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper ul.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper li.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper label.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper fieldset.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper button.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper img.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper a.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper svg.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper p.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper a.w-css-reset{border:0;}\n#wistia_chrome_23 #wistia_grid_29_wrapper h1.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:2em;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper h2.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:1.5em;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper h3.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:1.17em;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper p.w-css-reset{margin:1.4em 0;}\n#wistia_chrome_23 #wistia_grid_29_wrapper a.w-css-reset{display:inline;}\n#wistia_chrome_23 #wistia_grid_29_wrapper span.w-css-reset{display:inline;}\n#wistia_chrome_23 #wistia_grid_29_wrapper svg.w-css-reset{display:inline;}\n#wistia_chrome_23 #wistia_grid_29_wrapper ul.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased;list-style-type:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper ol.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased;list-style-type:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper li.w-css-reset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased;list-style-type:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper ul:before.w-css-reset{display:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper ol:before.w-css-reset{display:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper li:before.w-css-reset{display:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper ul:after.w-css-reset{display:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper ol:after.w-css-reset{display:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper li:after.w-css-reset{display:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper label.w-css-reset{background-attachment:scroll;background-color:transparent;background-image:none;background-position:0 0;background-repeat:no-repeat;background-size:100% 100%;float:none;outline:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper button.w-css-reset{background-attachment:scroll;background-color:transparent;background-image:none;background-position:0 0;background-repeat:no-repeat;background-size:100% 100%;border:0;border-radius:0;outline:none;position:static}\n#wistia_chrome_23 #wistia_grid_29_wrapper img.w-css-reset{border:0;display:inline-block;vertical-align:top;border-radius:0;outline:none;position:static}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset button::-moz-focus-inner{border: 0;}\n      #wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree {font-size:14px;}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree div{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree span{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree ul{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree li{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree label{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree fieldset{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree button{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree img{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree a{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree svg{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree p{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree a{border:0;}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree h1{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:2em;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree h2{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:1.5em;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree h3{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:1.17em;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree p{margin:1.4em 0;}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree a{display:inline;}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree span{display:inline;}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree svg{display:inline;}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree ul{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased;list-style-type:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree ol{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased;list-style-type:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree li{box-sizing:inherit;box-shadow:none;color:inherit;display:block;float:none;font:inherit;font-family:inherit;font-style:normal;font-weight:normal;font-size:inherit;letter-spacing:0;line-height:inherit;margin:0;max-height:none;max-width:none;min-height:0;min-width:0;padding:0;position:static;text-decoration:none;text-transform:none;text-shadow:none;transition:none;word-wrap:normal;-webkit-tap-highlight-color:rgba(0,0,0,0);-webkit-user-select:none;-webkit-font-smoothing:antialiased;list-style-type:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree ul:before{display:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree ol:before{display:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree li:before{display:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree ul:after{display:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree ol:after{display:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree li:after{display:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree label{background-attachment:scroll;background-color:transparent;background-image:none;background-position:0 0;background-repeat:no-repeat;background-size:100% 100%;float:none;outline:none}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree button{background-attachment:scroll;background-color:transparent;background-image:none;background-position:0 0;background-repeat:no-repeat;background-size:100% 100%;border:0;border-radius:0;outline:none;position:static}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree img{border:0;display:inline-block;vertical-align:top;border-radius:0;outline:none;position:static}\n#wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-tree  button::-moz-focus-inner{border: 0;}\n      #wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-max-width-none-important{max-width:none!important}\n      #wistia_chrome_23 #wistia_grid_29_wrapper .w-css-reset-button-important{border-radius:0!important;color:#fff!important;}\n\t\t\t\t\t\t\t\t</p></div></div>\n\t\t\t\t\t\t<div id=\"wistia_grid_29_front\">\n\t\t\t\t\t\t</div>\t\t\t\t\t\t<div id=\"wistia_grid_29_top_inside\">\n\t\t\t\t\t\t\t<div id=\"wistia_grid_29_top\">\n\t\t\t\t\t\t\t</div></div>\n\t\t\t\t\t\t<div id=\"wistia_grid_29_bottom_inside\">\n\t\t\t\t\t\t\t<div id=\"wistia_grid_29_bottom\">\n\t\t\t\t\t\t\t</div></div>\n\t\t\t\t\t\t<div id=\"wistia_grid_29_left_inside\">\n\t\t\t\t\t\t\t<div id=\"wistia_grid_29_left\">\n\t\t\t\t\t\t\t</div></div>\n\t\t\t\t\t\t<div id=\"wistia_grid_29_right_inside\">\n\t\t\t\t\t\t\t<div id=\"wistia_grid_29_right\">\n\t\t\t\t\t\t\t</div></div></div>\n\t\t\t\t\t<div id=\"wistia_grid_29_below\">\n\t\t\t\t\t</div><p>\n\t\t\t\t\t\t#wistia_grid_29_wrapper{-moz-box-sizing:content-box;-webkit-box-sizing:content-box;box-sizing:content-box;font-family:Arial,sans-serif;font-size:14px;height:100%;position:relative;text-align:left;width:100%;}\n#wistia_grid_29_wrapper *{-moz-box-sizing:content-box;-webkit-box-sizing:content-box;box-sizing:content-box;}\n#wistia_grid_29_above{position:relative;}\n#wistia_grid_29_main{display:block;height:100%;position:relative;}\n#wistia_grid_29_behind{height:100%;left:0;position:absolute;top:0;width:100%;}\n#wistia_grid_29_center{height:100%;overflow:hidden;position:relative;width:100%;}\n#wistia_grid_29_front{display:none;height:100%;left:0;position:absolute;top:0;width:100%;}\n#wistia_grid_29_top_inside{position:absolute;left:0;top:0;width:100%;}\n#wistia_grid_29_top{width:100%;position:absolute;bottom:0;left:0;}\n#wistia_grid_29_bottom_inside{position:absolute;left:0;bottom:0;width:100%;}\n#wistia_grid_29_bottom{width:100%;position:absolute;top:0;left:0;}\n#wistia_grid_29_left_inside{height:100%;position:absolute;left:0;top:0;}\n#wistia_grid_29_left{height:100%;position:absolute;right:0;top:0;}\n#wistia_grid_29_right_inside{height:100%;right:0;position:absolute;top:0;}\n#wistia_grid_29_right{height:100%;left:0;position:absolute;top:0;}\n#wistia_grid_29_below{position:relative;}\n\t\t\t\t\t</p></div></div></div></div></div><script src=\"https://fast.wistia.com/player.js\" async=\"\" type=\"text/javascript\"></script><script src=\"https://fast.wistia.com/embed/3aj8es8ggx.js\" async=\"\" type=\"text/javascript\"></script><script src=\"https://fast.wistia.com/embed/3aj8es8ggx.js\" async=\"\" type=\"text/javascript\"></script><h3><hr>\n</h3><h3>How to create a Material Lead Time?&nbsp;</h3><p>\n\tTo create a Material Lead Time, first, hover over a task bar and click the \n\t<strong>Track Material</strong> icon.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6892175569727762e276c966/file-r8ODPJOx8o.png\" style=\"background-color: initial;\"></p><p>\n\tNext, you have the option to enter a \n\t<strong>Required on Job</strong> (ROJ) date. This is the date that all materials are required to be on the job. If you do not enter an ROJ date, the lead times will be based on the start date of the task.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/68921b46542aae161fa83607/file-1S2r3dQP4G.png\"></p><p>\n\tNow, you can add your materials by clicking \n\t<strong>+ Add material. </strong>A material will have a name, a lead time, an option to upload any purchase orders, assign a purchaser, and select a status. Days left will be automatically populated based on the ROJ date.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a8c585c8565417004fc5b16/file-tcgxKvSHwG.png\"></p><p><strong style=\"background-color: initial;\">Note:</strong> Lead time can be entered in the format of 0m 0w 0d.&nbsp;</p><p>\n\tOnce materials are added, they will display on the Gantt chart as colored triangles on the same line as the task. The ROJ will be represented by a hexagon.&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/689255bbf6580d21de295b1c/file-bFQiz9jgnH.png\"></p><hr><h3>How do I know if a material has been ordered?&nbsp;</h3><p>\n\tWhen a material has been ordered, the material icon (triangle) will be shaded. If a material has not been ordered, the material icon will not be shaded.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6892573ff6580d21de295b2a/file-Hp2oMMkfP4.png\"></p><hr><h3>How to tell if a material is past due to be ordered?&nbsp;</h3><p>\n\tIf a material is past due to be ordered, an exclamation mark will appear in the middle of the material icon.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6892586cf6580d21de295b3b/file-IigfJkGBlF.png\"></p><hr><h3>What happens to my Material Lead Times if I reschedule a task?&nbsp;</h3><p>\n\tIf you reschedule a task, your materials and ROJ (if necessary) will automatically be rescheduled. A notification will appear informing you that the materials have been rescheduled.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/689259aaba4a9366bde759ad/file-rrThnoNesz.png\"></p><hr><h2>How do I track materials for all of my jobs?&nbsp;</h2><p>\n\tUse the Procurement tracker feature to view and update materials across your active projects.&nbsp;</p><p>\n\t<a href=\"https://support.teamgantt.com/article/181-procurement-tracking-only-available-on-the-builder-edition\">Learn more about the Procurement tracker</a>.</p>","name":"Material Lead Times (Only Available on the Builder Edition)","number":172,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"single-sign-on-sso-for-enterprise-plans","text":"<p>\n\tSingle sign-on (SSO) gives Enterprise customers a secure, company-controlled way to access TeamGantt through their organization’s identity provider. Once SSO is set up for your account, your team will use a unique TeamGantt login URL that’s specific to your company.</p><hr><h2>What is SSO?</h2><p>\n\tSSO lets your organization manage TeamGantt access through a SAML-based identity provider, such as Microsoft Entra ID, Okta, Auth0, or another provider that supports SAML authentication.</p><p>\n\tThis is especially helpful for companies that require centralized security controls before purchasing or rolling out TeamGantt across their team.</p>\n<table>\n<tbody>\n<tr>\n\t<td>\n\t\t<strong>Note: </strong>SSO is available for Enterprise accounts and requires help from TeamGantt to set up. To get started, <a href=\"https://meetings.hubspot.com/manny-smirnov/teamgantt-book-a-demo-universal-link?utm_source=pricing_2_page&amp;uuid=fbdee62c-ebe9-4258-94e5-7f783a02a521\">contact Sales</a>.<br>\n\t</td>\n</tr>\n</tbody>\n</table><hr><h2><span style=\"background-color: initial;\">How do I log in with SSO?</span></h2><p>\n\t1. &nbsp; Go to your company’s TeamGantt SSO Login URL.</p><p>\n\t2. &nbsp; Click \"Log in with SSO account.\"</p><p>\n\t3. &nbsp; Complete the sign-in steps through your company’s identity provider.</p><p>\n\t4. &nbsp; Once authentication is complete, you’ll be taken into your TeamGantt account.</p><p>\n\tWhen you log out of TeamGantt, you’ll be sent back to your company’s SSO login page instead of the general TeamGantt login page.</p>\n<table>\n<tbody>\n<tr>\n\t<td>\n\t\t<p>\n\t\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69fcfbdcb0af9ec67097b3e8/file-YWj50g9P26.png\" alt=\"\" style=\"display: block; margin: auto;\">\n\t\t</p>\n\t</td>\n</tr>\n</tbody>\n</table><table>\n<tbody>\n<tr>\n\t<td>\n\t\t<br>\n\t</td>\n</tr>\n</tbody>\n</table><h2>Where can I find my company’s SSO Login URL?</h2><p>\n\tYour TeamGantt SSO Login URL is unique to your organization. TeamGantt will send this URL directly to your account admin after SSO has been set up.</p><p>\n\tAdmins can also view and copy the Login URL from TeamGantt:</p><p>\n\t1. &nbsp; Click your profile icon in the upper right corner of TeamGantt.</p><p>\n\t2. &nbsp; Go to <em>Account Settings &gt; Company Details.</em></p><p>\n\t3. &nbsp; Find the SSO Login URL and copy it to share with your team.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69fcfc3e62795e90c763e477/file-ghsgMLJutr.png\"></p><hr><h2>How do I add people to an SSO-enabled account?</h2><p>\n\tFor accounts using SSO, people must be added through your company’s SSO provider. Invite options are removed from TeamGantt so your organization can control who has access from one central place.</p><p>\n\tIf someone can’t access TeamGantt, first confirm they’ve been added to the correct TeamGantt application or group in your identity provider. If they still can’t log in, contact your TeamGantt admin or reach out to TeamGantt support for help.</p>\n<table>\n<tbody>\n<tr>\n\t<td>\n\t\t<strong>Important: </strong>Users should not be invited manually from inside TeamGantt on SSO-enabled accounts. Manage access in your SSO provider instead.\n\t</td>\n</tr>\n</tbody>\n</table><hr><h2><strong style=\"background-color: initial;\">Which SSO providers does TeamGantt support?</strong></h2><p>\n\tTeamGantt supports SAML-based SSO providers, such as Microsoft Entra ID, Okta, and Auth0.</p><p>\n\tBecause each provider and company configuration can be different, setting up SSO may require some coordination between your team and TeamGantt.</p><hr><h2><strong style=\"background-color: initial;\">How do I get SSO for my TeamGantt account?</strong></h2><p>\n\tSSO is available for Enterprise accounts. To learn more or request SSO for your organization, please <a href=\"https://meetings.hubspot.com/manny-smirnov/teamgantt-book-a-demo-universal-link?utm_source=pricing_2_page&amp;uuid=fbdee62c-ebe9-4258-94e5-7f783a02a521\">contact Sales</a>.</p><hr><h2>FAQs</h2><p>\n\t<strong>Can I use the normal TeamGantt login page if my company uses SSO?</strong></p><p>\n\tUse your company’s unique SSO Login URL to access TeamGantt. If you log out, TeamGantt will return you to your organization’s SSO login page.</p><p>\n\t<strong>Can admins still invite users from TeamGantt?</strong></p><p>\n\tNo. On SSO-enabled accounts, people should be added and managed through your organization’s SSO provider.</p><p>\n\t<strong>Is SSO available on every TeamGantt plan?</strong></p><p>\n\tNo. SSO is available for Enterprise accounts.</p><p>\n\t<strong>What type of SSO does TeamGantt support?</strong></p><p>\n\tTeamGantt supports SAML-based SSO providers.</p>","name":"Single Sign-On (SSO) for Enterprise Plans","number":176,"categories":["57e9e78d9033602e61d4835c"]}},{"node":{"slug":"navigating-your-project-and-custom-board","text":"<p>Use this guide to help you effectively manage your board and customize how information is displayed to best suit your workflow.</p><hr><h3>How do I access the Board menu?&nbsp;</h3><p><strong>Menu </strong>can be located in the top left of the board. In a Custom Board, the <strong>Menu </strong>currently has 2 options: <strong>Invite People </strong>and <strong>Edit Board</strong>.</p><ul><li><strong>Invite People:&nbsp;</strong>Add and manage users who have access to your board.</li><li><strong>Edit Board:&nbsp;</strong>Update the board name and status, and adjust automated column settings.&nbsp;</li></ul><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/688394d18e5da9481ed4b855/file-d1u6yoa6iL.png\"></p><hr><h3>What does the View dropdown do on the Board?&nbsp;</h3><p>The <strong style=\"background-color: initial;\">View</strong> dropdown allows you to display the <strong style=\"background-color: initial;\">project name</strong> and/or <strong style=\"background-color: initial;\">group name</strong> on each card.&nbsp;Cards are directly tied to tasks, so turning on these options gives you context about where the task is located within the project.</p><p>You can also choose to display the <strong>task count</strong> for each column, helping you quickly assess workload distribution.</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/68839700ccd8424661790876/file-OzHQocTVIg.png\"></p><hr><h3>How do I highlight cards?&nbsp;</h3><p>You can use the <strong>Highlight</strong> option to emphasize certain cards based on selected filters. This is especially helpful when your board has many cards and you want to quickly surface specific information.</p><p>You can highlight cards based on:</p><ul><li>Assigned people</li><li>Assigned labels</li><li>Task status</li><li>Start and/or due dates</li><li>Estimated points or hours</li><li>Color(s)</li></ul><p> <strong>Helpful Tip:&nbsp;</strong>Board view includes a <strong>“stale” card</strong> option&mdash;this highlights cards that haven’t moved in a set number of days.&nbsp;It’s great for catching tasks that might be falling behind.</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/68839a18af51197b3c20aa8d/file-1DaUuQi1wG.png\"></p><hr><h3>How do I apply Board filters?&nbsp;</h3><p>The <strong>Filter</strong> option lets you temporarily narrow your board view by only showing cards that meet selected criteria.</p><p>Filters are available for:</p><ul><li>Assigned people</li><li>Assigned labels</li><li>Task status</li><li>Start and/or due dates</li><li>Estimated points or hours</li><li>Color(s)</li></ul><p>Any active filters will appear next to your board’s navigation controls.</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/68839b42af64236627768003/file-Z5ssSLk7Ds.png\"></p><hr><h3>How do I search for tasks on a Board?&nbsp;</h3><p>You can use the <strong>Search</strong>&nbsp;bar&nbsp;to enter a task name and either&nbsp;<strong>Filter</strong> results<em>&nbsp;</em>(only show cards that are relevant) or&nbsp;<strong>Highlight</strong> results&nbsp;(visually emphasize cards that are relevant).&nbsp;</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/68839c98af64236627768008/file-pF4xnc5qiq.png\"></p><hr><h3>How do I hide completed tasks?&nbsp;</h3><p>You can hide completed tasks by selecting the&nbsp;<strong>Hide Completed</strong>&nbsp;tab. This will hide all cards that have been marked as 100% complete, as well as any milestones that have been checked off as complete.&nbsp;</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/68839d2eccd842466179089c/file-hVozke8OQj.png\"></p>","name":"Navigating your Project and Custom Board","number":170,"categories":["5f510e62c9e77c0016384617"]}},{"node":{"slug":"lookaheads","text":"<p>\n\tA lookahead schedule is a vital tool in construction project management, focusing on detailed planning for the immediate future, typically covering periods ranging from 2-6 weeks. Its primary purpose is to bridge the gap between the overarching project schedule and daily crew activities, ensuring that upcoming tasks are clearly defined, resources are appropriately allocated, and potential obstacles are identified and addressed promptly.</p><h2>How do I create a lookahead schedule for my project?</h2><p>\n\tTo use a Lookahead, you can select a duration and a start date to base the Lookahead on. Only tasks that start, end, or cross that period are shown; all other tasks are filtered out.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a9053539f65cc0cc64d679b/file-Ud7rssFtTL.png\"> You can also use filters to narrow the list down further.&nbsp;If you click on a date before selecting a duration, the first duration (2 weeks) will automatically be selected.</p><ul>\t\n<li>If you click on a duration before selecting a date, the current date will automatically be selected.&nbsp;</li></ul><p>\n\tYou can click the \"x\" to clear the Lookahead from your board.&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6812650d24cd181cc9ff2ebb/file-d6AwnmxGYd.png\"></p>","name":"Lookaheads (Available on the Builder Edition)","number":166,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"schedule-confirmation-available-in-the-construction-edition","text":"<p>\n\tSchedule Confirmation helps&nbsp;Project Managers confirm both the initial&nbsp;project schedule and&nbsp;any schedule changes with the people assigned to the work. This ensures everyone is aligned on timelines, responsibilities, and expectations&mdash;before work begins or when plans change.</p><hr><h3>What is Schedule Confirmation?</h3><p>\n\tSchedule Confirmation is designed to close the communication gap between project planning and execution. When a schedule is created or updated, Project Managers can request confirmation from team members or \n\t<a href=\"https://support.teamgantt.com/article/179-adding-and-managing-subcontractors\">subcontractors</a> assigned to tasks, giving them a chance to review and acknowledge their timelines.</p><p>\n\tThis creates clarity, accountability, and fewer surprises down the road.</p><hr><h3>How to use Schedule Confirmation</h3><p>\n\tOnce tasks have been assigned or changes have been made to the schedule, a number will appear next to the \"Confirm schedule\" button&nbsp;at the top of the Gantt chart. This number indicates how many tasks have new or updated dates that need confirmation.</p><p>\n\tIf you'd like to confirm tasks within a certain parameter (i.e. only tasks the next 3 weeks), you can apply a \n\t<a href=\"https://support.teamgantt.com/article/166-lookaheads\">Lookahead window</a> or another filter to your project first. Only unconfirmed tasks that fit the newly applied parameters will appear in your schedule confirmation modal.&nbsp;&nbsp;</p><p>\n\tYou can click on \"Confirm schedule\" to view the tasks with new or rescheduled dates.&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69384cb71f22f82edb02666a/file-B0SanbgH1D.png\"></p><p>\n\tTo request confirmation of the changes, select the user(s) you would like to notify and click \"Request Confirmation\".&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69384d2c1f22f82edb02666f/file-i5qlnAft56.png\"></p><p>\n\tOnce you click on \"Request Confirmation\", the selected user(s) will receive an email to confirm or deny the schedule. The user(s) will also move to the \"Pending\" section until the user(s) have viewed the schedule.&nbsp;\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69384ec67b948f645c556c80/file-qS9Y8EZYGf.png\"></p><ul>\n\t\n<li>You can monitor confirmation status directly within the Confirmation column in <em>Gantt </em>view.</li>\t\n<li>If needed, click <strong>Resend Confirmation</strong> to send another reminder to users who have not yet responded.</li></ul><p>\n\tThis makes it easy to ensure all assigned users have reviewed and acknowledged schedule changes&mdash;without chasing updates manually.</p><hr><h3>How does a user confirm their schedule?&nbsp;</h3><p>\n\tOnce schedule changes or task assignments are sent for confirmation, the selected user(s) will receive an email notification prompting them to review the updates.</p><p>\n\tIf you're assigning \n\t<a href=\"https://support.teamgantt.com/article/179-adding-and-managing-subcontractors\">Subcontractors</a>, you can also send confirmation requests via SMS.&nbsp;</p><p>\n\tTo confirm the schedule changes, the recipient must simply click on \"Confirm schedule changes\" in the email or text message.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6939c72fd81df77376ce2792/file-KIM2WQZa0e.png\">Once they click on the link, the user can confirm or decline the changes.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6939c951eca6b83e9f9e16bf/file-pokjDYdfCL.png\"></p><p>\n\tAfter all tasks have been confirmed or declined, click \"Finish\"&nbsp;to complete the process.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6939c9b4d81df77376ce27a0/file-VXzG4YWUeT.png\"></p><p>\n\tProject Managers can view each user’s responses at any time via the \"Confirmation\" column in the Gantt chart.&nbsp;</p><hr><h3>How to view responses to the schedule confirmation&nbsp;</h3><p>\n\tThere are 2 ways to receive updates on task confirmations:</p><ol>\n\t\n<li>The Manager who requested the confirmation will receive confirmed and declined dates via email notification.&nbsp;</li>\t\n<li>Via the <strong>Confirmation </strong>column in your project. Once a person has confirmed or declined the schedule changes, you can view the response via the \"Confirmation\" column of the Gantt chart. You can enable the column by going to \n\t<strong style=\"background-color: initial;\">View &gt; Columns &gt; Show Confirmation Column</strong>.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a905417039b617b1742821b/file-IAAkUplDXF.png\"></li></ol><p>\n\tOnce the column is enabled, you will be able to see if the changes have been \n\t<em>confirmed, declined, pending, or not notified.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a9056034b84f76cf81bf0a6/file-B8UjZoULbf.png\"></em></p>","name":"Confirming schedules with Subcontractors (Available in the Builder Plan)","number":173,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"creating-a-project-with-teamgantt-ai-assistant","text":"<p>Need to build a project plan quickly? TeamGantt's <strong style=\"background-color: initial;\">AI Project Creation</strong> tool helps you generate a project schedule in seconds. Simply describe your project, and AI will create a project with suggested tasks, milestones, phases, and timelines that you can customize to fit your needs.</p><hr><h2>How to create a project with TeamGantt AI Assistant?</h2><p>From the My Projects page, click <strong>New Project</strong>. You can also click <strong>Create </strong>from the left sidebar</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a733378da71c39c6db3f9eb/file-oKuBUJQqMp.png\"></p><p>Select <strong>Try Now </strong>from the banner<strong>&nbsp;</strong>at the top of the project creation page.</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a733479f7fcd531381573a8/file-r3pRtQI1j1.png\"></p><p>Enter a description of your project and hit <strong>Enter</strong>.&nbsp;The more details you provide, the better your results will be.</p><ul><li>For example:<ul><li>Website redesign for a small business</li><li>Marketing campaign for a product launch</li><li>Office renovation project</li><li>Residential home construction</li></ul></li></ul><p>Review the generated project outline.&nbsp;If needed, edit the prompt and generate a new version.</p><p>When you're happy with the results, click <strong>Create Project</strong>.&nbsp;</p><p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a7336275e1bc5721f668338/file-BLvFyih0Dz.png\"></p><p>Your new project will open in TeamGantt, where you can continue making changes just like any other project.</p><hr><h2>Tips for better results</h2><h2><p>For the best project plan, include details such as:</p><ul> <li>The type of project</li><li>Your industry</li><li>Major deliverables</li><li>Important deadlines</li><li>Project goals</li><li>Team size or key roles (if applicable)</li></ul><p>For example, instead of:</p><blockquote> <p>Create a marketing project.</p></blockquote><p>Try:</p><blockquote> <p>Create a 10-week marketing campaign for a new software launch that includes content creation, email marketing, social media, paid advertising, and launch activities.</p></blockquote><p>The more context you provide, the more tailored your project plan will be.</p><hr></h2><h2>Who can use this feature?</h2><p>Anyone who has Manager permission can use the AI Project Creation tool.</p><hr><h2>What's included in an AI-generated project?</h2><p>Depending on your prompt, AI may generate:</p><ul> <li>Project phases</li><li>Tasks</li><li>Milestones</li><li>Suggested task durations</li><li>A recommended project timeline</li></ul><p>The generated project serves as a starting point. You can add, remove, or edit any tasks after the project is created.</p><hr><h2>How to edit your AI-generated project?</h2><h2><p>After your project is created in TeamGantt, you can:</p><ul> <li>Rename tasks and phases.</li><li>Adjust dates and durations.</li><li>Assign work to team members.</li><li>Add notes, attachments, and checklists.</li><li>Customize the project to match your workflow.</li></ul><p>AI provides a starting point&mdash;you remain in complete control of your project plan.</p></h2><hr>","name":"Creating a Project with TeamGantt AI Assistant","number":184,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"adding-and-managing-subcontractors","text":"<p>\n\t<strong style=\"background-color: initial;\">Need a simple way to keep trades aligned on your project schedule? </strong>Subcontractors help managers communicate schedule updates to people outside their TeamGantt account by email or SMS, without requiring subcontractors to log in.</p><h2><strong>What is a Subcontractor?</strong></h2><p>\n\tA Subcontractor is a TeamGantt resource type designed for construction teams that need to coordinate with external trades, vendors, or partners who help complete project work but do not need full access to the company TeamGantt account.</p><p>\n\tSubcontractors can be assigned to tasks and included in the \n\t<a href=\"https://support.teamgantt.com/article/173-schedule-confirmation-available-in-the-construction-edition\">Schedule Confirmation</a> feature. When schedule dates are assigned or change, managers can send subcontractors a quick confirmation request by SMS, email, or both.</p><p>\n\t<strong>Note</strong>: Subcontractors cannot log into your company TeamGantt account; they access project information only through direct links sent to them.</p><hr>\n<strong><h2></h2></strong><p><strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><p>\n\t<strong></strong></p><h2>When should I use Subcontractors?&nbsp;</h2><p>\n\tUse Subcontractors when you need to keep external project contributors informed, but they do not need to actively manage work inside TeamGantt.</p><ul>\n\t\n<li>Builders coordinating with trades such as HVAC, insulation, drywall, electrical, plumbing, or framing</li>\t\n<li>Project managers who need schedule confirmations from outside contributors</li>\t\n<li>Teams that want fewer scattered texts, emails, and calls when schedules shift</li>\t\n<li>Companies that need a simple way to see who has confirmed schedule changes and who still needs follow-up</li></ul><hr><p>\n\t<strong style=\"background-color: initial; font-family: inherit; font-size: 24px;\">What can Subcontractors do?</strong></p><ul>\n\t\n<li>Be added to a project and assigned to tasks</li>\t\n<li>Receive schedule confirmation requests by SMS, email, or both</li>\t\n<li>Review schedule changes from a direct link without logging in</li>\t\n<li>Confirm or decline schedule changes so managers can track responses in TeamGantt</li></ul><p>\n\t<strong>Subcontractors cannot </strong>log into the company TeamGantt account, create or edit projects, manage project settings, invite people, or receive standard account access like managers or collaborators.</p><hr><h2><strong>How do I add a Subcontractor to a project?</strong></h2><p>\n\tManagers can add subcontractors from the same places they add other people to a project.</p><ol>\n\t\n<li>Open the project you want to add a subcontractor to.</li>\t\n<li>Go to the <strong>People</strong> tab, or open <strong>Menu &gt; Manage People and Labels</strong>.</li>\t\n<li>Click <strong>Add subcontractors.</strong></li>\t\n<li>Choose from the list of available subcontractors in your account or select <strong>Create new subcontractor.</strong></li>\t\n<li>Enter the subcontractor's name and select their trade.</li>\t\n<li>Optionally, enter a phone number (opt-in required) and/or email address, depending on how you prefer to notify them.&nbsp;</li>\t\n<li>Select the notification preference: Email only, SMS only, Email &amp; SMS, or None.&nbsp;</li>\t\n<li>Click Add <strong>Subcontractor</strong> to save the subcontractor and add them to the project.</li></ol>\n<table>\n<tbody>\n<tr>\n\t<td>\n\t\t<strong>Important:</strong><br>\n\t\t<ul>\n\t\t\t<li>A subcontractor's permission type in your company cannot be changed later. Existing users cannot be changed to subcontractors, and subcontractors cannot be upgraded to regular users. If someone needs a different level of access, create a new person with the correct permission.</li>\n\t\t\t<li>Subcontractors must opt in to receive SMS updates.&nbsp;</li>\n\t\t</ul>\n\t</td>\n</tr>\n</tbody>\n</table><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a345041c5573f5a2092d373/file-Ijfjv8oaWK.png\" alt=\"\" style=\"display: block; margin: auto;\"></p>\n<table>\n<tbody>\n<tr>\n\t<td>\n\t\t<h2>How do I opt Subcontractors into receiving updates by SMS?&nbsp;</h2>\n\t\t<p>\n\t\t\tBy law, SMS updates can only sent to phone numbers that have opted into receiving updates.&nbsp;\n\t\t</p>\n\t\t<p>\n\t\t\tOnce a subcontractor has been added to your account, you'll be able to view their opt-in status from the \n\t\t\t<strong>People </strong>page in any project that they've been invited to.&nbsp;\n\t\t</p>\n\t\t<p>\n\t\t\tTo get subs opted in:&nbsp;\n\t\t</p>\n\t\t<ol>\n\t\t\t<li>Copy the SMS opt-in link for the subcontractor you wish to opt in.</li>\n\t\t\t<li>Send them the opt-in link manually.&nbsp;</li>\n\t\t\t<li>Upon opening the link, they will have to check a box and click \"Enable SMS Notifications\"</li>\n\t\t</ol>\n\t\t<p>\n\t\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a3453046a11e5f5c78bc714/file-J1DiVqnble.png\" alt=\"\" style=\"display: block; margin: auto;\">\n\t\t</p>\n\t\t<p>\n\t\t\tThat's it! Once they're opted in, you'll a green \"Verified\" checkmark next to their phone number on the \n\t\t\t<strong style=\"background-color: initial;\">People </strong>page.&nbsp;\n\t\t</p>\n\t\t<hr>\n\t\t<h2>How do I manage Subcontractors on my account?&nbsp;</h2>\n\t\t<p>\n\t\t\tIf you have account admin permission, you can manage all subcontractors from \n\t\t\t<strong>Account Settings &gt; Manage Subcontractors</strong>\n\t\t</p>\n\t\t<ul>\n\t\t\t<li>You can update a subcontractor's name, trade, phone number, email address, or notification preferences by clicking on their name.&nbsp;</li>\n\t\t\t<li>You can delete subcontractor by clicking on the <strong>3-dot icon &gt; Delete subcontractor</strong>.</li>\n\t\t</ul>\n\t\t<p>\n\t\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a3450dab7b5b7d606b2e9cf/file-NSg8c20ooa.png\" alt=\"\" style=\"display: block; margin: auto;\">\n\t\t</p>\n\t</td>\n</tr>\n</tbody>\n</table><h2><hr>\n</h2><h2>How do I assign a Subcontractor to tasks?&nbsp;</h2><p>\n\tOnce a subcontractor has been added to your project, you can assign them to tasks like you would assign any other person or resource.</p><ul>\n\t\n<li>Click the person icon next to a taskbar, then choose the subcontractor from the assignment list.</li>\t\n<li>Or, use the Assigned column to select the subcontractor for a task.</li>\t\n<li>To assign several tasks at once, select the tasks first, then use the person icon that appears for your selection.</li></ul><p>\n\tAfter a subcontractor is assigned to tasks, they can be included in Schedule Confirmation requests for those tasks.</p><hr><h2><strong>How do I request schedule confirmation from Subcontractors?</strong></h2><p>\n\tSubcontractors who are assigned to tasks are included in the \n\t<a href=\"https://support.teamgantt.com/article/173-schedule-confirmation-available-in-the-construction-edition\">Schedule Confirmation</a> flow. This makes it easy to confirm schedule changes with external trades and see who still needs to respond.</p><ol>\n\t\n<li>After tasks are assigned or assigned schedule dates change, click <strong>Confirm schedule</strong> at the top of the Gantt chart.</li>\t\n<li>Review the people who need to confirm the schedule. Subcontractors assigned to affected tasks will appear in the confirmation list.</li>\t\n<li>Select the people you want to notify.</li>\t\n<li>Click <strong>Request Confirmation</strong>.</li>\t\n<li>Subcontractors will receive the request by their selected notification method: SMS, email, or both.</li></ol><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a345266c5573f5a2092d37a/file-l9oWOEEgGM.png\" alt=\"\" style=\"display: block; margin: auto;\"></p>\n<br>\n<table>\n<tbody>\n<tr>\n\t<td>\n\t\t<strong>Important:&nbsp;</strong><br>\n\t\t<ul>\n\t\t\t<li>You can monitor each person's response from the Confirmation column in Gantt view. Responses may show as confirmed, declined, pending, or not notified.</li>\n\t\t\t<li>If someone has not responded yet, click on&nbsp;<strong style=\"background-color: initial;\">Confirm schedule &gt; Pending &gt; Resend Confirmation </strong>to resend selected requests.</li>\n\t\t</ul>\n\t</td>\n</tr>\n</tbody>\n</table><h2><hr>\n</h2><h2><strong>What does a Subcontractor receive?</strong></h2><p>\n\tWhen you request schedule confirmation, subcontractors receive a message that summarizes the schedule change and links them to a lightweight confirmation page. They do not need a TeamGantt login to review and respond.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a3452a2c5573f5a2092d37d/file-WfVpblXzGS.png\" alt=\"\" style=\"display: block; margin: auto;\"></p><p>\n\tSubcontractors can choose to either confirm or decline the dates.&nbsp;Upon decline, they can optionally leave a message, which is emailed directly to the requester.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a34538c6a11e5f5c78bc715/file-BOeNwYNYac.png\" alt=\"\" style=\"display: block; margin: auto;\"></p>\n<table>\n<tbody>\n<tr>\n\t<td>\n\t\t<br>\n\t</td>\n</tr>\n</tbody>\n</table><h2><strong>FAQs</strong></h2><p>\n\t<strong>Do Subcontractors need a TeamGantt login?</strong></p><p>\n\tNo. Subcontractors access schedule confirmation through a direct link sent by SMS or email. They cannot log in to your company TeamGantt account.</p><p>\n\t<strong>Is an email address required?</strong></p><p>\n\tNo. An email address is optional for subcontractors. It's only required if you have selected to notify them via email.</p><p>\n\t<strong>Can Subcontractors receive both email and SMS notifications?</strong></p><p>\n\tYes. If both a phone number and email address are added, you can choose Email, SMS, or Both as the notification preference.</p><p>\n\t<strong>Can I change a regular user into a Subcontractor?</strong></p><p>\n\tNo. Existing users cannot be changed into subcontractors, and subcontractors cannot be upgraded into regular users. Create a new person with the correct permission type instead.</p><p>\n\t<strong>Can I add Subcontractors to Teams?</strong></p><p>\n\tNo. Not at this time.&nbsp;</p><p>\n\t<strong>Can Subcontractors be assigned to tasks?</strong></p><p>\n\tYes. Managers can assign subcontractors to tasks and include them in Schedule Confirmation requests.</p><p>\n\t<strong>Which plans include Subcontractors?</strong></p><p>\n\tSubcontractors are available on Builder plans.</p><hr><h2><strong>Related articles</strong></h2><ul>\n\t\n<li><a href=\"https://support.teamgantt.com/article/173-schedule-confirmation-available-in-the-construction-edition/\">Schedule Confirmation (Available in the Construction Edition)</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/6-inviting-people/\">Invite People (Users) &amp; Assign Tasks</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/114-changing-account-level-permissions/\">Manage People (For Managers)</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/75-collborator-or-label/\">Manager, Collaborator, and Label Defined</a></li></ul>","name":"Adding and Managing Subcontractors (Available in the Builder Plan)","number":179,"categories":["5284de2fe4b027e0d843bc97"]}},{"node":{"slug":"setup-procore-integration-with-teamgantt","text":"<h2>Step 1: Install the app in Procore</h2><p>\n\tStart by logging into your Procore account and going to your dashboard.</p><blockquote>\n\tNote: You will need permission to install apps in your company before performing this step.\n</blockquote><ol>\n\t\n<li>In the Procore dashboard, click the \"Apps\" dropdown.</li>\t\n<li>In the dropdown, click \"App Management\".<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a4d49cccfd7aa8bea1b34a1/file-PTeL3c1BkM.png\"></li>\t\n<li>Click the \"Install App\" dropdown.</li>\t\n<li>Click \"Install App from Marketplace\".<p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a501cbeab2386dd4065027a/file-BWqF1AFNaC.png\"></p></li>\t\n<li>Search for the TeamGantt App in the Marketplace and install it.</li></ol><h2>Step 2: Setup the integration in TeamGantt</h2><p>\n\tLogin to your TeamGantt account in order to setup the Procore integration.</p><blockquote>\n\tNote: Your company must have the Procore feature available on their TeamGantt subscription to setup the integration.\n</blockquote><ol>\n\t\n<li>In the navigation sidebar, select \"Integrations\".</li>\t\n<li>Click \"Configure\" in the Procore card on the Integrations page.</li>\t\n<li>Click \"Login to Procore\".<p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a501ce4ccc4eabb36cbb37d/file-2HVa99EzPg.png\"></p></li>\t\n<li>After logging in, you should be sent back to the Integrations page in TeamGantt. Ensure that your Procore company is listed in the modal and shows \"Connected\".<p><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a501cf8c985582245f02832/file-Ob3TcomVYW.png\"></p></li></ol>","name":"Setup Procore Integration with TeamGantt","number":180,"categories":["528a6bcee4b0bb9de0e9a1f6"]}},{"node":{"slug":"import-a-project-from-primavera-p6","text":"<p>\n\tImporting a Primavera P6 file is a quick way to get your existing project into TeamGantt without having to rebuild your schedule from scratch.</p><hr><h2>How do I import a Primavera P6 project?</h2><ol>\n\t\n<li>Click <strong>New Project</strong> in the upper-right corner of your <strong>My Projects</strong> page, or click <strong>Create</strong>&nbsp;from the left sidebar.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a734040f7fcd531381573cf/file-aX2LsD48oy.png\"></li>\t\n<li>Select <strong>Import from Primavera P6</strong> to begin the import process.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a73406fda71c39c6db3fa22/file-8X5eAoNwt6.png\"></li>\t\n<li>Upload your Primavera P6 file by clicking <strong>Upload a file</strong> or by dragging and dropping the file into the upload area.<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a7340a304b4d6c8307bece3/file-YV82O141zK.png\"></li></ol><p>\n\tOnce the file has been uploaded, TeamGantt will process your project and create a new Gantt chart.</p><hr style=\"background-color: initial;\"><h2 style=\"color: rgb(64, 82, 97); font-family: Arial, Helvetica, Verdana, Tahoma, sans-serif;\">What data can I import?</h2><ul>\n\t\n<li>Task Name</li>\t\n<li>Dependencies</li>\t\n<li>Start/End Dates</li>\t\n<li>Task Completion Percentages</li></ul><hr><h2>What data can't be imported?&nbsp;</h2><ul>\n\t\n<li>Task Resource Assignments</li>\t\n<li>Resources</li></ul><p>\n\tHaving trouble with importing your file? Email us at support@teamgantt.com. We'd be happy to help!</p><p>\n\tLooking for another way to sync your data with TeamGantt? Check out our <a href=\"https://support.teamgantt.com/article/152-teamgantt-integration-for-zapier\">integration with Zapier</a>!&nbsp;</p>","name":"Import a project from Primavera P6","number":185,"categories":["5284df24e4b027e0d843bca8"]}},{"node":{"slug":"client-portal-client-access-builders-edition-only","text":"<p>\n\tYour contact may invite you to view project updates through TeamGantt's&nbsp;\n\t<strong style=\"background-color: initial;\">Client Portal</strong>. This portal gives you a simple way to stay informed about your project schedule, upcoming milestones, and progress updates&mdash;all in one place.</p><p>\n\tYou can access the portal from any device using the link your contact sends you.</p><hr><h2>Do I need a TeamGantt account?</h2><p>\n\tNo. You do&nbsp;\n\t<strong>not</strong> need a TeamGantt account to use the Client Portal.</p><p>\n\tJust open the link or accept the invite provided by your contact to view your project updates! You will need to authenticate your email upon invite. Once authenticated, you will stay logged in, unless you choose to log out.&nbsp;</p><hr><h2>How to access your Client Portal</h2><p>\n\tFollow these steps to open your portal:</p><h3>Step 1: Open your invitation link</h3><p>\n\tClick the Client Portal link your contact shared with you by email.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69cbf6a9eaa67dc49eb4bce9/file-bIJgLBViHk.png\"></p><h3>Step 2: View your project schedule</h3><p>\n\tOnce the portal opens, you’ll see a view of your project timeline and updates.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a207d4ed40ab70e38bfc476/file-EGWXu3NOf4.png\"></p><ul>\n\t\n<li>If only a link was shared with you, you will first need to enter your email address and name to access the project timeline.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69cbf7e2710d1ad5f140ff27/file-mycGRdbJQ5.png\"></li></ul><h2><hr id=\"horizontalrule\">\n</h2><h2>What can you see in the Client Portal?</h2><p>\n\tYour builder can choose to share any of the following:</p><ul>\n\t\n<li>Upcoming project steps</li>\t\n<li>Important milestones</li>\t\n<li>Progress updates</li>\t\n<li>Shared photos</li>\t\n<li>Updates on the project</li></ul><hr><h2>How to switch between list and calendar views</h2><p>\n\tYou can view your project schedule in two formats:</p><ul>\n\t\n<li><strong>List view</strong> shows a structured outline of upcoming work</li>\t\n<li><strong>Calendar view</strong> shows when project steps are scheduled to happen</li></ul><p>\n\tUse the toggle at the top of the portal to change between views.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a208166171940265cf2bf5f/file-OHFkLARNHq.png\"></p><hr><h2>How to read messages sent from your builder</h2><p>\n\tYour contact may share updates that include comments and photos via messages.</p><p>\n\tTo view them:</p><ol>\n\t\n<li>Select <strong>Messages</strong> in the left panel.&nbsp;</li>\t\n<li>Click on the desired message.&nbsp;</li></ol><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69cbf9c1eaa67dc49eb4bd71/file-jAkDtpzF72.png\"></p><hr><h2>How to send messages to your builder?</h2><p>\n\tThe Client Portal includes a messaging inbox so you can stay connected in one place.</p><p>\n\tTo send a new message:</p><ol>\n\t\n<li>Open the <strong>Messaging Inbox</strong></li>\t\n<li>Click <strong>Compose</strong><img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69cbfab8ee943559957fb20b/file-TgDtqWxtA3.png\"></li>\t\n<li>Enter a <strong>Subject</strong>&nbsp;and <strong>Message</strong>. Optionally, you can add an attachment or reference specific work.&nbsp;</li>\t\n<li>Click<strong> Send</strong></li></ol><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a2082b45b5b068c5eefe16f/file-MBu5RsXN55.png\">To reply to a message:</p><ol>\n\t\n<li>Open the message</li>\t\n<li>Then, enter your reply in the text box. You can add attachments and reference specific project work here too.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69cc0d4c094309ab5238140a/file-JrYsLhK0mz.png\"></li></ol><p>\n\tYour builder will be notified when you send a message.</p><hr><h2>What if I have a portal for multiple projects?&nbsp;</h2><p>\n\tYour builder may invite you to view multiple projects. To switch between projects, simply click \n\t<strong>Switch projects</strong><strong>&nbsp;</strong>in the bottom left panel.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a20820c36f5d6d1101e702b/file-oZdXsBxzdi.png\"></p><h2><hr>\n</h2><h2>Tips for using your Client Portal</h2><p>\n\tTo get the most out of your portal:</p><ul>\n\t\n<li>Check the portal regularly for updates</li>\t\n<li>Review milestone dates to stay informed about progress</li>\t\n<li>Look for photos attached to updates</li>\t\n<li>Use the messaging inbox instead of email when possible, so communication stays in one place</li></ul><p>\n\tYour Client Portal helps you stay informed about what’s happening now and what’s coming next in your project!</p>","name":"Client Portal - Client Access & How-to","number":175,"categories":["5284de2fe4b027e0d843bc97"]}},{"node":{"slug":"reorder-tasks-by-start-date","text":"<p>\n\tNeed to quickly organize your project tasks by date? TeamGantt makes it easy to reorder all tasks in a project based on their start dates.</p>\n<div>\n\tThis is especially helpful if your tasks were added out of order or if you want to quickly restructure your project into a more chronological, waterfall-style timeline.\n</div><h2>How to reorder tasks by start date</h2>\n<div>\n\tHere’s how to reorder the tasks in your project:\n</div><ol>\n\t\n<li>Open the project you’d like to update.</li>\t\n<li>Click the Menu drop-down in the upper right corner of your project.</li>\t\n<li>Select <strong>Reorder Tasks by Start Date.</strong></li></ol>\n<div>\n\tTeamGantt will automatically reorder the tasks in your project based on each task’s start date.\n</div><h2>What happens when tasks are reordered?</h2>\n<div>\n\tWhen you use Reorder Tasks by Start Date, TeamGantt will update the order of your project so tasks appear chronologically by start date.\n</div><div>\n\tThis change applies to:\n</div><ul>\n\t\n<li>Tasks within each group</li>\t\n<li>Groups within the project</li></ul>\n<div>\n\tThat means your project will be reorganized so tasks and groups follow the order of your schedule more closely.\n</div><div>\n\t<div>\n\t\tBefore reordering:\n\t</div></div>\n<div>\n\t<p>\n\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a1df07ff71f9172009ce38b/file-bKovhGGvMN.png\">\n\t</p>\n</div><div>\n\tAfter reordering:\n</div><div>\n\t<p>\n\t\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a1df09f86a2a0d7f494fc38/file-IktmYEFDV3.png\">\n\t</p>\n</div><h2>Important note</h2>\n<div>\n\tThis action cannot be undone. Be sure you’re ready to permanently reorder your project before selecting this option.\n</div><div>\n\tIf you’d like to preserve the current task order, we recommend duplicating the project first. That way, you’ll have a backup copy to reference if needed.\n</div><h2>When should I use this feature?</h2>\n<div>\n\tReordering tasks by start date can be useful when you want to:\n</div><ul>\n\t\n<li>Clean up a project where tasks were entered out of order</li>\t\n<li>Organize your project into a more logical timeline</li>\t\n<li>Quickly convert a project into a waterfall-style schedule</li>\t\n<li>Make your task list easier to scan and follow</li></ul>\n<div>\n\tOnce reordered, your project will be easier to review from top to bottom based on when work is scheduled to begin.\n</div>","name":"Reorder Tasks by Start Date","number":178,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"client-portal-manager-access","text":"<p>\n\tClient Portal gives builders an easy way to share project updates with clients&nbsp;in a clear, professional, and centralized experience. Instead of relying on scattered calls, texts, and emails, you can choose exactly what to share and send clients a simple link where they can follow progress.</p><hr><h2>Who can use the Client Portal?</h2><p>\n\tThe Client Portal is available only on the&nbsp;Builder plan and Enterprise plans.&nbsp;</p><p>\n\t<strong>Permissions:</strong></p><ul>\n\t\n<li>Managers can configure and send Client Portal access.</li>\t\n<li>Collaborators cannot configure or send portals.</li>\t\n<li>Clients do <strong>not</strong> need a TeamGantt account to access the portal.</li></ul><hr><h2>What is the Client Portal?</h2><p>\n\tThe Client Portal allows you to create a shareable view of your project that clients can access anytime.</p><p>\n\tWith the Client Portal, you control what clients see while giving them visibility into project progress, upcoming milestones, and important updates&mdash;all in one place.</p><p>\n\tClients can:</p><ul>\n\t\n<li>View project schedules in <strong>List view </strong>or <strong>C</strong><strong>alendar view</strong></li>\t\n<li>See progress updates</li>\t\n<li>Access shared <strong>photos and comments</strong></li>\t\n<li>Use a built-in <strong>messaging inbox</strong> to stay connected</li>\t\n<li>What can you share with clients?</li></ul><p>\n\tBefore sending access, you choose exactly what appears in the portal.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a207d9d01b9ab7a6001b582/file-pgJ48xUpo6.png\">You can share:</p><ul>\n\t\n<li><strong>Groups only</strong></li>\t\n<li><strong>Milestones only</strong></li>\t\n<li><strong>Groups and milestones</strong></li>\t\n<li><strong>The entire project</strong></li></ul><p>\n\tThis flexibility helps you control the level of visibility that makes sense for each client. You can update a client's visibility any time from the \n\t<strong>Accesses </strong>section of your Client Portal tab.&nbsp;</p><p>\n\t<strong>Tip: </strong>If you would like to preview what the portal will look like for your clients,&nbsp;you can invite yourself to the portal.&nbsp;</p><hr><h2>How to set up and share the Client Portal</h2><p>\n\tFollow these steps to configure and share a Client Portal:</p><h3>Step 1: Open your project</h3><p>\n\tNavigate to the project you want to share with your client.</p><h3>\nStep 2: Open Client Portal&nbsp;</h3><p>\n\tSelect the&nbsp;\n\t<strong>Client Portal</strong>&nbsp;tab at the top of your project. Then, select&nbsp;<strong>Invite clients. </strong>You can then choose to<strong>&nbsp;Invite by email</strong> or<strong>&nbsp;Share a link.</strong></p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69cbdab0b48e78d3d423e85c/file-17dSZVO4rF.png\"></p><h3>Step 3: Choose what to share</h3><p>\n\tSelect one of the following visibility options:</p><ul>\n\t\n<li>Groups only</li>\t\n<li>Milestones only</li>\t\n<li>Groups and milestones</li>\t\n<li>Entire project</li></ul><p>\n\tYou can update a client's visibility any time from the \n\t<strong>Accesses</strong> section of your Client Portal tab.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/69cbdb97b48e78d3d423e866/file-e5Dzmu1lUW.png\"></p><h3>Step 4: Send the email invite or share the link</h3><p>\n\tOnce your portal is configured, you can invite your client by:</p><ul>\n\t\n<li>Sending the invitation directly via email from TeamGantt</li>\t\n<li>Copying the share link and sending it manually by email or text message. Your client will be prompted to enter their email to receive a link to accept the invitation.&nbsp;</li></ul><p>\n\tOnce your client accepts the invitation via either method, they'll be logged into their portal automatically.</p><hr><h2>How to remove access to the Client Portal</h2><p>\n\tTo remove access:</p><ol>\n\t\n<li>Open the project</li>\t\n<li>Return to <strong>Client Portal &gt; Accesses</strong></li>\t\n<li>Select <strong>Revoke access (</strong>under the <strong>Actions</strong> menu<strong>)</strong></li></ol><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a207d105b5b068c5eefe157/file-IXSJULKeF8.png\"></p><hr><h2>How to message clients in the Client Portal&nbsp;</h2><p>\n\tTo message a client:</p><ol>\n\t\n<li>Click on&nbsp;<strong>&nbsp;+ New Message</strong></li>\t\n<li>Enter a <strong>Subject</strong>&nbsp;and&nbsp;<strong>Message</strong></li>\t\n<li>Optionally, attach files or reference a task or group in your project.&nbsp;</li>\t\n<li>Then, select <strong>Create Thread</strong></li></ol><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a207f2336f5d6d1101e7024/file-9qCyrvjJUj.png\"></p><p>\n\tIf a group or task&nbsp;has been referenced in your message, you can click on the item to be taken to the task in question.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a207f7a6440b9a7594eab01/file-v9f8QJk9TQ.png\"></p><p>\n\t<strong>Tip: </strong>If you would like to archive a thread, you can do so at the upper right side of your open message. Clients will not be able to view threads that have been archived.&nbsp;</p><hr><h2>\n</h2><h2>\nTips for getting the most out of the Client Portal</h2><p>\n\tTo create the best experience for homeowners:</p><ul>\n\t\n<li>Share milestones to highlight key project moments</li>\t\n<li>Include photos in updates whenever possible</li>\t\n<li>Use comments to provide quick progress notes</li>\t\n<li>Choose the visibility level that matches your communication style</li></ul><p>\n\tA well-maintained Client Portal helps clients stay informed without needing frequent status requests.</p>","name":"Client Portal - Manager Access (Available on Select Paid Plans)","number":174,"categories":["5284de2fe4b027e0d843bc97"]}},{"node":{"slug":"using-teamgantt-in-the-classroom","text":"<p>\n\tTeamGantt can be used as an educational tool to help instructors teach project management concepts and give students hands-on experience with project planning.</p><p>\n\tWhether you're teaching a project management course, guiding students through a classroom project, or using Gantt charts to organize your course, an educational account can help you and your students plan, collaborate, and track progress in one place.</p><hr><h2>Who can use an educational account?</h2><p>\n\tTeamGantt offers special accounts&nbsp;for instructors using TeamGantt in an educational setting.</p><p>\n\tEducational accounts can be a great fit for:</p><ul>\n\t\n<li>College and university instructors</li>\t\n<li>Project management courses</li>\t\n<li>Instructors teaching project planning and scheduling</li>\t\n<li>Other classroom environments where students can benefit from hands-on project management experience</li></ul><hr id=\"horizontalrule\"><h2>How do I set up an educational account?</h2><h3>Step 1: Contact TeamGantt</h3><p>\n\tTo learn more about educational account options, contact our Support team at <a href=\"mailto:support@teamgantt.com\"><strong>support@teamgantt.com</strong></a> using your <strong>workplace- or school-provided email address</strong>.</p><p>\n\tIn your email, let us know that you're an instructor interested in using TeamGantt for educational purposes.</p><h3>Step 2: Work with our team to set up your account</h3><p>\n\tOur team can help you determine the best account setup for your classroom and provide information about available educational pricing.</p><p>\n\tOnce your account is set up, you'll be ready to start building projects and inviting students.</p><h3>Step 3: Invite your students</h3><p>\n\tOnce your account is ready, invite your students to join the account</p><p>\n\tYou can invite your students by going to <strong>Account Settings &gt; Manage users</strong>.&nbsp;<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6abbcf004a8ba16a8dfa06aa/file-s5sN2juvm0.png\"></p><h3>Step 4: Introduce students to TeamGantt</h3><p>\n\tTeamGantt provides support resources to help students get familiar with the platform, including support documentation and tutorial videos.</p><p>\n\tFor instructors, TeamGantt can also provide classroom-specific guidance to help you get the most out of the platform.</p><hr><h2>How can TeamGantt be used in the classroom?</h2><p>\n\tTeamGantt can help instructors give students practical experience with project planning and management.</p><h3>For instructors</h3><p>\n\tTeamGantt provides tools to:</p><ul>\n\t\n<li>Keep an eye on student projects and progress</li>\t\n<li>Collaborate with students in real time</li>\t\n<li>Review changes students make to their Gantt charts</li>\t\n<li>Help students learn project management concepts using real-world software</li></ul><h3>For students</h3><p>\n\tStudents can:</p><ul>\n\t\n<li>Build and manage their own project plans</li>\t\n<li>Collaborate with classmates</li>\t\n<li>Update their projects from anywhere with an internet connection</li>\t\n<li>Learn how project management tools are used in professional environments</li>\t\n<li>Practice organizing tasks, schedules, and dependencies</li></ul><hr><h2>Need help getting started?</h2><p>\n\tIf you have questions about setting up an educational account or using TeamGantt in your classroom, contact our Support team at <a href=\"mailto:support@teamgantt.com\"><strong>support@teamgantt.com</strong></a>.</p><p>\n\tWe're happy to help you get your classroom up and running!</p>","name":"Using TeamGantt in the Classroom","number":186,"categories":["5511aff4e4b061031401fb4c"]}},{"node":{"slug":"procurement-tracking-only-available-on-the-builder-edition","text":"<p>\n\tThe Procurement tracker helps construction teams manage materials across active projects from one global board. Use it to see what needs to be ordered soon, what has already been ordered, what is delayed, and what has been delivered.</p>\n<table>\n<tbody>\n<tr>\n\t<td>\n\t\t<strong>Note: </strong>Procurement works with materials in your projects. <a href=\"https://support.teamgantt.com/article/172-material-lead-times/\">Materials&nbsp;</a>can be pulled into the board based on the projects you select and how far ahead you want TeamGantt to look for upcoming order dates.\n\t</td>\n</tr>\n</tbody>\n</table><h2>\n<strong>What is the Procurement tracker?</strong></h2><p>\n\tProcurement is a global view that brings \n\t<a href=\"https://support.teamgantt.com/article/172-material-lead-times/\">materials</a> from selected projects into one status-based workflow. Instead of opening each project to check material needs, you can review and update materials from Procurement in the sidebar.</p><p>\n\tThe tracker is organized into 4 material status columns:</p><ul>\n\t\n<li>Not ordered</li>\t\n<li>Ordered</li>\t\n<li>Delayed</li>\t\n<li>Delivered</li></ul><p>\n\tEach material appears as a card. Moving a card to a new column updates the material status and keeps that status connected to the material in your project.</p><hr><h2>\n<strong>How does the Procurement tracker work?</strong></h2><p>\n\tDuring setup, an account admin chooses which active projects should be tracked. They also choose how far ahead TeamGantt should look for materials that need to be ordered.</p><p>\n\tOnce the tracker is set up, materials can appear in Procurement in 2 ways:</p><ul>\n\t\n<li>Automatically, when materials from selected projects fall within the timeframe you chose.</li>\t\n<li>Manually, when you add a new material directly from the Procurement tracker.</li></ul><p>\n\tProcurement helps teams connect material planning back to the project schedule, so upcoming order needs and delays are easier to spot before they impact the job.</p><hr><h2>\n<strong>How do I set up the Procurement tracker?</strong></h2><p>\n\tTo set up Procurement:</p><p>\n\t1) Select \n\t<strong style=\"background-color: initial;\">Procurement </strong>from the left sidebar.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a5107d357be4eea8c37fa26/file-4t5GUdXwiV.png\" alt=\"\" style=\"display: block; margin: auto;\"></p><p>\n\t2)&nbsp;Choose the active projects you want to include in the tracker.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a5107f7f457003c1f086057/file-JRpd8rMF9k.png\" alt=\"\" style=\"display: block; margin: auto;\">3) Choose how far ahead TeamGantt should look for materials based on their order-by date. For instance, if you'd like to see all of the things that you need to order a week from now, you could select \"7d\".&nbsp;</p><p>\n\tYou can also input a custom range, if desired.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a510810f457003c1f086058/file-BjWFk3FM6N.png\" alt=\"\" style=\"display: block; margin: auto;\"></p><p>\n\t4)&nbsp;Save your settings to enable tracking.</p>\n<table>\n<tbody>\n<tr>\n\t<td>\n\t\t<strong>Tip: </strong>The timeframe controls when materials appear in the Not ordered column. For example, if you choose 14 days, materials with an upcoming order-by date within the next 14 days can be pulled into the tracker.\n\t</td>\n</tr>\n</tbody>\n</table><table>\n<tbody>\n<tr>\n\t<td>\n\t\t<strong style=\"background-color: initial; font-family: inherit; font-size: 24px;\">How do I add or update materials from the Procurement tracker?</strong>\n\t</td>\n</tr>\n</tbody>\n</table><p>\n\t<strong></strong><strong>Update a material status</strong></p><p>\n\tTo update a material status, drag the material card to a different column on the Procurement tracker. The material status will update on the tracker and sync back to the related material in the project.</p><p>\n\tFor example, moving a material from \n\t<strong>Not ordered</strong> to <strong>Ordered</strong> marks that material as ordered. Moving it to <strong>Delayed</strong> helps your team quickly see that the material needs attention.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a5108b1ab2386dd40650490/file-MLgcqvCbIN.gif\" alt=\"\" style=\"display: block; margin: auto;\"></p><p>\n\t<strong>Add a new material from Procurement</strong></p><p>\n\tYou can also add a new material directly from the Procurement tracker. This is helpful when you need to quickly add something that should be tracked through procurement without opening the project first.</p><ol>\n\t\n<li>Open the Procurement tracker.</li>\t\n<li>Select the option to <strong>add&nbsp;material</strong> from the link in any column.</li>\t\n<li>Choose the related project, group, and task details as needed.</li>\t\n<li>Add the material details, including the order-by date and purchaser if applicable.</li>\t\n<li>Save the material.</li></ol><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a5108f5f457003c1f08605a/file-vH16VQ4n5k.png\" alt=\"\" style=\"display: block; margin: auto;\"></p>\n<table>\n<tbody>\n<tr>\n\t<td>\n\t\t<strong>Note: </strong>Exact fields may vary based on your account settings and the project where the material is being added.\n\t</td>\n</tr>\n</tbody>\n</table><hr><h2><strong>How do I filter or customize the Procurement tracker?</strong></h2><p>\n\t<strong></strong>Procurement includes controls to help you focus on the materials that matter most.</p><p>\n\t<strong>Filter Procurement</strong></p><p>\n\tYou can filter Procurement by:</p><ul>\n\t\n<li>Project</li>\t\n<li>Purchaser</li>\t\n<li>Dates</li></ul><p>\n\tFilters are helpful when you want to focus on a single project, a specific person responsible for ordering, or materials that fall within a certain date range.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a510924ab2386dd40650492/file-2HHGIvzYjD.png\" alt=\"\" style=\"display: block; margin: auto;\"></p><p>\n\t<strong>Show or hide card details</strong></p><p>\n\tFrom the View menu, you can choose which details appear on material cards, such as project name, group name, and task name. This helps you keep the view as simple or detailed as your workflow requires.</p><h2><hr>\n</h2><h2>\n<strong>How do I review materials that are due or overdue to be ordered?</strong></h2><p>\n\tIf the Procurement tracker includes materials that are due today or overdue to be ordered, TeamGantt will show a banner at the top of the page.This gives your team a quick way to spot materials that need attention before they impact the project schedule.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a51096a1cbd0a3afd56a937/file-JiCeJXcgrU.png\" alt=\"\" style=\"display: block; margin: auto;\"></p><p>\n\tTo review due or overdue materials:</p><ol>\n\t\n<li>Open the Procurement tracker.</li>\t\n<li>Look for the banner at the top of the page.</li>\t\n<li>Select the button in the banner to filter the tracker to materials that are due today or overdue to be ordered.</li>\t\n<li>Review the filtered materials and update their status as needed.</li></ol><p>\n\tTip: Once you are done reviewing due or overdue items, clear the filter to return to the full view.</p><hr><h2>\n<strong>How do I update Procurement settings?</strong></h2><p>\n\tYou can update Procurement settings if you need to change which projects are included or how far ahead materials should be pulled into the tracker. This will change the setting for all users of the Procurement tracker.&nbsp;</p><p>\n\tTo change the projects that are pulled in:</p><ol>\n\t\n<li>Open the Procurement tracker.</li>\t\n<li>Select <strong>Settings</strong>.</li>\t\n<li>Update the included projects.</li>\t\n<li>Save your changes.</li></ol><p>\n\tTo change the timeframe for when you want a material to appear on the board:</p><ol>\n\t\n<li>Open the Procurement tracker.</li>\t\n<li>Select <strong>Time to order</strong>.</li>\t\n<li>Update the # of days.</li></ol><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a510a2457be4eea8c37fa30/file-MeUNkYiuKA.png\" alt=\"\" style=\"display: block; margin: auto;\"></p>\n<table>\n<tbody>\n<tr>\n\t<td>\n\t\t<strong>Tip: </strong>Changing these settings can affect which materials appear on the tracker. If a material is not showing, check that its project is included and that its order-by date falls within the selected timeframe.\n\t</td>\n</tr>\n</tbody>\n</table><h2><hr>\n</h2><h2><strong>How do I manage people and permissions?</strong></h2><p>\n\t<strong></strong>Procurement includes a People page where admins can invite users or teams to the tracker. This helps the right people collaborate on ordering, delays, and delivery updates across projects. Currently, only Managers can be invited to the Procurement tracker.&nbsp;</p><p>\n\tUse the\n\t<strong> Invite people</strong> link to invite people to the tracker.&nbsp;</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a510aa7f457003c1f086066/file-zKOJQ7WHK3.png\" alt=\"\" style=\"display: block; margin: auto;\"></p><p>\n\tProject access still matters. If someone does not have access to every project included in Procurement, some related project details may be limited based on their permissions. However, if applicable, there will be quick way to see which projects a person doesn't have access to and invite them immediately--all without leaving this page.&nbsp;</p>\n<table>\n<tbody>\n<tr>\n\t<td>\n\t\t<strong>Note: </strong>Admins can control who has access to the Procurement workflow while still keeping project-level permissions in place.\n\t</td>\n</tr>\n</tbody>\n</table><hr><h2>\n<strong>FAQs</strong></h2><p>\n\t<strong>Who can use the Procurement tracker?</strong></p><p>\n\tProcurement is designed for construction teams and is available on select construction plans. If you do not see Procurement in your sidebar, your account may not have access to this feature. Currently, this is limited to users with Manager-level permission.&nbsp;</p><p>\n\t<strong>Which projects can be included?</strong></p><p>\n\tProcurement can include selected active projects. During setup, an admin chooses which active projects should be pulled into the tracker.</p><p>\n\t<strong>Why is a material not showing on the tracker?</strong></p><p>\n\tCheck that the related project is active and included in Procurement settings. You should also confirm the material has an order-by date that falls within the selected timeframe and that no filters are hiding it.</p><p>\n\t<strong>What happens when I move a material card?</strong></p><p>\n\tMoving a card updates the material status. That status syncs back to the material in the related project.</p><p>\n\t<strong>Does Procurement change my task dates?</strong></p><p>\n\tChanging a material status updates the material status. It does not automatically change task dates.</p><p>\n\t<strong>Can I use Procurement for delayed materials?</strong></p><p>\n\tYes. Move a material to the Delayed column when it needs attention. This gives your team a clear visual way to track materials that may affect the schedule.</p><p>\n\t<strong>Can I add materials directly from the tracker?</strong></p><p>\n\tYes. You can add new materials directly from Procurement and connect them to the appropriate project, group, and task details.</p><p>\n\t<strong>Why am I seeing a banner at the top of the Procurement tracker?</strong></p><p>\n\tYou will see this banner when materials are due today or overdue to be ordered. Use the button in the banner to quickly filter your view to those items.</p><p>\n\t<strong>Related articles</strong></p><ul>\n\t\n<li><a href=\"https://support.teamgantt.com/article/172-material-lead-times/\">Material Lead Times</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/143-gantt-view/\">Gantt View</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/106-projects/\">Projects</a></li>\t\n<li><a href=\"https://support.teamgantt.com/article/6-inviting-people/\">Invite People to Your Project</a></li></ul>","name":"Procurement Tracking (Only Available on the Builder Edition)","number":181,"categories":["526eaf43e4b06c89ec332a52"]}},{"node":{"slug":"custom-fields","text":"<p>\n\tCustom fields (available on select paid plans) make it easy to track additional task details that are specific to the way your team works.</p><p>\n\tUse custom fields to add details like internal notes, dates, numbers, yes/no indicators, or dropdown selections directly to tasks in your project. Once a custom field is enabled on a project, you can view and update that information from task details or as a column in your gantt chart.</p><h2>What are custom fields?</h2><p>\n\tCustom fields are task-level fields you create for your account. They help your team track information that is not included in TeamGantt’s standard task fields.</p><p>\n\tCustom field types include:</p><ul>\n\t\n<li>Text</li>\t\n<li>Date</li>\t\n<li>Number</li>\t\n<li>Toggle</li>\t\n<li>Single Select</li></ul><hr><h2>Create a custom field</h2><p>\n\tManagers can create custom fields from inside a project.</p><p>\n\tHere’s how:</p><ol>\n\t\n<li>Open your project.</li>\t\n<li>Go to <strong>Menu &gt; Open project details</strong>.</li>\t\n<li>Select the <strong>Custom Fields</strong> tab.</li>\t\n<li>Click <strong>Create custom field</strong>.</li>\t\n<li>Enter a name for your field.</li>\t\n<li>Add a description, if needed.</li>\t\n<li>Choose a field type.</li>\t\n<li>Click <strong>Create custom field</strong>.</li></ol><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a907c47ce92cdaba13d0501/file-Y2ZgEFzkUs.png\" alt=\"\" style=\"display: block; margin: auto;\"></p><p>\n\tCustom field names must be unique. If a custom field with the same name already exists, you’ll see an error message.</p><hr><h2>Manage custom fields for a project</h2><p>\n\tCustom fields are turned on for all projects by default. You can choose which custom fields appear in a specific project from the project details window.</p><p>\n\tHere’s how:</p><ol>\n\t\n<li>Open your project.</li>\t\n<li>Go to <strong>Menu &gt; Open project details</strong>.</li>\t\n<li>Select the <strong>Custom Fields</strong> tab.</li>\t\n<li>Use the toggles to turn fields on or off for that project.</li></ol><p>\n\tWhen a custom field is turned off for a project, it will no longer appear in the column menu or task details for that project.</p><p>\n\tAny existing data in that field will be saved. If you turn the field back on later, the data will still be there.</p><hr><h2>Manage custom fields at the company level</h2><p>\n\tAccount admins can manage all custom fields from account settings.</p><p>\n\tHere’s how:</p><ol>\n\t\n<li>Go to <strong>Account Settings</strong>.</li>\t\n<li>Select <strong>Manage Custom Fields</strong>.</li>\t\n<li>From here, you can create, edit, or delete custom fields for your account.</li></ol><p>\n\tCustom fields can be turned on for all projects by default by toggling \"\n\t<strong>Enabled by default</strong>.\" To choose which custom fields appear in a specific project, open the project and go to \n\t<strong>Menu &gt; Open project details</strong>.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a907d3e039b617b17428329/file-VRtczDpVoc.png\" alt=\"\" style=\"display: block; margin: auto;\"></p><h2><hr>\n</h2><h2>Add custom field values to a task</h2><p>\n\tOnce a custom field is enabled on a project, managers can add or edit custom field values on tasks.</p><p>\n\tHere’s how:</p><ol>\n\t\n<li>Open the task.</li>\t\n<li>Go to the <strong>Details</strong> tab.</li>\t\n<li>Find the <strong>Custom Fields</strong> section.</li>\t\n<li>Add or update the custom field value.</li>\t\n<li>Your changes will save automatically.</li></ol><p>\n\tThe Custom Fields section only shows fields that are enabled for the project.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a907d976f9f378e74c1fcaa/file-VMIFyFVFAU.png\" alt=\"\" style=\"display: block; margin: auto;\"></p><h2><hr>\n</h2><h2>Show custom fields as columns</h2><p>\n\tYou can also show custom fields as \n\t<a href=\"https://support.teamgantt.com/article/163-displaying-and-hiding-columns/\">columns in your gantt chart</a>.</p><p>\n\tHere’s how:</p><ol>\n\t\n<li>Open your project.</li>\t\n<li>Open <strong>View &gt; Columns</strong>.</li>\t\n<li>Scroll to the <strong>Custom fields</strong> section.</li>\t\n<li>Select the fields you want to show as columns.</li></ol><p>\n\tCustom field columns can be resized and reordered, just like other columns in your project.</p><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a907dd56f9f378e74c1fcac/file-WFDfxdn23R.png\" alt=\"\" style=\"display: block; margin: auto;\"></p><h2><hr>\n</h2><h2>Edit custom fields from the gantt chart</h2><p>\n\tManagers can update custom field values directly from custom field columns in the gantt chart.</p><p>\n\tField behavior depends on the field type:</p><ul>\n\t\n<li><strong>Text:</strong> Click the cell to enter or edit text.</li>\t\n<li><strong>Date:</strong> Click the cell to choose or update a date.</li>\t\n<li><strong>Number:</strong> Click the cell to enter or edit a number.</li>\t\n<li><strong>Toggle:</strong> Use the toggle to turn the value on or off.</li>\t\n<li><strong>Single Select:</strong> Click the cell to choose or update a selection.</li></ul><p>\n\t<img src=\"https://s3.amazonaws.com/helpscout.net/docs/assets/526eaec5e4b09e5feddf35bb/images/6a907e3b9f65cc0cc64d68b2/file-WplFkyWFlz.png\" alt=\"\" style=\"display: block; margin: auto;\"></p><h2><hr>\n</h2><h2>Custom fields in multi-project gantt view</h2><p>\n\tIf you’re viewing multiple projects in gantt view, custom field columns can still be shown.</p><p>\n\tIf a custom field is not enabled on one of the open projects, the cells for that project will appear empty.</p><h2>Export &amp; share custom field data (Coming soon)</h2><p>\n\tCustom field column data will b included when exporting your project to CSV.&nbsp;If you export multiple projects, custom field data will be included for the projects where those fields are available.</p><p>\n\tCustom field column data will also included in share URLs, so people viewing the shared project can see the custom field information included in the shared view.</p><h2><hr>\n</h2><h2>Permissions</h2><p>\n\tCustom field access depends on your permission level.</p><p>\n\tManagers with account admin permission can:</p><ul>\n\t\n<li>Create custom fields</li>\t\n<li>Manage which fields are enabled on a project</li>\t\n<li>Add and edit custom field values on tasks</li>\t\n<li>Create, edit, and delete fields from <strong>Account Settings &gt; Manage Custom Fields</strong></li></ul><p>\n\tManagers can:</p><ul>\n\t\n<li>Create custom fields</li>\t\n<li>Manage which fields are enabled on a project</li>\t\n<li>Add and edit custom field values on tasks</li></ul><p>\n\tManagers who are not account admins cannot manage, edit, or delete fields from the company-level \n\t<strong>Manage Custom Fields</strong> page.</p><p>\n\tCollaborators can:</p><ul>\n\t\n<li>View custom fields</li></ul><p>\n\tCollaborators cannot create or manage custom fields, turn fields on or off for a project, or add and edit custom field values on tasks.</p><hr><h2>FAQ</h2><p>\n\t<strong>What happens if I turn off a custom field for a project?</strong></p><p>\n\tThe field will be hidden from the column menu and task details for that project. Any existing data will be saved and will reappear if the field is turned back on later.</p><p>\n\t<strong>Can I create a custom field from inside a project?</strong></p><p>\n\tYes. Managers can create custom fields from the \n\t<strong>Custom Fields</strong> tab in project details.</p><p>\n\t<strong>Can I delete a custom field?</strong></p><p>\n\tAccount admins can delete custom fields from \n\t<strong>Account Settings &gt; Manage Custom Fields</strong>.</p><p>\n\t<strong>Can collaborators edit custom field values?</strong></p><p>\n\tNo. Collaborators can view custom fields, but they cannot create, manage, or edit them.</p><p>\n\t<strong>Are custom fields included in CSV exports?</strong></p><p>\n\tYes. Custom field column data is included in CSV exports.</p><p>\n\t<strong>Can I filter by custom fields?</strong></p><p>\n\tFiltering by custom fields is not available at this time.</p>","name":"Custom Fields","number":182,"categories":["526eaf43e4b06c89ec332a52"]}}]}},"layoutContext":{}}

/***/ }),
/* 224 */,
/* 225 */
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ }),
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTYnIGhlaWdodD0nMTMnIHZpZXdCb3g9JzAgMCAxNiAxMycgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cGF0aCBkPSdNMTYgMS41YzAtLjU1NS0uNDQ1LTEtMS0xSDFjLS41NTUgMC0xIC40NDUtMSAxbDggNiA4LTZ6TTAgMy4yOTdWMTEuNWMwIC41NTUuNDQ1IDEgMSAxaDE0Yy41NTUgMCAxLS40NDUgMS0xVjMuMjk3bC04IDYtOC02eicgZmlsbD0nI0ZGRicgZmlsbC1ydWxlPSdldmVub2RkJy8+PC9zdmc+"

/***/ }),
/* 246 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTYnIGhlaWdodD0nMTYnIHZpZXdCb3g9JzAgMCAxNiAxNicgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cGF0aCBkPSdNMTYgMWMwLS41NDctLjQ1My0xLTEtMUgxQy40NTMgMCAwIC40NTMgMCAxdjE0YzAgLjU0Ny40NTMgMSAxIDFoNy41NTVWOS43ODFoLTJWNy40NzdoMlY1LjQ4NGMwLTEuODIgMS4xMS0zLjAzOSAzLjMwNC0zLjAzOS45NyAwIDEuNjQxLjExIDEuNjQxLjExdjIuMDc4SDEyYy0uNjY0IDAtMSAuMzc1LTEgMS4wMzF2MS44MTNoMi4zMzZMMTMgOS43OGgtMlYxNmg0Yy41NDcgMCAxLS40NTMgMS0xVjF6JyBmaWxsPScjRkZGJyBmaWxsLXJ1bGU9J2V2ZW5vZGQnLz48L3N2Zz4="

/***/ }),
/* 247 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTYnIGhlaWdodD0nMTcnIHZpZXdCb3g9JzAgMCAxNiAxNycgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cGF0aCBkPSdNLjMzNiA2LjE2NFYxNi41aDMuMzI4VjYuMTY0SC4zMzZ6TTkgMTAuNWMwLTEuMzM2Ljg1Mi0yIDEuODUyLTJzMS44MTIuNjY0IDEuODEyIDIuMzM2VjE2LjVIMTZ2LTZjMC0zLTEuNjY0LTQuNjY0LTQtNC42NjQtMS4zMzYgMC0yLjMzNi43NTgtMyAxLjc1OGwtLjExLTEuNDNINS42MWMwIC4zNTIuMDU0IDIuMzM2LjA1NCAyLjMzNnY4SDl2LTZ6bS03LjAxNi02QzMuMjIgNC41IDQgMy42ODcgNCAyLjY2NCAzLjk4NCAxLjYzMyAzLjIxOS44MzYgMi4wMTYuODM2Ljc5Ni44MzYgMCAxLjYzMyAwIDIuNjY0IDAgMy42ODcuNzgxIDQuNSAxLjk2IDQuNWguMDI0eicgZmlsbD0nI0ZGRicgZmlsbC1ydWxlPSdldmVub2RkJy8+PC9zdmc+"

/***/ }),
/* 248 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMTYnIGhlaWdodD0nMTMnIHZpZXdCb3g9JzAgMCAxNiAxMycgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz48cGF0aCBkPSdNMTYgMS41MzFhNi40MDIgNi40MDIgMCAwIDEtMS44OS41MjQgMy4yNTQgMy4yNTQgMCAwIDAgMS40NDUtMS44MiA2LjU5IDYuNTkgMCAwIDEtMi4wNy43OTZBMy4zOTYgMy4zOTYgMCAwIDAgMTEuMDcgMGEzLjI2OCAzLjI2OCAwIDAgMC0zLjI3MyAzLjI3M2MwIC4yNTguMDE2LjUyNC4wNy43NThDNS4xNDggMy44ODMgMi43NDIgMi42NDggMS4xMS42NjRjLS4yNzMuNDg0LS40NDUuOTg0LS40NDUgMS41OTQgMCAxLjEyNS41NzggMi4xMjUgMS40NjkgMi43MTlBMy4yOSAzLjI5IDAgMCAxIC42NDggNC41N3YuMDRhMy4yOCAzLjI4IDAgMCAwIDIuNjMzIDMuMjE4IDMuMjgyIDMuMjgyIDAgMCAxLS44NzUuMTE3Yy0uMjAzIDAtLjQwNi0uMDIzLS42MS0uMDYyLjQwNyAxLjI5NyAxLjYzNCAyLjI2NSAzLjA1NiAyLjI4MS0xLjExLjg5LTIuNTQgMS41NTUtNC4wNyAxLjU1NS0uMjY2IDAtLjUyNC0uMDE2LS43ODItLjA1NUMxLjQ0NSAxMi41OTQgMy4xODggMTMgNS4wNCAxM2M2LjAzIDAgOS4zMjctNSA5LjMyNy05LjMzNnYtLjQzQTYuNjQ4IDYuNjQ4IDAgMCAwIDE2IDEuNTMxeicgZmlsbD0nI0ZGRicgZmlsbC1ydWxlPSdldmVub2RkJy8+PC9zdmc+"

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0naHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmcnIHdpZHRoPScxOScgaGVpZ2h0PScxNCc+PHBhdGggZD0nTTcuNTQgNC43bDUuMTMgMi42MUw3LjU0IDkuOXptMTAuNTEtMi43M2MtLjcyLS43NC0xLjUzLS43NC0xLjktLjc4QzEzLjQ5IDEgOS41IDEgOS41IDFzLTMuOTkgMC02LjY1LjE5Yy0uMzcuMDQtMS4xOC4wNC0xLjkuNzhDLjM4IDIuNTMuMTkgMy44LjE5IDMuOFMwIDUuMyAwIDYuOHYxLjRjMCAxLjQ5LjE5IDIuOTkuMTkgMi45OXMuMTkgMS4yNy43NiAxLjgzYy43Mi43NCAxLjY3LjcyIDIuMDkuNzkgMS41Mi4xNSA2LjQ2LjE5IDYuNDYuMTlzMy45OS0uMDEgNi42NS0uMTljLjM3LS4wNSAxLjE4LS4wNSAxLjktLjc5LjU3LS41Ni43Ni0xLjgzLjc2LTEuODNTMTkgOS42OSAxOSA4LjJWNi44YzAtMS41LS4xOS0zLS4xOS0zcy0uMTktMS4yNy0uNzYtMS44M3onIGZpbGw9JyNGRkYnLz48L3N2Zz4="

/***/ }),
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(339);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(223);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Input = __webpack_require__(89);
	
	var _Input2 = _interopRequireDefault(_Input);
	
	var _TypeaheadResults = __webpack_require__(91);
	
	var _TypeaheadResults2 = _interopRequireDefault(_TypeaheadResults);
	
	var _heroModule = __webpack_require__(432);
	
	var _heroModule2 = _interopRequireDefault(_heroModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero(_ref) {
	  var tags = _ref.tags;
	  return _react2.default.createElement(
	    'section',
	    { className: _heroModule2.default.Hero },
	    _react2.default.createElement(
	      'div',
	      { className: _heroModule2.default.Hero__content },
	      _react2.default.createElement(
	        'p',
	        { className: _heroModule2.default.Hero__eyebrow },
	        'TeamGantt Support'
	      ),
	      _react2.default.createElement(
	        'h1',
	        { className: _heroModule2.default.Hero__heading },
	        'How can we help?'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: _heroModule2.default.Hero__summary },
	        'Search the help docs or browse by topic to get answers fast.'
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: _heroModule2.default.Hero__search },
	        _react2.default.createElement(
	          _Input2.default,
	          null,
	          function (_ref2) {
	            var query = _ref2.query,
	                typeaheadResults = _ref2.typeaheadResults;
	            return _react2.default.createElement(_TypeaheadResults2.default, { query: query, results: typeaheadResults });
	          }
	        )
	      ),
	      tags.length > 0 && _react2.default.createElement(
	        'div',
	        { className: _heroModule2.default.Tags },
	        _react2.default.createElement(
	          'span',
	          { className: _heroModule2.default.Tags__label },
	          'Popular'
	        ),
	        _react2.default.createElement(
	          'ul',
	          { className: _heroModule2.default.Tags__list },
	          tags.map(function (_ref3) {
	            var title = _ref3.title,
	                href = _ref3.href;
	            return _react2.default.createElement(
	              'li',
	              { key: title },
	              _react2.default.createElement(
	                'a',
	                { className: _heroModule2.default.Tags__tag, href: href },
	                title
	              )
	            );
	          })
	        )
	      )
	    )
	  );
	};
	
	Hero.propTypes = {
	  tags: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    title: _propTypes2.default.string.isRequired,
	    href: _propTypes2.default.string.isRequired
	  }))
	};
	
	Hero.defaultProps = {
	  tags: []
	};
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(138);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _categories = __webpack_require__(10);
	
	__webpack_require__(225);
	
	var _header = __webpack_require__(189);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _hero = __webpack_require__(330);
	
	var _hero2 = _interopRequireDefault(_hero);
	
	var _footer = __webpack_require__(187);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Layout = function Layout(_ref) {
	  var children = _ref.children,
	      data = _ref.data;
	  var _data$site$siteMetada = data.site.siteMetadata,
	      title = _data$site$siteMetada.title,
	      popularTags = _data$site$siteMetada.popularTags,
	      footerLinks = _data$site$siteMetada.footerLinks,
	      articleEdges = data.allHelpScoutArticle.edges,
	      categoryEdges = data.allHelpScoutCategory.edges;
	
	
	  var navigation = (0, _categories.buildTree)(categoryEdges, articleEdges);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      meta: [{
	        name: 'description',
	        content: 'Frequently asked questions and support documentation for TeamGantt'
	      }],
	      title: title
	    }),
	    _react2.default.createElement(_header2.default, { articleNavigation: navigation }),
	    _react2.default.createElement(
	      'main',
	      null,
	      _react2.default.createElement(_hero2.default, { tags: popularTags }),
	      children()
	    ),
	    _react2.default.createElement(_footer2.default, { footerLinks: footerLinks })
	  );
	};
	
	Layout.propTypes = {
	  children: _propTypes2.default.func,
	  data: _propTypes2.default.object
	};
	
	exports.default = Layout;
	
	// eslint-disable-next-line
	
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"Hero":"src-components-hero----hero-module---Hero---fJNvc","Hero__content":"src-components-hero----hero-module---Hero__content---2bgzy","Hero__eyebrow":"src-components-hero----hero-module---Hero__eyebrow---ShXfZ","Hero__heading":"src-components-hero----hero-module---Hero__heading---2THTV","Hero__summary":"src-components-hero----hero-module---Hero__summary---1ud5_","Hero__search":"src-components-hero----hero-module---Hero__search---3s6EI","Tags":"src-components-hero----hero-module---Tags---ZybLA","Tags__label":"src-components-hero----hero-module---Tags__label---1k2nX","Tags__list":"src-components-hero----hero-module---Tags__list---20CZ8","Tags__tag":"src-components-hero----hero-module---Tags__tag---3UTEu","spinAround":"src-components-hero----hero-module---spinAround---1K4vM"};

/***/ })
]);


// WEBPACK FOOTER //
// component---src-layouts-index-js-2fc84e18ff4e9d5caa32.js